import { uninitState, statusSuccess, successState, IntlSelectors, statusLoading, statusUninit, loadingState, actions, failedState, combineReducers, persistReducer, sessionStorage, ApiConfigSelectors, assertApiConfig, useIntl, useFeatureToggles, useApiConfig, Locales, useViewHistory, ViewHistoryKey, useSelector, useDispatch, statusFailed, LOADING, UNINIT, statusWarning, SUCCESS, FAILED, useSaga, withIntl, withApiConfig, SagaRegistry, ReducersRegistry } from '@grandvisionhq/state';
import * as swcHelpers from '@swc/helpers';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { Helpers, StockIndicator } from '@grandvisionhq/inventory';
import { formatPrice, getLocalizedValue, getNestedProperty, getLocalizedAttrValue, getAttrValue, isPresent, getLocalizedAttrValues, getJoinedLocalizedAttrValues, placeholderImage, isString, getFrontImage, isDefined as isDefined$1, DateUtils, isNumber, createImageUrl, sanitizeStringForUrl, isNil, isBoolean, sortPrescriptionParameters, PrescriptionValueUtils, optionalKey, calculateHeaderHeight, isPlainObject, isModifiedClickEvent, withLazyLoading } from '@grandvisionhq/utils';
import { createSelector } from 'reselect';
import { Selectors, Actions, ConfiguratorStepTitleAndDescription, StepForm, useConfiguratorContext, ctaLabelSelectorProps, ConnectedStepForm, Configurator } from '@grandvisionhq/configurator';
import { takeLatest, call, select, put, all, race, take, delay } from 'redux-saga/effects';
import { Products, useApiClient } from '@grandvisionhq/api-client';
import { DataLayer, calcPrice, useWasSeenByUser, getIncludedVatAmount, priceVatCalc, pushSdAction, createPriceSpecification, parseProductData, ActionType, useAlgoliaAnalytics, WebPage, AlgoliaAnalytics, Product } from '@grandvisionhq/analytics';
import { Util, Select, RadioButtons, DateOfBirthSelect, DatePicker, CheckboxWithLabel, Form, RequiredFieldsLabel } from '@grandvisionhq/forms';
import * as React from 'react';
import React__default, { useEffect, useState, useMemo, useCallback, createContext, useRef } from 'react';
import classnames from 'classnames';
import { MediaQuery, LazyImage, Price, Carousel, ProductTag, Loader, List, Sticky, StickyCallToAction, PriceTag, RadioButton, Card, LoaderScreen, Image, FilesList, Link, Alert, Tooltip, toast, RichTextArea, CheckboxList, EyeSideIndicator, DateTime, Button, ScrollIntoView, Modal, Tabs, Tab, QuantitySelector, SliderCarousel, Breadcrumbs, Util as Util$1, SelectionGroup } from '@grandvisionhq/common';
import { Heading, Text, SkeletonLoader, Hr, ButtonWithDropdown, Container } from '@grandvisionhq/elements';
import { Discount, ProductDetailReducer, useVtoConfig, vtoEvent, ProductImageGalleryMobile, ProductImageGalleryView, useProductDetailSlots, NonRxProductCTA, ProductDetailTitle, ProductVisualSwitcher, ProductDetailDescription, ProductDetailPrice, ProductDiscountLabel, VariantPicker, ProductDetailUsps, SelectionBoxRadio, ProductImage, TileLayout, RxGlassesCTA, TryOnButton, FrameSize, BrandPromotion, PrescriptionAvailabilityIndicator, ProductDetailFeatures, SunglassesRxableSelect, ProductDetailActions, PromoteInstallmentsModalSlot, getFrameMeasurements, FrameMeasurements } from '@grandvisionhq/fun-products';
import { useInView } from 'react-intersection-observer';
import { useReviewsContext, Actions as Actions$1, ReviewSnippet } from '@grandvisionhq/reviews';
import { Icon, FeatureIcon } from '@grandvisionhq/icons';
import { useUpload, Upload, useUploadHandler, Types, UploadProvider } from '@grandvisionhq/upload';
import { isUspsGroupTheme, UspGroup, PromoteInstallmentsLabel } from '@grandvisionhq/content';
import { debounce } from 'throttle-debounce';
import { Hooks, AddToCart, Context } from '@grandvisionhq/carts-v2';
import { Types as Types$1, gql, useLazyQuery, useQuery } from '@grandvisionhq/graphql';
import { DeliveryIndicator } from '@grandvisionhq/shipping';
import useOnClickOutside from 'use-onclickoutside';
import { Components } from '@grandvisionhq/stores-v2';
import { motion } from 'framer-motion';

// returns discounted value
const getDiscount = (variant, locale)=>{
    var ref, ref1;
    if (!Array.isArray(variant.prices) || !variant.prices.length) {
        return undefined;
    }
    const { discounted  } = variant.prices[0];
    // check that discounted contains discount object
    if (!discounted || !((ref = discounted.discount) === null || ref === void 0 ? void 0 : ref.obj)) return undefined;
    const { value , isActive  } = (ref1 = discounted.discount) === null || ref1 === void 0 ? void 0 : ref1.obj;
    return value.type === 'absolute' ? getAbsoluteDiscount(value, isActive, locale) : getRelativeDiscount(value, isActive);
};
// gets absolute discount value (in currency)
const getAbsoluteDiscount = (value, isActive, locale)=>{
    const { centAmount , currencyCode  } = value.money[0];
    if (centAmount === 0 || !isActive) return undefined;
    return `-${formatPrice(locale, centAmount, currencyCode, true)}`;
};
// gets relative discount value (in percentage)
const getRelativeDiscount = (value, isActive)=>value.permyriad !== 0 && isActive ? `-${value.permyriad / 100}%` : undefined
;

const getProductTag = (variant, locale)=>{
    const zeroDiscount = getZeroDiscountValue(variant, locale);
    const tags = variant.tags;
    if (!(tags === null || tags === void 0 ? void 0 : tags.length) && !zeroDiscount) return undefined;
    // tags have more weight than a description from the zero discount
    if (tags && tags.length) {
        const value = typeof tags[0].value !== 'string' ? getLocalizedValue(tags[0].value, locale) : tags[0].value;
        return {
            key: tags[0].key,
            value
        };
    }
    // temporally uses zero discount as a custom product tag.
    return {
        key: null,
        value: zeroDiscount || ''
    };
};
// gets description value and to create a custom tag. remove this after the unification
const getZeroDiscountValue = (variant, locale)=>{
    var ref, ref1;
    if (!Array.isArray(variant.prices) || !variant.prices.length) {
        return undefined;
    }
    const { discounted  } = variant.prices[0];
    // check that discounted contains discount object
    if (!discounted || !((ref = discounted.discount) === null || ref === void 0 ? void 0 : ref.obj)) return undefined;
    const { value , description  } = (ref1 = discounted.discount) === null || ref1 === void 0 ? void 0 : ref1.obj;
    let discountLabel = null;
    if (value.type === 'absolute') {
        discountLabel = description && (value.money && value.money[0].centAmount) === 0 ? getLocalizedValue(description, locale) : null;
    } else if (value.type === 'relative') {
        discountLabel = description && value.permyriad === 0 ? getLocalizedValue(description, locale) : null;
    }
    return discountLabel;
};

// using hardcoded english locale here to map:
// https://github.com/GrandVisionHQ/gv-core-components/blob/69612677a059e714191bee6c94b62f7866e039f1/packages/common/src/ColorPicker/color-mapping.tsx#L1
const COLOR_MAPPING_LOCALE = 'en-GB';
function getDiscountText(locale, variant) {
    if (!Array.isArray(variant.prices) || !variant.prices.length) {
        return '';
    }
    const priceObject = variant.prices[0];
    const description = getNestedProperty(priceObject, 'discounted.discount.obj.description');
    return getLocalizedValue(description, locale);
}
const getExtrasId = (product)=>{
    if (!product || !product.masterVariant || !Array.isArray(product.masterVariant.attributes)) {
        return undefined;
    }
    const extrasAttribute = product.masterVariant.attributes.find((attr)=>attr.name === 'lensExtras'
    );
    if (!extrasAttribute || !extrasAttribute.value) {
        return undefined;
    }
    return extrasAttribute.value.id;
};
function getPrice$2(variant) {
    if (!Array.isArray(variant.prices) || !variant.prices.length) {
        return undefined;
    }
    const price = variant.prices[0];
    if (!price.discounted) {
        return {
            originalPrice: price.value.centAmount,
            currency: price.value.currencyCode
        };
    }
    const discounted = price.discounted;
    return {
        currency: price.value.currencyCode,
        originalPrice: price.value.centAmount,
        discountedPrice: discounted.value.centAmount
    };
}
function getProductTypeName$1(product) {
    const result = product && product.productType && product.productType.obj && CommerceToolsApi.isProductTypeName(product.productType.obj.name) ? product.productType.obj.name : false;
    return !!result ? result : undefined;
}
function getProductModelName(variant, locale, productType) {
    if (CommerceToolsApi.isLenses(productType)) {
        return getLocalizedAttrValue(variant, 'materialType', locale);
    }
    return variant.name || '';
}
function getActiveVariant$1(product, sku) {
    if (!sku) {
        return product.masterVariant;
    }
    if (product.masterVariant.sku === sku) {
        return product.masterVariant;
    }
    return product.variants.find((variant)=>variant.sku === sku
    ) || product.masterVariant;
}
function getAvailability$1(variant) {
    return variant.availability ? {
        availableQuantity: Helpers.getAvailableQuantity(variant.availability)
    } : {};
}
const getLensPropertyValue = (variant, attrName)=>{
    const value = getAttrValue(variant, attrName);
    // We only care about numbers and strings
    if (!isPresent(value) || !(typeof value === 'number' || typeof value === 'string')) {
        return undefined;
    }
    return String(value);
};
function getSunglassesFeatureValue(variant, attrName, attrType) {
    const value = getAttrValue(variant, attrName);
    // We want to only return a value of type number in case that's the requested attr type.
    if (attrType === 'number') {
        return typeof value === 'number' ? value : undefined;
    }
    // We want to only return a value of type boolean in case that's the requested attr type.
    if (attrType === 'boolean') {
        return typeof value === 'boolean' ? value : undefined;
    }
    return undefined;
}
function getVariantInfo$1(product, productType, locale, variant, staticsUrl, isBynderImagesEnabled) {
    const activeVariant = !variant || typeof variant === 'string' ? getActiveVariant$1(product, variant) : variant;
    const allowBackOrderAttribute = getAttrValue(activeVariant, 'allowBackOrder');
    const allowBackOrder = typeof allowBackOrderAttribute === 'undefined' ? undefined : !!allowBackOrderAttribute;
    const sharedProductInfo = {
        sku: activeVariant.sku || '',
        modelName: getProductModelName(activeVariant, locale, productType),
        header: getLocalizedAttrValue(activeVariant, 'header', locale),
        description: getLocalizedAttrValue(activeVariant, 'description', locale),
        images: getProductImages$1(activeVariant, staticsUrl, isBynderImagesEnabled),
        usps: getLocalizedAttrValues(activeVariant, 'usps', locale) || [],
        price: getPrice$2(activeVariant),
        brand: String(getAttrValue(activeVariant, 'brand')),
        discountText: getDiscountText(locale, activeVariant),
        discounted: getDiscount(activeVariant, locale),
        tag: getProductTag(activeVariant, locale),
        allowBackOrder,
        excludedFromCheckout: !!getAttrValue(activeVariant, 'excludedFromCheckout'),
        channelAvailability: activeVariant.channelAvailability
    };
    var _isOfferedWithPrescriptions;
    const sharedFrameInfo = {
        name: activeVariant.name || '',
        frameColorLabel: getJoinedLocalizedAttrValues(activeVariant, 'frameColor', locale),
        frameColor: getJoinedLocalizedAttrValues(activeVariant, 'frameColor', COLOR_MAPPING_LOCALE),
        frameShape: getLocalizedAttrValue(activeVariant, 'frameShape', locale),
        frameMaterial: getLocalizedAttrValue(activeVariant, 'frameMaterial', locale),
        gender: getLocalizedAttrValues(activeVariant, 'gender', locale) || [
            'UNISEX'
        ],
        isKids: false,
        isOfferedWithPrescriptions: (_isOfferedWithPrescriptions = activeVariant.isOfferedWithPrescriptions) !== null && _isOfferedWithPrescriptions !== void 0 ? _isOfferedWithPrescriptions : false,
        sku: activeVariant.sku || ''
    };
    const genderKeys = getLocalizedAttrValues(activeVariant, 'gender', locale);
    if (genderKeys && Array.isArray(genderKeys) && genderKeys.length) {
        sharedFrameInfo.isKids = genderKeys.some((a)=>a.toLowerCase() === 'kids'
        );
    }
    // Contact-lenses
    if (CommerceToolsApi.isLenses(productType)) {
        const info = swcHelpers.objectSpread({}, sharedProductInfo, {
            productType: 'Contact-lenses',
            brand: getLocalizedValue(product.name, locale),
            replacementFrequency: getLocalizedAttrValue(activeVariant, 'replacementFrequency', locale),
            materialType: getLocalizedAttrValue(activeVariant, 'materialType', locale),
            lensType: getLocalizedAttrValue(activeVariant, 'lensType', locale),
            material: getLocalizedAttrValue(activeVariant, 'material', locale),
            waterContent: getLocalizedAttrValue(activeVariant, 'waterContent', locale),
            packageQuantity: Number(getAttrValue(activeVariant, 'packageQuantity')),
            features: {
                hydration: !!getAttrValue(activeVariant, 'cbHydration'),
                softness: !!getAttrValue(activeVariant, 'cbSoftness'),
                breathability: !!getAttrValue(activeVariant, 'cbBreathability'),
                fatigue: !!getAttrValue(activeVariant, 'cbFatigue'),
                uv: !!getAttrValue(activeVariant, 'cbUV'),
                basics: !!getAttrValue(activeVariant, 'cbBasics')
            },
            lensProperties: {
                power: getLensPropertyValue(activeVariant, 'power'),
                baseCurve: getLensPropertyValue(activeVariant, 'baseCurve'),
                diameter: getLensPropertyValue(activeVariant, 'diameter'),
                axis: getLensPropertyValue(activeVariant, 'axis'),
                cylinder: getLensPropertyValue(activeVariant, 'cylinder'),
                addition: getLensPropertyValue(activeVariant, 'addition'),
                color: getLensPropertyValue(activeVariant, 'color')
            },
            promotionalText: getLocalizedAttrValue(activeVariant, 'promotionalText', locale)
        });
        return info;
    // Sunglasses
    } else if (CommerceToolsApi.isSunglasses(productType)) {
        const availability = getAvailability$1(activeVariant);
        const info = swcHelpers.objectSpread({}, sharedProductInfo, sharedFrameInfo, {
            productType: 'Sunglasses',
            lensColor: getJoinedLocalizedAttrValues(activeVariant, 'lensColor', locale),
            features: {
                uvCategory: getSunglassesFeatureValue(activeVariant, 'UVCategory', 'number'),
                polarized: getSunglassesFeatureValue(activeVariant, 'polarized', 'boolean'),
                glazable: getSunglassesFeatureValue(activeVariant, 'glazeble', 'boolean')
            }
        }, {
            availability
        });
        return info;
    } else if (CommerceToolsApi.isAccessories(productType)) {
        const availability = getAvailability$1(activeVariant);
        const info = swcHelpers.objectSpread({}, sharedProductInfo, {
            productType: 'Accessories',
            accessoryColor: getJoinedLocalizedAttrValues(activeVariant, 'accessoryColor', locale)
        }, {
            availability
        });
        return info;
    } else if (CommerceToolsApi.isSolutions(productType)) {
        const availability = getAvailability$1(activeVariant);
        return swcHelpers.objectSpread({}, sharedProductInfo, {
            contactLensCareType: getLocalizedAttrValue(activeVariant, 'contactLensCareType', locale),
            packageOption: String(getAttrValue(activeVariant, 'packageOption')),
            productType: 'Solutions',
            description: getLocalizedValue(product.description, locale),
            targetUsers: getLocalizedAttrValue(activeVariant, 'targetUsers', locale),
            convenience: getLocalizedAttrValue(activeVariant, 'convenience', locale),
            keyInstructions: getLocalizedAttrValue(activeVariant, 'keyInstructions', locale),
            features: {
                cleaning: getAttrValue(activeVariant, 'cbCleaning'),
                comfort: getAttrValue(activeVariant, 'cbComfort'),
                disinfect: getAttrValue(activeVariant, 'cbDisinfect'),
                hydration: getAttrValue(activeVariant, 'cbHydration'),
                rinsing: getAttrValue(activeVariant, 'cbRinsing'),
                sensitivity: getAttrValue(activeVariant, 'cbSensitivity')
            }
        }, {
            availability
        });
    } else if (CommerceToolsApi.isReadyReaders(productType)) {
        const availability = getAvailability$1(activeVariant);
        return swcHelpers.objectSpread({}, sharedProductInfo, sharedFrameInfo, {
            productType: 'Ready-readers',
            features: {
                blueFilter: getAttrValue(activeVariant, 'blueFilter'),
                isOfferedWithPrescriptions: getAttrValue(activeVariant, 'isOfferedWithPrescriptions')
            }
        }, {
            availability
        });
    } else {
        const info = swcHelpers.objectSpread({}, sharedProductInfo, sharedFrameInfo, {
            productType: 'Frames',
            availability: getAvailability$1(activeVariant)
        });
        return info;
    }
}
var ref$7;
const getVariants$1 = (variants, slug, staticsUrl, productType, locale, isBynderImagesEnabled)=>{
    return variants.map((variant)=>{
        var ref1;
        return {
            sku: variant.sku || '',
            slug,
            productType,
            description: getVariantDescription(variant, locale),
            imageUrl: (ref$7 = (ref1 = getFullImageUrls(variant, staticsUrl, isBynderImagesEnabled)[0]) === null || ref1 === void 0 ? void 0 : ref1.url) !== null && ref$7 !== void 0 ? ref$7 : ''
        };
    });
};
const getVariantDescription = (variant, locale)=>[
        'lensColor',
        'frameColor',
        'accessoryColor'
    ].map((attr)=>getJoinedLocalizedAttrValues(variant, attr, locale)
    ).filter((str)=>str.trim() !== ''
    ).join(' / ')
;
function getSunVariantPickerLabel(variant) {
    return [
        variant.lensColor,
        variant.frameColorLabel
    ].filter((str)=>str.trim() !== ''
    ).join(' / ');
}
function getProductAltTag(name, product, productType, locale) {
    const brand = getAttrValue(product, 'brand');
    const frameColor = getJoinedLocalizedAttrValues(product, 'frameColor', locale);
    const lensColor = getJoinedLocalizedAttrValues(product, 'lensColor', locale);
    if (productType && (CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType))) {
        return typeof name === 'string' ? name : getLocalizedValue(name, locale);
    }
    const colorInfo = productType && CommerceToolsApi.isFrames(productType) || !lensColor ? frameColor : `${lensColor}${frameColor && ` / ${frameColor}`}`;
    return `${brand} ${product.name} ${colorInfo}`;
}
/**
 * This function decides where and how to load the product images
 * There are two different paths, one with a supplied staticsUrl and one without
 *  - If a staticsUrl is supplied, we return the full image urls
 *  - If bynder images are enabled, we return the full image urls from the media property
 *  - If no staticsUrl is given and bynder is not enabled, we return the image filename in a legacy format
 */ function getProductImages$1(variant, staticsUrl, isBynderImagesEnabled) {
    // Return legacy format
    if (!staticsUrl && !isBynderImagesEnabled) {
        var _images;
        const [primary, secondary] = (_images = variant.images) !== null && _images !== void 0 ? _images : [];
        return {
            primary,
            secondary
        };
    }
    return getFullImageUrls(variant, staticsUrl, isBynderImagesEnabled);
}
/**
 * Prepends variant images with staticsUrl
 */ function getFullImageUrls(variant, staticsUrl, isBynderImagesEnabled) {
    if (isBynderImagesEnabled) {
        const images = getNestedProperty(variant, 'media.images', []);
        return images;
    }
    if (!variant.images || !variant.images.length) {
        return [
            placeholderImage
        ];
    }
    return variant.images.map((image)=>{
        return {
            url: `${staticsUrl}${image.url}`,
            dimensions: swcHelpers.objectSpread({}, image.dimensions)
        };
    });
}
/**
 * This helper returns a composition of the
 * `brand`, `brandModel` en `brandModelCode` attributes for a variant
 */ const getProductTitle$1 = (productType = '', product, variant, locale)=>{
    const brand = productType.toLowerCase() === 'contact-lenses' ? getLocalizedValue(product.name || '', locale) : String(getAttrValue(variant, 'brand'));
    var _masterVariant;
    const replacementFrequency = getLocalizedAttrValue((_masterVariant = product.masterVariant) !== null && _masterVariant !== void 0 ? _masterVariant : {}, 'replacementFrequency', locale) || '';
    const brandModel = getAttrValue(variant, 'brandModel') || '';
    const brandModelCode = getAttrValue(variant, 'brandModelCode') || '';
    const brandModelColorCode = getAttrValue(variant !== null && variant !== void 0 ? variant : {}, 'brandModelColorCode') || '';
    return `${replacementFrequency} ${brand} ${brandModel} ${brandModelCode !== brandModel ? brandModelCode : ''} ${brandModelColorCode}`.replace(/\s+/g, ' ').trim();
};

var helpers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getDiscountText: getDiscountText,
  getExtrasId: getExtrasId,
  getPrice: getPrice$2,
  getProductTypeName: getProductTypeName$1,
  getProductModelName: getProductModelName,
  getActiveVariant: getActiveVariant$1,
  getLensPropertyValue: getLensPropertyValue,
  getSunglassesFeatureValue: getSunglassesFeatureValue,
  getVariantInfo: getVariantInfo$1,
  getVariants: getVariants$1,
  getSunVariantPickerLabel: getSunVariantPickerLabel,
  getProductAltTag: getProductAltTag,
  getProductImages: getProductImages$1,
  getFullImageUrls: getFullImageUrls,
  getProductTitle: getProductTitle$1
});

const reduceVariantInfo = (locale)=>{
    return (mem, variant)=>{
        var ref, ref1;
        if (!variant.sku || !variant.isMatchingVariant || !variant.attributes) {
            return mem;
        }
        const variationAttribute = getAttrValue(variant, 'variationAttribute');
        if (!variationAttribute || !isString(variationAttribute)) {
            return mem;
        }
        const title = getLocalizedAttrValue(variant, variationAttribute, locale);
        if (!title) {
            return mem;
        }
        const isDefault = getAttrValue(variant, 'default') === true;
        return [
            ...mem,
            swcHelpers.objectSpread({
                sku: variant.sku,
                title,
                isDefault
            }, ((ref = variant.images) === null || ref === void 0 ? void 0 : ref.length) ? {
                image: variant.images[0]
            } : {}, ((ref1 = variant.images) === null || ref1 === void 0 ? void 0 : ref1.length) ? {
                image_v2: variant.images.filter((item)=>item.label === 'rx_configurator_v2'
                )[0]
            } : {}), 
        ];
    };
};
const getVariants = (product, locale)=>{
    const productHasOnlyMasterVariant = !product.variants.length;
    return productHasOnlyMasterVariant ? {} : {
        variants: [
            product.masterVariant,
            ...product.variants
        ].reduce(reduceVariantInfo(locale), [])
    };
};
const getBaseInfo = (product, sku, locale)=>{
    var ref, ref2, ref3, ref4, ref5, ref6, ref7;
    const variant = getActiveVariant$1(product, sku);
    const isMasterVariant = product.masterVariant.sku === variant.sku;
    const productHasOnlyMasterVariant = !product.variants.length;
    let isDefault = false;
    // We only want to consider the "default" value of a master variant if the product doesn't have any variants
    if (isMasterVariant && productHasOnlyMasterVariant) {
        isDefault = getAttrValue(variant, 'default') === true;
    } else if (!isMasterVariant) {
        isDefault = getAttrValue(variant, 'default') === true;
    }
    let rootImage;
    var _images;
    // We always take the root image from the masterVariant
    const [firstMasterImage, secondMasterImage] = (_images = product.masterVariant.images) !== null && _images !== void 0 ? _images : [];
    var _images1;
    const [variantImage] = (_images1 = variant.images) !== null && _images1 !== void 0 ? _images1 : [];
    const image_v2 = (ref = product.masterVariant.images) === null || ref === void 0 ? void 0 : ref.filter((item)=>item.label === 'rx_configurator_v2'
    )[0];
    // If it has variants the second image is the root image
    if (!isMasterVariant) {
        // If the SKU isn't the masterVariant's SKU we're constructing this object for when a variant has been selected
        rootImage = variantImage;
    } else {
        rootImage = productHasOnlyMasterVariant ? firstMasterImage : secondMasterImage;
    }
    const discountDescription = (ref2 = variant.prices) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.discounted) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.discount) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.obj) === null || ref6 === void 0 ? void 0 : ref6.description;
    const discountText = discountDescription ? getLocalizedValue(discountDescription, locale) : undefined;
    // converting the tags[].value to a localized string
    const tags = (ref7 = product.masterVariant.tags) === null || ref7 === void 0 ? void 0 : ref7.map(({ key , value  })=>({
            key,
            value: typeof value === 'string' ? value : value[locale]
        })
    ).filter(({ value  })=>!!value
    );
    return swcHelpers.objectSpread({
        sku,
        title: getLocalizedValue(product.name, locale),
        description: product.description ? getLocalizedValue(product.description, locale) : undefined,
        price: getPrice$2(variant),
        isDefault,
        tags
    }, discountText && {
        discountText
    }, rootImage ? {
        image: rootImage
    } : {}, image_v2 ? {
        image_v2
    } : {});
};
const getUsps$1 = (product, sku, locale)=>{
    const variant = getActiveVariant$1(product, sku);
    return getLocalizedAttrValues(variant, 'prescriptionGlassPackageUsps', locale);
};
const convertToFrameInfo = (product, sku, locale)=>{
    const variant = getActiveVariant$1(product, sku);
    const brand = typeof getAttrValue(variant, 'brand') !== 'object' ? String(getAttrValue(variant, 'brand')) : '';
    const codeAttr = getAttrValue(variant, 'brandModelCode');
    const code = typeof codeAttr === 'string' ? codeAttr : '';
    const title = getLocalizedValue(product.name, locale) || [
        brand,
        code
    ].filter(Boolean).join(' ');
    return {
        brand,
        code,
        price: getPrice$2(variant),
        sku,
        title
    };
};
const convertToLensTypeInfo = (product, sku, locale)=>swcHelpers.objectSpread({}, getBaseInfo(product, sku, locale), getVariants(product, locale))
;
const convertToPackageInfo = (product, sku, locale)=>{
    var ref, ref8;
    const variant = getActiveVariant$1(product, sku);
    var ref9;
    return swcHelpers.objectSpread({}, getBaseInfo(product, sku, locale), {
        usps: getUsps$1(product, sku, locale),
        areAddOnsOptional: (ref9 = (ref8 = (ref = variant.attributes) === null || ref === void 0 ? void 0 : ref.find((a)=>a.name === 'areAddonsOptional'
        )) === null || ref8 === void 0 ? void 0 : ref8.value) !== null && ref9 !== void 0 ? ref9 : true
    });
};
const convertToLensAddOnInfo = (product, sku, locale)=>swcHelpers.objectSpread({}, getBaseInfo(product, sku, locale), getVariants(product, locale))
;
const lowToHigh = (extractPrice)=>(left, right)=>{
        return (extractPrice(left) || 0) - (extractPrice(right) || 0);
    }
;

const stateProp$1 = (s)=>s
;
const configuratorIdProp$1 = (_, { id  })=>id
;
const frameSkuProp = (_, { frameSku  })=>frameSku
;
const lensTypeSkuProp = (_, { lensTypeSku  })=>lensTypeSku
;
const packageSkuProp = (_, { packageSku  })=>packageSku
;
const addOnSkuProp = (_, { addOnSku  })=>addOnSku
;
const getPrescriptionGlasses = (state)=>state.prescriptionGlasses
;
createSelector(getPrescriptionGlasses, (pg)=>pg.prescription
);

const getProducts = createSelector(getPrescriptionGlasses, (pg)=>pg.products
);
const getFrames = createSelector(getProducts, (p)=>p.frames
);
const getLensTypes$2 = createSelector(getProducts, (p)=>p.lensTypes
);
/**
 * Returns the SKUs of the lens-types that we've already loaded from the server
 */ createSelector(getLensTypes$2, (lensTypes)=>new Set(Object.keys(lensTypes))
);
const getPackages$2 = createSelector(getProducts, (p)=>p.packages
);
createSelector(getPackages$2, (packages)=>new Set(Object.keys(packages))
);
const getFrame = createSelector(getFrames, frameSkuProp, (frames, frameSku)=>frames[frameSku]
);
const getLensType = createSelector(getLensTypes$2, lensTypeSkuProp, (lensTypes, lensTypeSku)=>lensTypes[lensTypeSku]
);
const getPackage = createSelector(getPackages$2, packageSkuProp, (packages, packageSku)=>packages[packageSku]
);
const getAddOns$1 = createSelector(getProducts, (p)=>p.addOns
);
createSelector(getAddOns$1, (addOns)=>new Set(Object.keys(addOns))
);
const getAddOn = createSelector(getAddOns$1, addOnSkuProp, (addOns, addOnSku)=>addOns[addOnSku]
);
const getBundleProductVariants = createSelector(getProducts, (p)=>p.variants
);
/**
 * Whenever a lens type is not a master variant, we need to be able to find its parent lens type
 * to be able to use all of our state infrastructure and helpers in the same way as with a master variant.
 */ const lookupParentLensType = createSelector(getBundleProductVariants, getLensTypes$2, lensTypeSkuProp, (variants, lensTypes, lensTypeSku)=>{
    const masterSku = variants[lensTypeSku];
    if (!masterSku) {
        return undefined;
    }
    return lensTypes[masterSku];
});
/**
 * Whenever a lens add-on is not a master variant, we need to be able to find its parent add-on
 * to be able to use all of our state infrastructure and helpers in the same way as with a master variant.
 */ const lookupParentAddOn = createSelector(getBundleProductVariants, getAddOns$1, addOnSkuProp, (variants, addOns, addOnSku)=>{
    const masterSku = variants[addOnSku];
    if (!masterSku) {
        return undefined;
    }
    return addOns[masterSku];
});

const getBundles = createSelector(getPrescriptionGlasses, (pg)=>pg.bundles
);
/**
 * Frames
 */ const getBundleFrames = createSelector(getBundles, (b)=>b.frames
);
const getBundleFrame = createSelector(getBundleFrames, frameSkuProp, (frames, frameSku)=>frames[frameSku]
);
/**
 * Lens Types
 */ const getBundleLensTypes = createSelector(getBundles, (b)=>b.lensTypes
);
const getBundleLensType = createSelector(getBundleLensTypes, lensTypeSkuProp, (lensTypes, lensTypeSku)=>lensTypes[lensTypeSku]
);
/**
 * Packages
 */ const getBundlePackages = createSelector(getBundles, (b)=>b.packages
);
const getBundlePackage = createSelector(getBundlePackages, packageSkuProp, (packages, packageSku)=>packages[packageSku]
);
/**
 * Add-ons
 */ const getBundleAddOns = createSelector(getBundles, (b)=>b.addOns
);
const convertToParamArray = (o)=>Object.entries(o).map(([name, param])=>({
            name,
            values: param ? param.values : new Set()
        })
    )
;
const getOpticalParameters = createSelector(getBundleFrame, getBundleLensType, (bundle, lensType)=>{
    if (!bundle) {
        return uninitState();
    }
    if (!statusSuccess(lensType)) {
        return lensType;
    }
    return successState([
        ...convertToParamArray(lensType.result.opticalParameters),
        ...convertToParamArray(bundle.opticalParameters), 
    ]);
});

const isDefined = (v)=>typeof v !== 'undefined'
;
const isDefinedAndHasPrice = (v)=>isDefined(v) && isDefined(v.price)
;
/**
 * Checks if the SKU belongs to a master variant. This decides whether the "product" gets
 * its own tile, or that it should be part of a tile as a variant.
 */ const isMasterProduct = (product, sku)=>{
    return (product === null || product === void 0 ? void 0 : product.masterVariant.sku) === sku;
};
/**
 * These are public selectors that are meant to be used from the container components outside of this state dir
 */ const isAnyStillLoading = (resources, skus)=>{
    return [
        ...skus
    ].reduce((isLoading, sku)=>{
        if (isLoading) {
            return isLoading;
        }
        var _sku;
        const resource = (_sku = resources[sku]) !== null && _sku !== void 0 ? _sku : uninitState();
        return statusLoading(resource) || statusUninit(resource);
    }, false);
};
const getLensTypes$1 = createSelector(getBundleFrame, getBundleLensTypes, IntlSelectors.getLocale, (s)=>s
, (bundle, lensTypes, locale, s)=>{
    if (!bundle || !locale) {
        return uninitState();
    }
    const { lensTypeSkus  } = bundle;
    if (isAnyStillLoading(lensTypes, lensTypeSkus)) {
        return loadingState();
    }
    var ref;
    const results = [
        ...lensTypeSkus
    ].map((lensTypeSku)=>{
        const lensType = getLensType(s, {
            lensTypeSku
        });
        if (!lensType) {
            return undefined;
        }
        if (!isMasterProduct(lensType, lensTypeSku)) {
            return undefined;
        }
        return convertToLensTypeInfo(lensType, lensTypeSku, locale);
    }).filter(isDefinedAndHasPrice).sort(lowToHigh((lensType)=>{
        var ref2, ref1;
        return (ref = (ref2 = lensType.price) === null || ref2 === void 0 ? void 0 : ref2.discountedPrice) !== null && ref !== void 0 ? ref : (ref1 = lensType.price) === null || ref1 === void 0 ? void 0 : ref1.originalPrice;
    }));
    return successState(results);
});
const getPackages$1 = createSelector(getBundleLensType, getBundlePackages, IntlSelectors.getLocale, (s)=>s
, (lensType, packages, locale, s)=>{
    if (!lensType || !locale) {
        return uninitState();
    }
    if (!statusSuccess(lensType)) {
        return lensType;
    }
    const { packageSkus  } = lensType.result;
    if (isAnyStillLoading(packages, packageSkus)) {
        return loadingState();
    }
    var ref;
    const results = [
        ...packageSkus
    ].map((packageSku)=>{
        const packageProduct = getPackage(s, {
            packageSku
        });
        if (!packageProduct) {
            return undefined;
        }
        if (!isMasterProduct(packageProduct, packageSku)) {
            return undefined;
        }
        return convertToPackageInfo(packageProduct, packageSku, locale);
    }).filter(isDefinedAndHasPrice).sort(lowToHigh((packageInfo)=>{
        var ref4, ref3;
        return (ref = (ref4 = packageInfo.price) === null || ref4 === void 0 ? void 0 : ref4.discountedPrice) !== null && ref !== void 0 ? ref : (ref3 = packageInfo.price) === null || ref3 === void 0 ? void 0 : ref3.originalPrice;
    }));
    return successState(results);
});
const getLensAddOns = createSelector(getBundlePackage, getBundleAddOns, IntlSelectors.getLocale, (s)=>s
, (bundlePackage, addOns, locale, s)=>{
    if (!bundlePackage || !locale) {
        return uninitState();
    }
    if (!statusSuccess(bundlePackage)) {
        return bundlePackage;
    }
    const { addOnSkus  } = bundlePackage.result;
    if (isAnyStillLoading(addOns, addOnSkus)) {
        return loadingState();
    }
    var ref;
    const results = [
        ...addOnSkus
    ].map((addOnSku)=>{
        const addOnProduct = getAddOn(s, {
            addOnSku
        });
        if (!addOnProduct) {
            return undefined;
        }
        if (!isMasterProduct(addOnProduct, addOnSku)) {
            return undefined;
        }
        return convertToLensAddOnInfo(addOnProduct, addOnSku, locale);
    }).filter(isDefinedAndHasPrice).sort(lowToHigh((addOnInfo)=>{
        var ref6, ref5;
        return (ref = (ref6 = addOnInfo.price) === null || ref6 === void 0 ? void 0 : ref6.discountedPrice) !== null && ref !== void 0 ? ref : (ref5 = addOnInfo.price) === null || ref5 === void 0 ? void 0 : ref5.originalPrice;
    }));
    return successState(results);
});

const add = actions.action('products/prescription-glasses/add-to-cart');
const addSuccess = actions.action('products/prescription-glasses/add-to-cart-success');
const addFailed = actions.action('products/prescription-glasses/add-to-cart-failed', (error)=>({
        error
    })
);

const fetchLensTypes = actions.action('products/prescription-glasses/fetch-lens-types', actions.payload());
const fetchLensTypesSuccess = actions.action('products/prescription-glasses/fetch-lens-types-success', actions.payload());
const fetchLensTypesFailed = actions.action('products/prescription-glasses/fetch-lens-types-failed', actions.payload());
const fetchPackages = actions.action('products/prescription-glasses/fetch-packages', actions.payload());
const fetchPackagesSuccess = actions.action('products/prescription-glasses/fetch-packages-success', actions.payload());
const fetchPackagesFailed = actions.action('products/prescription-glasses/fetch-packages-failed', actions.payload());
const fetchAddOns = actions.action('products/prescription-glasses/fetch-add-ons', actions.payload());
const fetchAddOnsSuccess = actions.action('products/prescription-glasses/fetch-add-ons-success', actions.payload());
const fetchAddOnsFailed = actions.action('products/prescription-glasses/fetch-add-ons-failed', actions.payload());

const selectLensType = actions.action('products/prescription-glasses/select-lens-type', actions.payload());
const selectLensTypeFailed = actions.action('products/prescription-glasses/select-lens-type-failed', actions.payload());
const selectLensTypeSuccess = actions.action('products/prescription-glasses/select-lens-type-success', actions.payload());
const selectPackage = actions.action('products/prescription-glasses/select-package', actions.payload());
const selectPackageFailed = actions.action('products/prescription-glasses/select-package-failed', actions.payload());
const selectPackageSuccess = actions.action('products/prescription-glasses/select-package-success', actions.payload());
const resetSelectedPackage = actions.action('products/prescription-glasses/reset-selected-package', actions.payload());
const selectAddOn = actions.action('products/prescription-glasses/select-add-on', actions.payload());
const selectAddOnFailed = actions.action('products/prescription-glasses/select-add-on-failed', actions.payload());
const selectAddOnSuccess = actions.action('products/prescription-glasses/select-add-on-success', actions.payload());
const resetSelectedAddOn = actions.action('products/prescription-glasses/reset-selected-add-on', actions.payload());
const updateUploadReference = actions.action('products/prescription-glasses/update-upload-reference', actions.payload());
const removeUploadReference = actions.action('products/prescription-glasses/remove-upload-reference', actions.payload());
const updatePrescriptionValue = actions.action('products/prescription-glasses/update-prescription-value', actions.payload());
const updatePrescriptionInfo = actions.action('products/prescription-glasses/update-prescription-info', actions.payload());
const updatePrescriptionType = actions.action('products/prescription-glasses/update-prescription-type', actions.payload());
const updateVerificationAllowed = actions.action('products/prescription-glasses/update-verification-allowed', actions.payload());

const getFileUploadResult = (result)=>{
    if (typeof result === 'string') {
        return result;
    }
    if (!result) {
        return null;
    }
    const key = ('errors' in result ? result.errors[0].code : result.message).toLowerCase();
    const keyToLabelMap = {
        'file-invalid-type': 'file not supported',
        'file-too-large': 'file too large',
        'too-many-files': 'too many files'
    };
    if (key.includes('recaptcha')) {
        return 'upload not possible - recaptcha';
    }
    return keyToLabelMap[key] || null;
};

const fileUploadResult = actions.action('products/prescription-glasses/file-upload-result', (result)=>({
        result: getFileUploadResult(result)
    })
);

const startPrescriptionGlassesConfiguration = actions.action('products/prescription-glasses/start', actions.payload());
actions.action('products/prescription-glasses/next-step');
actions.action('products/prescription-glasses/next-step-success', actions.payload());
actions.action('products/prescription-glasses/next-step-failed', actions.payload());
actions.action('products/prescription-glasses/previous-step');
actions.action('products/prescription-glasses/previous-step-failed', actions.payload());
actions.action('products/prescription-glasses/previous-step-success', actions.payload());

const extractSkus = (attributeName)=>{
    return (variant)=>{
        var ref;
        const attribute = (ref = variant.attributes) === null || ref === void 0 ? void 0 : ref.find((a)=>a.name === attributeName
        );
        if (!attribute) {
            return new Set();
        }
        if (Array.isArray(attribute.value)) {
            return new Set(attribute.value);
        } else if (typeof attribute.value === 'string') {
            return new Set(attribute.value.split(','));
        }
        return new Set();
    };
};
const extractLensTypeSkus = extractSkus('compatibleLensTypeProducts');
const extractPackageSkus = extractSkus('compatiblePackageProducts');
const extractAddOnSkus = extractSkus('compatibleOptionProduct');
const extractOpticalParameters = (variant)=>{
    if (!variant.opticalParameters) {
        return {};
    }
    return Object.entries(variant.opticalParameters).reduce((m, [name, value])=>swcHelpers.objectSpread({}, m, {
            [name]: {
                values: value ? new Set(value.values) : new Set()
            }
        })
    , {});
};
const indexVariantsBySku = (products)=>products.reduce((m, p)=>[
            ...m,
            [
                p.masterVariant.sku,
                p.masterVariant
            ],
            ...p.variants.map((v)=>[
                    v.sku,
                    v
                ]
            ), 
        ]
    , []).filter((v)=>!!v[0]
    ).reduce((acc, [sku, v])=>swcHelpers.objectSpread({}, acc, {
            [sku]: v
        })
    , {})
;
const createStates = (skus, stateCreator)=>[
        ...skus
    ].reduce((acc, sku)=>{
        const state = stateCreator(sku);
        if (!state) {
            return acc;
        }
        return swcHelpers.objectSpread({}, acc, {
            [sku]: state
        });
    }, {})
;
const initialState$5 = {
    lensTypes: {},
    packages: {},
    addOns: {},
    frames: {}
};
const reducer$8 = actions.reducer(initialState$5, /**
   * Initializes a new configuration when necessary
   */ actions.on(startPrescriptionGlassesConfiguration, (s, { payload: { frame , frameSku  }  })=>{
    const variant = getActiveVariant$1(frame, frameSku);
    return swcHelpers.objectSpread({}, s, {
        frames: {
            [frameSku]: {
                lensTypeSkus: extractLensTypeSkus(variant),
                opticalParameters: extractOpticalParameters(frame.masterVariant)
            }
        }
    });
}), actions.on(fetchLensTypes, (s, a)=>swcHelpers.objectSpread({}, s, {
        lensTypes: swcHelpers.objectSpread({}, s.lensTypes, createStates(a.payload.skus, ()=>loadingState()
        ))
    })
), actions.on(fetchLensTypesFailed, (s, a)=>swcHelpers.objectSpread({}, s, {
        lensTypes: swcHelpers.objectSpread({}, s.lensTypes, createStates(a.payload.skus, ()=>failedState(a.payload.error)
        ))
    })
), actions.on(fetchLensTypesSuccess, (s, a)=>{
    const variantLookup = indexVariantsBySku(a.payload.products);
    return swcHelpers.objectSpread({}, s, {
        lensTypes: swcHelpers.objectSpread({}, s.lensTypes, createStates(a.payload.tried, (sku)=>{
            const variant = variantLookup[sku];
            if (!variant) {
                return;
            }
            return successState({
                packageSkus: extractPackageSkus(variant),
                opticalParameters: extractOpticalParameters(variant)
            });
        }), createStates(a.payload.missing, (sku)=>failedState(new Error(`Couldn't find lens type with SKU "${sku}"`))
        ))
    });
}), actions.on(fetchPackages, (s, { payload: { skus  }  })=>swcHelpers.objectSpread({}, s, {
        packages: swcHelpers.objectSpread({}, s.packages, createStates(skus, ()=>loadingState()
        ))
    })
), actions.on(fetchPackagesFailed, (s, a)=>swcHelpers.objectSpread({}, s, {
        packages: swcHelpers.objectSpread({}, s.packages, createStates(a.payload.skus, ()=>failedState(a.payload.error)
        ))
    })
), actions.on(fetchPackagesSuccess, (s, a)=>swcHelpers.objectSpread({}, s, {
        packages: swcHelpers.objectSpread({}, s.packages, createStates(a.payload.tried, (sku)=>{
            const product = a.payload.products.find((p)=>p.masterVariant.sku === sku
            );
            if (!product) {
                return;
            }
            return successState({
                addOnSkus: extractAddOnSkus(product.masterVariant)
            });
        }), createStates(a.payload.missing, (sku)=>failedState(new Error(`Couldn't find package with SKU "${sku}"`))
        ))
    })
), actions.on(fetchAddOns, (s, { payload: { skus  }  })=>swcHelpers.objectSpread({}, s, {
        addOns: swcHelpers.objectSpread({}, s.addOns, createStates(skus, ()=>loadingState()
        ))
    })
), actions.on(fetchAddOnsFailed, (s, a)=>swcHelpers.objectSpread({}, s, {
        addOns: swcHelpers.objectSpread({}, s.addOns, createStates(a.payload.skus, ()=>failedState(a.payload.error)
        ))
    })
), actions.on(fetchAddOnsSuccess, (s, a)=>swcHelpers.objectSpread({}, s, {
        addOns: swcHelpers.objectSpread({}, s.addOns, createStates(a.payload.tried, ()=>successState(undefined)
        ), createStates(a.payload.missing, (sku)=>failedState(new Error(`Couldn't find add-on with SKU "${sku}"`))
        ))
    })
));

const RX_SCOPE = 'pg-prescription';
const PD_SCOPE = 'pg-pupillary-distance';
const PRESCRIPTION_STEP_FORM_ERROR_ID = 'prescription-step-form-error';
const PRESCRIPTION_STEP_UPLOAD_ERROR_ID = 'prescription-step-upload-error';
const PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID = 'prescription-step-upload-description';

const isPrescriptionValue = (value)=>typeof value === 'number'
;
const BOOK_APPOINTMENT = 'book-appointment';
function isBookAppointmentEntrySelection(prescription) {
    return prescription === BOOK_APPOINTMENT;
}

const defaultState$1 = Object.freeze({
    left: {},
    right: {}
});

const getConfiguration$1 = createSelector(getPrescriptionGlasses, frameSkuProp, (pg, frameSku)=>pg.configurations[frameSku]
);
const getLensTypeSku = createSelector(getConfiguration$1, (config)=>{
    var ref1;
    return config === null || config === void 0 ? void 0 : (ref1 = config.lensType) === null || ref1 === void 0 ? void 0 : ref1.sku;
});
const getPackageSku = createSelector(getConfiguration$1, (config)=>{
    return config === null || config === void 0 ? void 0 : config.package;
});
const getAddOnSku = createSelector(getConfiguration$1, (config)=>{
    return config === null || config === void 0 ? void 0 : config.addOn;
});
var ref$6;
const getPrescription$4 = createSelector(getConfiguration$1, (c)=>{
    var ref2;
    return (ref$6 = c === null || c === void 0 ? void 0 : (ref2 = c.lensType) === null || ref2 === void 0 ? void 0 : ref2.prescriptionInfo) !== null && ref$6 !== void 0 ? ref$6 : defaultState$1;
});

const getPrescriptionType$2 = createSelector(getConfiguration$1, (c)=>{
    return c === null || c === void 0 ? void 0 : c.prescriptionType;
});
/**
 * The currently selected lens-type product for the given frame SKU
 */ const getSelectedLensType$1 = createSelector(getLensTypeSku, IntlSelectors.getLocale, (s)=>s
, (lensTypeSku, locale, state)=>{
    if (!lensTypeSku || !locale) {
        return undefined;
    }
    const lensTypeProduct = lookupParentLensType(state, {
        lensTypeSku
    });
    if (!lensTypeProduct) {
        return undefined;
    }
    return convertToLensTypeInfo(lensTypeProduct, lensTypeSku, locale);
});
/**
 * The currently selected package product for the given frame SKU
 */ const getSelectedPackage$1 = createSelector(getPackageSku, IntlSelectors.getLocale, (s)=>s
, (packageSku, locale, state)=>{
    if (!packageSku || !locale) {
        return undefined;
    }
    const packageProduct = getPackage(state, {
        packageSku
    });
    if (!packageProduct) {
        return undefined;
    }
    return convertToPackageInfo(packageProduct, packageSku, locale);
});
/**
 * The currently selected add-on product for the given frame SKU
 */ const getSelectedAddOn$1 = createSelector(getAddOnSku, IntlSelectors.getLocale, (s)=>s
, (addOnSku, locale, state)=>{
    if (!addOnSku || !locale) {
        return;
    }
    const addOnProduct = lookupParentAddOn(state, {
        addOnSku
    });
    if (!addOnProduct) {
        return undefined;
    }
    return convertToLensAddOnInfo(addOnProduct, addOnSku, locale);
});
/**
 * The prescription parameter values as entered on the current frame / lens
 */ const getPrescription$3 = createSelector(getPrescription$4, getLensTypeSku, getOpticalParameters, (prescription, lensTypeSku, parameters)=>{
    if (!lensTypeSku) {
        return uninitState();
    }
    if (!statusSuccess(parameters)) {
        return parameters;
    }
    return successState(swcHelpers.objectSpread({
        parameters: parameters.result
    }, prescription, {
        uploadReferences: prescription.uploadReferences || {}
    }));
});
var _additionalInfo;
/**
 * The prescription info as entered on the current frame / lens
 */ const getAdditionalPrescriptionInfoFormState$1 = createSelector(getPrescription$4, (prescription)=>(_additionalInfo = prescription.additionalInfo) !== null && _additionalInfo !== void 0 ? _additionalInfo : {}
);
// Returns the values in b that aren't present in a
const diff = (a, b)=>new Set([
        ...b
    ].filter((i)=>!a.has(i)
    ))
;
/**
 * Get the validation state of the currently selected lens-type for the given frameSku
 */ const getManualPrescriptionValidationState$1 = createSelector(getPrescription$4, getLensTypeSku, getOpticalParameters, (prescription, lensTypeSku, parameters)=>{
    if (!lensTypeSku) {
        return undefined;
    }
    if (!statusSuccess(parameters)) {
        return undefined;
    }
    const parameterNames = new Set(parameters.result.map((p)=>p.name
    ));
    const leftHasExtra = diff(parameterNames, Object.keys(prescription.left)).size > 0;
    const rightHasExtra = diff(parameterNames, Object.keys(prescription.right)).size > 0;
    const initialValidationState = {
        isValid: !leftHasExtra && !rightHasExtra,
        left: {
            isValid: !leftHasExtra
        },
        right: {
            isValid: !rightHasExtra
        }
    };
    return parameters.result.reduce((acc, param)=>{
        const leftValue = prescription.left[param.name];
        const rightValue = prescription.right[param.name];
        const isLeftValid = isPrescriptionValue(leftValue) && param.values.has(leftValue);
        const isRightValid = isPrescriptionValue(rightValue) && param.values.has(rightValue);
        const left = swcHelpers.objectSpread({}, acc.left, {
            isValid: acc.left.isValid && isLeftValid,
            [param.name]: isLeftValid
        });
        const right = swcHelpers.objectSpread({}, acc.right, {
            isValid: acc.right.isValid && isRightValid,
            [param.name]: isRightValid
        });
        return {
            isValid: acc.isValid && left.isValid && right.isValid,
            left,
            right
        };
    }, initialValidationState);
});
const getPrescriptionUploadValidationState = createSelector(getPrescription$4, getLensTypeSku, (prescription, lensTypeSku)=>{
    var ref2, ref1;
    if (!lensTypeSku) {
        return undefined;
    }
    const { uploadReferences  } = prescription;
    const hasUploadedRx = !!((ref2 = (uploadReferences || {})[RX_SCOPE]) === null || ref2 === void 0 ? void 0 : ref2.storageToken);
    const hasUploadedPd = !!((ref1 = (uploadReferences || {})[PD_SCOPE]) === null || ref1 === void 0 ? void 0 : ref1.storageToken);
    return {
        isValid: hasUploadedRx && hasUploadedPd,
        [RX_SCOPE]: {
            isValid: hasUploadedRx
        },
        [PD_SCOPE]: {
            isValid: hasUploadedPd
        }
    };
});
var ref$5;
const getVerificationAllowed$1 = createSelector(getPrescription$4, (c)=>{
    return (ref$5 = c === null || c === void 0 ? void 0 : c.verificationAllowed) !== null && ref$5 !== void 0 ? ref$5 : false;
});

const getPrescriptionType$1 = (s, frameSku)=>{
    var ref;
    return ((ref = s[frameSku]) === null || ref === void 0 ? void 0 : ref.prescriptionType) || 'NewPrescription';
};
var reducer$7 = actions.reducer({}, /**
   * Create a blank configuration but only on the first call
   */ actions.on(startPrescriptionGlassesConfiguration, (s, { payload: { frameSku , preselectedPrescriptionEntry  }  })=>{
    if (frameSku in s) {
        return s;
    }
    return swcHelpers.objectSpread({}, s, {
        [frameSku]: {
            prescriptionType: preselectedPrescriptionEntry || 'NewPrescription'
        }
    });
}), /**
   * Changes the selected lens type. If no prescriptionPrefill is passed along we reset the prescription data
   */ actions.on(selectLensTypeSuccess, (s, { payload  })=>{
    var ref;
    const currentLensType = (ref = s[payload.frameSku]) === null || ref === void 0 ? void 0 : ref.lensType;
    if ((currentLensType === null || currentLensType === void 0 ? void 0 : currentLensType.sku) === payload.lensTypeSku) {
        // Don't do anything if we're reselecting the same SKU
        return s;
    }
    var ref1, _prescriptionPrefill;
    return swcHelpers.objectSpread({}, s, {
        [payload.frameSku]: swcHelpers.objectSpread({}, s[payload.frameSku], {
            prescriptionType: getPrescriptionType$1(s, payload.frameSku),
            lensType: {
                sku: payload.lensTypeSku,
                prescriptionInfo: swcHelpers.objectSpread({}, (ref1 = currentLensType === null || currentLensType === void 0 ? void 0 : currentLensType.prescriptionInfo) !== null && ref1 !== void 0 ? ref1 : {
                    uploadReferences: {}
                }, (_prescriptionPrefill = payload.prescriptionPrefill) !== null && _prescriptionPrefill !== void 0 ? _prescriptionPrefill : {
                    left: {},
                    right: {}
                })
            }
        })
    });
}), /**
   * Changes the selected package for the given frameSku
   */ actions.on(selectPackageSuccess, (s, { payload: { frameSku , packageSku  }  })=>{
    const frameConfig = s[frameSku];
    if ((frameConfig === null || frameConfig === void 0 ? void 0 : frameConfig.package) === packageSku) {
        return s;
    }
    return swcHelpers.objectSpread({}, s, {
        [frameSku]: swcHelpers.objectSpread({}, s[frameSku], {
            prescriptionType: getPrescriptionType$1(s, frameSku),
            package: packageSku
        })
    });
}), /**
   * This is used for when there's a package selected that isn't compatible with the current lens-type
   */ actions.on(resetSelectedPackage, (s, { payload: { frameSku  }  })=>swcHelpers.objectSpread({}, s, {
        [frameSku]: swcHelpers.objectSpread({}, s[frameSku], {
            prescriptionType: getPrescriptionType$1(s, frameSku),
            package: undefined
        })
    })
), /**
   * Changes the selected add-on for the given frameSku
   */ actions.on(selectAddOnSuccess, (s, { payload: { frameSku , addOnSku  }  })=>{
    const frameConfig = s[frameSku];
    if ((frameConfig === null || frameConfig === void 0 ? void 0 : frameConfig.addOn) === addOnSku) {
        return s;
    }
    return swcHelpers.objectSpread({}, s, {
        [frameSku]: swcHelpers.objectSpread({}, s[frameSku], {
            prescriptionType: getPrescriptionType$1(s, frameSku),
            addOn: addOnSku
        })
    });
}), /**
   * This is used for when there's a add-on selected that isn't compatible with the current package
   */ actions.on(resetSelectedAddOn, (s, { payload: { frameSku  }  })=>swcHelpers.objectSpread({}, s, {
        [frameSku]: swcHelpers.objectSpread({}, s[frameSku], {
            prescriptionType: getPrescriptionType$1(s, frameSku),
            addOn: undefined
        })
    })
), /**
   * Changes the prescription parameters' value for the given frameSku
   */ actions.on(updatePrescriptionValue, (s, { payload  })=>{
    var ref;
    const currentLensType = (ref = s[payload.frameSku]) === null || ref === void 0 ? void 0 : ref.lensType;
    if (!currentLensType) {
        return s;
    }
    const currentSide = currentLensType.prescriptionInfo[payload.side];
    if (currentSide[payload.parameter] === payload.value) {
        return s;
    }
    return swcHelpers.objectSpread({}, s, {
        [payload.frameSku]: swcHelpers.objectSpread({}, s[payload.frameSku], {
            prescriptionType: getPrescriptionType$1(s, payload.frameSku),
            lensType: swcHelpers.objectSpread({}, currentLensType, {
                prescriptionInfo: swcHelpers.objectSpread({}, currentLensType.prescriptionInfo, {
                    [payload.side]: swcHelpers.objectSpread({}, currentSide, {
                        [payload.parameter]: payload.value
                    })
                })
            })
        })
    });
}), /**
   * Changes the prescription info for the given frameSku
   */ actions.on(updatePrescriptionInfo, (s, { payload  })=>{
    var ref, ref2;
    const currentLensType = (ref = s[payload.frameSku]) === null || ref === void 0 ? void 0 : ref.lensType;
    if (!currentLensType) {
        return s;
    }
    return swcHelpers.objectSpread({}, s, {
        [payload.frameSku]: swcHelpers.objectSpread({}, s[payload.frameSku], {
            prescriptionType: ((ref2 = s[payload.frameSku]) === null || ref2 === void 0 ? void 0 : ref2.prescriptionType) || 'NewPrescription',
            lensType: swcHelpers.objectSpread({}, currentLensType, {
                prescriptionInfo: swcHelpers.objectSpread({}, currentLensType.prescriptionInfo, {
                    additionalInfo: payload.value
                })
            })
        })
    });
}), /**
   * Changes the type of prescription, i.e. existing, email upload, manual input, etc...
   */ actions.on(updatePrescriptionType, (s, { payload  })=>{
    return swcHelpers.objectSpread({}, s, {
        [payload.frameSku]: swcHelpers.objectSpread({}, s[payload.frameSku], {
            prescriptionType: payload.prescriptionType
        })
    });
}), /**
   * Changes the verification allowed info for the given frameSku
   */ actions.on(updateVerificationAllowed, (s, { payload  })=>{
    var ref;
    const currentLensType = (ref = s[payload.frameSku]) === null || ref === void 0 ? void 0 : ref.lensType;
    if (!currentLensType) {
        return s;
    }
    return swcHelpers.objectSpread({}, s, {
        [payload.frameSku]: swcHelpers.objectSpread({}, s[payload.frameSku], {
            prescriptionType: getPrescriptionType$1(s, payload.frameSku),
            lensType: swcHelpers.objectSpread({}, currentLensType, {
                prescriptionInfo: swcHelpers.objectSpread({}, currentLensType.prescriptionInfo, {
                    verificationAllowed: payload.value
                })
            })
        })
    });
}), actions.on(updateUploadReference, (s, { payload  })=>{
    var ref;
    const currentLensType = (ref = s[payload.frameSku]) === null || ref === void 0 ? void 0 : ref.lensType;
    if (!currentLensType) {
        return s;
    }
    return swcHelpers.objectSpread({}, s, {
        [payload.frameSku]: swcHelpers.objectSpread({}, s[payload.frameSku], {
            prescriptionType: getPrescriptionType$1(s, payload.frameSku),
            lensType: swcHelpers.objectSpread({}, currentLensType, {
                prescriptionInfo: swcHelpers.objectSpread({}, currentLensType.prescriptionInfo, {
                    uploadReferences: swcHelpers.objectSpread({}, currentLensType.prescriptionInfo.uploadReferences, {
                        [payload.scope]: payload.uploadReference
                    })
                })
            })
        })
    });
}), actions.on(removeUploadReference, (s, { payload  })=>{
    var ref;
    const currentLensType = (ref = s[payload.frameSku]) === null || ref === void 0 ? void 0 : ref.lensType;
    if (!currentLensType) {
        return s;
    }
    const currentUploadReferences = currentLensType.prescriptionInfo.uploadReferences;
    const _ref = currentUploadReferences || {}, _scope = payload.scope, remainingScopes = swcHelpers.objectWithoutProperties(_ref, [
        _scope
    ].map(swcHelpers.toPropertyKey));
    return swcHelpers.objectSpread({}, s, {
        [payload.frameSku]: swcHelpers.objectSpread({}, s[payload.frameSku], {
            prescriptionType: getPrescriptionType$1(s, payload.frameSku),
            lensType: swcHelpers.objectSpread({}, currentLensType, {
                prescriptionInfo: swcHelpers.objectSpread({}, currentLensType.prescriptionInfo, {
                    uploadReferences: remainingScopes
                })
            })
        })
    });
}));

const getProductImageData = (product, sku, width, staticsUrl, isBynderImagesEnabled)=>{
    var ref, ref1;
    const variant = getActiveVariant$1(product, sku);
    const ctImage = ((ref = variant.images) === null || ref === void 0 ? void 0 : ref.length) ? variant.images[0] : undefined;
    const ctHeight = (ctImage === null || ctImage === void 0 ? void 0 : ctImage.dimensions.h) || 0;
    const ctWidth = (ctImage === null || ctImage === void 0 ? void 0 : ctImage.dimensions.w) || 0;
    // Need to guess an aspect ratio as a fallback
    const aspectRatio = ctHeight > 0 && ctWidth > 0 ? ctHeight / ctWidth : 0.6;
    const calculatedHeight = Math.floor(width * aspectRatio);
    const calculatedWidth = Math.floor(width);
    if (isBynderImagesEnabled) {
        var ref2;
        const image = getFrontImage((ref2 = variant.media) === null || ref2 === void 0 ? void 0 : ref2.images);
        return {
            url: `${image.url}?w=${calculatedWidth}&fm=jpeg&auto=format`,
            dimensions: image.dimensions
        };
    }
    if (!((ref1 = variant.images) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        return undefined;
    }
    return {
        url: `${staticsUrl}${variant.images[0].url}?w=${calculatedWidth}&fm=jpeg&auto=format`,
        dimensions: {
            h: calculatedHeight,
            w: calculatedWidth
        }
    };
};

const frameImageProps = (_, props)=>props
;
const getFrameImage$1 = createSelector(getFrame, frameSkuProp, frameImageProps, (frame, frameSku, frameImageProps1)=>{
    if (!frame) {
        return undefined;
    }
    const { width , staticsUrl , isBynderImagesEnabled  } = frameImageProps1;
    return getProductImageData(frame, frameSku, width, staticsUrl, isBynderImagesEnabled);
});

const getConfigurator$1 = createSelector(getPrescriptionGlasses, (pg)=>pg.configurator
);

/**
 * Exported selectors to be used in container components
 */ const getIsExtraValidationStepEnabled = createSelector(getConfigurator$1, (c)=>c.isExtraValidationStepEnabled
);
const getRxEntryTypes = createSelector(getConfigurator$1, (c)=>c.rxEntryTypes
);
const getRoutes = createSelector(getConfigurator$1, (c)=>c.routes
);
const getFrameSku = createSelector(getConfigurator$1, (c)=>{
    return c === null || c === void 0 ? void 0 : c.frameSku;
});
const getFrameImage = createSelector(getFrameSku, (s)=>s
, (_, props)=>props
, (frameSku, state, frameImageProps)=>{
    if (!frameSku) {
        return undefined;
    }
    const { width , staticsUrl , isBynderImagesEnabled  } = frameImageProps;
    return getFrameImage$1(state, {
        frameSku,
        width,
        staticsUrl,
        isBynderImagesEnabled
    });
});
/**
 * Returns the FrameInfo of the frame that's currently being configured
 */ const getSelectedFrame = createSelector(getFrameSku, getFrames, IntlSelectors.getLocale, (frameSku, frames, locale)=>{
    if (!frameSku || !locale) {
        return undefined;
    }
    const frame = frames[frameSku];
    if (!frame) {
        return undefined;
    }
    return convertToFrameInfo(frame, frameSku, locale);
});
const getSelectedFrameProductType = createSelector(getFrameSku, getFrames, (frameSku, frames)=>{
    var ref1;
    if (!frameSku) {
        return;
    }
    const frame = frames[frameSku];
    if (!frame) {
        return;
    }
    return (ref1 = frame.productType.obj) === null || ref1 === void 0 ? void 0 : ref1.name;
});
/**
 * Get the prescription type enum value
 */ const getPrescriptionType = createSelector(getFrameSku, (s)=>s
, (frameSku, state)=>{
    if (!frameSku) {
        return undefined;
    }
    return getPrescriptionType$2(state, {
        frameSku
    });
});
/**
 * The currently selected lens-type product the frame that's being configured
 */ const getSelectedLensType = createSelector(getFrameSku, (s)=>s
, (frameSku, state)=>{
    if (!frameSku) {
        return undefined;
    }
    return getSelectedLensType$1(state, {
        frameSku
    });
});
/**
 * Returns the available lens-types for the frame that's currently being configured
 */ const getLensTypes = createSelector(getFrameSku, (s)=>s
, (frameSku, state)=>{
    if (!frameSku) {
        return uninitState();
    }
    return getLensTypes$1(state, {
        frameSku
    });
});
/**
 * The currently selected package product for the frame that's being configured
 */ const getSelectedPackage = createSelector(getFrameSku, (s)=>s
, (frameSku, state)=>{
    if (!frameSku) {
        return undefined;
    }
    return getSelectedPackage$1(state, {
        frameSku
    });
});
const getPackages = createSelector(getFrameSku, (s)=>s
, (frameSku, state)=>{
    if (!frameSku) {
        return uninitState();
    }
    const lensTypeSku = getLensTypeSku(state, {
        frameSku
    });
    if (!lensTypeSku) {
        return uninitState();
    }
    return getPackages$1(state, {
        lensTypeSku
    });
});
/**
 * The currently selected add-on product for the frame that's being configured
 */ const getSelectedAddOn = createSelector(getFrameSku, (s)=>s
, (frameSku, state)=>{
    if (!frameSku) {
        return undefined;
    }
    return getSelectedAddOn$1(state, {
        frameSku
    });
});
const getAddOns = createSelector(getFrameSku, (s)=>s
, (frameSku, state)=>{
    if (!frameSku) {
        return uninitState();
    }
    const packageSku = getPackageSku(state, {
        frameSku
    });
    const lensTypeSku = getLensTypeSku(state, {
        frameSku
    });
    if (!lensTypeSku || !packageSku) {
        return uninitState();
    }
    return getLensAddOns(state, {
        packageSku
    });
});
/**
 * The prescription parameter values as entered on the current frame / lens
 */ const getPrescription$2 = createSelector(getFrameSku, (s)=>s
, (frameSku, state)=>{
    if (!frameSku) {
        return uninitState();
    }
    const lensTypeSku = getLensTypeSku(state, {
        frameSku
    });
    if (!lensTypeSku) {
        return uninitState();
    }
    return getPrescription$3(state, {
        frameSku,
        lensTypeSku
    });
});
/**
 * The prescription info as entered on the current frame / lens
 */ const getAdditionalPrescriptionInfoFormState = createSelector(getFrameSku, (s)=>s
, (frameSku, state)=>{
    if (!frameSku) {
        return {};
    }
    return getAdditionalPrescriptionInfoFormState$1(state, {
        frameSku
    });
});
/**
 * Get the validation state of the manual prescription form
 */ const getManualPrescriptionValidationState = createSelector(getFrameSku, (s)=>s
, (frameSku, state)=>{
    if (!frameSku) {
        return undefined;
    }
    const lensTypeSku = getLensTypeSku(state, {
        frameSku
    });
    if (!lensTypeSku) {
        return undefined;
    }
    return getManualPrescriptionValidationState$1(state, {
        frameSku,
        lensTypeSku
    });
});
/**
 * Get the validation state of the Prescription Step,
 * considering the currently selected prescriptionType
 */ const getIsPrescriptionStepValid = createSelector(getFrameSku, getPrescriptionType, (s)=>s
, (frameSku, prescriptionType, state)=>{
    if (!frameSku) {
        return undefined;
    }
    if (CommerceToolsApi.isPrescriptionFile(prescriptionType)) {
        var ref3;
        return (ref3 = getPrescriptionUploadValidationState(state, {
            frameSku
        })) === null || ref3 === void 0 ? void 0 : ref3.isValid;
    }
    if (CommerceToolsApi.isNewPrescription(prescriptionType)) {
        var ref2;
        return (ref2 = getManualPrescriptionValidationState(state)) === null || ref2 === void 0 ? void 0 : ref2.isValid;
    }
    return undefined;
});
/**
 * Step related selectors
 */ const hasVisitedStepPrescription = createSelector((s)=>s
, configuratorIdProp$1, (s, id)=>Selectors.hasVisitedStep(s, {
        id,
        stepName: 'prescription'
    })
);
const hasVisitedStepLensPackage = createSelector((s)=>s
, configuratorIdProp$1, (s, id)=>Selectors.hasVisitedStep(s, {
        id,
        stepName: 'lensPackage'
    })
);
const hasVisitedStepAddOn = createSelector((s)=>s
, configuratorIdProp$1, (s, id)=>Selectors.hasVisitedStep(s, {
        id,
        stepName: 'lensAddOn'
    })
);
/**
 * Calculates the total price and total discounted price for the current configuration
 */ const getBundlePrice = createSelector(getSelectedFrame, getSelectedLensType, getSelectedPackage, hasVisitedStepLensPackage, getSelectedAddOn, hasVisitedStepAddOn, (frame, lensType, lensPackage, hasVisitedStepLensPackage1, addOn, hasVisitedStepAddOn1)=>{
    var ref25, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    if (!frame || !frame.price) {
        return undefined;
    }
    var ref15, ref16, ref17;
    const bundlePrices = [
        frame.price.originalPrice,
        (ref15 = lensType === null || lensType === void 0 ? void 0 : (ref25 = lensType.price) === null || ref25 === void 0 ? void 0 : ref25.originalPrice) !== null && ref15 !== void 0 ? ref15 : 0,
        hasVisitedStepLensPackage1 ? (ref16 = lensPackage === null || lensPackage === void 0 ? void 0 : (ref4 = lensPackage.price) === null || ref4 === void 0 ? void 0 : ref4.originalPrice) !== null && ref16 !== void 0 ? ref16 : 0 : 0,
        hasVisitedStepAddOn1 ? (ref17 = addOn === null || addOn === void 0 ? void 0 : (ref5 = addOn.price) === null || ref5 === void 0 ? void 0 : ref5.originalPrice) !== null && ref17 !== void 0 ? ref17 : 0 : 0, 
    ];
    const originalPrice = bundlePrices.reduce((sum, current)=>sum + current
    , 0);
    const hasDiscounts = [
        frame.price.discountedPrice,
        lensType === null || lensType === void 0 ? void 0 : (ref6 = lensType.price) === null || ref6 === void 0 ? void 0 : ref6.discountedPrice,
        hasVisitedStepLensPackage1 && (lensPackage === null || lensPackage === void 0 ? void 0 : (ref7 = lensPackage.price) === null || ref7 === void 0 ? void 0 : ref7.discountedPrice),
        hasVisitedStepAddOn1 && (addOn === null || addOn === void 0 ? void 0 : (ref8 = addOn.price) === null || ref8 === void 0 ? void 0 : ref8.discountedPrice), 
    ].filter((p)=>typeof p === 'number' && !isNaN(p)
    ).length > 0;
    var _discountedPrice, ref18, ref19, ref20, ref21, ref22, ref23, ref24;
    const bundlePricesDiscounted = hasDiscounts ? [
        (ref18 = (_discountedPrice = frame.price.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : frame.price.originalPrice) !== null && ref18 !== void 0 ? ref18 : 0,
        (ref20 = (ref19 = lensType === null || lensType === void 0 ? void 0 : (ref9 = lensType.price) === null || ref9 === void 0 ? void 0 : ref9.discountedPrice) !== null && ref19 !== void 0 ? ref19 : lensType === null || lensType === void 0 ? void 0 : (ref10 = lensType.price) === null || ref10 === void 0 ? void 0 : ref10.originalPrice) !== null && ref20 !== void 0 ? ref20 : 0,
        hasVisitedStepLensPackage1 ? (ref22 = (ref21 = lensPackage === null || lensPackage === void 0 ? void 0 : (ref11 = lensPackage.price) === null || ref11 === void 0 ? void 0 : ref11.discountedPrice) !== null && ref21 !== void 0 ? ref21 : lensPackage === null || lensPackage === void 0 ? void 0 : (ref12 = lensPackage.price) === null || ref12 === void 0 ? void 0 : ref12.originalPrice) !== null && ref22 !== void 0 ? ref22 : 0 : 0,
        hasVisitedStepAddOn1 ? (ref24 = (ref23 = addOn === null || addOn === void 0 ? void 0 : (ref13 = addOn.price) === null || ref13 === void 0 ? void 0 : ref13.discountedPrice) !== null && ref23 !== void 0 ? ref23 : addOn === null || addOn === void 0 ? void 0 : (ref14 = addOn.price) === null || ref14 === void 0 ? void 0 : ref14.originalPrice) !== null && ref24 !== void 0 ? ref24 : 0 : 0, 
    ] : [];
    const discountedPrice = hasDiscounts ? bundlePricesDiscounted.reduce((sum, current)=>sum + current
    , 0) : undefined;
    return {
        originalPrice,
        discountedPrice,
        currency: frame.price.currency
    };
});
createSelector(getConfigurator$1, (c)=>c.formatProductUrl
);
const getVerificationAllowed = createSelector(getFrameSku, (s)=>s
, (frameSku, state)=>{
    if (!frameSku) {
        return undefined;
    }
    return getVerificationAllowed$1(state, {
        frameSku
    });
});
var ref$4;
/**
 * Returns a boolean whether the currently selected package allows add ons to be optional
 * The default value is always `true` unless it is specifically set to `false` in the product data
 */ const getAreAddOnsOptional = createSelector(getSelectedPackage, (p)=>{
    return (ref$4 = p === null || p === void 0 ? void 0 : p.areAddOnsOptional) !== null && ref$4 !== void 0 ? ref$4 : true;
});
const getUsps = createSelector(getConfigurator$1, ({ usps  })=>usps || []
);

const initialState$4 = {};
const reducer$6 = actions.reducer(initialState$4, /**
   * Set the correct frameSku and always reset the configurator to the initial state
   */ actions.on(startPrescriptionGlassesConfiguration, (s, { payload: { frameSku , formatProductUrl , isExtraValidationStepEnabled , usps , rxEntryTypes , routes ,  } ,  })=>{
    return swcHelpers.objectSpread({}, initialState$4, {
        frameSku,
        formatProductUrl,
        isExtraValidationStepEnabled,
        usps,
        rxEntryTypes,
        routes
    });
}));

var reducer$5 = actions.reducer(defaultState$1, actions.on(updatePrescriptionValue, (s, { payload  })=>swcHelpers.objectSpread({}, s, {
        [payload.side]: swcHelpers.objectSpread({}, s[payload.side], {
            [payload.parameter]: payload.value
        })
    })
), actions.on(updateUploadReference, (s, { payload  })=>swcHelpers.objectSpread({}, s, {
        uploadReferences: swcHelpers.objectSpread({}, s.uploadReferences || {}, {
            [payload.scope]: payload.uploadReference
        })
    })
), actions.on(removeUploadReference, (s, { payload  })=>{
    const _ref = s.uploadReferences || {}, _scope = payload.scope, remainingScopes = swcHelpers.objectWithoutProperties(_ref, [
        _scope
    ].map(swcHelpers.toPropertyKey));
    return swcHelpers.objectSpread({}, s, {
        uploadReferences: remainingScopes
    });
}), /**
   * Changes the prescription expiry date for the given frameSku
   */ actions.on(updatePrescriptionInfo, (s, { payload  })=>{
    return swcHelpers.objectSpread({}, s, {
        additionalInfo: payload.value
    });
}));

const indexBySku = (m, p)=>{
    if (!p.masterVariant.sku) {
        return m;
    }
    return swcHelpers.objectSpread({}, m, {
        [p.masterVariant.sku]: p
    });
};
const reduceProducts = (products)=>products.reduce(indexBySku, {})
;
const initialState$3 = {
    frames: {},
    lensTypes: {},
    variants: {},
    packages: {},
    addOns: {}
};
const reduceVariant = (masterSku)=>(m, variant)=>{
        if (!variant.sku || !variant.isMatchingVariant) {
            return m;
        }
        return swcHelpers.objectSpread({}, m, {
            [variant.sku]: masterSku
        });
    }
;
const indexAllVariantsBySKU = (m, product)=>{
    const { sku: masterSku  } = product.masterVariant;
    if (!masterSku) {
        return m;
    }
    return swcHelpers.objectSpread({}, m, {
        // We also record a reference for the masterVariant to make lookups simpler
        [masterSku]: masterSku
    }, product.variants.reduce(reduceVariant(masterSku), {}));
};
const addToLookup = (s, products)=>swcHelpers.objectSpread({}, s.variants, products.reduce(indexAllVariantsBySKU, {}))
;
const reducer$4 = actions.reducer(initialState$3, actions.on(fetchLensTypesSuccess, (s, { payload: { products  }  })=>swcHelpers.objectSpread({}, s, {
        lensTypes: swcHelpers.objectSpread({}, s.lensTypes, reduceProducts(products)),
        variants: addToLookup(s, products)
    })
), actions.on(fetchPackagesSuccess, (s, { payload: { products  }  })=>swcHelpers.objectSpread({}, s, {
        packages: swcHelpers.objectSpread({}, s.packages, reduceProducts(products))
    })
), actions.on(fetchAddOnsSuccess, (s, { payload: { products  }  })=>swcHelpers.objectSpread({}, s, {
        addOns: swcHelpers.objectSpread({}, s.addOns, reduceProducts(products)),
        variants: addToLookup(s, products)
    })
), actions.on(startPrescriptionGlassesConfiguration, (s, { payload: { frame , frameSku  }  })=>swcHelpers.objectSpread({}, s, {
        frames: swcHelpers.objectSpread({}, s.frames, {
            [frameSku]: frame
        })
    })
));

const getConfig = (key)=>({
        storage: sessionStorage,
        key
    })
;
var prescriptionGlassesReducer = combineReducers({
    bundles: reducer$8,
    configurations: persistReducer(getConfig('grandvision_pg_configurations'), reducer$7),
    prescription: persistReducer(getConfig('grandvision_pg_prescription'), reducer$5),
    products: reducer$4,
    configurator: reducer$6
});

const defined = (v)=>typeof v !== 'undefined'
;
function* fetchBundleProducts(productType, skus1) {
    if (!skus1.size) {
        return {
            products: [],
            tried: skus1,
            missing: new Set()
        };
    }
    const config = yield select(ApiConfigSelectors.getApiConfig);
    assertApiConfig(config);
    const { results  } = yield call(Products.query, config.productsUrl, {
        expand: [
            'masterVariant.prices[*].discounted.discount',
            'variants[*].prices[*].discounted.discount', 
        ],
        filters: [
            `variants.sku:${encodeURIComponent([
                ...skus1
            ].map((id)=>`"${id}"`
            ).join(','))}`
        ]
    });
    const fetchedSkus = new Set(results.reduce((skus, p)=>[
            ...skus,
            p.masterVariant.sku,
            ...(p.variants || []).map((v)=>v.sku
            )
        ]
    , []).filter(defined));
    const missing = new Set([
        ...skus1
    ].filter((s)=>!fetchedSkus.has(s)
    ));
    return {
        products: results,
        tried: skus1,
        missing
    };
}
/**
 * Lens Types
 */ function* ensureLensTypesAreLoaded({ payload: { frameSku  }  }) {
    yield call(loadMissingLensTypes, frameSku);
}
function* loadMissingLensTypes(frameSku) {
    const frame = yield select(getBundleFrame, {
        frameSku
    });
    if (!frame) {
        return;
    }
    const lensTypes = yield select(getBundleLensTypes);
    const lensTypeSkusToFetch = [
        ...frame.lensTypeSkus
    ].filter((sku)=>!(sku in lensTypes)
    );
    yield put(fetchLensTypes({
        frameSku,
        skus: new Set(lensTypeSkusToFetch)
    }));
}
function* onFetchLensTypes({ payload: { skus , frameSku  }  }) {
    try {
        const result = yield call(fetchBundleProducts, 'lens-type', skus);
        yield put(fetchLensTypesSuccess(swcHelpers.objectSpread({
            frameSku
        }, result)));
    } catch (error) {
        yield put(fetchLensTypesFailed({
            frameSku,
            skus,
            error
        }));
    }
}
/**
 * Packages
 */ function* loadMissingPackages(lensTypeSku) {
    const bundleLensType = yield select(getBundleLensType, {
        lensTypeSku
    });
    if (!bundleLensType || !statusSuccess(bundleLensType)) {
        return;
    }
    const packages = yield select(getBundlePackages);
    const packageSkusToFetch = [
        ...bundleLensType.result.packageSkus
    ].filter((packageSku)=>!(packageSku in packages)
    );
    if (packageSkusToFetch.length) {
        yield put(fetchPackages({
            lensTypeSku,
            skus: new Set(packageSkusToFetch)
        }));
    }
}
function* ensurePackagesAreLoaded({ payload: { lensTypeSku  }  }) {
    yield call(loadMissingPackages, lensTypeSku);
}
function* onFetchPackages({ payload: { skus , lensTypeSku  }  }) {
    try {
        const result = yield call(fetchBundleProducts, 'package', skus);
        yield put(fetchPackagesSuccess(swcHelpers.objectSpread({
            lensTypeSku
        }, result)));
    } catch (error) {
        yield put(fetchPackagesFailed({
            lensTypeSku,
            skus,
            error
        }));
    }
}
/**
 * Add-ons
 */ function* loadMissingAddOns(packageSku) {
    const bundlePackage = yield select(getBundlePackage, {
        packageSku
    });
    if (!bundlePackage || !statusSuccess(bundlePackage)) {
        return;
    }
    const addons = yield select(getBundleAddOns);
    const addOnSkusToFetch = [
        ...bundlePackage.result.addOnSkus
    ].filter((addOnSku)=>!(addOnSku in addons)
    );
    if (addOnSkusToFetch.length) {
        yield put(fetchAddOns({
            packageSku,
            skus: new Set(addOnSkusToFetch)
        }));
    }
}
function* ensureAddOnsAreLoaded({ payload: { packageSku  }  }) {
    yield call(loadMissingAddOns, packageSku);
}
function* onFetchAddOns({ payload: { skus , packageSku  }  }) {
    try {
        const result = yield call(fetchBundleProducts, 'addon', skus);
        yield put(fetchAddOnsSuccess(swcHelpers.objectSpread({
            packageSku
        }, result)));
    } catch (error) {
        yield put(fetchAddOnsFailed({
            packageSku,
            skus,
            error
        }));
    }
}
/**
 * These effects make sure data is loaded as soon as possible
 */ const listenForSelectionChanges = [
    takeLatest(startPrescriptionGlassesConfiguration.type, ensureLensTypesAreLoaded),
    takeLatest(selectLensTypeSuccess.type, ensurePackagesAreLoaded),
    takeLatest(selectPackageSuccess.type, ensureAddOnsAreLoaded), 
];
/**
 * These listen for the actual fetching actions
 */ const listenForFetchEvents = [
    takeLatest(fetchLensTypes.type, onFetchLensTypes),
    takeLatest(fetchPackages.type, onFetchPackages),
    takeLatest(fetchAddOns.type, onFetchAddOns), 
];
var bundleSagas = [
    ...listenForFetchEvents,
    ...listenForSelectionChanges
];

const getPrescription$1 = createSelector(getPrescriptionGlasses, (pg)=>pg.prescription
);

const filterPrescriptionKeysAndValues = (prescriptionProperties, validOpticalParameters)=>{
    const validOpticalParamsMap = validOpticalParameters.reduce((m, p)=>swcHelpers.objectSpread({}, m, {
            [p.name]: p.values
        })
    , {});
    return Object.entries(prescriptionProperties).reduce((m, property)=>{
        const [pKey, pValue] = property;
        const validPropertyValues = validOpticalParamsMap[pKey];
        if (!validPropertyValues || !pValue) {
            return m;
        }
        if (validPropertyValues.has(pValue)) {
            return swcHelpers.objectSpread({}, m, {
                [pKey]: pValue
            });
        }
        return m;
    }, {});
};
function* onSelectLensType({ payload: { frameSku , lensTypeSku , reason  }  }) {
    function* fail(error) {
        yield put(selectLensTypeFailed({
            frameSku,
            lensTypeSku,
            error
        }));
    }
    const bundleFrame = yield select(getBundleFrame, {
        frameSku
    });
    if (!bundleFrame || !bundleFrame.lensTypeSkus.has(lensTypeSku)) {
        return yield* fail(new Error(`Lens-type with SKU "${lensTypeSku}" can't be selected for frame with SKU "${frameSku}", valid lens-type SKUs are "${bundleFrame && JSON.stringify([
            ...bundleFrame.lensTypeSkus
        ])}"`));
    }
    const lensType = yield select(getBundleLensType, {
        lensTypeSku
    });
    if (!statusSuccess(lensType)) {
        return yield* fail(new Error('Lens-type not available'));
    }
    const prescription = yield select(getPrescription$1);
    const opticalParameters = yield select(getOpticalParameters, {
        frameSku,
        lensTypeSku
    });
    let prescriptionPrefill = {
        left: {},
        right: {},
        uploadReferences: {}
    };
    if (statusSuccess(opticalParameters)) {
        const validParameters = opticalParameters.result;
        prescriptionPrefill = {
            left: filterPrescriptionKeysAndValues(prescription.left, validParameters),
            right: filterPrescriptionKeysAndValues(prescription.right, validParameters),
            uploadReferences: prescription.uploadReferences
        };
    }
    yield put(selectLensTypeSuccess({
        frameSku,
        lensTypeSku,
        prescriptionPrefill,
        reason
    }));
}
function* ensureCompatibleLensPackage({ payload: { frameSku , lensTypeSku  }  }) {
    const selectedPackageSku = yield select(getPackageSku, {
        frameSku
    });
    if (!selectedPackageSku) {
        return;
    }
    const lensType = yield select(getBundleLensType, {
        lensTypeSku
    });
    if (!statusSuccess(lensType)) {
        return;
    }
    // Make sure that we unselect the current package if it's not compatible with the newly selected lens-type
    if (!lensType.result.packageSkus.has(selectedPackageSku)) {
        yield put(resetSelectedPackage({
            frameSku
        }));
    }
}
function* ensureCompatibleLensAddOn({ payload: { frameSku , packageSku  }  }) {
    const selectedAddOnSku = yield select(getAddOnSku, {
        frameSku
    });
    if (!selectedAddOnSku) {
        return;
    }
    const bundlePackage = yield select(getBundlePackage, {
        packageSku
    });
    if (!statusSuccess(bundlePackage)) {
        return;
    }
    // Make sure we deselect the current add-on if it's not compatible with the newly selected package
    if (!bundlePackage.result.addOnSkus.has(selectedAddOnSku)) {
        yield put(resetSelectedAddOn({
            frameSku,
            reason: 'default selection'
        }));
    }
}
function* onSelectPackage({ payload: { frameSku , packageSku , reason  }  }) {
    function* fail(error) {
        yield put(selectPackageFailed({
            frameSku,
            packageSku,
            error
        }));
    }
    const lensTypeSku = yield select(getLensTypeSku, {
        frameSku
    });
    if (!lensTypeSku) {
        return yield* fail(new Error(`A lens-type needs to be selected before we can select a package`));
    }
    const lensPackage = yield select(getBundlePackage, {
        packageSku
    });
    if (!statusSuccess(lensPackage)) {
        return yield* fail(new Error('Lens-package is unavailable'));
    }
    const lensType = yield select(getBundleLensType, {
        lensTypeSku
    });
    if (!statusSuccess(lensType)) {
        return yield* fail(new Error(`Lens-type with SKU "${lensTypeSku}" is unavailable`));
    }
    if (!lensType.result.packageSkus.has(packageSku)) {
        return yield* fail(new Error(`Package is not compatible with selected lens-type with SKU "${lensTypeSku}`));
    }
    yield put(selectPackageSuccess({
        frameSku,
        lensTypeSku,
        packageSku,
        reason
    }));
}
function* onSelectAddOn({ payload: { frameSku , addOnSku , reason  }  }) {
    function* fail(error) {
        yield put(selectAddOnFailed({
            frameSku,
            addOnSku,
            error
        }));
    }
    const config = yield select(getConfiguration$1, {
        frameSku
    });
    if (!config) {
        return yield* fail(new Error(`No add-on can be selected for Frame: ${frameSku}, there's no active configuration for it`));
    }
    const { lensType , package: packageSku  } = config;
    if (!(lensType === null || lensType === void 0 ? void 0 : lensType.sku) || !packageSku) {
        return yield* fail(new Error(`To select an add-on we need a lens-type, and a package; current lens-type is "${lensType === null || lensType === void 0 ? void 0 : lensType.sku}", package is "${packageSku}"`));
    }
    const bundlePackage = yield select(getBundlePackage, {
        packageSku
    });
    if (!statusSuccess(bundlePackage)) {
        return yield* fail(new Error(`Can't select add-on because package with SKU ${packageSku} is unavailable`));
    }
    if (!bundlePackage.result.addOnSkus.has(addOnSku)) {
        return yield* fail(new Error(`Add-on cannot be selected for selected package with SKU "${packageSku}"`));
    }
    yield put(selectAddOnSuccess({
        frameSku,
        addOnSku,
        reason
    }));
}
const selectionHandlers = [
    takeLatest(selectLensType.type, onSelectLensType),
    takeLatest(selectPackage.type, onSelectPackage),
    takeLatest(selectAddOn.type, onSelectAddOn), 
];
var configurationSagas = [
    ...selectionHandlers,
    takeLatest(selectLensTypeSuccess.type, ensureCompatibleLensPackage),
    takeLatest(selectPackageSuccess.type, ensureCompatibleLensAddOn), 
];

var getAdditionalPrescriptionInfo = createSelector(getAdditionalPrescriptionInfoFormState, (additionalPrescriptionInfoFormState)=>{
    if (!additionalPrescriptionInfoFormState) {
        return {};
    }
    const _ref = Util.getValuesFromState(additionalPrescriptionInfoFormState), { examDate , expiryDate  } = _ref, rest = swcHelpers.objectWithoutProperties(_ref, [
        "examDate",
        "expiryDate"
    ]);
    return swcHelpers.objectSpread({}, examDate ? {
        examDate
    } : {}, expiryDate ? {
        expiryDate
    } : {}, {
        opticianDetails: swcHelpers.objectSpread({}, rest)
    });
});
/*
 * Utilities for getAddToCartLineItem -----------
 */ const configureBundleLineItemsForCart = (config)=>{
    if (!config) {
        return;
    }
    const bundleLineItems = [];
    Object.keys(config).forEach((item)=>{
        var ref;
        let sku;
        if (item === 'prescriptionType' || !config[item]) {
            return;
        }
        if (item === 'lensType' && (config === null || config === void 0 ? void 0 : (ref = config.lensType) === null || ref === void 0 ? void 0 : ref.sku)) {
            sku = config.lensType.sku;
        }
        bundleLineItems.push({
            sku: sku !== null && sku !== void 0 ? sku : config[item]
        });
    });
    return bundleLineItems;
};
const configurePrescriptionInfo = (config, additionalInfo)=>{
    const prescriptionType = config === null || config === void 0 ? void 0 : config.prescriptionType;
    if (!prescriptionType || isBookAppointmentEntrySelection(prescriptionType)) {
        return;
    }
    if (CommerceToolsApi.isEmailPrescription(prescriptionType)) {
        return {
            type: 'email-prescription'
        };
    }
    if (CommerceToolsApi.isExistingCustomer(prescriptionType)) {
        return {
            type: 'existing-customer'
        };
    }
    if (CommerceToolsApi.isNewPrescription(prescriptionType)) {
        var ref;
        const prescriptionInfo = config === null || config === void 0 ? void 0 : (ref = config.lensType) === null || ref === void 0 ? void 0 : ref.prescriptionInfo;
        if (!prescriptionInfo) {
            return;
        }
        const { right , left  } = prescriptionInfo;
        return {
            type: 'new-prescription',
            details: swcHelpers.objectSpread({
                rightLens: right,
                leftLens: left
            }, additionalInfo)
        };
    }
    if (CommerceToolsApi.isPrescriptionFile(prescriptionType)) {
        var ref1;
        const uploadReferences = config === null || config === void 0 ? void 0 : (ref1 = config.lensType) === null || ref1 === void 0 ? void 0 : ref1.prescriptionInfo.uploadReferences;
        if (!uploadReferences || !uploadReferences['pg-prescription'] || !uploadReferences['pg-pupillary-distance']) {
            return;
        }
        return {
            type: 'prescription-file',
            details: {
                prescriptionFile: uploadReferences['pg-prescription'],
                pupillaryDistanceFile: uploadReferences['pg-pupillary-distance']
            }
        };
    }
};
/*
 * end Utility functions for getAddToCartLineItem -----------
 */ /*
 * Get a line item configured to be added to cart.
 */ const getAddToCartLineItem = createSelector(getFrameSku, (s)=>s
, (frameSku, state)=>{
    if (!frameSku) {
        return undefined;
    }
    const lineItemRawConfig = getConfiguration$1(state, {
        frameSku
    });
    const additionalPrescriptionInfo = getAdditionalPrescriptionInfo(state);
    const bundleLineItems = configureBundleLineItemsForCart(lineItemRawConfig);
    const prescription = configurePrescriptionInfo(lineItemRawConfig, additionalPrescriptionInfo);
    if (!bundleLineItems || !prescription) {
        return undefined;
    }
    return {
        type: 'prescription-glasses',
        sku: frameSku,
        bundleLineItems,
        prescription
    };
});

function getBundleProductTitle(bundleProduct) {
    var ref;
    if (!bundleProduct) {
        return;
    }
    if ((ref = bundleProduct.variants) === null || ref === void 0 ? void 0 : ref.length) {
        var ref1;
        const selected = (ref1 = bundleProduct.variants) === null || ref1 === void 0 ? void 0 : ref1.find((v)=>v.sku === bundleProduct.sku
        );
        // to prevent "title -"
        if (!selected || !(selected === null || selected === void 0 ? void 0 : selected.title)) {
            return bundleProduct.title;
        }
        return `${bundleProduct.title} - ${selected.title}`;
    } else {
        return bundleProduct.title;
    }
}

function getLensProductVariantName(lensProduct) {
    var ref, ref1;
    if (!(lensProduct === null || lensProduct === void 0 ? void 0 : (ref = lensProduct.variants) === null || ref === void 0 ? void 0 : ref.length)) {
        return;
    }
    const selected = (ref1 = lensProduct.variants) === null || ref1 === void 0 ? void 0 : ref1.find((v)=>v.sku === lensProduct.sku
    );
    const title = selected === null || selected === void 0 ? void 0 : selected.title;
    return title || undefined;
}

const stepMapping$1 = {
    lensType: {
        name: 'lens type',
        id: '100'
    },
    lensTypeVariant: {
        name: 'lens type variant',
        id: '150'
    },
    prescription: {
        name: 'prescription',
        id: '200'
    },
    prescriptionForm: {
        name: 'prescription',
        id: '210'
    },
    prescriptionUpload: {
        name: 'prescription',
        id: '210'
    },
    prescriptionValidation: {
        name: 'prescription validation',
        id: '250'
    },
    lensPackage: {
        name: 'lens package',
        id: '300'
    },
    lensAddOn: {
        name: 'add-ons',
        id: '400'
    },
    lensAddOnVariant: {
        name: 'add-ons-variant',
        id: '450'
    }
};
/**
 * SHARED SELECTORS
 * Most data layer selectors will use these
 */ const getStepData$1 = createSelector(configuratorIdProp$1, stateProp$1, (id, s)=>{
    const currentStep = Selectors.getCurrentStep(s, {
        id
    });
    return currentStep ? stepMapping$1[currentStep.name] : undefined;
});
const getPrice$1 = createSelector(getBundlePrice, (bundlePrice)=>{
    if (!bundlePrice) {
        console.warn(`Need bundle price to log data layer event. Received "${JSON.stringify(bundlePrice)}"`);
        return;
    }
    const { discountedPrice , originalPrice  } = bundlePrice;
    /**
   * Both "discountedPrice" and "originalPrice" are in cents, as per usual. There is no e.g. "centAmount" property
   * to check here anymore.
   */ return discountedPrice ? (discountedPrice / 100).toFixed(2) : (originalPrice / 100).toFixed(2);
});
const formatPrescriptionValue = (value)=>typeof value === 'number' && !isNaN(value) ? value.toFixed(2) : 'n/a'
;
/**
 * Creates a reducer function that converts PrescriptionValue to a data-layer PrescriptionValue
 */ const reduceParameter = (values)=>(info, { name  })=>swcHelpers.objectSpread({}, info, {
            [name]: formatPrescriptionValue(values[name])
        })
;
const getLensParameters$1 = createSelector(getPrescription$2, (pre)=>{
    if (!statusSuccess(pre)) {
        return;
    }
    const { parameters , left , right  } = pre.result;
    return {
        OS: parameters.reduce(reduceParameter(left), {}),
        OD: parameters.reduce(reduceParameter(right), {})
    };
});
const getSelectedLensNames = createSelector(getLensTypes$2, getSelectedLensType, (s)=>s
, (lensTypes, selectedLensType, state)=>{
    if (!lensTypes || !selectedLensType) {
        return;
    }
    const lensTypeProduct = lookupParentLensType(state, {
        lensTypeSku: selectedLensType.sku
    });
    if (!lensTypeProduct) {
        return;
    }
    const lensTypeInfo = convertToLensTypeInfo(lensTypeProduct, selectedLensType.sku, 'en');
    return {
        productName: lensTypeInfo.title,
        variantName: getLensProductVariantName(lensTypeInfo)
    };
});
const getSelectedPackageName = createSelector(getPackages$2, getSelectedPackage, (packages, selectedPackage)=>{
    if (!packages || !selectedPackage) {
        return;
    }
    const packageProductData = packages[selectedPackage.sku];
    if (!packageProductData) {
        return;
    }
    return getLocalizedValue(packageProductData.name, 'en');
});
const getSelectedAddOnName = createSelector(getSelectedAddOn, (s)=>s
, (selectedAddOn, state)=>{
    if (!selectedAddOn) {
        return 'no add-on';
    }
    const addOnProduct = lookupParentAddOn(state, {
        addOnSku: selectedAddOn.sku
    });
    if (!addOnProduct) {
        return;
    }
    const addOnInfo = convertToLensAddOnInfo(addOnProduct, selectedAddOn.sku, 'en');
    return getBundleProductTitle(addOnInfo);
});
const getProductConfig$1 = createSelector(getSelectedLensNames, getSelectedPackageName, getSelectedAddOnName, getPrice$1, getLensParameters$1, hasVisitedStepAddOn, (lensNames, packageName, addOnName, price, lens, hasVisitedStepAddOn)=>{
    return swcHelpers.objectSpread({}, (lensNames === null || lensNames === void 0 ? void 0 : lensNames.productName) ? {
        lensType: lensNames.productName.toLowerCase()
    } : {}, (lensNames === null || lensNames === void 0 ? void 0 : lensNames.variantName) ? {
        lensVariant: lensNames.variantName.toLowerCase()
    } : {}, packageName ? {
        lensPackage: packageName.toLowerCase()
    } : {}, hasVisitedStepAddOn && addOnName ? {
        'add-ons': addOnName.toLowerCase()
    } : {}, {
        price: price !== null && price !== void 0 ? price : '0'
    }, lens ? {
        lens
    } : {});
});
const getConfigFlow$1 = createSelector(getStepData$1, getPrescriptionType, hasVisitedStepPrescription, (stepData, prescriptionType, hasVisitedStepPrescription)=>{
    /**
     * Should only occur on programmer error. We should always have this data available.
     */ if (!stepData) {
        return undefined;
    }
    const rxInputMethodMapping = {
        NewPrescription: 'manual',
        EmailPrescription: 'email',
        ExistingCustomer: 'customer',
        PrescriptionFile: 'upload',
        'book-appointment': 'book-appointment'
    };
    if (CommerceToolsApi.isPrescriptionFile(prescriptionType)) {
        /**
       * Note: there isn't yet a data layer implementation plan for the PrescriptionFile option. For that reason we're
       * not logging anything specific for that option to the data layer.
       */ return {
            version: '1.0',
            step: stepData
        };
    }
    return swcHelpers.objectSpread({
        version: '1.0',
        step: stepData
    }, hasVisitedStepPrescription && isDefined$1(prescriptionType) ? {
        RxInputMethod: rxInputMethodMapping[prescriptionType]
    } : {});
});
const getUser = createSelector(getPrescriptionType, (prescriptionType)=>{
    if (CommerceToolsApi.isPrescriptionFile(prescriptionType)) {
        /**
     * Note: there isn't yet a data layer implementation plan for the PrescriptionFile option. For that reason we're
     * not logging anything specific for that option to the data layer.
     */ return;
    }
    return {
        custStatus: CommerceToolsApi.isExistingCustomer(prescriptionType) ? 'customer' : 'prob noncustomer'
    };
});

function isSun(productType) {
    var ref;
    if (typeof productType === 'string') {
        return productType === 'Sunglasses';
    }
    return ((ref = productType.obj) === null || ref === void 0 ? void 0 : ref.name) === 'Sunglasses';
}
const getEventType = (p)=>{
    const productType = typeof p === 'string' ? p : p.productType;
    return isSun(productType) ? 'RxSunConfigEvent' : 'RxGlassesConfigEvent';
};
function* onStartConfiguration$1({ payload: { frame  }  }) {
    const openConfiguratorEvent = {
        event: getEventType(frame),
        eventAction: 'click on button',
        eventLabel: 'configure glasses button'
    };
    yield put(DataLayer.Actions.pushEvent(openConfiguratorEvent));
}
function* onPushEvent$1(id, eventAction, eventLabel) {
    const productConfig = yield select(getProductConfig$1, {
        id
    });
    const configFlow = yield select(getConfigFlow$1, {
        id
    });
    const user = yield select(getUser);
    const hasVisitedStepPrescription$1 = yield select(hasVisitedStepPrescription, {
        id
    });
    const productType = yield select(getSelectedFrameProductType);
    if (productType !== 'Frames' && productType !== 'Sunglasses') {
        console.error(`Did not receive a valid product type for pushing an event to the data layer. Expected "Frames" or "Sunglasses", received: ${productType}`);
        return;
    }
    const DATA_KEY = isSun(productType) ? 'RxSun' : 'RxGlasses';
    const action = DataLayer.Actions.pushEvent(swcHelpers.objectSpread({
        event: getEventType(productType),
        eventAction,
        eventLabel
    }, hasVisitedStepPrescription$1 && user ? {
        user
    } : {}, {
        [DATA_KEY]: {
            configFlow,
            productConfig
        }
    }));
    yield put(action);
}
/**
 * Actions that respond to different product selections during configuration of a product.
 */ const createSelectionHandler = (id, eventAction)=>function*() {
        yield call(onPushEvent$1, id, eventAction);
    }
;
const manualLensTypeSelection = (a)=>actions.isType(a, selectLensTypeSuccess) && a.payload.reason === 'user selection'
;
const manualLensPackageSelection = (a)=>actions.isType(a, selectPackageSuccess) && a.payload.reason === 'user selection'
;
const manualAddOnSelection = (a)=>(actions.isType(a, selectAddOnSuccess) || actions.isType(a, resetSelectedAddOn)) && a.payload.reason === 'user selection'
;
/**
 * Logs a 'view step' event an every step change
 */ function* onViewStep$1({ payload: { id  }  }) {
    yield call(onPushEvent$1, id, 'view step');
}
/**
 * Logs a 'select rx attribute' on every prescription value change
 * Also logs an event label with the parameter name and eye side, i.e. "axis left"
 */ function* onUpdatePrescriptionValue(id, { payload: { parameter , side  }  }) {
    yield call(onPushEvent$1, id, 'select rx attribute', `${parameter} ${side}`);
}
/**
 * Logs an 'existing customer' value change
 */ function* onUpdatePrescriptionType(id, { payload: { prescriptionType , reason  }  }) {
    if (reason === 'default selection') {
        return;
    }
    /**
   * Values discussed with Helena Heno on 2021/06/09. As of today, this list is not yet
   * represented in any documentation.
   */ const rxInputMethodMapping = {
        NewPrescription: {
            eventAction: 'manual prescription',
            eventLabel: 'manual'
        },
        EmailPrescription: {
            eventAction: 'email prescription',
            eventLabel: 'email'
        },
        ExistingCustomer: {
            eventAction: 'existing customer',
            eventLabel: 'customer'
        },
        PrescriptionFile: {
            eventAction: 'upload prescription',
            eventLabel: 'upload'
        },
        'book-appointment': {
            eventAction: 'book-appointment',
            eventLabel: 'book-appointment'
        }
    };
    const event = rxInputMethodMapping[prescriptionType];
    if (!event) {
        return;
    }
    yield call(onPushEvent$1, id, event.eventAction, event.eventLabel);
}
function* onFileUploadResult(id, { result  }) {
    if (result) {
        yield call(onPushEvent$1, id, 'upload message', result);
    }
}
/**
 * Logs when successfully moved to the next step
 */ function* onNextStep$1({ payload: { id  }  }) {
    yield call(onPushEvent$1, id, 'click on button', 'next step');
}
/**
 * This saga binds the the configurator ID to the selection actions, which is necessary to provide
 * the correct data for data layer events.
 */ const getConfigurationChangesSagas = (id)=>[
        takeLatest(updatePrescriptionValue.type, (a)=>onUpdatePrescriptionValue(id, a)
        ),
        takeLatest(updatePrescriptionType.type, (a)=>onUpdatePrescriptionType(id, a)
        ),
        // upload
        takeLatest(fileUploadResult.type, (a)=>onFileUploadResult(id, a)
        ),
        takeLatest(manualLensTypeSelection, createSelectionHandler(id, 'select lens type')),
        takeLatest(manualLensPackageSelection, createSelectionHandler(id, 'select lens package')),
        takeLatest(manualAddOnSelection, createSelectionHandler(id, 'select add-on')),
        /**
   * Configurator stepping actions
   */ takeLatest(Actions.isStepShownWithId(id), onViewStep$1),
        takeLatest(Actions.isNextStepWithId(id), onNextStep$1), 
    ]
;
function* listenForConfigurationChanges$1(id) {
    yield all(getConfigurationChangesSagas(id));
}
var dataLayerSagas = [
    takeLatest(startPrescriptionGlassesConfiguration.type, onStartConfiguration$1), 
];

const productsSagas = [
    ...bundleSagas,
    ...configurationSagas,
    ...dataLayerSagas
];
function* prescriptionGlassesSaga() {
    yield all(productsSagas);
}

const stateProp = (s)=>s
;
const configuratorIdProp = (_, { id  })=>id
;
const variantGroupProp = (_, { variantGroup  })=>variantGroup
;
const getContactLensSubscription = (state)=>state.contactLensSubscription
;

const getConfiguration = createSelector(getContactLensSubscription, variantGroupProp, (contactLensSubscription, variantGroup)=>contactLensSubscription.configurations[variantGroup]
);

const getSelectedDeliveryFrequency$1 = createSelector(getConfiguration, (c)=>{
    return c === null || c === void 0 ? void 0 : c.deliveryFrequency;
});
const getSelectedBillingPeriod$1 = createSelector(getConfiguration, (c)=>{
    return c === null || c === void 0 ? void 0 : c.billingPeriod;
});
const getSelectedStartDate$1 = createSelector(getConfiguration, (c)=>{
    return c === null || c === void 0 ? void 0 : c.startDate;
});
const getSelectedRatePlan$1 = createSelector(getConfiguration, (c)=>{
    return c === null || c === void 0 ? void 0 : c.ratePlan;
});
const getSelectedSolution$1 = createSelector(getConfiguration, (c)=>{
    return c === null || c === void 0 ? void 0 : c.solution;
});

var selectors$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getSelectedDeliveryFrequency: getSelectedDeliveryFrequency$1,
  getSelectedBillingPeriod: getSelectedBillingPeriod$1,
  getSelectedStartDate: getSelectedStartDate$1,
  getSelectedRatePlan: getSelectedRatePlan$1,
  getSelectedSolution: getSelectedSolution$1
});

const namespace$4 = 'products/contact-lens-subscription';
const selectDeliveryFrequency$1 = actions.action(`${namespace$4}/select-delivery-frequency`, actions.payload());
actions.action(`${namespace$4}/select-delivery-frequency-failed`, actions.payload());
const selectDeliveryFrequencySuccess = actions.action(`${namespace$4}/select-delivery-frequency-success`, actions.payload());
const selectBillingPeriod$1 = actions.action(`${namespace$4}/select-billing-period`, actions.payload());
actions.action(`${namespace$4}/select-billing-period-failed`, actions.payload());
const selectBillingPeriodSuccess = actions.action(`${namespace$4}/select-billing-period-success`, actions.payload());
const selectStartDate$2 = actions.action(`${namespace$4}/select-start-date`, actions.payload());
const selectStartDateFailed = actions.action(`${namespace$4}/select-start-date-failed`, actions.payload());
const selectStartDateSuccess = actions.action(`${namespace$4}/select-start-date-success`, actions.payload());
actions.action(`${namespace$4}/select-rate-plan`, actions.payload());
const selectRatePlanFailed = actions.action(`${namespace$4}/select-rate-plan-failed`, actions.payload());
const selectRatePlanSuccess = actions.action(`${namespace$4}/select-rate-plan-success`, actions.payload());
const selectSolution = actions.action(`${namespace$4}/select-solution`, actions.payload());
const resetConfigurationState = actions.action(`${namespace$4}/reset-configurator-state`);
const resetSelectedSolution = actions.action(`${namespace$4}/reset-solution`, actions.payload());

const namespace$3 = 'products/contact-lens-subscription';
const addToCart = actions.action(`${namespace$3}/add-to-cart`);
const addToCartFailed = actions.action(`${namespace$3}/add-to-cart-failed`, (error)=>({
        error
    })
);
const addToCartSuccess = actions.action(`${namespace$3}/add-to-cart-success`);

const namespace$2 = 'products/datalayer';
const selectStartDate$1 = actions.action(`${namespace$2}/select-start-date`, actions.payload());

const namespace$1 = 'products/contact-lens-subscription';
const fetchRatePlansFailed = actions.action(`${namespace$1}/fetch-rate-plans-failed`, actions.payload());
const fetchRatePlansSuccess = actions.action(`${namespace$1}/fetch-rate-plans-success`, actions.payload());

const namespace = 'products/contact-lens-subscription';
const startContactLensSubscriptionConfiguration = actions.action(`${namespace}/start`, actions.payload());
actions.action(`${namespace}/start-success`);

const defaultState = {};
const reducer$3 = actions.reducer(defaultState, actions.on(/**
     * Create a blank configuration but only on the first call
     */ startContactLensSubscriptionConfiguration, (s, { payload: { variantGroup  }  })=>{
    // If we have an existing configuration for a variant group (brand key) we use it.
    if (variantGroup in s) {
        return s;
    }
    return swcHelpers.objectSpread({}, s, {
        [variantGroup]: {}
    });
}), /**
   * Changes the delivery frequency.
   */ actions.on(selectDeliveryFrequencySuccess, (s, { payload: { variantGroup , deliveryFrequency  }  })=>{
    return swcHelpers.objectSpread({}, s, {
        [variantGroup]: swcHelpers.objectSpread({}, s[variantGroup], {
            deliveryFrequency
        })
    });
}), /**
   * Changes the billing period.
   */ actions.on(selectBillingPeriodSuccess, (s, { payload: { variantGroup , billingPeriod  }  })=>{
    return swcHelpers.objectSpread({}, s, {
        [variantGroup]: swcHelpers.objectSpread({}, s[variantGroup], {
            billingPeriod
        })
    });
}), /**
   * Changes the start date.
   */ actions.on(selectStartDateSuccess, (s, { payload: { variantGroup , startDate  }  })=>{
    return swcHelpers.objectSpread({}, s, {
        [variantGroup]: swcHelpers.objectSpread({}, s[variantGroup], {
            startDate
        })
    });
}), /**
   * Changes the rate plan and (re)sets other selections to their rate plan
   * values to ensure all values are compatible with a plan.
   */ actions.on(selectRatePlanSuccess, (s, { payload: { variantGroup , ratePlan  }  })=>{
    return swcHelpers.objectSpread({}, s, {
        [variantGroup]: swcHelpers.objectSpread({}, s[variantGroup], {
            deliveryFrequency: ratePlan.shippingSchedule,
            billingPeriod: ratePlan.billingPeriod,
            ratePlan
        })
    });
}), actions.on(selectSolution, (s, { payload: { variantGroup , solution  }  })=>{
    return swcHelpers.objectSpread({}, s, {
        [variantGroup]: swcHelpers.objectSpread({}, s[variantGroup], {
            solution
        })
    });
}), actions.on(resetConfigurationState, ()=>swcHelpers.objectSpread({}, defaultState)
), actions.on(resetSelectedSolution, (s, { payload: { variantGroup  }  })=>swcHelpers.objectSpread({}, s, {
        [variantGroup]: swcHelpers.objectSpread({}, s[variantGroup], {
            solution: undefined
        })
    })
));

const NO_SOLUTION_SKU = '-1';

const getConfigurator = createSelector(getContactLensSubscription, (contactLensSubscription)=>contactLensSubscription.configurator
);

var PrescriptionAttribute;
(function(PrescriptionAttribute) {
    PrescriptionAttribute["Addition"] = 'addition';
    PrescriptionAttribute["Axis"] = 'axis';
    PrescriptionAttribute["BaseCurve"] = 'baseCurve';
    PrescriptionAttribute["Cylinder"] = 'cylinder';
    PrescriptionAttribute["Diameter"] = 'diameter';
    PrescriptionAttribute["Power"] = 'power';
})(PrescriptionAttribute || (PrescriptionAttribute = {}));
var LensSide;
(function(LensSide) {
    LensSide["Left"] = 'leftLens';
    LensSide["Right"] = 'rightLens';
})(LensSide || (LensSide = {}));
const PRESCRIPTION_ATTRIBUTES = [
    PrescriptionAttribute.Addition,
    PrescriptionAttribute.Axis,
    PrescriptionAttribute.BaseCurve,
    PrescriptionAttribute.Cylinder,
    PrescriptionAttribute.Diameter,
    PrescriptionAttribute.Power, 
];
const EYE_SIDE_LENS_MAP = {
    left: LensSide.Left,
    right: LensSide.Right
};
const getVariantGroup = createSelector(getConfigurator, (configurator)=>configurator.variantGroup
);
const getPackSize = createSelector(getConfigurator, (configurator)=>configurator.packSize
);
const getUsageFrequency = createSelector(getConfigurator, (configurator)=>configurator.usageFrequency
);
const getEyeSides = createSelector(getConfigurator, (configurator)=>configurator.eyeSides
);
const getLensVariants = createSelector(getConfigurator, (configurator)=>configurator.lensVariants
);
const getProduct = createSelector(getConfigurator, (configurator)=>configurator.product
);
const getStaticsUrl = createSelector(getConfigurator, (configurator)=>{
    return configurator === null || configurator === void 0 ? void 0 : configurator.staticsUrl;
});
var _clsUsps;
const getClsUsps = createSelector(getConfigurator, (configurator)=>(_clsUsps = configurator.clsUsps) !== null && _clsUsps !== void 0 ? _clsUsps : []
);
const getRecommendedCategoryKey = createSelector(getConfigurator, (configurator)=>{
    return configurator === null || configurator === void 0 ? void 0 : configurator.recommendedCategoryKey;
});
/**
 * The currently selected delivery frequency of the variant group that is being configured
 */ const getSelectedDeliveryFrequency = createSelector(getVariantGroup, (s)=>s
, (variantGroup, state)=>{
    if (!variantGroup) {
        return undefined;
    }
    return getSelectedDeliveryFrequency$1(state, {
        variantGroup
    });
});
/**
 * The currently selected billing period of the variant group that is being configured
 */ const getSelectedBillingPeriod = createSelector(getVariantGroup, (s)=>s
, (variantGroup, state)=>{
    if (!variantGroup) {
        return undefined;
    }
    return getSelectedBillingPeriod$1(state, {
        variantGroup
    });
});
/**
 * The currently selected start date of the variant group that is being configured
 */ const getSelectedStartDate = createSelector(getVariantGroup, (s)=>s
, (variantGroup, state)=>{
    if (!variantGroup) {
        return undefined;
    }
    return getSelectedStartDate$1(state, {
        variantGroup
    });
});
const getSelectedRatePlan = createSelector(getVariantGroup, (s)=>s
, (variantGroup, state)=>{
    if (!variantGroup) {
        return undefined;
    }
    return getSelectedRatePlan$1(state, {
        variantGroup
    });
});
const getSelectedSolution = createSelector(getVariantGroup, (s)=>s
, (variantGroup, state)=>{
    if (!variantGroup) {
        return undefined;
    }
    return getSelectedSolution$1(state, {
        variantGroup
    });
});
/**
 * located here instead of in ./steps to avoid circular dependency
 */ const getCurrentStep = createSelector(stateProp, configuratorIdProp, (s, id)=>Selectors.getCurrentStep(s, {
        id
    })
);
/**
 * Aggregates
 */ const getConfigurationTotalPrice = createSelector(getSelectedRatePlan, getCurrentStep, getSelectedSolution, getEyeSides, (selectedRatePlan, currentStep, selectedSolution, eyeSides)=>{
    var ref, ref1, ref2;
    if (!selectedRatePlan) {
        return undefined;
    }
    const lensPrice = (((ref = selectedRatePlan.totalPrice) === null || ref === void 0 ? void 0 : ref.centAmount) || 0) * eyeSides.length;
    const solutionPrice = (selectedSolution === null || selectedSolution === void 0 ? void 0 : (ref1 = selectedSolution.price) === null || ref1 === void 0 ? void 0 : ref1.discountedPrice) || (selectedSolution === null || selectedSolution === void 0 ? void 0 : (ref2 = selectedSolution.price) === null || ref2 === void 0 ? void 0 : ref2.originalPrice) || 0;
    return {
        originalPrice: lensPrice + solutionPrice,
        currency: selectedRatePlan.totalPrice.currencyCode
    };
});
const getFormatProductUrl = createSelector(getConfigurator, (configurator)=>configurator.formatProductUrl
);
const getPrescription = createSelector(getEyeSides, getLensVariants, (eyeSides1, lensVariants1)=>{
    if (!eyeSides1 || !lensVariants1) {
        return null;
    }
    const toLensPrescription = (variant)=>PRESCRIPTION_ATTRIBUTES.reduce((previous, key)=>{
            const value = parseFloat(variant.attributes[key]);
            if (!isNumber(value)) return previous;
            return swcHelpers.objectSpread({}, previous, {
                [key]: value
            });
        }, {
            sku: variant.sku || '',
            gan: variant.attributes.gan || ''
        })
    ;
    const toPrescription = (eyeSides, lensVariants)=>{
        return eyeSides.reduce((previous, eyeSide)=>{
            const variant1 = Object.values(lensVariants).find((variant)=>variant.eyeSide === eyeSide
            );
            if (!variant1) return previous;
            return swcHelpers.objectSpread({}, previous, {
                [EYE_SIDE_LENS_MAP[eyeSide]]: toLensPrescription(variant1)
            });
        }, {});
    };
    return toPrescription(eyeSides1, lensVariants1);
});
const getTypeDetails = createSelector(getSelectedDeliveryFrequency, getSelectedBillingPeriod, getSelectedStartDate, getPrescription, (deliveryFrequency, billingPeriod, startDate, prescription)=>{
    if (!deliveryFrequency || !billingPeriod || !startDate || !prescription) return null;
    return {
        deliveryFrequency,
        billingFrequency: billingPeriod,
        subscriptionStartDate: DateUtils.toLocalDate(startDate),
        prescription
    };
});
const getBundleLineItems = createSelector(getVariantGroup, getEyeSides, getProduct, getSelectedRatePlan, getSelectedSolution, (variantGroup1, eyeSides, product1, selectedRatePlan, selectedSolution)=>{
    if (!(eyeSides === null || eyeSides === void 0 ? void 0 : eyeSides.length) || !product1 || !selectedRatePlan) return null;
    const toGan = (product)=>{
        if (!product) return '';
        var ref;
        return `${(ref = getAttrValue(product.masterVariant, 'gan')) !== null && ref !== void 0 ? ref : ''}`;
    };
    const toLensBundleLineItem = (product, variantGroup, ratePlan)=>{
        return {
            sku: `${product === null || product === void 0 ? void 0 : product.masterVariant.sku}`,
            gan: toGan(product),
            ratePlanId: (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.externalId) || '',
            quantity: 1,
            name: variantGroup || '',
            type: 'lens'
        };
    };
    var ref3;
    const toSolutionBundleLineItem = (solution)=>{
        var ref;
        return {
            sku: (solution === null || solution === void 0 ? void 0 : solution.sku) || '',
            gan: (ref3 = solution === null || solution === void 0 ? void 0 : solution.gan) !== null && ref3 !== void 0 ? ref3 : '',
            ratePlanId: (solution === null || solution === void 0 ? void 0 : (ref = solution.ratePlan) === null || ref === void 0 ? void 0 : ref.externalId) || '',
            quantity: 1,
            name: (solution === null || solution === void 0 ? void 0 : solution.title) || '',
            type: 'solution'
        };
    };
    const bundleLineItems = eyeSides.map(()=>toLensBundleLineItem(product1, variantGroup1, selectedRatePlan)
    );
    if (selectedSolution && selectedSolution.sku !== NO_SOLUTION_SKU) {
        bundleLineItems.push(toSolutionBundleLineItem(selectedSolution));
    }
    return bundleLineItems;
});
const getLineItemDraft = createSelector(getProduct, getBundleLineItems, getTypeDetails, (product, bundleLineItems, typeDetails)=>{
    if (!product || !bundleLineItems || !typeDetails) return null;
    return {
        type: 'contact-lenses-subscription',
        sku: `${product === null || product === void 0 ? void 0 : product.masterVariant.sku}`,
        quantity: 1,
        bundleLineItems,
        typeDetails
    };
});

var selectors$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getVariantGroup: getVariantGroup,
  getPackSize: getPackSize,
  getUsageFrequency: getUsageFrequency,
  getEyeSides: getEyeSides,
  getLensVariants: getLensVariants,
  getProduct: getProduct,
  getStaticsUrl: getStaticsUrl,
  getClsUsps: getClsUsps,
  getRecommendedCategoryKey: getRecommendedCategoryKey,
  getSelectedDeliveryFrequency: getSelectedDeliveryFrequency,
  getSelectedBillingPeriod: getSelectedBillingPeriod,
  getSelectedStartDate: getSelectedStartDate,
  getSelectedRatePlan: getSelectedRatePlan,
  getSelectedSolution: getSelectedSolution,
  getCurrentStep: getCurrentStep,
  getConfigurationTotalPrice: getConfigurationTotalPrice,
  getFormatProductUrl: getFormatProductUrl,
  getPrescription: getPrescription,
  getTypeDetails: getTypeDetails,
  getLineItemDraft: getLineItemDraft
});

const initialState$2 = {
    lensVariants: [],
    eyeSides: [],
    clsUsps: []
};
const reducer$2 = actions.reducer(initialState$2, /**
   * Set the correct frameSku and always reset the configurator to the initial state
   */ actions.on(startContactLensSubscriptionConfiguration, (_s, { payload: { clsUsps , formatProductUrl , input , lensVariants , product , recommendedCategoryKey , staticsUrl , variantGroup ,  } ,  })=>swcHelpers.objectSpread({}, initialState$2, input, {
        usageFrequency: input.usageFrequency,
        clsUsps,
        formatProductUrl,
        lensVariants,
        product,
        recommendedCategoryKey,
        staticsUrl,
        variantGroup
    })
), /**
   * When adding the config to cart has succeeded we start from the initialState
   */ actions.on(addToCartSuccess, ()=>swcHelpers.objectSpread({}, initialState$2)
));

const getSubscriptions = createSelector(getContactLensSubscription, (cls)=>cls.subscriptions
);

const getRatePlans = createSelector(getSubscriptions, (s)=>s.ratePlans
);

var selectors$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getRatePlans: getRatePlans
});

const initialState$1 = Object.freeze({
    ratePlans: uninitState()
});
const reducer$1 = actions.reducer(initialState$1, actions.on(startContactLensSubscriptionConfiguration, (s)=>swcHelpers.objectSpread({}, s, {
        ratePlans: loadingState()
    })
), actions.on(fetchRatePlansFailed, (s, { payload: { error  }  })=>swcHelpers.objectSpread({}, s, {
        ratePlans: failedState(error)
    })
), actions.on(fetchRatePlansSuccess, (s, { payload: { ratePlans  }  })=>swcHelpers.objectSpread({}, s, {
        ratePlans: successState(ratePlans)
    })
));

var contactLensSubscriptionReducer = combineReducers({
    configurations: reducer$3,
    configurator: reducer$2,
    subscriptions: reducer$1
});

function* selectDeliveryFrequency({ payload: { variantGroup , deliveryFrequency  }  }) {
    const selectedDeliveryFrequency = yield select(getSelectedDeliveryFrequency);
    if (selectedDeliveryFrequency !== deliveryFrequency) {
        yield put(resetSelectedSolution({
            variantGroup
        }));
    }
    yield put(selectDeliveryFrequencySuccess({
        variantGroup,
        deliveryFrequency
    }));
}
function* selectBillingPeriod({ payload: { variantGroup , billingPeriod  }  }) {
    const selectedBillingPeriod = yield select(getSelectedBillingPeriod);
    if (selectedBillingPeriod !== billingPeriod) {
        yield put(resetSelectedSolution({
            variantGroup
        }));
    }
    yield put(selectBillingPeriodSuccess({
        variantGroup,
        billingPeriod
    }));
}
function* selectStartDate({ payload: { variantGroup , startDate  }  }) {
    yield put(selectStartDateSuccess({
        variantGroup,
        startDate
    }));
}
function* selectRatePlan({ payload: { variantGroup  }  }) {
    const selectedDeliveryFrequency = yield select(getSelectedDeliveryFrequency);
    const selectedBillingPeriod = yield select(getSelectedBillingPeriod);
    const ratePlans = yield select(getRatePlans);
    if (!statusSuccess(ratePlans)) {
        return;
    }
    let compatibleRatePlans = [];
    if (selectedBillingPeriod) {
        compatibleRatePlans = ratePlans.result.filter((rp)=>rp.shippingSchedule === selectedDeliveryFrequency && rp.billingPeriod === selectedBillingPeriod
        );
    }
    if (!compatibleRatePlans.length && selectedDeliveryFrequency) {
        compatibleRatePlans = ratePlans.result.filter((rp)=>rp.shippingSchedule === selectedDeliveryFrequency
        );
    }
    if (!compatibleRatePlans.length) {
        return yield put(selectRatePlanFailed({
            variantGroup,
            ratePlan: undefined,
            error: new Error('Unable to resolve selections to a compatible rate plan.')
        }));
    }
    const resolvedRatePlan = compatibleRatePlans[0];
    yield put(selectRatePlanSuccess({
        variantGroup,
        ratePlan: resolvedRatePlan
    }));
}
var configurationsSagas = [
    takeLatest(selectDeliveryFrequency$1.type, selectDeliveryFrequency),
    takeLatest(selectBillingPeriod$1.type, selectBillingPeriod),
    takeLatest(selectStartDate$2.type, selectStartDate),
    takeLatest(selectDeliveryFrequencySuccess.type, selectRatePlan),
    takeLatest(selectBillingPeriodSuccess.type, selectRatePlan), 
];

const LABEL_PREFIX = 'products.contactLenses.configurator';
const CONFIGURATOR_ID = 'contact-lenses-subscription';

var UsageLevel;
(function(UsageLevel) {
    UsageLevel["One"] = 'one_day_a_week';
    UsageLevel["Two"] = 'two_days_a_week';
    UsageLevel["ThreeFour"] = 'three_four_days_a_week';
    UsageLevel["FivePlus"] = 'more_than_five_days_a_week';
})(UsageLevel || (UsageLevel = {}));
var BillingFrequency;
(function(BillingFrequency) {
    BillingFrequency["Monthly"] = 'monthly';
    BillingFrequency["Quarterly"] = 'quarterly';
})(BillingFrequency || (BillingFrequency = {}));
var DeliveryFrequency;
(function(DeliveryFrequency) {
    DeliveryFrequency["Monthly"] = 'monthly';
    DeliveryFrequency["Quarterly"] = 'quarterly';
})(DeliveryFrequency || (DeliveryFrequency = {}));

var types = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get UsageLevel () { return UsageLevel; },
  get BillingFrequency () { return BillingFrequency; },
  get DeliveryFrequency () { return DeliveryFrequency; }
});

const usageLevelToFrequency = (usageLevel)=>// Data layer labels are always english
    (({
        [UsageLevel.One]: '1 time a week',
        [UsageLevel.Two]: '2 times a week',
        [UsageLevel.ThreeFour]: '3 or 4 times a week',
        [UsageLevel.FivePlus]: 'more than 5 times a week'
    })[usageLevel])
;
const mapBoxQuantity = (packs, packageQuantity)=>`${packs} ${packs > 1 ? 'boxes' : 'box'} of ${packageQuantity} lenses`
;

var selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  configurations: selectors$3,
  configurator: selectors$2,
  subscriptions: selectors$1
});

const stepMapping = {
    deliveryFrequency: {
        name: 'delivery frequency',
        id: '200'
    },
    subscriptionPlan: {
        name: 'subscription plan',
        id: '300'
    },
    solution: {
        name: 'solutions',
        id: '400'
    }
};
/**
 * Local mappers
 */ const toFrequency = (frequency)=>frequency === 'monthly' ? 'every month' : 'every quarter'
;
/**
 * SHARED SELECTORS
 * Most data layer selectors will use these
 */ const getStepData = createSelector(configuratorIdProp, stateProp, (id, s)=>{
    const currentStep = Selectors.getCurrentStep(s, {
        id
    });
    return currentStep ? stepMapping[currentStep.name] : undefined;
});
const getBoxConfig = createSelector(getPackSize, getSelectedRatePlan, getUsageFrequency, (packSize, ratePlan, usageLevel)=>{
    return {
        frequency: usageLevel && usageLevelToFrequency(usageLevel),
        quantity: mapBoxQuantity(packSize || 1, (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.packageQuantity) || 1)
    };
});
const getLensParameters = createSelector(getPrescription, (prescription)=>{
    if (!prescription) {
        return;
    }
    const { leftLens , rightLens  } = prescription;
    const toLens = (lens)=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        return lens && {
            baseCurve: ((ref = lens.baseCurve) === null || ref === void 0 ? void 0 : ref.toString()) || 'n/a',
            diameter: ((ref1 = lens.diameter) === null || ref1 === void 0 ? void 0 : ref1.toString()) || 'n/a',
            addition: ((ref2 = lens.addition) === null || ref2 === void 0 ? void 0 : ref2.toString()) || 'n/a',
            axis: ((ref3 = lens.axis) === null || ref3 === void 0 ? void 0 : ref3.toString()) || 'n/a',
            power: ((ref4 = lens.power) === null || ref4 === void 0 ? void 0 : ref4.toString()) || 'n/a',
            cylinder: ((ref5 = lens.cylinder) === null || ref5 === void 0 ? void 0 : ref5.toString()) || 'n/a'
        };
    };
    return {
        OS: toLens(leftLens),
        OD: toLens(rightLens)
    };
});
const getConfigFlow = createSelector(getStepData, (step)=>{
    if (!step) return undefined;
    return {
        version: '1.0',
        step
    };
});
const getDeliveryProductConfig = createSelector(getBoxConfig, getLensParameters, getSelectedDeliveryFrequency, getConfigurationTotalPrice, (box, lens, selectedDeliveryFrequency, configurationPrice)=>{
    if (!selectedDeliveryFrequency || !lens || !configurationPrice) {
        return undefined;
    }
    const deliveryFrequency = toFrequency(selectedDeliveryFrequency);
    const price = calcPrice(configurationPrice.originalPrice);
    return {
        purchaseType: 'subscription',
        box,
        lens,
        deliveryFrequency,
        price
    };
});
const getSubscriptionPlanProductConfig = createSelector(getDeliveryProductConfig, getSelectedBillingPeriod, getSelectedStartDate, (productConfig, selectedBillingPeriod, startDate)=>{
    if (!startDate || !selectedBillingPeriod || !productConfig) {
        return undefined;
    }
    const billingFrequency = toFrequency(selectedBillingPeriod);
    return swcHelpers.objectSpread({}, productConfig, {
        billingFrequency,
        startDate: DateUtils.toLocalDate(startDate)
    });
});
const getSolutionsProductConfig = createSelector(getSubscriptionPlanProductConfig, getSelectedSolution, (productConfig, selectedSolution)=>{
    if (!selectedSolution || !productConfig) {
        return undefined;
    }
    const solution = selectedSolution ? {
        included: selectedSolution.sku === '-1' ? 'no' : 'yes',
        sku: selectedSolution.sku === '-1' ? undefined : selectedSolution.sku,
        name: selectedSolution.title === '-1' ? undefined : selectedSolution.title
    } : undefined;
    return swcHelpers.objectSpread({}, productConfig, {
        solution
    });
});
const getProductConfig = createSelector(configuratorIdProp, stateProp, getConfigFlow, (id, s, configFlow)=>{
    if ((configFlow === null || configFlow === void 0 ? void 0 : configFlow.step.id) === '200') {
        return getDeliveryProductConfig(s, {
            id
        });
    }
    if ((configFlow === null || configFlow === void 0 ? void 0 : configFlow.step.id) === '300') {
        return getSubscriptionPlanProductConfig(s, {
            id
        });
    }
    if ((configFlow === null || configFlow === void 0 ? void 0 : configFlow.step.id) === '400') {
        return getSolutionsProductConfig(s, {
            id
        });
    }
    return undefined;
});

const ContactLensesConfigEvent$1 = 'ContactLensesConfigEvent';
function* onStartConfiguration() {
    yield call(onButtonEvent, 'choose plan');
}
/**
 * Wrapper for all 'button click' events
 */ function* onButtonEvent(eventLabel) {
    const buttonEvent = {
        event: ContactLensesConfigEvent$1,
        eventAction: 'click on button',
        eventLabel
    };
    yield put(DataLayer.Actions.pushEvent(buttonEvent));
}
/**
 * Wrapper for all 'view step' events
 */ function* onPushEvent(id, eventAction, eventLabel) {
    const productConfig = yield select(getProductConfig, {
        id
    });
    const configFlow = yield select(getConfigFlow, {
        id
    });
    if (!productConfig || !configFlow) {
        return;
    }
    const event = {
        event: ContactLensesConfigEvent$1,
        eventAction,
        eventLabel,
        RxContactLenses: {
            configFlow,
            productConfig
        }
    };
    yield put(DataLayer.Actions.pushEvent(event));
}
/**
 * Logs a 'view step' event on every step change
 */ function* onViewStep({ payload: { id  }  }) {
    yield call(onPushEvent, id, 'view step');
}
/**
 * Logs when successfully moved to the next step
 */ function* onNextStep() {
    yield call(onButtonEvent, 'next step');
}
/**
 * Logs when successfully moved to the previous step
 */ function* onPreviousStep() {
    yield call(onButtonEvent, 'step back');
}
/**
 * Logs when footer expander is toggled
 */ function* onToggleFooter({ payload: { id  }  }) {
    const isFooterOpen = yield select(Selectors.isFooterOpen, {
        id
    });
    yield call(onButtonEvent, isFooterOpen ? 'expand plan overview' : 'close plan overview');
}
/**
 * Logs when modal is closed, based on the 'resetConfigurationState' action
 */ function* onModalClose() {
    yield call(onButtonEvent, 'close modal');
}
/**
 * Wrapper for all 'changed input' events
 */ function* onChangeEvent(eventAction, productConfig, eventLabel) {
    const changeEvent = {
        event: ContactLensesConfigEvent$1,
        eventAction,
        eventLabel,
        RxContactLenses: {
            productConfig
        }
    };
    yield put(DataLayer.Actions.pushEvent(changeEvent));
}
/**
 * Runs on change of delivery frequency
 */ const onDeliveryChange = (id)=>function*() {
        const productConfig = yield select(getProductConfig, {
            id
        });
        if (!productConfig) return;
        const { deliveryFrequency , price  } = productConfig;
        yield call(onChangeEvent, 'select delivery frequency', {
            deliveryFrequency,
            price
        });
    }
;
/**
 * Runs on change of billing frequency
 */ const onBillingChange = (id)=>function*() {
        const productConfig = yield select(getProductConfig, {
            id
        });
        if (!productConfig) return;
        const { billingFrequency , price  } = productConfig;
        yield call(onChangeEvent, 'select billing frequency', {
            billingFrequency,
            price
        });
    }
;
/**
 * Runs on change of subscription start date
 */ function* onStartDateChange({ payload: { startDate  }  }) {
    yield call(onChangeEvent, 'select start date', {
        startDate
    });
}
/**
 * Runs on change of solution
 */ const onSolutionChange = (id)=>function*() {
        const productConfig = yield select(getProductConfig, {
            id
        });
        if (!productConfig) return;
        const { solution , price  } = productConfig;
        yield call(onChangeEvent, 'select solution', {
            solution,
            price
        });
    }
;
/**
 * This function binds the the configurator ID to the selection actions, which is necessary to provide
 * the correct data for data layer events.
 */ function* listenForConfigurationChanges(id) {
    yield all([
        takeLatest(selectDeliveryFrequencySuccess.type, onDeliveryChange(id)),
        takeLatest(selectBillingPeriodSuccess.type, onBillingChange(id)),
        takeLatest(selectSolution.type, onSolutionChange(id)), 
    ]);
}
var datalayerSagas = [
    // CLS configurator actions
    takeLatest(startContactLensSubscriptionConfiguration.type, onStartConfiguration),
    takeLatest(resetConfigurationState.type, onModalClose),
    // Generic configurator actions
    takeLatest(Actions.isStepShownWithId(CONFIGURATOR_ID), onViewStep),
    takeLatest(Actions.isNextStepWithId(CONFIGURATOR_ID), onNextStep),
    takeLatest(Actions.isPreviousStepWithId(CONFIGURATOR_ID), onPreviousStep),
    takeLatest(Actions.isToggleFooterWithId(CONFIGURATOR_ID), onToggleFooter),
    // Data Layer actions
    // this action is listened to separately from the listenForConfigurationChanges because
    // it needs to be triggered explicitly on demand
    takeLatest(selectStartDate$1.type, onStartDateChange), 
];

function* contactLensSubscriptionSaga() {
    yield all([
        ...configurationsSagas,
        ...datalayerSagas
    ]);
}

const ProductReimbursableLogo = ({ logos , variant ='default'  })=>{
    const { getLabel  } = useIntl();
    if (!logos || !logos.default && !logos.alternative) {
        return null;
    }
    const logoUrl = variant === 'alternative' && logos.alternative ? logos.alternative : logos.default;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-reimbursable",
        "data-t": variant
    }, /*#__PURE__*/ React.createElement("img", {
        className: "product-reimbursable__image",
        src: logoUrl,
        alt: getLabel('products.insuranceReimbursable')
    }));
};

const isLightProductModel = (product)=>'objectID' in product
;
const isContactLenses = (productType)=>CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType)
;

const Details = ({ brand , name  })=>/*#__PURE__*/ React__default.createElement("header", {
        className: "product-block-details"
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        className: "product-block-details__brand",
        variant: "subheading1"
    }, brand), /*#__PURE__*/ React__default.createElement(Text, {
        className: "product-block-details__name",
        variant: "caption"
    }, name))
;

const Images = ({ front , angle  })=>{
    // Default width and height to set the right aspect ratios 320/180 = 16:9
    const defaultSettings = {
        width: 320,
        height: 180,
        rootMargin: '150px 0px'
    };
    const isPhone = MediaQuery.useIsPhone();
    const { getLabel  } = useIntl();
    const Placeholder = (src, alt)=>/*#__PURE__*/ React__default.createElement("div", {
            className: "product-block-image-placeholder"
        }, /*#__PURE__*/ React__default.createElement(SkeletonLoader, null, /*#__PURE__*/ React__default.createElement("svg", {
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            height: "220",
            "aria-label": getLabel('common.loadingText')
        }, /*#__PURE__*/ React__default.createElement("rect", {
            width: "100%",
            height: "100",
            rx: "5",
            fill: "currentColor"
        }), /*#__PURE__*/ React__default.createElement("rect", {
            width: "80%",
            height: "15",
            rx: "5",
            fill: "currentColor",
            x: "10%",
            y: "140"
        }), /*#__PURE__*/ React__default.createElement("rect", {
            width: "80%",
            height: "15",
            rx: "5",
            fill: "currentColor",
            x: "10%",
            y: "165"
        }), /*#__PURE__*/ React__default.createElement("rect", {
            width: "50%",
            height: "15",
            rx: "5",
            fill: "currentColor",
            x: "25%",
            y: "200"
        }))), /*#__PURE__*/ React__default.createElement("noscript", null, /*#__PURE__*/ React__default.createElement("img", {
            src: src,
            alt: alt,
            width: defaultSettings.width,
            height: defaultSettings.height
        })))
    ;
    return /*#__PURE__*/ React__default.createElement("section", {
        className: classnames('product-block-image-wrapper', {
            // Only enable hover behaviour if we have have an angle image as well and are not on a phone
            'product-block-image-wrapper--hover': !!angle && !isPhone
        }),
        style: {
            paddingBottom: `${defaultSettings.height / defaultSettings.width * 100}%`
        }
    }, front && /*#__PURE__*/ React__default.createElement("figure", {
        className: "product-block-image product-block-image--front"
    }, /*#__PURE__*/ React__default.createElement(LazyImage, swcHelpers.extends({}, defaultSettings, {
        className: "product-block-image__lazy-image",
        src: front.url,
        alt: front.alt || '',
        srcSet: front.srcSet,
        sizes: front.sizes,
        placeholder: Placeholder(front.url, front.alt)
    }))), angle && !isPhone && /*#__PURE__*/ React__default.createElement("figure", {
        className: "product-block-image product-block-image--angle"
    }, /*#__PURE__*/ React__default.createElement(LazyImage, swcHelpers.extends({}, defaultSettings, {
        className: "product-block-image__lazy-image",
        src: angle.url,
        alt: angle.alt || '',
        srcSet: angle.srcSet,
        sizes: angle.sizes,
        placeholder: Placeholder(angle.url, angle.alt)
    }))));
};

const Prices = ({ price , discountedPrice  })=>{
    const { currency  } = useIntl();
    const hasDiscount = !!discountedPrice && discountedPrice !== price;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-block-prices"
    }, /*#__PURE__*/ React.createElement(Price, {
        value: discountedPrice !== null && discountedPrice !== void 0 ? discountedPrice : price,
        currency: currency,
        size: "small",
        type: hasDiscount ? 'discount' : 'default'
    }), hasDiscount && /*#__PURE__*/ React.createElement(Price, {
        value: price,
        currency: currency,
        size: "small",
        type: "strikethrough"
    }));
};

const PromotionLabel = ({ children  })=>/*#__PURE__*/ React__default.createElement("span", {
        className: "product-block-promotion-label"
    }, children)
;

const VariantSwitcherItem = ({ image , sku , isActive , onClick  })=>{
    const handleClick = React__default.useCallback((e)=>{
        onClick(sku);
        e.preventDefault();
        e.stopPropagation();
    }, [
        sku
    ]);
    if (!image) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement("button", {
        onClick: handleClick,
        "aria-label": image.alt || '',
        className: classnames('variant-switcher-item', {
            'variant-switcher-item--active': isActive
        })
    }, /*#__PURE__*/ React__default.createElement(LazyImage, {
        className: "variant-switcher-item__image",
        src: image.url,
        alt: image.alt || '',
        // 16:9 ratio
        height: 22.5,
        width: 40
    }));
};
const VariantSwitcher = ({ variants , activeSku , onVariantChange , className ,  })=>{
    const itemsPerSlide = MediaQuery.useIsPhone() ? 2 : 3;
    const carouselItems = React__default.useMemo(()=>{
        const max = Math.ceil(variants.length / itemsPerSlide);
        const items = [];
        for(let i = 0; i < max; i++){
            const start = i * itemsPerSlide;
            const end = (i + 1) * itemsPerSlide;
            items.push(/*#__PURE__*/ React__default.createElement("div", {
                key: `variant-switcher-${i}`,
                className: classnames('variant-switcher__slide', {
                    'variant-switcher__slide--single': max === 1
                })
            }, variants.slice(start, end).map(({ sku , image  })=>/*#__PURE__*/ React__default.createElement(VariantSwitcherItem, {
                    key: sku,
                    image: image,
                    sku: sku,
                    isActive: sku === activeSku,
                    onClick: onVariantChange
                })
            )));
        }
        return items;
    }, [
        variants,
        activeSku,
        onVariantChange,
        itemsPerSlide
    ]);
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('variant-switcher', className)
    }, /*#__PURE__*/ React__default.createElement(Carousel, {
        pagination: false
    }, carouselItems));
};

const ProductBlock = /*#__PURE__*/ React.forwardRef(({ brand , discounted , name , url , productType , activeSku , images , price , discountedPrice , variants , offering , promotionLabel , className , onVariantChange , onClick , isInsuranceReimbursable , reimbursableLogos , isReimbursableFiltered , tag ,  }, ref)=>{
    const { getFormattedLabel  } = useIntl();
    const isLargeScreen = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    if (!activeSku || !price || !url) {
        console.warn(`Cannot render ProductBlock component without a valid price: ${price} and url: ${url} and active sku: ${activeSku}.`);
        return null;
    }
    const { isProductLabelEnabled  } = useFeatureToggles();
    return /*#__PURE__*/ React.createElement("a", {
        ref: ref,
        href: url,
        onClick: onClick,
        "aria-label": `${brand} ${name}`,
        "data-t": "product-block",
        className: classnames('product-block', {
            'product-block--contact-lenses': isContactLenses(productType)
        }, className)
    }, /*#__PURE__*/ React.createElement("aside", {
        className: "product-block__header"
    }, isProductLabelEnabled && promotionLabel && /*#__PURE__*/ React.createElement(PromotionLabel, null, promotionLabel), !isProductLabelEnabled && tag && /*#__PURE__*/ React.createElement(ProductTag, {
        className: "product-block__header-tag",
        tag: tag
    }), isLargeScreen && isInsuranceReimbursable && /*#__PURE__*/ React.createElement(ProductReimbursableLogo, {
        logos: reimbursableLogos,
        variant: isReimbursableFiltered ? 'alternative' : 'default'
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-block__main"
    }, /*#__PURE__*/ React.createElement(Images, {
        front: images.front,
        angle: images.angle
    }), /*#__PURE__*/ React.createElement(Details, {
        brand: brand,
        name: name
    }), /*#__PURE__*/ React.createElement(Prices, {
        price: price,
        discountedPrice: discountedPrice
    }), !isProductLabelEnabled && discounted && /*#__PURE__*/ React.createElement(Discount, {
        label: promotionLabel,
        discount: discounted
    })), /*#__PURE__*/ React.createElement("footer", {
        className: "product-block__footer"
    }, !!(variants === null || variants === void 0 ? void 0 : variants.length) && /*#__PURE__*/ React.createElement(VariantSwitcher, {
        variants: variants,
        activeSku: activeSku,
        onVariantChange: onVariantChange,
        className: "product-block__variant-switcher"
    }), (offering === null || offering === void 0 ? void 0 : offering.includesLenses) && /*#__PURE__*/ React.createElement(Text, {
        className: "product-block__bottom-link"
    }, getFormattedLabel('products.glasses.offering.includesLenses', {
        parseLink: true,
        hideLabelKey: true
    }))));
});

const createAltTag = (options)=>{
    var ref, ref1;
    const variant = options.variant;
    const locale = options.locale;
    const labels = options.labels;
    const brand = getAttrValue(variant, 'brand') || '';
    const accessoireType = getJoinedLocalizedAttrValues(variant, 'accessoryType', locale);
    const accessoireColor = getJoinedLocalizedAttrValues(variant, 'accessoryColor', locale);
    const frameColor = getJoinedLocalizedAttrValues(variant, 'frameColor', locale);
    const lensColor = getJoinedLocalizedAttrValues(variant, 'lensColor', locale);
    const replacementFrequency = getJoinedLocalizedAttrValues(variant, 'replacementFrequency', locale);
    const solutionType = (ref1 = (ref = getAttrValue(variant, 'solutionType')) === null || ref === void 0 ? void 0 : ref.toString()) === null || ref1 === void 0 ? void 0 : ref1.replace('Eye drops', '');
    const packageOption = getAttrValue(variant, 'packageOption');
    const colorsLabel = [
        lensColor,
        frameColor
    ].filter((s)=>s.trim() !== ''
    ).join(' / ');
    const packageQuantity = getAttrValue(variant, 'packageQuantity');
    const packageQuantityLabel = packageQuantity && labels ? `${packageQuantity} ${packageQuantity === 1 ? labels.lens : labels.lenses} ${labels.perBox}` : '';
    return [
        options.prefix,
        brand,
        variant.name,
        solutionType,
        packageOption,
        replacementFrequency,
        packageQuantityLabel,
        colorsLabel,
        accessoireType,
        accessoireColor, 
    ].filter(Boolean).filter((entry)=>entry != ''
    ).join(' ');
};

const defaultParams = {
    fit: 'fill',
    format: 'jpeg'
};
const imageSizes = {
    S: 171,
    M: 192,
    L: 272,
    XL: 544
};
/**
 *
 * Product Image helpers
 */ const calcHeightToRatio = (w)=>Math.round(w * (9 / 16))
;
const createImgUrl = (url, params = {})=>{
    return `${createImageUrl(url, swcHelpers.objectSpread({}, defaultParams, params))}`;
};
const createImageSrcSetItem = (url, width, params)=>{
    return `${createImageUrl(url, swcHelpers.objectSpread({}, defaultParams, params, {
        width,
        height: calcHeightToRatio(width)
    }))} ${width}w`;
};
const createImageSrcSet = (url, imageSizes1, params)=>{
    return Object.values(imageSizes1).map((size)=>createImageSrcSetItem(url, size, params)
    ).toString();
};
const createImageSizes = (imageSizes2)=>{
    const sizes = Object.values(imageSizes2);
    return Object.values(MediaQuery.Breakpoints).map((bp, i)=>`(max-width: ${bp}px) ${sizes[i]}px`
    ).join(', ');
};
function createResponsiveImage(image, alt, params) {
    const imageUrl = typeof image === 'string' ? image : image.url;
    const resolvedAlt = (typeof image === 'string' ? alt : image.alt) || alt;
    return {
        url: createImgUrl(imageUrl, params),
        alt: resolvedAlt,
        srcSet: createImageSrcSet(imageUrl, imageSizes),
        sizes: createImageSizes(imageSizes)
    };
}
//----- End helpers ----- //
function getVariantImages(variant, locale, params, responsive = true, labels) {
    const altTag = createAltTag({
        variant,
        locale,
        labels
    });
    const settings = Boolean(params) ? params : {
        width: imageSizes.XL,
        height: calcHeightToRatio(imageSizes.XL)
    };
    return getProductImages(variant, responsive, altTag, settings);
}
// Map placeholderImage to correct format
const placeholderImg = {
    url: placeholderImage.url
};
function getProductImages(variant, responsive, altTag, params) {
    var ref;
    const images = (ref = variant.media) === null || ref === void 0 ? void 0 : ref.images;
    if (!images || !images.length) {
        return [
            placeholderImg
        ];
    }
    return images.map((img)=>{
        const imageUrl = img.url;
        return responsive ? createResponsiveImage(imageUrl, altTag, params) : {
            url: createImgUrl(imageUrl, params),
            alt: altTag
        };
    });
}

function getVariantInfo(locale, product, variant, productType) {
    const isLenses = CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType);
    const isSolutions = CommerceToolsApi.isSolutions(productType);
    const brand = isLenses || isSolutions ? getLocalizedValue(product.name, locale) : String(getAttrValue(variant, 'brand'));
    const name = isLenses ? getLocalizedAttrValue(variant, 'replacementFrequency', locale) : isSolutions ? `${getLocalizedAttrValue(variant, 'contactLensCareType', locale) || ''} ${getAttrValue(variant, 'packageOption') || ''}` : variant.name;
    const { originalPrice , discountedPrice  } = getPrice$2(variant) || {};
    const framePriceIncluded = CommerceToolsApi.isFrames(productType) && getAttrValue(variant, 'priceIncluded');
    const price = framePriceIncluded && typeof framePriceIncluded === 'object' ? Number(framePriceIncluded.centAmount) : originalPrice;
    return swcHelpers.objectSpread({
        brand: brand || '',
        discounted: getDiscount(variant, locale),
        name: name || '',
        sku: variant.sku,
        price,
        tag: getProductTag(variant, locale)
    }, discountedPrice && discountedPrice !== originalPrice ? {
        discountedPrice
    } : {});
}

function getVariantUrl(formatProductUrl, product, variant, productType, additionalUrlParams) {
    if (!productType) {
        console.error(`ProductType data is missing from product with id ${product.id}, make sure you 'expand' the productType when fetching from commercetools.`, product);
        return '#';
    }
    if (!variant.sku) {
        console.error(`Variant for product with id ${product.id} has no sku`, {
            variant,
            product
        });
        return '#';
    }
    return formatProductUrl({
        productType,
        sku: variant.sku,
        slug: product.slug
    }, additionalUrlParams);
}

const getActiveVariant = (variants, sku)=>sku && variants.find((variant)=>variant.sku === sku
    ) || variants[0]
;

var ref$3;
const getProductTypeName = (product)=>{
    var ref1;
    return (ref$3 = (ref1 = product.productType.obj) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref$3 !== void 0 ? ref$3 : '';
};
function useCommerceToolsProductData(product, activeSku, formatProductUrl, additionalUrlParams) {
    const { getLabel , locale  } = useIntl();
    const productType = React.useMemo(()=>getProductTypeName(product)
    , [
        product
    ]);
    const variants = React.useMemo(()=>[
            product.masterVariant,
            ...product.variants
        ]
    , [
        product.masterVariant,
        product.variants, 
    ]);
    const activeVariant = React.useMemo(()=>getActiveVariant(variants, activeSku)
    , [
        variants,
        activeSku, 
    ]);
    const variantInfo = getVariantInfo(locale, product, activeVariant, productType);
    const variantUrl = getVariantUrl(formatProductUrl, product, activeVariant, productType, additionalUrlParams);
    const promotionLabel = getDiscountText(locale, activeVariant);
    const labels = React.useMemo(()=>({
            lens: getLabel(`products.unit.contactLens`),
            lenses: getLabel(`products.unit.contactLenses`),
            perBox: getLabel(`products.perBox`)
        })
    , [
        getLabel
    ]);
    const variantImages = React.useMemo(()=>{
        const [front, angle] = getVariantImages(activeVariant, locale, undefined, true, labels);
        return {
            front,
            angle
        };
    }, [
        locale,
        activeVariant
    ]);
    const otherVariants = React.useMemo(()=>{
        const thumbnailSize = {
            width: 40,
            height: 23
        };
        return variants.length > 1 ? variants.map((variant)=>({
                sku: variant.sku,
                image: getVariantImages(variant, locale, thumbnailSize, false, labels)[0]
            })
        ) : [];
    }, [
        variants,
        locale
    ]);
    const isInsuranceReimbursable = Boolean(activeVariant.isInsuranceReimbursable);
    return {
        productType,
        variantInfo,
        variantUrl,
        promotionLabel,
        variantImages,
        otherVariants,
        isInsuranceReimbursable
    };
}

const CommerceToolsProductBlock = ({ product , formatProductUrl , onClick , onImpression , className , reimbursableLogos ,  })=>{
    const [activeSku, setActiveSku] = React.useState(product.masterVariant.sku || '');
    const { wasSeen , ref  } = useWasSeenByUser();
    const handleVariantChange = React.useCallback((sku)=>{
        sku && setActiveSku(sku);
    }, []);
    React.useEffect(()=>{
        if (wasSeen && onImpression) onImpression();
    }, [
        wasSeen
    ]);
    const { productType , variantInfo , variantUrl , variantImages , otherVariants , promotionLabel , isInsuranceReimbursable ,  } = useCommerceToolsProductData(product, activeSku, formatProductUrl);
    if (!variantInfo || !variantUrl) {
        console.error('CommerceToolsProductBlock: missing critical info required for rendering', {
            variantInfo,
            variantUrl
        });
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductBlock, swcHelpers.extends({
        ref: ref,
        className: className,
        url: variantUrl,
        images: variantImages,
        variants: otherVariants || [],
        promotionLabel: promotionLabel,
        productType: productType,
        activeSku: activeSku,
        reimbursableLogos: reimbursableLogos,
        onVariantChange: handleVariantChange,
        onClick: onClick,
        isInsuranceReimbursable: isInsuranceReimbursable
    }, variantInfo));
};

const pushPowerSelectionEvent = (event, eventLabel)=>{
    DataLayer.pushEvent({
        event,
        eventAction: 'plp select lens power',
        eventLabel
    });
};

const AlgoliaProductBlock = ({ product , formatProductUrl , additionalUrlParams , onClick , onImpression , className , reimbursableLogos ,  })=>{
    const [activeSku, setActiveSku] = React.useState(product.masterVariant.sku || '');
    const { wasSeen , ref: ref2  } = useWasSeenByUser();
    const handleVariantChange = React.useCallback((sku)=>{
        var ref;
        var ref1;
        if (CommerceToolsApi.isReadyReaders((ref1 = (ref = product.productType.obj) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : '')) {
            const selectedVariant = product.variants.find((variant)=>variant.sku === sku
            );
            const selectedPower = selectedVariant && getAttrValue(selectedVariant, 'power');
            const eventLabel = selectedPower && `${sku} | ${selectedPower}`;
            eventLabel ? pushPowerSelectionEvent('readyreaders', eventLabel) : null;
        }
        sku && setActiveSku(sku);
    }, []);
    React.useEffect(()=>{
        if (wasSeen && onImpression) onImpression();
    }, [
        wasSeen
    ]);
    // TODO: in the near future, we want to start stripping the data models we use in algolia (ProductProjectionLight)
    //  to make the records much smaller and improve performance. Then we can start splitting stuff from the CT data resolver.
    const { productType , variantInfo , variantUrl , variantImages , otherVariants , promotionLabel , isInsuranceReimbursable ,  } = useCommerceToolsProductData(product, activeSku, formatProductUrl, additionalUrlParams);
    const isReimbursableFiltered = (additionalUrlParams === null || additionalUrlParams === void 0 ? void 0 : additionalUrlParams.isInsuranceReimbursable) === 'true';
    if (!variantInfo || !variantUrl) {
        console.error('AlgoliaProductBlock: missing critical info required for rendering', {
            variantInfo,
            variantUrl
        });
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductBlock, swcHelpers.extends({
        ref: ref2,
        productType: productType,
        className: className,
        url: variantUrl,
        images: variantImages,
        variants: otherVariants || [],
        promotionLabel: promotionLabel,
        activeSku: activeSku,
        onVariantChange: handleVariantChange,
        onClick: onClick,
        reimbursableLogos: reimbursableLogos,
        isInsuranceReimbursable: isInsuranceReimbursable,
        isReimbursableFiltered: isReimbursableFiltered,
        offering: product.offering
    }, variantInfo));
};

function useGetProductsBySku(skus, limit) {
    const { productsUrl  } = useApiConfig();
    const [state, setState] = React.useState({
        products: [],
        isLoading: true,
        error: null
    });
    React.useEffect(()=>{
        let isCancelled = false;
        function loadProducts() {
            return _loadProducts.apply(this, arguments);
        }
        function _loadProducts() {
            _loadProducts = swcHelpers.asyncToGenerator(function*() {
                try {
                    const products = yield fetchProducts(productsUrl, skus, limit);
                    if (products && !isCancelled) {
                        setState(swcHelpers.objectSpread({}, state, {
                            products,
                            isLoading: false
                        }));
                    }
                } catch (error) {
                    console.error(error);
                    if (!isCancelled) {
                        setState(swcHelpers.objectSpread({}, state, {
                            error,
                            isLoading: false
                        }));
                    }
                }
            });
            return _loadProducts.apply(this, arguments);
        }
        (skus === null || skus === void 0 ? void 0 : skus.length) && loadProducts();
        return ()=>{
            isCancelled = true;
        };
    }, [
        productsUrl,
        skus
    ]);
    return state;
}
function fetchProducts(apiUrl) {
    return _fetchProducts.apply(this, arguments);
}
function _fetchProducts() {
    _fetchProducts = swcHelpers.asyncToGenerator(function*(apiUrl, skus = [], limit) {
        if (!skus.length) {
            return [];
        }
        const skusFilter = skus.filter((s)=>!!s.length
        ).map((sku)=>`"${sku}"`
        ).join(',');
        const filters = [
            `variants.sku:${skusFilter}`
        ];
        const expand = [
            'productType',
            'masterVariant.prices[*].discounted.discount',
            'variants[*].prices[*].discounted.discount', 
        ];
        const { results  } = yield Products.query(apiUrl, {
            filters,
            expand
        });
        const sortedProducts = sortProducts(skus, results);
        return limit ? sortedProducts.slice(0, limit) : sortedProducts;
    });
    return _fetchProducts.apply(this, arguments);
}
// The Product service currently doesn't have a way to return the products in the same order
// as the SKUs array is provided, so we have to manually sort the products based on the SKU array.
function sortProducts(skus, products = []) {
    return [
        ...products
    ].sort((productA, productB)=>{
        const indexA = skus.findIndex((sku)=>[
                productA.masterVariant,
                ...productA.variants
            ].find((v)=>v.sku === sku
            )
        );
        const indexB = skus.findIndex((sku)=>[
                productB.masterVariant,
                ...productB.variants
            ].find((v)=>v.sku === sku
            )
        );
        return indexA - indexB;
    });
}

const ProductBlocksContainer = ({ skus =[] , limit , staticsUrl , formatProductUrl , className , reimbursableLogos  })=>{
    const { products , isLoading  } = useGetProductsBySku(skus, limit);
    const classNames = classnames('product-blocks-container', {
        className,
        loading: isLoading
    });
    const productBlockProps = React.useMemo(()=>({
            staticsUrl,
            formatProductUrl,
            reimbursableLogos,
            showVariants: true
        })
    , [
        staticsUrl,
        formatProductUrl
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames
    }, isLoading ? /*#__PURE__*/ React.createElement(Loader, null) : products.map((product)=>/*#__PURE__*/ React.createElement(CommerceToolsProductBlock, swcHelpers.extends({
            key: product.id,
            product: product
        }, productBlockProps))
    ));
};

const ProductDetailContext = /*#__PURE__*/ React.createContext({});
const useProductDetailContext = ()=>React.useContext(ProductDetailContext)
;
var ProductDetailProvider = (_param)=>{
    var { children , product , locale , sku , productType , staticsUrl , renderAddToCartButton , reimbursableLogos  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "product",
        "locale",
        "sku",
        "productType",
        "staticsUrl",
        "renderAddToCartButton",
        "reimbursableLogos"
    ]);
    const { isBynderImagesEnabled  } = useFeatureToggles();
    const [state, dispatch] = React.useReducer(ProductDetailReducer.productDetailContextReducer, swcHelpers.objectSpread({}, ProductDetailReducer.initialState, {
        activeSku: sku
    }));
    const activeVariant = React.useMemo(()=>getVariantInfo$1(product, productType, locale, state.activeSku, staticsUrl, isBynderImagesEnabled)
    , [
        staticsUrl,
        locale,
        product,
        productType,
        state.activeSku,
        isBynderImagesEnabled
    ]);
    const value = swcHelpers.objectSpread({}, state, {
        activeVariant,
        dispatch,
        product,
        productType,
        staticsUrl,
        renderAddToCartButton,
        reimbursableLogos
    }, rest);
    return /*#__PURE__*/ React.createElement(ProductDetailContext.Provider, {
        value: value
    }, children);
};

const attributes = {
    addition: undefined,
    axis: undefined,
    baseCurve: undefined,
    color: undefined,
    cylinder: undefined,
    diameter: undefined,
    power: undefined
};
const initialState = {
    left: attributes,
    right: attributes
};
const reducer = (state, action)=>{
    switch(action.type){
        case 'set':
            {
                const { key , value  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    [key]: swcHelpers.objectSpread({}, state[key], value)
                });
            }
        case 'clear':
            {
                const key = action.payload;
                if (key) {
                    return swcHelpers.objectSpread({}, state, {
                        [key]: initialState[key]
                    });
                }
                return initialState;
            }
        default:
            return state;
    }
};
const useAttributes = ()=>{
    const [attributes1, dispatch] = React__default.useReducer(reducer, initialState);
    const setAttribute = React__default.useCallback((eyeSide, attribute, value)=>dispatch({
            type: 'set',
            payload: {
                key: eyeSide,
                value: {
                    [attribute]: value
                }
            }
        })
    , []);
    const reset = React__default.useCallback(()=>dispatch({
            type: 'clear'
        })
    , []);
    const clearEyeSide = React__default.useCallback((eyeSide)=>dispatch({
            type: 'clear',
            payload: eyeSide
        })
    , []);
    const actions = React__default.useMemo(()=>({
            clearEyeSide,
            reset,
            setAttribute
        })
    , []);
    return React__default.useMemo(()=>[
            attributes1,
            actions
        ]
    , [
        actions,
        attributes1
    ]);
};

const useFetchBundle = (bundleSku)=>{
    const { productsUrl  } = useApiConfig();
    const params = React__default.useMemo(()=>bundleSku ? {
            sku: bundleSku
        } : null
    , [
        bundleSku
    ]);
    const bundleRequestOptions = React__default.useMemo(()=>({
            skip: !params
        })
    , [
        params
    ]);
    const [, data] = useApiClient(Products.getContactLensBundles, bundleRequestOptions, productsUrl, params);
    return data;
};

const upperFirst = (value)=>{
    return value[0].toUpperCase() + value.slice(1);
};
const defaultLineItems = {
    leftLensSku: '',
    leftLensName: '',
    rightLensSku: '',
    rightLensName: ''
};
const convertAttributesToLineItems = ({ attributesState , bundleSku , name , sku , solutionSku , solutionName ,  })=>{
    const productType = 'contact-lens-bundle';
    const eyeSides = Object.keys(attributesState);
    const eyeAttributes = eyeSides.reduce((result, eyeSide)=>{
        const lensAttributes = attributesState[eyeSide];
        const attributeKeys = Object.keys(lensAttributes);
        const lineItems = attributeKeys.reduce((eyeSideResult, attribute)=>{
            const lensAttributeName = `${eyeSide}Lens${upperFirst(attribute)}`;
            const lensAttributeValue = lensAttributes[attribute];
            if (lensAttributeValue === undefined) {
                return eyeSideResult;
            }
            // Some values can be "- 5.25", parseFloat needs "-5.25"
            const cleanValue = lensAttributeValue.replace(/\s+/g, '');
            return swcHelpers.objectSpread({}, eyeSideResult, {
                [lensAttributeName]: parseFloat(cleanValue)
            });
        }, {});
        return swcHelpers.objectSpread({}, result, lineItems, {
            [`${eyeSide}LensSku`]: sku,
            [`${eyeSide}LensName`]: name
        });
    }, defaultLineItems);
    // Remove undefined or empty string values
    const customAttributes = Object.entries(swcHelpers.objectSpread({}, eyeAttributes, {
        solutionSku,
        solutionName,
        type: productType
    })).reduce((result, [key, value])=>value == null || value === '' ? result : swcHelpers.objectSpread({}, result, {
            [key]: value
        })
    , {});
    return [
        {
            sku: bundleSku,
            customAttributes
        }
    ];
};

const LensBundleContext = /*#__PURE__*/ React.createContext(null);
const LensBundleProvider = ({ subscriptionProductSKU , children  })=>{
    const data = useFetchBundle(subscriptionProductSKU);
    const { locale  } = useIntl();
    const bundle = data && data.results[0];
    const solutions = data && data.solutions;
    // Bridge between current lenses logic and bundle logic
    const [attributesState, attributeActions] = useAttributes();
    // When the solution changes, the requested sku is updated
    const [bundleSku, setBundleSku] = React.useState('');
    // This sets the initial selected sku
    React.useEffect(()=>{
        if (bundle === null || bundle === void 0 ? void 0 : bundle.masterVariant.sku) {
            setBundleSku(bundle === null || bundle === void 0 ? void 0 : bundle.masterVariant.sku);
        } else {
            console.error('LensBundleProvider: Missing contact lens bundle product');
        }
    }, [
        bundle
    ]);
    const solution1 = React.useMemo(()=>{
        return solutions === null || solutions === void 0 ? void 0 : solutions.find((solution)=>solution.bundleSku === bundleSku
        );
    }, [
        bundleSku,
        solutions
    ]);
    // Based on the selected solution a price is calculated for each month
    const pricePerMonth = React.useMemo(()=>{
        return solution1 && solution1.bundlePrice[0].value;
    }, [
        solution1
    ]);
    const lensSku = React.useMemo(()=>{
        if (bundle) {
            var ref, ref1, ref2, ref3;
            const productReference = (ref1 = (ref = bundle.masterVariant.attributes) === null || ref === void 0 ? void 0 : ref.find((attribute)=>attribute.name === 'bundleProduct1'
            )) === null || ref1 === void 0 ? void 0 : ref1.value;
            const lensMasterData = productReference === null || productReference === void 0 ? void 0 : (ref2 = productReference.obj) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.masterData) === null || ref3 === void 0 ? void 0 : ref3.current;
            const sku = lensMasterData === null || lensMasterData === void 0 ? void 0 : lensMasterData.masterVariant.sku;
            return sku;
        }
    }, [
        bundle
    ]);
    const lineItems = React.useMemo(()=>{
        return convertAttributesToLineItems({
            bundleSku,
            name: (bundle === null || bundle === void 0 ? void 0 : bundle.name) ? getLocalizedValue(bundle === null || bundle === void 0 ? void 0 : bundle.name, locale) : '',
            sku: lensSku,
            attributesState,
            solutionName: (solution1 === null || solution1 === void 0 ? void 0 : solution1.name) ? getLocalizedValue(solution1 === null || solution1 === void 0 ? void 0 : solution1.name, locale) : undefined,
            solutionSku: solution1 === null || solution1 === void 0 ? void 0 : solution1.sku
        });
    }, [
        bundleSku,
        bundle,
        lensSku,
        attributesState,
        solution1,
        locale
    ]);
    const context = React.useMemo(()=>{
        return {
            bundleSku,
            pricePerMonth,
            attributes: {
                state: attributesState,
                actions: attributeActions
            },
            lineItems,
            solutions: {
                onSolutionChange: (sku, onChanged)=>{
                    setBundleSku(sku);
                    onChanged && onChanged();
                },
                activeSolution: solution1,
                items: (data === null || data === void 0 ? void 0 : data.solutions) || []
            }
        };
    }, [
        attributesState,
        lineItems,
        bundle,
        bundleSku
    ]);
    return /*#__PURE__*/ React.createElement(LensBundleContext.Provider, {
        value: context
    }, children);
};
const useLensBundle = ()=>{
    const context = React.useContext(LensBundleContext);
    if (context === null) {
        throw new Error('Missing contact lens bundle provider. Make sure the page is wrapped with the LensBundleProvider');
    }
    return context;
};

const pushImageGalleryItemExpandedEvent = (isExpanded)=>{
    DataLayer.pushEvent({
        event: 'image gallery',
        eventAction: 'click',
        eventLabel: isExpanded ? 'show more' : 'show less'
    });
};

const defaultImageParams = {
    fit: 'fill',
    format: 'png'
};
const highlightedPackshots = new Set([
    'On_Model_Female01',
    'On_Model_Female02',
    'On_Model_Female03',
    'On_Model_Male01',
    'On_Model_Male02',
    'On_Model_Male03', 
]);
const ProductImageGalleryContainer = ({ product , vtoBanner , activeVariant ,  })=>{
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { getLabel , locale  } = useIntl();
    const [isImageVisible, setImageVisible] = React.useState(false);
    const [zoomMobileOpenIndex, setZoomMobileOpenIndex] = React.useState(null);
    const { isEnabled , isActive: vtoActive , setActive: setVtoActive  } = useVtoConfig();
    const buttonClickedForZoomRef = React.useRef(null);
    const [isExpanded, setIsExpanded] = React.useState(false);
    const activeVariantProduct = getActiveVariant$1(product, activeVariant.sku);
    const handleGalleryExpansion = React.useCallback((expanded)=>{
        if (!isImageVisible && expanded) {
            setImageVisible(true);
        }
        setIsExpanded(expanded);
    }, [
        isImageVisible
    ]);
    React.useEffect(()=>{
        if (isImageVisible) {
            pushImageGalleryItemExpandedEvent(isExpanded);
        }
    }, [
        isImageVisible,
        isExpanded
    ]);
    const handleImageInteraction = React.useCallback((index)=>{
        var ref;
        if (index === null) (ref = buttonClickedForZoomRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        setZoomMobileOpenIndex(index);
    }, []);
    const altTagLabels = React.useMemo(()=>({
            lens: getLabel(`products.unit.contactLens`),
            lenses: getLabel(`products.unit.contactLenses`),
            perBox: getLabel(`products.perBox`)
        })
    , [
        getLabel
    ]);
    const { initialImages: initialImages1 , expandableImages: expandableImages1 , enhancedImages: enhancedImages1  } = React.useMemo(()=>{
        var ref;
        // Use placeholder if there are no images
        const variantImages = ((ref = activeVariant.images) === null || ref === void 0 ? void 0 : ref.length) > 0 ? activeVariant.images : [
            placeholderImage
        ];
        const enhancedImages = variantImages.map((image)=>swcHelpers.objectSpread({}, image, {
                thumbnailUrl: createImageUrl(image.url, swcHelpers.objectSpread({}, defaultImageParams, {
                    width: 224
                })),
                altText: createAltTag({
                    variant: product.masterVariant,
                    locale,
                    prefix: image.label,
                    labels: altTagLabels
                }),
                highlighted: highlightedPackshots.has(image.label),
                zoom: !highlightedPackshots.has(image.label)
            })
        );
        const vtoImg = vtoBanner ? {
            url: vtoBanner.image.url,
            dimensions: {
                w: vtoBanner.image.original.width,
                h: vtoBanner.image.original.height
            },
            thumbnailUrl: createImageUrl(vtoBanner.image.url, swcHelpers.objectSpread({}, defaultImageParams, {
                width: 112,
                height: 63,
                fit: 'cover'
            })),
            altText: vtoBanner.image.description || vtoBanner.title,
            highlighted: false,
            zoom: false,
            label: 'vto',
            vto: true
        } : swcHelpers.objectSpread({}, enhancedImages[0], {
            label: 'vto',
            zoom: false,
            vto: true
        });
        if (vtoActive && !isSmallScreen && activeVariantProduct.vtoEnabled) {
            enhancedImages.unshift(vtoImg);
        } else if (vtoActive && activeVariantProduct.vtoEnabled) {
            enhancedImages.push(vtoImg);
        } else if (vtoBanner && isEnabled && activeVariantProduct.vtoEnabled) {
            enhancedImages.push(vtoImg);
        }
        /**
     * In order to correctly follow the design we need to decide how many images we will initially render on load.
     * If there is a highlightedPackshot we have more space to render an extra image.
     *
     * This follows the following logic:
     * 1. If there are no highlightedPackshots: render 3 images.
     * 2. If only the first image is a highlightedPackshot: render 3 images.
     * 3. If the second OR third image is a highlightedPackshot: render 4 images.
     * 4. If the second AND third images are highlightedPackshots: render 3 images.
     */ const initialImageSize = enhancedImages.slice(1, 3).filter((image)=>image.highlighted === true
        ).length === 1 ? 4 : 3;
        const initialImages = enhancedImages.slice(0, initialImageSize);
        const expandableImages = enhancedImages.slice(initialImageSize);
        return {
            initialImages,
            expandableImages,
            enhancedImages
        };
    }, [
        activeVariant.images,
        vtoBanner,
        vtoActive,
        isSmallScreen,
        activeVariantProduct.vtoEnabled,
        isEnabled,
        product.masterVariant,
        locale,
        altTagLabels, 
    ]);
    useEffect(()=>{
        if (!activeVariantProduct.vtoEnabled) setVtoActive(false);
    }, [
        activeVariantProduct.vtoEnabled,
        setVtoActive
    ]);
    useEffect(()=>{
        if (product.masterVariant.sku && product.masterVariant.vtoEnabled) vtoEvent('vto.view', {
            sku: product.masterVariant.sku
        });
    }, []);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isSmallScreen ? /*#__PURE__*/ React.createElement(ProductImageGalleryMobile, {
        images: enhancedImages1,
        sku: activeVariantProduct.sku,
        imageParams: defaultImageParams,
        vtoBanner: vtoBanner,
        handleImageInteraction: handleImageInteraction,
        zoomModalOpenIndex: zoomMobileOpenIndex
    }) : /*#__PURE__*/ React.createElement(ProductImageGalleryView, {
        initialImages: initialImages1,
        expandableImages: expandableImages1,
        showMoreLabel: getLabel('products.imageGallery.showMore'),
        showLessLabel: getLabel('products.imageGallery.showLess'),
        isImageVisible: isImageVisible,
        handleGalleryExpansion: handleGalleryExpansion,
        handleImageInteraction: handleImageInteraction,
        setVtoActive: setVtoActive,
        sku: activeVariantProduct.sku,
        vtoActive: vtoActive,
        vtoBanner: vtoBanner,
        zoomModalOpenIndex: zoomMobileOpenIndex,
        buttonClickedForZoomRef: buttonClickedForZoomRef
    }));
};

function getEnPrioritizedText(text) {
    const locales = Object.keys(text).sort();
    for (const locale of locales){
        if (locale.toLocaleLowerCase().startsWith('en')) {
            return text[locale];
        }
    }
    return text[locales[0]];
}

function mapOfferingToOfferingSelectionEvent(offering, { isDefaultSelection =false  } = {}) {
    return {
        event: 'RxGlassesConfigEvent',
        eventAction: isDefaultSelection ? 'view step' : 'click on button',
        eventLabel: getEnPrioritizedText(offering.title)
    };
}
function mapOfferingToAddToCartEvent(offering) {
    return {
        event: 'RxGlassesConfigEvent',
        eventAction: 'click on button',
        eventLabel: 'add to cart',
        RxGlasses: {
            productConfig: {
                offering: getEnPrioritizedText(offering.title)
            }
        }
    };
}

const calcSumPrices = (...args)=>calcPrice(args.reduce((sum, n)=>sum + (n !== null && n !== void 0 ? n : 0)
    , 0))
;
const parsePrice = (price, vatRate)=>{
    var ref;
    if (!price) return {
        regularPrice: null,
        discountedPrice: null,
        discountAmount: null,
        vatAmount: null
    };
    const regularPrice = price.value.centAmount;
    var _centAmount;
    const discountedPrice = (_centAmount = (ref = price.discounted) === null || ref === void 0 ? void 0 : ref.value.centAmount) !== null && _centAmount !== void 0 ? _centAmount : null;
    const { vatAmount  } = discountedPrice !== null ? priceVatCalc(discountedPrice, vatRate) : priceVatCalc(regularPrice, vatRate);
    return {
        regularPrice,
        discountedPrice,
        discountAmount: discountedPrice ? regularPrice - discountedPrice : 0,
        vatAmount
    };
};
const getPrices = (variant, vat, offering)=>{
    if (!variant) {
        console.warn('No variant data found.');
        return null;
    }
    if (typeof vat === 'undefined') {
        console.warn(`No VAT amount found for variant with SKU ${variant.sku}.`);
        return null;
    }
    var _prices;
    const pricing = ((_prices = variant.prices) !== null && _prices !== void 0 ? _prices : []).find((price)=>typeof price.value.centAmount !== 'undefined'
    );
    if (!pricing) {
        console.warn(`Variant with SKU ${variant.sku} doesn't have any pricing.`);
        return null;
    }
    const productPricing = parsePrice(pricing, vat);
    const offeringPricing = parsePrice(offering === null || offering === void 0 ? void 0 : offering.price, vat);
    return {
        original: calcSumPrices(productPricing.regularPrice, offeringPricing.regularPrice),
        discountedPrice: productPricing.discountedPrice !== null ? calcSumPrices(productPricing.discountedPrice, offeringPricing.discountedPrice) : calcSumPrices(productPricing.regularPrice, offeringPricing.regularPrice),
        discountAmount: calcSumPrices(productPricing.discountAmount, offeringPricing.discountAmount),
        vatAmount: calcSumPrices(productPricing.vatAmount, offeringPricing.vatAmount)
    };
};
const getSharedAttributes = (product, purchaseType, activeVariant, lineItemType, pricePerMonth, offering)=>{
    const { sku  } = activeVariant;
    const includedVatAmount = getIncludedVatAmount(product);
    const isSubscription = !!(purchaseType === DataLayer.DataLayerTypes.PurchaseType.Subscription);
    const prices = !isSubscription ? getPrices(activeVariant, includedVatAmount, offering) : null;
    const subscriptionPrice = pricePerMonth ? calcPrice(pricePerMonth) : '';
    const name = DataLayer.DataLayerUtils.getNameFromVariant(activeVariant);
    return {
        name,
        id: sku || '',
        price: !isSubscription ? (prices === null || prices === void 0 ? void 0 : prices.discountedPrice) || '' : subscriptionPrice || '',
        dimension143: purchaseType,
        dimension144: lineItemType,
        dimension145: 'true',
        metric140: !isSubscription ? (prices === null || prices === void 0 ? void 0 : prices.original) || '' : subscriptionPrice || '',
        metric141: (prices === null || prices === void 0 ? void 0 : prices.discountAmount) || '',
        metric142: (prices === null || prices === void 0 ? void 0 : prices.vatAmount) || ''
    };
};
const getSunglassesAttributes = (sharedAttributes, product, activeVariant, locale)=>swcHelpers.objectSpread({}, sharedAttributes, {
        category: DataLayer.DataLayerTypes.Category.Sunglasses,
        brand: activeVariant.brand || '',
        variant: getLocalizedAttrValue(activeVariant, 'frameShape', locale).toLowerCase(),
        dimension16: getJoinedLocalizedAttrValues(activeVariant, 'gender', locale).toLowerCase() || '',
        dimension140: product.masterVariant.sku || '',
        dimension146: getLocalizedAttrValue(activeVariant, 'frameMaterial', locale).toLowerCase(),
        dimension147: getJoinedLocalizedAttrValues(activeVariant, 'frameColor', locale).toLowerCase()
    })
;
const getContactLensesAttributes = (sharedAttributes, product, activeVariant, locale)=>{
    const brandValue = getAttrValue(activeVariant, 'brand');
    const brand = brandValue && typeof brandValue === 'string' ? brandValue : '';
    return swcHelpers.objectSpread({}, sharedAttributes, {
        name: activeVariant.name || '',
        brand,
        category: DataLayer.DataLayerTypes.Category.ContactLenses,
        variant: getLocalizedAttrValue(activeVariant, 'lensType', locale),
        dimension140: product.masterVariant.sku || '',
        dimension148: getLocalizedAttrValue(activeVariant, 'replacementFrequency', locale),
        dimension146: getLocalizedAttrValue(activeVariant, 'material', locale).toLowerCase()
    });
};
const getPrescriptionGlassesAttributes = (sharedAttributes, product, activeVariant, locale)=>{
    const frameMaterial = getJoinedLocalizedAttrValues(activeVariant, 'frameMaterial', locale).toLowerCase();
    const frameColor = getJoinedLocalizedAttrValues(activeVariant, 'frameColor', locale).toLowerCase();
    const frameShape = getJoinedLocalizedAttrValues(activeVariant, 'frameShape', locale).toLowerCase();
    const gender = getJoinedLocalizedAttrValues(activeVariant, 'gender', locale).toLowerCase();
    return swcHelpers.objectSpread({}, sharedAttributes, {
        brand: activeVariant.brand || '',
        variant: frameShape || '',
        dimension140: product.masterVariant.sku || '',
        dimension16: gender,
        category: DataLayer.DataLayerTypes.Category.Optical
    }, frameMaterial ? {
        dimension146: frameMaterial
    } : null, frameColor ? {
        dimension147: frameColor
    } : null);
};
const getContactLensesBundleBeneluxAttributes = (sharedAttributes, activeVariant, locale)=>swcHelpers.objectSpread({}, sharedAttributes, {
        category: DataLayer.DataLayerTypes.Category.ContactLenses,
        variant: getLocalizedAttrValue(activeVariant, 'lensType', locale)
    })
;
const getSolutionsAttributes = (sharedAttributes, product, activeVariant)=>swcHelpers.objectSpread({}, sharedAttributes, {
        name: activeVariant.name || '',
        category: DataLayer.DataLayerTypes.Category.Solutions,
        brand: activeVariant.brand || '',
        variant: String(getAttrValue(activeVariant, 'packageOption')),
        dimension140: String(product.masterVariant.sku),
        dimension146: String(getAttrValue(activeVariant, 'solutionType'))
    })
;
const getReadyReadersAttributes = (sharedAttributes, product, activeVariant, locale)=>swcHelpers.objectSpread({}, sharedAttributes, {
        category: DataLayer.DataLayerTypes.Category.ReadyReaders,
        brand: activeVariant.brand || '',
        variant: getLocalizedAttrValue(activeVariant, 'frameShape', locale).toLowerCase(),
        dimension16: getJoinedLocalizedAttrValues(activeVariant, 'gender', locale).toLowerCase() || '',
        dimension140: product.masterVariant.sku || '',
        dimension146: getLocalizedAttrValue(activeVariant, 'frameMaterial', locale).toLowerCase(),
        dimension147: getJoinedLocalizedAttrValues(activeVariant, 'frameColor', locale).toLowerCase()
    })
;
const getAccessoriesAttributes = (sharedAttributes, product, activeVariant, locale)=>swcHelpers.objectSpread({}, sharedAttributes, {
        category: DataLayer.DataLayerTypes.Category.Accessories,
        brand: activeVariant.brand || '',
        variant: getLocalizedAttrValue(activeVariant, 'accessoryType', locale).toLowerCase(),
        dimension16: getJoinedLocalizedAttrValues(activeVariant, 'gender', locale).toLowerCase(),
        dimension146: getLocalizedAttrValue(activeVariant, 'material', locale).toLowerCase(),
        dimension147: getJoinedLocalizedAttrValues(activeVariant, 'accessoryColor', locale).toLowerCase(),
        dimension140: product.masterVariant.sku || ''
    })
;
const mapProductToDataLayerProductObject = (purchaseType, product, activeSku, locale = Locales['en-GB'], productType, pricePerMonth, offering)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const activeVariant = [
        product.masterVariant,
        ...product.variants
    ].find((variant)=>variant.sku === activeSku
    ) || product.masterVariant;
    const sharedAttributes = getSharedAttributes(product, purchaseType, activeVariant, productType || DataLayer.DataLayerTypes.LineItemType.Single, pricePerMonth, offering);
    if (((ref = product.productType.obj) === null || ref === void 0 ? void 0 : ref.name) === 'Sunglasses') {
        return getSunglassesAttributes(sharedAttributes, product, activeVariant, locale);
    }
    if (((ref1 = product.productType.obj) === null || ref1 === void 0 ? void 0 : ref1.name) === 'Contact-lenses') {
        return getContactLensesAttributes(sharedAttributes, product, activeVariant, locale);
    }
    if (((ref2 = product.productType.obj) === null || ref2 === void 0 ? void 0 : ref2.name) === 'Contact-lens-bundles') {
        return getContactLensesBundleBeneluxAttributes(sharedAttributes, activeVariant, locale);
    }
    if (((ref3 = product.productType.obj) === null || ref3 === void 0 ? void 0 : ref3.name) === 'Frames') {
        return getPrescriptionGlassesAttributes(sharedAttributes, product, activeVariant, locale);
    }
    if (((ref4 = product.productType.obj) === null || ref4 === void 0 ? void 0 : ref4.name) === 'Ready-readers') {
        return getReadyReadersAttributes(sharedAttributes, product, activeVariant, locale);
    }
    if (((ref5 = product.productType.obj) === null || ref5 === void 0 ? void 0 : ref5.name) === 'Accessories') {
        return getAccessoriesAttributes(sharedAttributes, product, activeVariant, locale);
    }
    if (((ref6 = product.productType.obj) === null || ref6 === void 0 ? void 0 : ref6.name) === 'Solutions') {
        return getSolutionsAttributes(sharedAttributes, product, activeVariant);
    }
};

const pushPdpEventToDataLayer = (purchaseType, product, activeSku, currency, productType, pricePerMonth)=>{
    pushEventToDataLayer(purchaseType, product, activeSku, currency, {
        list: 'pdp'
    }, 'gvProductDetail', productType, pricePerMonth);
};
const pushEventToDataLayer = (purchaseType, product, activeSku, currency, actionField, dataEvent, productType, pricePerMonth, eventType, offering)=>{
    const productObject = mapProductToDataLayerProductObject(purchaseType, product, activeSku, // Data in the Data Layer should always be English, therefore hardcoded locale
    Locales['en-GB'], productType, pricePerMonth, offering);
    if (!productObject) {
        return;
    }
    DataLayer.pushEcommerceEvent({
        event: dataEvent,
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                [eventType || 'detail']: {
                    actionField,
                    products: [
                        productObject
                    ]
                }
            }
        }
    });
};
const pushTabClickEvent = (isSubscriptionSelected)=>{
    DataLayer.pushEvent({
        event: 'ContactLensesConfigEvent',
        eventAction: 'click on tab',
        eventLabel: isSubscriptionSelected ? DataLayer.DataLayerTypes.PurchaseType.Subscription : DataLayer.DataLayerTypes.PurchaseType.OneTime
    });
};
const pushSubscriptionStartEvent = (packs, packageQuantity, price, selectedVariants, usageLevel)=>{
    const toLens = (lens)=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        return {
            baseCurve: ((ref = lens === null || lens === void 0 ? void 0 : lens.attributes.baseCurve) === null || ref === void 0 ? void 0 : ref.toString()) || 'n/a',
            diameter: ((ref1 = lens === null || lens === void 0 ? void 0 : lens.attributes.diameter) === null || ref1 === void 0 ? void 0 : ref1.toString()) || 'n/a',
            addition: ((ref2 = lens === null || lens === void 0 ? void 0 : lens.attributes.addition) === null || ref2 === void 0 ? void 0 : ref2.toString()) || 'n/a',
            axis: ((ref3 = lens === null || lens === void 0 ? void 0 : lens.attributes.axis) === null || ref3 === void 0 ? void 0 : ref3.toString()) || 'n/a',
            power: ((ref4 = lens === null || lens === void 0 ? void 0 : lens.attributes.power) === null || ref4 === void 0 ? void 0 : ref4.toString()) || 'n/a',
            cylinder: ((ref5 = lens === null || lens === void 0 ? void 0 : lens.attributes.cylinder) === null || ref5 === void 0 ? void 0 : ref5.toString()) || 'n/a'
        };
    };
    const event = {
        event: 'ContactLensesConfigEvent',
        eventAction: 'view step',
        eventLabel: undefined,
        RxContactLenses: {
            configFlow: {
                version: '1.0',
                step: {
                    name: 'box quantity and prescription',
                    id: '100'
                }
            }
        },
        productConfig: {
            purchaseType: DataLayer.DataLayerTypes.PurchaseType.Subscription,
            price: calcPrice(price),
            box: {
                frequency: usageLevel && usageLevelToFrequency(usageLevel),
                quantity: mapBoxQuantity(packs, packageQuantity)
            },
            lens: {
                OS: selectedVariants.left && toLens(selectedVariants.left),
                OD: selectedVariants.right && toLens(selectedVariants.right)
            }
        }
    };
    DataLayer.pushEvent(event);
};
function pushOfferingSelectionEvent(offering, { isDefaultSelection =false  } = {}) {
    DataLayer.pushEvent(mapOfferingToOfferingSelectionEvent(offering, {
        isDefaultSelection
    }));
}
function pushAddToCartEvent(product, activeSku, offering, currency) {
    DataLayer.pushEvent(mapOfferingToAddToCartEvent(offering));
    pushEventToDataLayer(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, activeSku, currency, {}, 'gvAddToCart', DataLayer.DataLayerTypes.LineItemType.Bundle, undefined, DataLayer.DataLayerTypes.EventType.add, offering);
}

const getFramesDisplayPrice = (variantPrice, offeringPrice, sspTotalPrice)=>{
    const { currency , originalPrice: originalVariantPrice , discountedPrice: discountedVariantPrice ,  } = variantPrice;
    if (isNumber(sspTotalPrice)) {
        const nonFrameSSPPrice = sspTotalPrice - originalVariantPrice;
        return {
            originalPrice: sspTotalPrice,
            /**
       * When the product doesn't have a discounted price, we want to keep it that way.
       * If the (total) discounted price returned from here is a number (even 0), it will
       * show up on the PDP. So we want to keep it undefined.
       */ discountedPrice: discountedVariantPrice ? discountedVariantPrice + nonFrameSSPPrice : undefined,
            currency
        };
    }
    /**
   *
   * The offering price is added on top of the variant price
   *
   * -- No discounts --
   * originalVariantPrice: €10
   * offeringOriginalPrice: +€3
   *
   * Displayed total price:  10 + 3 = €13
   *
   *
   *  -- Only Offering with discount --
   * originalVariantPrice: €10
   * offeringOriginalPrice: +€3
   * offeringDiscountPrice: +€1
   *
   * Displayed total pre-discount price:  10 + 3 = €13
   * Displayed total discounted price:    10 + 1 = €11
   *
   *
   * -- Only Variant with discount --
   * originalVariantPrice: €10
   * discountedVariantPrice: €9
   * offeringOriginalPrice: +€3
   *
   * Displayed total pre-discount price:  10 + 3 = €13
   * Displayed total discounted price:     9 + 3 = €12
   *
   *
   * -- Variant AND Offering with discount --
   * originalVariantPrice: €10
   * discountedVariantPrice: €9
   * offeringOriginalPrice: +€3
   * offeringDiscountPrice: +€1
   *
   * Displayed total pre-discount price:  10 + 3 = €13
   * Displayed total discounted price:     9 + 1 = €10
   *
   */ if (offeringPrice) {
        const { value: offeringOriginalPrice , discounted: offeringDiscount  } = offeringPrice;
        const offeringOriginalPriceValue = offeringOriginalPrice.centAmount;
        const displayedOriginalPrice = originalVariantPrice + offeringOriginalPriceValue;
        let displayedDiscountPrice = discountedVariantPrice;
        if (offeringDiscount) {
            const offeringDiscountPrice = offeringDiscount.value.centAmount;
            displayedDiscountPrice = discountedVariantPrice ? discountedVariantPrice + offeringDiscountPrice : originalVariantPrice + offeringDiscountPrice;
        } else {
            displayedDiscountPrice = displayedDiscountPrice ? displayedDiscountPrice + offeringOriginalPriceValue : displayedDiscountPrice;
        }
        return {
            originalPrice: displayedOriginalPrice,
            discountedPrice: displayedDiscountPrice,
            currency
        };
    }
    return variantPrice;
};

// This function maps from the REST sunglasses variant type to our Client-side ProductFeature[] type
const getProductFeatures = (serverVariant)=>{
    const productFeatures = [];
    const { glazable , polarized , uvCategory  } = serverVariant.features;
    if (!!uvCategory) {
        productFeatures.push({
            type: 'uvCategory',
            iconName: 'uv'
        });
    }
    if (!!polarized) {
        productFeatures.push({
            type: 'polarized',
            iconName: 'polarized'
        });
    }
    if (!!glazable) {
        productFeatures.push({
            type: 'glazeable',
            iconName: 'reading'
        });
    }
    return productFeatures;
};

// eslint-disable-next-line simple-import-sort/imports
const useBrandLink = (product)=>{
    var ref1;
    const { locale  } = useIntl();
    if (typeof window === 'undefined') {
        return '';
    }
    const link = React.useMemo(()=>{
        var ref;
        const productType = getProductTypeName$1(product);
        const brand = getAttrValue(product.masterVariant, 'brand');
        if (!isString(brand) || brand === '') return '';
        const sanitizedBrand = sanitizeStringForUrl(brand);
        const path = ((ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname) || '';
        const parts = path.split('/').filter((v)=>v !== ''
        );
        const isMultilingual = /[[a-z]{2}_[A-Z]{2}/g.test(parts[0]);
        const category = isMultilingual ? parts[1] : parts[0];
        const subCategory = isMultilingual ? parts[2] : parts[1];
        const baseUrl = `/${isMultilingual ? `${parts[0]}/` : ''}${category}`;
        if (productType && CommerceToolsApi.isLenses(productType)) {
            const replacementFrequency = getLocalizedAttrValue(product.masterVariant, 'replacementFrequency', locale) || '';
            return `${baseUrl}/${encodeURIComponent(sanitizeStringForUrl(replacementFrequency))}/${encodeURIComponent(sanitizedBrand)}`;
        }
        if (productType && CommerceToolsApi.isSolutions(productType)) {
            const contactLensCareType = product && getLocalizedAttrValue(product.masterVariant, 'contactLensCareType', locale) || '';
            return `${baseUrl}/${encodeURIComponent(sanitizeStringForUrl(contactLensCareType))}/${encodeURIComponent(sanitizedBrand)}`;
        }
        if (productType && CommerceToolsApi.isReadyReaders(productType)) {
            return `${baseUrl}/${subCategory}/${encodeURIComponent(sanitizedBrand)}`;
        }
        if (productType && CommerceToolsApi.isAccessories(productType)) {
            const accessoryType = getLocalizedAttrValue(product.masterVariant, 'accessoryType', locale) || '';
            return `${baseUrl}/${encodeURIComponent(sanitizeStringForUrl(accessoryType))}/${encodeURIComponent(sanitizedBrand)}`;
        }
        return `${baseUrl}/${encodeURIComponent(sanitizedBrand)}`;
    }, [
        (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.pathname,
        product
    ]);
    return link;
};

const getAttributeFactory = ({ isLocalised =false  })=>{
    if (!isLocalised) {
        return getAttrValue;
    }
    return getJoinedLocalizedAttrValues;
};
/**
 *
 * Helper for converting specification data to a string format
 *
 * if a value is an array, that value has to be converted to a string of those values. ('blue'. 'red')
 * if a value is a boolean, that value has to be converted to ('yes'/'no')
 * if a value is a number, that value has to be converted to a string of that number. (preventing things like 8.5e10)
 *
 */ const getSpecificationItem = (config, variant, getLabel, locale)=>{
    const getAttribute = getAttributeFactory(config);
    const attr = getAttribute(variant, config.attribute, locale);
    if (isNil(attr) || attr === '') {
        return;
    }
    let value = attr;
    if (isBoolean(attr)) {
        value = attr ? getLabel('common.yes') : getLabel('common.no');
    }
    if (isNumber(attr)) {
        value = attr.toString();
    }
    // Final check for when something unexpected happend
    if (!isString(value)) {
        console.warn(`Could not render ${config.labelKey} because the received value is a ${typeof attr} while expecting a string`);
        return;
    }
    return {
        label: getLabel(config.labelKey),
        value
    };
};

const SpecificationItem = ({ config , variant  })=>{
    const { getLabel , locale  } = useIntl();
    const item = getSpecificationItem(config, variant, getLabel, locale);
    if (!item) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-specification__item",
        "data-t": "specification-item",
        role: "presentation"
    }, /*#__PURE__*/ React.createElement("dt", {
        className: "product-detail-specification__item--label"
    }, item.label), /*#__PURE__*/ React.createElement("dd", {
        className: "product-detail-specification__item--value"
    }, item.value));
};
var SpecificationItem$1 = /*#__PURE__*/ React.memo(SpecificationItem);

const ProductDetailSpecification = ({ configuration , variant  })=>{
    const { getLabel  } = useIntl();
    const title = getLabel('products.detail.specifications.title');
    if (!configuration || !variant) {
        return null;
    }
    const items = configuration.map((config)=>/*#__PURE__*/ React.createElement(SpecificationItem$1, {
            config: config,
            variant: variant,
            key: config.labelKey
        })
    );
    if (!items.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("section", {
        className: "product-detail-specification",
        "data-t": "product-detail-specification"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        className: "product-detail-specification__title"
    }, title), /*#__PURE__*/ React.createElement("dl", {
        className: "product-detail-specification__list"
    }, items));
};

// Re-export the viewHistory API but with the products key used in localStorage bound to it
const useProductViewHistory = useViewHistory.bind(null, ViewHistoryKey.Products);

const Panel = ({ title , icon ='info' , className , children  })=>{
    if (!title || !children) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames([
            'panel',
            className
        ])
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "panel__header"
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        className: "panel__icon",
        name: icon
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "subheading1",
        className: "panel__title"
    }, title)), /*#__PURE__*/ React__default.createElement("div", {
        className: "panel__content"
    }, children));
};

const Accessories = ({ activeSku , activeVariant , addToCartRef , brandLink , currency , dispatch , formatProductUrl , handleConversionEvent , isBynderImagesEnabled , isMobile , isSmallScreen , isOrderable , labels , locale , onCTAClick , product , productImageAlt , productImageGallery , productTypeUsps , specificationConfiguration , stickyTop , stockCount , staticsUrl , showStickyButton , variant , variants , disclaimer , storesRoute  })=>{
    const { accessoryColor , brand , channelAvailability , description , discounted , discountText , excludedFromCheckout , header , images , modelName , price , productType , sku , tag , usps ,  } = variant;
    const { Slots  } = useProductDetailSlots();
    const { isProductLabelEnabled  } = useFeatureToggles();
    const productViewHistory = useProductViewHistory();
    const reviews = useReviewsContext();
    // Add SKU to viewed product history
    React.useEffect(()=>{
        // We only want 1 SKU(variant) per product to be in the view history
        productViewHistory.remove(variants.map((v)=>v.sku || ''
        ));
        productViewHistory.add(sku);
    }, [
        variants.length,
        sku
    ]);
    // Make sure the ReviewsDisplay component gets updated with the currently active SKU
    React.useEffect(()=>{
        if (reviews.enabled) {
            reviews.dispatch(Actions$1.updateReviewDisplay({
                variantId: activeSku
            }));
        }
    }, [
        activeSku,
        reviews.enabled
    ]);
    const CTAButton = /*#__PURE__*/ React.createElement(NonRxProductCTA, {
        storesRoute: storesRoute,
        action: channelAvailability === 'ONLINE' ? 'ADD_TO_CART' : 'ADD_TO_CART_UNAVAILABLE',
        handleConversionEvent: handleConversionEvent,
        addToCartConfig: {
            activeSku,
            variantUrl: formatProductUrl({
                productType,
                sku: activeSku || '',
                slug: product.slug
            }),
            onCTAClick
        }
    });
    var _discountedPrice;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main"
    }, isMobile && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitle, {
        title: `${brand} ${modelName}`,
        subtitle: brand,
        href: brandLink
    }), /*#__PURE__*/ React.createElement(ReviewSnippet, {
        productId: sku,
        variantId: activeSku
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, isBynderImagesEnabled ? productImageGallery : /*#__PURE__*/ React.createElement(ProductVisualSwitcher, {
        productImages: images,
        alt: productImageAlt
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__description"
    }, /*#__PURE__*/ React.createElement(ProductDetailDescription, {
        title: labels.productDetailDescription,
        header: header,
        description: description,
        usps: /*#__PURE__*/ React.createElement(List, {
            icon: "checkmark",
            items: usps
        })
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__specification"
    }, /*#__PURE__*/ React.createElement(ProductDetailSpecification, {
        configuration: specificationConfiguration,
        variant: activeVariant
    })), disclaimer && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__disclaimer"
    }, /*#__PURE__*/ React.createElement(Panel, {
        title: disclaimer.title
    }, disclaimer.description)), /*#__PURE__*/ React.createElement("aside", {
        className: "product-detail__aside",
        "data-t": "product-detail-aside",
        "aria-label": `${brand} ${modelName}`
    }, /*#__PURE__*/ React.createElement(Sticky, {
        top: stickyTop || 0,
        bottomBoundary: ".product-detail",
        enabled: !isMobile
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mobile-hidden"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitle, {
        title: `${brand} ${modelName}`,
        subtitle: brand,
        href: brandLink
    })), !isProductLabelEnabled && tag && tag.value && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__product-tag"
    }, /*#__PURE__*/ React.createElement(ProductTag, {
        tag: tag
    })), price && /*#__PURE__*/ React.createElement("div", {
        className: classnames('product-detail__specification-prices', {
            'product-detail__specification-prices--has-discount': !!discountText
        }),
        role: "group",
        "aria-label": labels.priceInformation
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__price-container"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        originalPrice: price.originalPrice,
        discountedPrice: price.discountedPrice,
        currency: currency
    })), isProductLabelEnabled && /*#__PURE__*/ React.createElement(ProductDiscountLabel, {
        title: discountText
    }), !isProductLabelEnabled && discounted && /*#__PURE__*/ React.createElement(Discount, {
        label: discountText,
        discount: discounted,
        isWide: true
    })), Slots.AfterPrice ? /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__after-price-slot"
    }, /*#__PURE__*/ React.createElement(Slots.AfterPrice, null)) : null, !isMobile && /*#__PURE__*/ React.createElement(ReviewSnippet, {
        productId: sku,
        variantId: activeSku
    }), /*#__PURE__*/ React.createElement(VariantPicker, {
        variantItems: getVariants$1(variants, getLocalizedValue(product.slug, locale), staticsUrl, productType, locale, isBynderImagesEnabled),
        activeVariantSku: sku,
        activeVariantLabel: accessoryColor,
        enableStockIndicator: !excludedFromCheckout,
        stockCount: stockCount,
        isAllowBackOrder: isOrderable,
        formatProductUrl: formatProductUrl,
        dispatch: dispatch,
        channelAvailability: variant.channelAvailability
    }), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details"
    }, /*#__PURE__*/ React.createElement("div", {
        ref: addToCartRef
    }, CTAButton), Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null), isSmallScreen && showStickyButton && price && /*#__PURE__*/ React.createElement(StickyCallToAction, {
        button: CTAButton,
        price: /*#__PURE__*/ React.createElement(Price, {
            value: (_discountedPrice = price.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : price.originalPrice,
            currency: currency,
            centAmount: true,
            type: price.discountedPrice ? 'discount' : 'default'
        })
    }), productTypeUsps && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), /*#__PURE__*/ React.createElement(ProductDetailUsps, {
        items: productTypeUsps
    })))));
};

const AccessoriesContainer = ({ activeSku , addToCartRef , dispatch , formatProductUrl , handleConversionEvent , onCTAClick , product , productImageGallery , productTypeUsps , showStickyButton , specificationConfiguration , stickyTop , stockResolver , staticsUrl , variant , storesRoute  })=>{
    var ref;
    const { currency , getFormattedLabel , getLabel , locale  } = useIntl();
    const { isBynderImagesEnabled  } = useFeatureToggles();
    const brandLink = useBrandLink(product);
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const activeVariant = getActiveVariant$1(product, activeSku);
    const productImageAlt = getLocalizedValue(product.name, locale);
    var ref1;
    const stockCount = (ref1 = (ref = variant.availability) === null || ref === void 0 ? void 0 : ref.availableQuantity) !== null && ref1 !== void 0 ? ref1 : 0;
    const isOrderable = (variant === null || variant === void 0 ? void 0 : variant.channelAvailability) === 'ONLINE';
    const variants = React.useMemo(()=>[
            product.masterVariant,
            ...product.variants
        ]
    , [
        product.masterVariant,
        product.variants, 
    ]);
    const labels = React.useMemo(()=>({
            productDetailDescription: getLabel('products.contactLenses.header.details'),
            priceInformation: getLabel('products.screenreader.priceInformation')
        })
    , [
        getLabel,
        getFormattedLabel
    ]);
    React.useEffect(()=>{
        pushPdpEventToDataLayer(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, activeSku, currency);
    }, [
        activeSku
    ]);
    return /*#__PURE__*/ React.createElement(Accessories, {
        activeSku: activeSku,
        activeVariant: activeVariant,
        dispatch: dispatch,
        addToCartRef: addToCartRef,
        brandLink: brandLink,
        currency: currency,
        formatProductUrl: formatProductUrl,
        handleConversionEvent: handleConversionEvent,
        isBynderImagesEnabled: isBynderImagesEnabled,
        isMobile: isMobile,
        isSmallScreen: isSmallScreen,
        isOrderable: isOrderable,
        labels: labels,
        locale: locale,
        onCTAClick: onCTAClick,
        product: product,
        productImageAlt: productImageAlt,
        productImageGallery: productImageGallery,
        productTypeUsps: productTypeUsps,
        showStickyButton: showStickyButton,
        specificationConfiguration: specificationConfiguration,
        stickyTop: stickyTop,
        stockCount: stockCount,
        stockResolver: stockResolver,
        staticsUrl: staticsUrl,
        variant: variant,
        variants: variants,
        storesRoute: storesRoute
    });
};

const PriceTagOrIncluded = (props)=>{
    const { getLabel , hasLabel  } = useIntl();
    const { originalPrice , discountedPrice , discountText , className  } = props;
    if (originalPrice === 0) {
        const labelKey = 'products.glasses.configurator.priceIsZero';
        return hasLabel(labelKey) ? /*#__PURE__*/ React.createElement("span", {
            className: className
        }, getLabel(labelKey)) : null;
    }
    if (discountedPrice === 0 && discountText && (discountText === null || discountText === void 0 ? void 0 : discountText.length) > 0) {
        return /*#__PURE__*/ React.createElement("span", {
            className: className
        }, discountText);
    }
    return /*#__PURE__*/ React.createElement(PriceTag, swcHelpers.extends({}, props));
};

const ImageSection = ({ image , alt , className  })=>{
    if ('dimensions' in image) {
        const { url , label , dimensions  } = image;
        return /*#__PURE__*/ React.createElement("img", {
            src: url,
            alt: label ? label : alt,
            height: dimensions.h,
            width: dimensions.w,
            className: className
        });
    } else {
        const { description , original  } = image;
        return /*#__PURE__*/ React.createElement("img", {
            src: original.url,
            alt: description ? description : alt,
            height: original.height,
            width: original.width,
            className: className
        });
    }
};
const RadioCardBody = ({ children , className , alignment ='top' , title , description , tag , image , icon , imageClassName , price , discountText , priceComment , withDivider =false ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        "data-t": "radio-card-body",
        className: classnames('radio-card-body', className)
    }, tag && /*#__PURE__*/ React.createElement("em", {
        className: "radio-card-body__tag"
    }, tag), !tag && /*#__PURE__*/ React.createElement("div", {
        className: "radio-card-body__tag radio-card-body__tag--hidden",
        "aria-hidden": "true"
    }, "\xa0"), /*#__PURE__*/ React.createElement("div", {
        className: classnames('radio-card-body__content', `radio-card-body__content--align-${alignment}`)
    }, image && !icon && /*#__PURE__*/ React.createElement(ImageSection, {
        image: image,
        alt: title,
        className: classnames('radio-card-body__image', imageClassName)
    }), icon && !image && /*#__PURE__*/ React.createElement("div", {
        className: "radio-card-body__icon"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: icon
    })), /*#__PURE__*/ React.createElement(Heading, {
        className: "radio-card-body__header",
        component: "h3",
        variant: "smallest"
    }, title), description && /*#__PURE__*/ React.createElement(Text, {
        className: "radio-card-body__description",
        variant: "caption-head"
    }, description), children), withDivider && /*#__PURE__*/ React.createElement(Hr, null), price && /*#__PURE__*/ React.createElement("div", {
        className: "radio-card-body__price-wrapper"
    }, /*#__PURE__*/ React.createElement(PriceTagOrIncluded, swcHelpers.extends({}, price, {
        discountText: discountText
    }))), priceComment && /*#__PURE__*/ React.createElement(Text, {
        className: "radio-card-body__price-comment",
        variant: "caption"
    }, priceComment));
};

const RadioCard = (_param)=>{
    var { className , isChecked , name , value , id , onChange  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "isChecked",
        "name",
        "value",
        "id",
        "onChange"
    ]);
    const handleChange = React.useCallback((e)=>onChange(e.currentTarget.value)
    , [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(RadioButton, {
        name: name,
        className: classnames('radio-card', className),
        id: id,
        isChecked: isChecked,
        position: "bottom",
        onChange: handleChange,
        value: value,
        "data-t": rest['data-t']
    }, /*#__PURE__*/ React.createElement(RadioCardBody, swcHelpers.extends({}, rest)));
};

const SingleItemRadioCard = (_param)=>{
    var { cardClassName  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "cardClassName"
    ]);
    return /*#__PURE__*/ React.createElement(Card.OldCard, {
        className: cardClassName
    }, /*#__PURE__*/ React.createElement(RadioCardBody, swcHelpers.extends({}, rest)));
};

const RadioCardWithVariants = (_param)=>{
    var { name , variants , selectedVariantSku , onChange , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "name",
        "variants",
        "selectedVariantSku",
        "onChange",
        "className"
    ]);
    const containsSelectedAddOn = variants.some((a)=>a.sku === selectedVariantSku
    );
    const handleChange = React.useCallback((e)=>onChange(e.currentTarget.value)
    , [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(Card.OldCard, {
        "data-t": rest['data-t'],
        className: classnames('radio-card-with-variants', className, {
            'radio-card-with-variants--active': containsSelectedAddOn
        })
    }, /*#__PURE__*/ React.createElement(RadioCardBody, {
        title: rest.title,
        description: rest.description,
        image: rest.image,
        imageClassName: rest.imageClassName,
        tag: rest.tag,
        price: rest.price,
        discountText: rest.discountText
    }, variants.map((v)=>{
        var ref;
        const isChecked = v.sku === selectedVariantSku;
        return /*#__PURE__*/ React.createElement(RadioButton, {
            key: v.sku,
            name: name,
            variant: "plain",
            position: "left",
            value: v.sku,
            isChecked: isChecked,
            onChange: handleChange,
            className: "radio-card-with-variants__variant-item"
        }, /*#__PURE__*/ React.createElement("img", {
            alt: "",
            src: (ref = v.image) === null || ref === void 0 ? void 0 : ref.url,
            className: "radio-card-with-variants__variant-item-image"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "radio-card-with-variants__variant-item-label"
        }, v.title));
    })));
};

const BundleProductRadioCard = (_param)=>{
    var { children , className , id , productInfo , selectedVariantSku , showPriceAsZero , value , onChange  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className",
        "id",
        "productInfo",
        "selectedVariantSku",
        "showPriceAsZero",
        "value",
        "onChange"
    ]);
    var ref1;
    const handleChange = React.useCallback(()=>onChange(productInfo)
    , [
        onChange,
        productInfo
    ]);
    const { description , image , price , title , discountText  } = productInfo;
    const { getLabel  } = useIntl();
    const handleVariantChange = React.useCallback((sku)=>{
        var ref;
        const addOn = (ref = productInfo.variants) === null || ref === void 0 ? void 0 : ref.find((v)=>v.sku === sku
        );
        addOn && onChange(addOn);
    }, [
        productInfo.variants,
        onChange
    ]);
    const zeroPriceLabel = showPriceAsZero ? undefined : getLabel('products.glasses.configurator.priceIsZero');
    const sharedProps = {
        className: classnames('bundle-product-radio-card', className),
        alignment: 'bottom',
        title,
        description,
        image,
        imageClassName: 'bundle-product-radio-card__image',
        price,
        zeroPriceLabel,
        discountText,
        'data-t': rest['data-t']
    };
    if ((ref1 = productInfo.variants) === null || ref1 === void 0 ? void 0 : ref1.length) {
        return /*#__PURE__*/ React.createElement(RadioCardWithVariants, swcHelpers.extends({}, sharedProps, {
            variants: productInfo.variants,
            selectedVariantSku: selectedVariantSku,
            onChange: handleVariantChange
        }));
    }
    let isChecked = selectedVariantSku === productInfo.sku;
    // Check if this is the dummy lens add-on and if it's checked
    if (selectedVariantSku === undefined && productInfo.sku === '') {
        isChecked = true;
    }
    return /*#__PURE__*/ React.createElement(RadioCard, swcHelpers.extends({}, sharedProps, {
        id: id !== null && id !== void 0 ? id : `${value}-radio`,
        isChecked: isChecked,
        value: value,
        onChange: handleChange
    }));
};

var StepWrapper = (_param)=>{
    var { children , className , usps , onPrevSlide , onNextSlide  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className",
        "usps",
        "onPrevSlide",
        "onNextSlide"
    ]);
    const { featureConfigs: { configuratorUspsGroupTheme  } ,  } = useFeatureToggles();
    const theme = isUspsGroupTheme(configuratorUspsGroupTheme) ? configuratorUspsGroupTheme : 'light';
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, usps && /*#__PURE__*/ React__default.createElement(UspGroup, {
        items: usps,
        theme: theme,
        onPrevSlide: onPrevSlide,
        onNextSlide: onNextSlide
    }), /*#__PURE__*/ React__default.createElement("div", {
        "data-t": rest['data-t'],
        className: classnames('step-wrapper', className)
    }, children));
};

var RxStepWrapper = (_param)=>{
    var { children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    const usps = useSelector(getUsps);
    return /*#__PURE__*/ React__default.createElement(StepWrapper, {
        "data-t": rest['data-t'],
        className: classnames('prescription-glasses-step', className),
        usps: usps
    }, children);
};

const convertCmsRxEntries = (entryTypes)=>{
    if (!entryTypes) return;
    const ConversionMap = {
        'existing-customer': 'ExistingCustomer',
        email: 'EmailPrescription',
        'file-upload': 'PrescriptionFile',
        'form-entry': 'NewPrescription',
        'book-appointment': 'book-appointment'
    };
    return entryTypes.map((item)=>swcHelpers.objectSpread({}, item, {
            key: ConversionMap[item.key]
        })
    );
};

function usePrescriptionTypes() {
    const { isPrescriptionFileEnabled , featureConfigs  } = useFeatureToggles();
    const { prescriptionTypesOrder  } = useProductDetailContext();
    const allTypes = [
        'EmailPrescription',
        'ExistingCustomer',
        'NewPrescription',
        'PrescriptionFile', 
    ];
    // checking environment variables
    const envTypes = featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.prescriptionTypesOrder;
    if (envTypes && envTypes.every((type)=>allTypes.includes(type)
    )) {
        return [
            ...envTypes
        ];
    }
    // checking ordered types passed in from the product-detail.tsx file
    if (prescriptionTypesOrder === null || prescriptionTypesOrder === void 0 ? void 0 : prescriptionTypesOrder.length) {
        // if this item exists
        return [
            ...prescriptionTypesOrder
        ];
    }
    // default behavior
    const finalTypes = [
        'NewPrescription',
        'ExistingCustomer'
    ];
    if (isPrescriptionFileEnabled) {
        finalTypes.push('EmailPrescription');
    }
    return finalTypes;
}

const RxGlassesConfiguratorContext = /*#__PURE__*/ React.createContext({});
const useRxGlassesConfiguratorContext = ()=>React.useContext(RxGlassesConfiguratorContext)
;
const RxGlassesConfiguratorProvider = ({ children , opticianForm , configuratorDocument , frame , frameSku , formatProductUrl , id , usps , routes ,  })=>{
    const { isPrescriptionGlassesConfiguratorValidationStepEnabled: isExtraValidationStepEnabled ,  } = useFeatureToggles();
    const prescriptionTypesOrder = usePrescriptionTypes();
    let preselectedPrescriptionEntry = prescriptionTypesOrder === null || prescriptionTypesOrder === void 0 ? void 0 : prescriptionTypesOrder[0];
    const { entryTypes  } = (configuratorDocument === null || configuratorDocument === void 0 ? void 0 : configuratorDocument.prescriptionStep) || {};
    const rxEntryTypes = convertCmsRxEntries(entryTypes);
    if (rxEntryTypes === null || rxEntryTypes === void 0 ? void 0 : rxEntryTypes[0]) {
        preselectedPrescriptionEntry = rxEntryTypes[0].key;
    }
    const value = {
        opticianForm,
        configuratorDocument,
        isExtraValidationStepEnabled,
        id
    };
    const dispatch = useDispatch();
    React.useEffect(()=>{
        dispatch(startPrescriptionGlassesConfiguration({
            frame,
            frameSku,
            formatProductUrl,
            isExtraValidationStepEnabled,
            preselectedPrescriptionEntry,
            rxEntryTypes,
            usps,
            routes
        }));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ React.createElement(RxGlassesConfiguratorContext.Provider, {
        value: value
    }, children);
};

/*
 * This component is used to show the "No Add-ons" option in the frontend.
 * No value is returned when it is selected, and nothing is returned to the BE when the user proceeds to checkout.
 */ const DummyLensAddOn = (_param)=>{
    var { children , className , selectedLensAddOnSku , onChange  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className",
        "selectedLensAddOnSku",
        "onChange"
    ]);
    const handleChange = React.useCallback(()=>onChange()
    , [
        onChange
    ]);
    const { getLabel , currency  } = useIntl();
    const { configuratorDocument  } = useRxGlassesConfiguratorContext();
    const noAddOnsImage = configuratorDocument === null || configuratorDocument === void 0 ? void 0 : configuratorDocument.addOnsStep.noAddonsImage;
    const productInfo = React.useMemo(()=>({
            variants: [],
            isDefault: false,
            sku: '',
            title: getLabel('products.glasses.lensAddOn.noAddOn.title'),
            price: {
                originalPrice: 0,
                currency
            },
            image: noAddOnsImage
        })
    , [
        noAddOnsImage,
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(BundleProductRadioCard, {
        className: className,
        id: "dummy-add-on-radio",
        productInfo: productInfo,
        selectedVariantSku: selectedLensAddOnSku,
        value: "",
        onChange: handleChange,
        showPriceAsZero: true,
        "data-t": rest['data-t']
    });
};

const LensAddOnStep = (_param)=>{
    var { className , lensAddOns , selectedLensAddOn , areAddOnsOptional , onChange , onSubmit  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "lensAddOns",
        "selectedLensAddOn",
        "areAddOnsOptional",
        "onChange",
        "onSubmit"
    ]);
    const selectedLensAddOnSku = selectedLensAddOn === null || selectedLensAddOn === void 0 ? void 0 : selectedLensAddOn.sku;
    return /*#__PURE__*/ React.createElement(RxStepWrapper, {
        className: classnames('lens-add-on-step', className),
        "data-t": rest['data-t']
    }, /*#__PURE__*/ React.createElement(ConfiguratorStepTitleAndDescription, null), /*#__PURE__*/ React.createElement(StepForm, {
        onSubmit: onSubmit
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lens-add-on-step__scroll-container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lens-add-on-step__scroll-container__inner"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lens-add-on-step__list"
    }, lensAddOns.map((lensAddOn)=>{
        return /*#__PURE__*/ React.createElement(BundleProductRadioCard, {
            "data-t": rest['data-t'] ? `${rest['data-t']}-${lensAddOn.sku}` : undefined,
            className: "lens-add-on-step__list-item",
            productInfo: lensAddOn,
            selectedVariantSku: selectedLensAddOnSku,
            value: lensAddOn.sku,
            key: lensAddOn.sku,
            onChange: onChange
        });
    }), areAddOnsOptional && /*#__PURE__*/ React.createElement(DummyLensAddOn, {
        className: "lens-add-on-step__list-item",
        onChange: onChange,
        selectedLensAddOnSku: selectedLensAddOnSku
    }))))));
};

const LensAddOnStepContainer$1 = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep  } = useConfiguratorContext();
    const frame = useSelector(getSelectedFrame);
    const addOns = useSelector(getAddOns);
    const selectedAddOn = useSelector(getSelectedAddOn);
    const areAddOnsOptional = useSelector(getAreAddOnsOptional);
    const onChange = React__default.useCallback((args)=>{
        if (!frame) {
            return;
        }
        if (!(args === null || args === void 0 ? void 0 : args.sku)) {
            dispatch(resetSelectedAddOn({
                frameSku: frame.sku,
                reason: 'user selection'
            }));
        } else {
            dispatch(selectAddOn({
                frameSku: frame.sku,
                addOnSku: args.sku,
                reason: 'user selection'
            }));
        }
    }, [
        dispatch,
        frame === null || frame === void 0 ? void 0 : frame.sku
    ]);
    if (!statusSuccess(addOns)) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    return /*#__PURE__*/ React__default.createElement(LensAddOnStep, {
        onChange: onChange,
        onSubmit: goToNextStep,
        lensAddOns: addOns.result,
        selectedLensAddOn: selectedAddOn,
        areAddOnsOptional: areAddOnsOptional
    });
};

const SelectionBoxTag = ({ title , id , className  })=>{
    return /*#__PURE__*/ React.createElement(Text, {
        id: id,
        className: classnames('selection-box-tag', className)
    }, title);
};

const ConfiguratorRadioTile = ({ className , value , title , description , image , headerRowImage , price , discountText , isSelected , uspList , tag , onChange ,  })=>{
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('configurator-radio-tile', className, {
            'configurator-radio-tile__with-tag': !!tag
        })
    }, tag ? /*#__PURE__*/ React__default.createElement(SelectionBoxTag, {
        id: `tag-${value}`,
        className: "configurator-radio-tile__tag",
        title: tag
    }) : null, /*#__PURE__*/ React__default.createElement(SelectionBoxRadio, {
        className: 'configurator-radio-tile__radio',
        name: "configurator-radio-tile",
        value: value,
        checked: isSelected,
        onChange: ()=>onChange(value)
        ,
        "aria-describedby": tag ? `tag-${value}` : undefined
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "configurator-radio-tile__wrapper"
    }, image && /*#__PURE__*/ React__default.createElement(Image, {
        className: "configurator-radio-tile__image",
        cover: true,
        alt: "",
        url: image
    }), /*#__PURE__*/ React__default.createElement("div", {
        className: "configurator-radio-tile__body"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "configurator-radio-tile__heading"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "configurator-radio-tile__heading-wrapper"
    }, headerRowImage && /*#__PURE__*/ React__default.createElement(Image, {
        className: "configurator-radio-tile__row-image",
        cover: false,
        url: headerRowImage,
        alt: ""
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        className: "configurator-radio-tile__subheading1",
        component: "div",
        variant: "subheading1",
        visualHeadingOnly: true
    }, title)), price && /*#__PURE__*/ React__default.createElement(PriceTagOrIncluded, swcHelpers.extends({}, price, {
        discountText: discountText
    }))), description && /*#__PURE__*/ React__default.createElement(Text, {
        className: "configurator-radio-tile__description"
    }, description), uspList && /*#__PURE__*/ React__default.createElement(List, {
        items: uspList,
        spacing: "compact",
        renderText: (item)=>/*#__PURE__*/ React__default.createElement(Text, {
                variant: "caption"
            }, item)
        ,
        className: "configurator-radio-tile__usp-list"
    })))));
};

const useConfigurationSummary = ()=>{
    const { id  } = useRxGlassesConfiguratorContext();
    const hasVisitedStepLensPackage$1 = useSelector((s)=>hasVisitedStepLensPackage(s, {
            id
        })
    );
    const hasVisitedStepAddOn$1 = useSelector((s)=>hasVisitedStepAddOn(s, {
            id
        })
    );
    const frame = useSelector(getSelectedFrame);
    const lensType = useSelector(getSelectedLensType);
    const lensPackage = useSelector(getSelectedPackage);
    const addOn = useSelector(getSelectedAddOn);
    const bundlePrice = useSelector((s)=>getBundlePrice(s, {
            id
        })
    );
    return {
        frame,
        lensType,
        lensPackage,
        addOn,
        bundlePrice,
        hasVisitedStepAddOn: hasVisitedStepAddOn$1,
        hasVisitedStepLensPackage: hasVisitedStepLensPackage$1
    };
};

const FrameImage = ({ className  })=>{
    const { staticsUrl  } = useProductDetailContext();
    const { isBynderImagesEnabled  } = useFeatureToggles();
    const frame = useSelector(getSelectedFrame);
    const frameImage = useSelector((s)=>getFrameImage(s, {
            width: 352,
            staticsUrl,
            isBynderImagesEnabled
        })
    );
    const altText = `${frame === null || frame === void 0 ? void 0 : frame.brand} ${frame === null || frame === void 0 ? void 0 : frame.code}`;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('frame-image', className)
    }, frameImage && /*#__PURE__*/ React.createElement(ProductImage, {
        className: "frame-image__product",
        imageUrl: frameImage.url,
        altText: altText
    }));
};

const ConfigurationSummaryRow = ({ label , value , price , discountText , className ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('configuration-summary-row', className),
        "data-t": "configuration-summary-row"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("strong", {
        className: "configuration-summary-row__label"
    }, label || ''), /*#__PURE__*/ React.createElement("span", {
        className: "configuration-summary-row__value"
    }, value || '')), typeof (price === null || price === void 0 ? void 0 : price.originalPrice) !== 'undefined' && /*#__PURE__*/ React.createElement(PriceTagOrIncluded, swcHelpers.extends({}, price, {
        discountText: discountText
    })));
};

const FrameInformation = ({ title , subtitle , imageUrl , showImage =true , textOrientation ='vertical' , textHeadingVariant ='subheading1' ,  })=>/*#__PURE__*/ React.createElement("div", {
        "data-t": "frame-information",
        className: `frame-information frame-information--${textOrientation}`
    }, showImage && imageUrl && /*#__PURE__*/ React.createElement("img", {
        src: imageUrl,
        alt: `${title} ${subtitle}`,
        className: "frame-information__image"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "frame-information__text"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: textHeadingVariant,
        component: "h2",
        className: "frame-information__title"
    }, title), /*#__PURE__*/ React.createElement("span", {
        className: "frame-information__subtitle"
    }, subtitle)))
;

const FrameInformationContainer = (props)=>{
    const { staticsUrl  } = useProductDetailContext();
    const { isBynderImagesEnabled  } = useFeatureToggles();
    const frame = useSelector(getSelectedFrame);
    const image = useSelector((s)=>getFrameImage(s, {
            width: 100,
            staticsUrl,
            isBynderImagesEnabled
        })
    );
    if (!frame) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(FrameInformation, swcHelpers.extends({}, props, {
        title: frame.brand,
        subtitle: frame.code,
        imageUrl: image === null || image === void 0 ? void 0 : image.url
    }));
};

const SummaryTitle = ({ children  })=>/*#__PURE__*/ React.createElement("strong", {
        className: "glasses-configurator-footer-prescription-column__title"
    }, children)
;

const Wrapper = ({ children , title  })=>/*#__PURE__*/ React.createElement("div", {
        className: "glasses-configurator-footer-prescription-column"
    }, /*#__PURE__*/ React.createElement(SummaryTitle, null, title), children)
;
const PrescriptionSummaryColumn = ({ title , labels , parameters , fields , prescriptionType ,  })=>{
    const sortedParameterNames = sortPrescriptionParameters((parameters || []).map((p)=>p.name
    ));
    if (CommerceToolsApi.isNewPrescription(prescriptionType) && fields && parameters) {
        return /*#__PURE__*/ React.createElement(Wrapper, {
            title: title
        }, /*#__PURE__*/ React.createElement("ol", {
            className: "glasses-configurator-footer-prescription-column__fields"
        }, sortedParameterNames.map((name)=>isNumber(fields[name]) ? /*#__PURE__*/ React.createElement(PrescriptionColumnRow, {
                key: name,
                name: name,
                label: labels[name],
                value: fields[name]
            }) : null
        )));
    }
    if (CommerceToolsApi.isExistingCustomer(prescriptionType)) {
        return /*#__PURE__*/ React.createElement(Wrapper, {
            title: title
        }, /*#__PURE__*/ React.createElement(Text, {
            variant: "body"
        }, labels.existingCustomer));
    }
    if (CommerceToolsApi.isEmailPrescription(prescriptionType)) {
        return /*#__PURE__*/ React.createElement(Wrapper, {
            title: title
        }, /*#__PURE__*/ React.createElement(Text, {
            variant: "body"
        }, labels.emailPrescription));
    }
    return null;
};
var ref$2;
const PrescriptionColumnRow = ({ label , name , value  })=>/*#__PURE__*/ React.createElement("li", {
        className: "glasses-configurator-footer-prescription-column__row"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "glasses-configurator-footer-prescription-column__label"
    }, `${label} `), /*#__PURE__*/ React.createElement("strong", {
        className: "glasses-configurator-footer-prescription-column__value"
    }, (ref$2 = PrescriptionValueUtils.formatPrescriptionValue(name, value)) !== null && ref$2 !== void 0 ? ref$2 : ''))
;

const PrescriptionSummary = ({ parameters , right , left , labels , prescriptionType ,  })=>{
    if (CommerceToolsApi.isNewPrescription(prescriptionType)) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "prescription-summary"
        }, /*#__PURE__*/ React.createElement(SummaryTitle, null, labels.prescriptionTitle), /*#__PURE__*/ React.createElement("div", {
            className: "glasses-configurator-footer-prescription",
            "data-t": "prescription-summary"
        }, Object.keys(right).length > 0 && /*#__PURE__*/ React.createElement(PrescriptionSummaryColumn, {
            title: labels.rightEye,
            fields: right,
            parameters: parameters,
            prescriptionType: prescriptionType,
            labels: labels
        }), Object.keys(left).length > 0 && /*#__PURE__*/ React.createElement(PrescriptionSummaryColumn, {
            title: labels.leftEye,
            fields: left,
            parameters: parameters,
            prescriptionType: prescriptionType,
            labels: labels
        })));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "glasses-configurator-footer-prescription",
        "data-t": "prescription-summary"
    }, !CommerceToolsApi.isNewPrescription(prescriptionType) && /*#__PURE__*/ React.createElement(PrescriptionSummaryColumn, {
        title: labels.prescriptionTitle,
        labels: labels,
        prescriptionType: prescriptionType
    }));
};

const PrescriptionSummaryContainer = ()=>{
    const { getLabel  } = useIntl();
    const prescription = useSelector(getPrescription$2);
    const prescriptionType = useSelector(getPrescriptionType);
    const labels = React.useMemo(()=>{
        if (!statusSuccess(prescription)) {
            return {};
        }
        const { parameters  } = prescription.result;
        const paramLabels = parameters.reduce((acc, { name  })=>swcHelpers.objectSpread({}, acc, {
                [name]: getLabel(`products.glasses.prescription.${name}`)
            })
        , {});
        return swcHelpers.objectSpread({}, paramLabels, {
            rightEye: getLabel('products.glasses.rightEye'),
            leftEye: getLabel('products.glasses.leftEye'),
            prescriptionTitle: getLabel('products.glasses.configurator.footer.prescription.title'),
            existingCustomer: getLabel('products.glasses.configurator.footer.existingCustomer'),
            emailPrescription: getLabel('products.glasses.configurator.footer.emailPrescription')
        });
    }, [
        getLabel,
        prescription
    ]);
    if (statusFailed(prescription)) {
        return /*#__PURE__*/ React.createElement("p", null, getLabel('products.glasses.prescription.loadingFailed'));
    }
    if (statusLoading(prescription)) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    if (!statusSuccess(prescription)) {
        return null;
    }
    const { right , left , parameters: parameters1 , uploadReferences  } = prescription.result;
    return /*#__PURE__*/ React.createElement(PrescriptionSummary, {
        prescriptionType: prescriptionType,
        parameters: parameters1,
        right: right,
        left: left,
        labels: labels,
        uploadReferences: uploadReferences
    });
};

const ConfigurationSummaryDivider = ({ isSmallScreen , className  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('configuration-summary-divider', className)
    }, isSmallScreen ? /*#__PURE__*/ React.createElement(Line, null) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Line, null), /*#__PURE__*/ React.createElement(Line, null), /*#__PURE__*/ React.createElement(Line, null)))
;
const Line = ()=>/*#__PURE__*/ React.createElement(Hr, {
        className: "configuration-summary-divider__line"
    })
;

const PrescriptionUploadSummary = ({ title , uploadReferences , hideDividers  })=>{
    const filteredUploadedFileNames = Object.values(uploadReferences).reduce((m, ref)=>!ref ? m : [
            ...m,
            ref.fileName
        ]
    , []);
    return (filteredUploadedFileNames === null || filteredUploadedFileNames === void 0 ? void 0 : filteredUploadedFileNames.length) ? /*#__PURE__*/ React__default.createElement("section", {
        className: "prescription-upload-summary"
    }, /*#__PURE__*/ React__default.createElement(SummaryTitle, null, title), !hideDividers && /*#__PURE__*/ React__default.createElement(ConfigurationSummaryDivider, {
        isSmallScreen: true,
        className: "prescription-upload-summary__divider"
    }), /*#__PURE__*/ React__default.createElement(FilesList, {
        items: filteredUploadedFileNames
    }), !hideDividers && /*#__PURE__*/ React__default.createElement(ConfigurationSummaryDivider, {
        isSmallScreen: true,
        className: "prescription-upload-summary__divider--bottom"
    })) : null;
};

const PrescriptionUploadSummaryContainer = ({ hideDividers  })=>{
    const { getLabel  } = useIntl();
    const prescription = useSelector(getPrescription$2);
    if (!statusSuccess(prescription) || !prescription.result.uploadReferences) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(PrescriptionUploadSummary, {
        title: getLabel('products.glasses.configurator.footer.prescription.title'),
        uploadReferences: prescription.result.uploadReferences,
        hideDividers: hideDividers
    });
};

const DesktopConfigurationSummary = ({ labels , bundlePrice , frame , addOn , lensType , lensPackage , isPhone , hasVisitedStepPrescription , hasVisitedStepLensPackage , hasVisitedStepAddOn , prescriptionType ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "desktop-configuration-summary"
    }, /*#__PURE__*/ React.createElement(FrameImage, null), frame && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        className: "desktop-configuration-summary__frame-row",
        zeroPriceLabel: labels.zeroPrice,
        label: /*#__PURE__*/ React.createElement(FrameInformationContainer, {
            textHeadingVariant: "smallest",
            showImage: isPhone,
            textOrientation: "vertical"
        }),
        price: frame.price
    }), /*#__PURE__*/ React.createElement("div", {
        className: "desktop-configuration-summary__selections"
    }, lensType && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: labels.lensType,
        value: getBundleProductTitle(lensType),
        price: lensType.price,
        discountText: lensType.discountText
    }), hasVisitedStepLensPackage && lensPackage && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: labels.lensPackage,
        value: lensPackage.title,
        price: lensPackage.price,
        discountText: lensPackage.discountText
    }), hasVisitedStepAddOn && addOn && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: labels.addOn,
        value: getBundleProductTitle(addOn),
        price: addOn.price,
        discountText: addOn.discountText
    }), /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: labels.totalPrice,
        price: bundlePrice,
        priceSize: "medium"
    })), hasVisitedStepPrescription ? /*#__PURE__*/ React.createElement("div", {
        className: "desktop-configuration-summary__prescription"
    }, CommerceToolsApi.isPrescriptionFile(prescriptionType) ? /*#__PURE__*/ React.createElement(PrescriptionUploadSummaryContainer, {
        hideDividers: true
    }) : /*#__PURE__*/ React.createElement(PrescriptionSummaryContainer, null)) : null);
};

const DesktopConfigurationSummaryContainer = ()=>{
    const { getLabel  } = useIntl();
    const prescriptionType = useSelector(getPrescriptionType);
    const { id  } = useRxGlassesConfiguratorContext();
    const hasVisitedStepPrescription$1 = useSelector((s)=>hasVisitedStepPrescription(s, {
            id
        })
    );
    const { frame , lensType , lensPackage , addOn , bundlePrice , hasVisitedStepAddOn , hasVisitedStepLensPackage ,  } = useConfigurationSummary();
    const labels = React.useMemo(()=>({
            lensType: getLabel('products.glasses.configurator.lensType'),
            lensPackage: getLabel('products.glasses.configurator.lensPackage'),
            addOn: getLabel('products.glasses.configurator.addOn'),
            totalPrice: getLabel('products.glasses.configurator.totalPrice'),
            zeroPrice: getLabel('products.glasses.configurator.priceIsZero')
        })
    , [
        getLabel
    ]);
    const isPhone = MediaQuery.useIsPhone();
    return /*#__PURE__*/ React.createElement(DesktopConfigurationSummary, {
        frame: frame,
        lensType: lensType,
        lensPackage: lensPackage,
        addOn: addOn,
        bundlePrice: bundlePrice,
        labels: labels,
        isPhone: isPhone,
        hasVisitedStepLensPackage: hasVisitedStepLensPackage,
        hasVisitedStepAddOn: hasVisitedStepAddOn,
        prescriptionType: prescriptionType,
        hasVisitedStepPrescription: hasVisitedStepPrescription$1
    });
};

const DesktopStepLayout = ({ children  })=>{
    const isDesktop = MediaQuery.useIsDesktop();
    return /*#__PURE__*/ React.createElement("div", {
        className: "desktop-step-layout"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "desktop-step-layout__left"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "desktop-step-layout__content"
    }, children)), isDesktop && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "desktop-step-layout__divider"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "desktop-step-layout__right"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "desktop-step-layout__content"
    }, /*#__PURE__*/ React.createElement(DesktopConfigurationSummaryContainer, null)))));
};

const ProductSelectionStep = ({ className , itemsList , selectedItemSku , readMoreLink , onChange , onSubmit ,  })=>{
    const isDesktop = MediaQuery.useIsDesktop();
    return /*#__PURE__*/ React.createElement(RxStepWrapper, {
        className: classnames('product-selection-step', className)
    }, /*#__PURE__*/ React.createElement(DesktopStepLayout, null, /*#__PURE__*/ React.createElement(StepForm, {
        onSubmit: onSubmit,
        className: "product-selection-step__wrapper"
    }, /*#__PURE__*/ React.createElement(ConfiguratorStepTitleAndDescription, {
        textAlignment: isDesktop ? 'left' : 'center'
    }), /*#__PURE__*/ React.createElement("div", {
        className: classnames('product-selection-step__products', className)
    }, /*#__PURE__*/ React.createElement("fieldset", {
        className: "product-selection-step__list"
    }, itemsList.map((item)=>{
        var ref, ref1, ref2;
         return React.createElement(ConfiguratorRadioTile, {
            className: "product-selection-step__list-item",
            isSelected: selectedItemSku === item.sku,
            onChange: onChange,
            value: item.sku,
            key: item.sku,
            title: item.title,
            image: (ref = item.image_v2) === null || ref === void 0 ? void 0 : ref.url,
            description: item.description,
            price: item.price,
            discountText: item.discountText,
            uspList: item.usps,
            tag: (ref1 = item.tags) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.value
        });
    })), readMoreLink && /*#__PURE__*/ React.createElement(Link, {
        className: "product-selection-step__read-more",
        url: readMoreLink.url,
        openInNewWindow: readMoreLink.openInNewWindow
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: "product-selection-step__read-more-icon",
        name: "info"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "product-selection-step__read-more-text"
    }, readMoreLink.label))))));
};

/**
 * For a given variant SKU, find the parent master variant SKU from a list of products
 */ function getSelectedVariantParentSku(itemList, sku) {
    var ref1;
    return (ref1 = itemList.filter((item)=>{
        var ref;
        return (ref = item.variants) === null || ref === void 0 ? void 0 : ref.filter((vItem)=>vItem.sku === sku
        ).length;
    })[0]) === null || ref1 === void 0 ? void 0 : ref1.sku;
}

/**
 * @experiment rx_configurator_v2
 */ const LensAddOnStepContainer = ()=>{
    const dispatch = useDispatch();
    const { getLabel , currency  } = useIntl();
    const { goToNextStep  } = useConfiguratorContext();
    const { configuratorDocument  } = useRxGlassesConfiguratorContext();
    var ref;
    const { readMoreLink  } = (ref = configuratorDocument === null || configuratorDocument === void 0 ? void 0 : configuratorDocument.addOnsStep) !== null && ref !== void 0 ? ref : {};
    const frame = useSelector(getSelectedFrame);
    const addOns = useSelector(getAddOns);
    const selectedAddOn = useSelector(getSelectedAddOn);
    const areAddOnsOptional = useSelector(getAreAddOnsOptional);
    const onChange = React__default.useCallback((sku)=>{
        if (!frame) {
            return;
        }
        if (sku === '') {
            //Reset the Add On selection if "No Add On" option is selected
            dispatch(resetSelectedAddOn({
                frameSku: frame.sku,
                reason: 'user selection'
            }));
        } else {
            dispatch(selectAddOn({
                frameSku: frame.sku,
                addOnSku: sku,
                reason: 'user selection'
            }));
        }
    }, [
        dispatch,
        frame === null || frame === void 0 ? void 0 : frame.sku
    ]);
    if (!statusSuccess(addOns)) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    const noAddOnOption = {
        variants: [],
        isDefault: false,
        sku: '',
        title: getLabel('products.glasses.lensAddOn.noAddOn.title'),
        description: getLabel('products.glasses.lensAddOn.noAddOn.description'),
        price: {
            originalPrice: 0,
            currency
        }
    };
    let selectedAddOnParentSku = '';
    const addOnsList = areAddOnsOptional ? [
        ...addOns.result,
        noAddOnOption
    ] : addOns.result;
    if (selectedAddOn) {
        selectedAddOnParentSku = getSelectedVariantParentSku(addOnsList, selectedAddOn === null || selectedAddOn === void 0 ? void 0 : selectedAddOn.sku) || (selectedAddOn === null || selectedAddOn === void 0 ? void 0 : selectedAddOn.sku);
    }
    return /*#__PURE__*/ React__default.createElement(ProductSelectionStep, {
        onChange: onChange,
        onSubmit: goToNextStep,
        itemsList: addOnsList,
        selectedItemSku: selectedAddOnParentSku,
        readMoreLink: readMoreLink
    });
};

const lensAddOnStepBase = {
    *onEnter () {
        yield call(selectDefaultAddOn);
    },
    view: LensAddOnStepContainer$1
};
/**
 * @experiment rx_configurator_v2
 */ const lensAddOnStepBaseV2 = {
    *onEnter () {
        yield call(selectDefaultAddOn);
    },
    ctaLabel: createSelector(ctaLabelSelectorProps, getSelectedAddOn, ({ defaultCtaLabel , alternativeCtaLabel  }, selectedAddOn)=>{
        var ref;
        return Number(selectedAddOn === null || selectedAddOn === void 0 ? void 0 : (ref = selectedAddOn.variants) === null || ref === void 0 ? void 0 : ref.length) > 1 && alternativeCtaLabel ? {
            key: alternativeCtaLabel
        } : {
            key: defaultCtaLabel
        };
    }),
    view: LensAddOnStepContainer
};
const isSuccess$2 = ({ packageSku  })=>(a)=>actions.isType(a, fetchAddOnsSuccess) && a.payload.packageSku === packageSku
;
const isFailed$2 = ({ packageSku  })=>(a)=>actions.isType(a, fetchAddOnsFailed) && a.payload.packageSku === packageSku
;
function* selectDefaultAddOn() {
    const selectedAddOn = yield select(getSelectedAddOn);
    if (!selectedAddOn) {
        const frameSku = yield select(getFrameSku);
        if (!frameSku) {
            return;
        }
        const selectedPackage = yield select(getSelectedPackage);
        let addOns = yield select(getAddOns);
        if (!statusSuccess(addOns) && !statusFailed(addOns)) {
            // If it's still loading we're going to wait a bit for the loading to finish
            const lensType = yield select(getSelectedLensType);
            if (!lensType) {
                return;
            }
            if (!selectedPackage) {
                return;
            }
            const [success] = yield race([
                take(isSuccess$2({
                    packageSku: selectedPackage.sku
                })),
                take(isFailed$2({
                    packageSku: selectedPackage.sku
                })),
                delay(30000, true), 
            ]);
            if (success) {
                addOns = yield select(getAddOns);
            }
        }
        if (statusSuccess(addOns)) {
            var ref;
            /**
       * Select the cheapest product that has the 'default' attribute set to true
       * If no product is set as default, select the cheapest one
       */ //make sure this is low to high
            const products = addOns.result;
            const variants = products.reduce((acc, p)=>[
                    ...acc,
                    p,
                    ...p.variants || []
                ]
            , []);
            let addOnSku = (selectedPackage === null || selectedPackage === void 0 ? void 0 : selectedPackage.areAddOnsOptional) ? '' : (ref = addOns.result[0]) === null || ref === void 0 ? void 0 : ref.sku;
            for (const variant of variants){
                if (variant.isDefault) {
                    addOnSku = variant.sku;
                    break;
                }
            }
            if (addOnSku) {
                yield put(selectAddOn({
                    frameSku,
                    addOnSku,
                    reason: 'default selection'
                }));
            }
        }
    }
}

const VariantSelectionStep = ({ className , itemsList , selectedItemSku , onChange , onSubmit ,  })=>{
    const showFrameImage = MediaQuery.useIsBelow(MediaQuery.BreakpointName.DESKTOP);
    const isDesktop = MediaQuery.useIsDesktop();
    return /*#__PURE__*/ React.createElement(RxStepWrapper, {
        className: classnames('variant-selection-step', className)
    }, /*#__PURE__*/ React.createElement(DesktopStepLayout, null, /*#__PURE__*/ React.createElement(StepForm, {
        onSubmit: onSubmit,
        className: "variant-selection-step__wrapper"
    }, /*#__PURE__*/ React.createElement(ConfiguratorStepTitleAndDescription, {
        textAlignment: isDesktop ? 'left' : 'center'
    }), showFrameImage && /*#__PURE__*/ React.createElement(FrameImage, null), /*#__PURE__*/ React.createElement("div", {
        className: classnames('variant-selection-step__products', className)
    }, /*#__PURE__*/ React.createElement("fieldset", {
        className: "variant-selection-step__list"
    }, itemsList.map((item)=>{
        var ref;
         return React.createElement(ConfiguratorRadioTile, {
            className: "variant-selection-step__list-item",
            isSelected: selectedItemSku === item.sku,
            onChange: onChange,
            value: item.sku,
            key: item.sku,
            title: item.title,
            headerRowImage: (ref = item.image) === null || ref === void 0 ? void 0 : ref.url,
            description: item.description,
            price: item.price,
            discountText: item.discountText
        });
    }))))));
};

/**
 * @experiment rx_configurator_v2
 */ const LensAddOnVariantStepContainer = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep  } = useConfiguratorContext();
    const frame = useSelector(getSelectedFrame);
    const addOns = useSelector(getAddOns);
    const selectedLensAddOn = useSelector(getSelectedAddOn);
    const onChange = React__default.useCallback((sku)=>{
        if (!frame) {
            return;
        }
        dispatch(selectAddOn({
            frameSku: frame.sku,
            addOnSku: sku,
            reason: 'user selection'
        }));
    }, [
        dispatch,
        frame
    ]);
    const variantsList = selectedLensAddOn === null || selectedLensAddOn === void 0 ? void 0 : selectedLensAddOn.variants;
    if (!statusSuccess(addOns)) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    if (!variantsList || variantsList.length === 0) {
        return /*#__PURE__*/ React__default.createElement(Failed$3, null);
    }
    return /*#__PURE__*/ React__default.createElement(VariantSelectionStep, {
        onChange: onChange,
        onSubmit: goToNextStep,
        itemsList: variantsList,
        selectedItemSku: selectedLensAddOn === null || selectedLensAddOn === void 0 ? void 0 : selectedLensAddOn.sku
    });
};
function Failed$3() {
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        title: getLabel('products.glasses.configurator.error'),
        className: "variant-selection-step__alert"
    });
}

const lensAddOnVariantStep = {
    stepStatus: createSelector(getSelectedAddOn, (selectedAddOn)=>{
        var ref;
        return Number(selectedAddOn === null || selectedAddOn === void 0 ? void 0 : (ref = selectedAddOn.variants) === null || ref === void 0 ? void 0 : ref.length) > 1 ? 'sub-step' : 'hidden';
    }),
    view: LensAddOnVariantStepContainer
};

const LensPackage = (_param)=>{
    var { className , lensPackage , isChecked , value , onChange  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "lensPackage",
        "isChecked",
        "value",
        "onChange"
    ]);
    const { getLabel  } = useIntl();
    const isTabletPortrait = MediaQuery.useIsTabletPortrait();
    const handleChange = React.useCallback(()=>onChange(lensPackage)
    , [
        onChange,
        lensPackage
    ]);
    const { title , description , price , discountText , usps  } = lensPackage;
    return /*#__PURE__*/ React.createElement(RadioCard, {
        "data-t": rest['data-t'],
        className: classnames('lens-package', className),
        id: `${value}-radio`,
        isChecked: isChecked,
        onChange: handleChange,
        value: value,
        title: title,
        description: description,
        price: price,
        discountText: discountText,
        zeroPriceLabel: getLabel('products.glasses.lensPackage.priceIsZero')
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lens-package__content"
    }, !!usps && !!usps.length && /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement("div", {
        className: "lens-package__usp-list-wrapper"
    }, /*#__PURE__*/ React.createElement(List, {
        icon: isTabletPortrait ? 'default' : 'checkmark-small',
        items: usps,
        renderText: (item)=>/*#__PURE__*/ React.createElement(Text, {
                variant: "caption-head"
            }, item)
        ,
        className: "lens-package__usp-list"
    })), /*#__PURE__*/ React.createElement(Hr, {
        className: "lens-package__bottom-divider"
    })));
};

const LensPackageStep = (_param)=>{
    var { className , lensPackages , selectedLensPackage , onChange , onSubmit  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "lensPackages",
        "selectedLensPackage",
        "onChange",
        "onSubmit"
    ]);
     return React__default.createElement(RxStepWrapper, {
        className: classnames('lens-package-step', className),
        "data-t": rest['data-t']
    }, /*#__PURE__*/ React__default.createElement(StepForm, {
        onSubmit: onSubmit
    }, /*#__PURE__*/ React__default.createElement(ConfiguratorStepTitleAndDescription, null), /*#__PURE__*/ React__default.createElement("div", {
        className: "lens-package-step__scroll-container"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "lens-package-step__scroll-container__inner"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "lens-package-step__list"
    }, lensPackages.map((lensPackage)=>{
        const isChecked = (selectedLensPackage === null || selectedLensPackage === void 0 ? void 0 : selectedLensPackage.sku) === lensPackage.sku;
        return /*#__PURE__*/ React__default.createElement(LensPackage, {
            "data-t": rest['data-t'] ? `${rest['data-t']}-${lensPackage.sku}` : undefined,
            isChecked: isChecked,
            className: "lens-package-step__list-item",
            lensPackage: lensPackage,
            value: lensPackage.sku,
            key: lensPackage.sku,
            onChange: onChange
        });
    }))))));
};

const LensPackageStepContainer$1 = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep  } = useConfiguratorContext();
    const frame = useSelector(getSelectedFrame);
    const lensPackages = useSelector(getPackages);
    const selectedLensPackage = useSelector(getSelectedPackage);
    const onChange = React__default.useCallback((lensPackage)=>{
        if (!frame) {
            return;
        }
        dispatch(selectPackage({
            frameSku: frame.sku,
            packageSku: lensPackage.sku,
            reason: 'user selection'
        }));
    }, [
        dispatch,
        frame === null || frame === void 0 ? void 0 : frame.sku
    ]);
    if (!statusSuccess(lensPackages)) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    return /*#__PURE__*/ React__default.createElement(LensPackageStep, {
        selectedLensPackage: selectedLensPackage,
        onChange: onChange,
        onSubmit: goToNextStep,
        lensPackages: lensPackages.result
    });
};

/**
 * @experiment rx_configurator_v2
 */ const LensPackageStepContainer = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep  } = useConfiguratorContext();
    const { configuratorDocument  } = useRxGlassesConfiguratorContext();
    var ref;
    const { readMoreLink  } = (ref = configuratorDocument === null || configuratorDocument === void 0 ? void 0 : configuratorDocument.packageStep) !== null && ref !== void 0 ? ref : {};
    const frame = useSelector(getSelectedFrame);
    const lensPackages = useSelector(getPackages);
    const selectedLensPackage = useSelector(getSelectedPackage);
    const onChange = React__default.useCallback((sku)=>{
        if (!frame) {
            return;
        }
        dispatch(selectPackage({
            frameSku: frame.sku,
            packageSku: sku,
            reason: 'user selection'
        }));
    }, [
        dispatch,
        frame === null || frame === void 0 ? void 0 : frame.sku
    ]);
    if (!statusSuccess(lensPackages)) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    return /*#__PURE__*/ React__default.createElement(ProductSelectionStep, {
        onChange: onChange,
        onSubmit: goToNextStep,
        itemsList: lensPackages.result,
        selectedItemSku: selectedLensPackage === null || selectedLensPackage === void 0 ? void 0 : selectedLensPackage.sku,
        readMoreLink: readMoreLink
    });
};

const lensPackageStepBase = {
    *onEnter () {
        yield call(selectDefaultPackage);
    },
    *onNext () {
        const selectedPackage = yield select(getSelectedPackage);
        if (!selectedPackage) {
            return new Error(`Selecting a lens-package is required`);
        }
    },
    view: LensPackageStepContainer$1
};
/**
 * @experiment rx_configurator_v2
 */ const lensPackageStepBaseV2 = {
    *onEnter () {
        yield call(selectDefaultPackage);
    },
    *onNext () {
        const selectedPackage = yield select(getSelectedPackage);
        if (!selectedPackage) {
            return new Error(`Selecting a lens-package is required`);
        }
    },
    view: LensPackageStepContainer
};
const isSuccess$1 = ({ lensTypeSku  })=>(a)=>actions.isType(a, fetchPackagesSuccess) && a.payload.lensTypeSku === lensTypeSku
;
const isFailed$1 = ({ lensTypeSku  })=>(a)=>actions.isType(a, fetchPackagesFailed) && a.payload.lensTypeSku === lensTypeSku
;
function* selectDefaultPackage() {
    const selectedPackage = yield select(getSelectedPackage);
    if (!selectedPackage) {
        const frameSku = yield select(getFrameSku);
        if (!frameSku) {
            return;
        }
        let packages = yield select(getPackages);
        if (!statusSuccess(packages) && !statusFailed(packages)) {
            // If it's still loading we're going to wait a bit for the loading to finish
            const lensType = yield select(getSelectedLensType);
            if (!lensType) {
                return;
            }
            const [success] = yield race([
                take(isSuccess$1({
                    lensTypeSku: lensType.sku
                })),
                take(isFailed$1({
                    lensTypeSku: lensType.sku
                })),
                delay(30000, true), 
            ]);
            if (success) {
                packages = yield select(getPackages);
            }
        }
        if (statusSuccess(packages)) {
            var ref;
            /**
       * Select the cheapest product that has the 'default' attribute set to true
       * If no product is set as default, select the cheapest one
       */ let packageSku = (ref = packages.result[0]) === null || ref === void 0 ? void 0 : ref.sku;
            for (const product of packages.result){
                if (product.isDefault) {
                    packageSku = product.sku;
                    break;
                }
            }
            if (packageSku) {
                yield put(selectPackage({
                    frameSku,
                    packageSku,
                    reason: 'default selection'
                }));
            }
        }
    } else {
        yield call(loadMissingAddOns, selectedPackage.sku);
    }
}

const LensTypeStep = (_param)=>{
    var { className , lensTypeInfoList , selectedLensType , onChange , onSubmit  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "lensTypeInfoList",
        "selectedLensType",
        "onChange",
        "onSubmit"
    ]);
     return React.createElement(RxStepWrapper, {
        className: classnames('lens-type-step', className),
        "data-t": rest['data-t']
    }, /*#__PURE__*/ React.createElement(StepForm, {
        onSubmit: onSubmit
    }, /*#__PURE__*/ React.createElement(ConfiguratorStepTitleAndDescription, null), /*#__PURE__*/ React.createElement("div", {
        className: "lens-type-step__scroll-container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lens-type-step__scroll-container__inner"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lens-type-step__list"
    }, lensTypeInfoList.map((lensTypeInfo)=>{
         return React.createElement(BundleProductRadioCard, {
            className: "lens-type-step__list-item",
            productInfo: lensTypeInfo,
            selectedVariantSku: selectedLensType === null || selectedLensType === void 0 ? void 0 : selectedLensType.sku,
            value: lensTypeInfo.sku,
            onChange: onChange,
            key: lensTypeInfo.sku,
            "data-t": rest['data-t'] ? `${rest['data-t']}-${lensTypeInfo.sku}` : undefined
        });
    }))))));
};

const LensTypeStepContainer$1 = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep  } = useConfiguratorContext();
    const frame = useSelector(getSelectedFrame);
    const lensTypes = useSelector(getLensTypes);
    const selectedLensType = useSelector(getSelectedLensType);
    const onChange = React__default.useCallback((lensType)=>{
        if (!frame) {
            return;
        }
        dispatch(selectLensType({
            frameSku: frame.sku,
            lensTypeSku: lensType.sku,
            reason: 'user selection'
        }));
    }, [
        dispatch,
        frame === null || frame === void 0 ? void 0 : frame.sku
    ]);
    if (!statusSuccess(lensTypes)) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    return /*#__PURE__*/ React__default.createElement(LensTypeStep, {
        onChange: onChange,
        onSubmit: goToNextStep,
        lensTypeInfoList: lensTypes.result,
        selectedLensType: selectedLensType
    });
};

/**
 * @experiment rx_configurator_v2
 */ const LensTypeStepContainer = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep  } = useConfiguratorContext();
    const frame = useSelector(getSelectedFrame);
    const lensTypes = useSelector(getLensTypes);
    const selectedLensType = useSelector(getSelectedLensType);
    const onChange = React__default.useCallback((sku)=>{
        if (!frame) {
            return;
        }
        dispatch(selectLensType({
            frameSku: frame.sku,
            lensTypeSku: sku,
            reason: 'user selection'
        }));
    }, [
        dispatch,
        frame === null || frame === void 0 ? void 0 : frame.sku
    ]);
    if (!statusSuccess(lensTypes)) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    const lensTypeList = lensTypes.result;
    let selectedLensTypeParentSku;
    if (selectedLensType) {
        selectedLensTypeParentSku = getSelectedVariantParentSku(lensTypeList, selectedLensType === null || selectedLensType === void 0 ? void 0 : selectedLensType.sku);
    }
    return /*#__PURE__*/ React__default.createElement(ProductSelectionStep, {
        onChange: onChange,
        onSubmit: goToNextStep,
        itemsList: lensTypeList,
        selectedItemSku: selectedLensTypeParentSku || (selectedLensType === null || selectedLensType === void 0 ? void 0 : selectedLensType.sku)
    });
};

const lensTypeStepBase = {
    *onEnter () {
        /**
     * Blocks the onEnter for this step, until the action has passed that
     * prepares the RxGlasses state for this configuration.
     */ yield race([
            take(startPrescriptionGlassesConfiguration),
            delay(3000)
        ]);
        yield call(selectDefaultLensType);
    },
    *onNext () {
        const lensType = yield select(getSelectedLensType);
        if (!lensType) {
            return new Error(`Selecting a lens-type is required`);
        }
    },
    view: LensTypeStepContainer$1
};
/**
 * @experiment rx_configurator_v2
 */ const lensTypeStepBaseV2 = {
    *onEnter () {
        /**
     * Blocks the onEnter for this step, until the action has passed that
     * prepares the RxGlasses state for this configuration.
     */ yield race([
            take(startPrescriptionGlassesConfiguration),
            delay(3000)
        ]);
        yield call(selectDefaultLensType);
    },
    *onNext () {
        const lensType = yield select(getSelectedLensType);
        if (!lensType) {
            return new Error(`Selecting a lens-type is required`);
        }
    },
    ctaLabel: createSelector(ctaLabelSelectorProps, getSelectedLensType, ({ defaultCtaLabel , alternativeCtaLabel  }, selectedLensType)=>{
        var ref;
        return Number(selectedLensType === null || selectedLensType === void 0 ? void 0 : (ref = selectedLensType.variants) === null || ref === void 0 ? void 0 : ref.length) > 1 && alternativeCtaLabel ? {
            key: alternativeCtaLabel
        } : {
            key: defaultCtaLabel
        };
    }),
    view: LensTypeStepContainer
};
const isSuccess = actions.guard(fetchLensTypesSuccess);
const isFailed = actions.guard(fetchLensTypesFailed);
function* selectDefaultLensType() {
    const lensType = yield select(getSelectedLensType);
    const frameSku = yield select(getFrameSku);
    if (!frameSku) {
        console.warn(`Did not find a frame SKU for this configuration. Received: ${frameSku}`);
        return;
    }
    if (!lensType) {
        let lensTypes = yield select(getLensTypes);
        if (statusLoading(lensTypes) || statusUninit(lensTypes)) {
            // If it's still loading we're going to wait a bit for the loading to finish
            const [success] = yield race([
                take((a)=>isSuccess(a)
                ),
                take((a)=>isFailed(a) && a.payload.frameSku === frameSku
                ),
                delay(30000, true), 
            ]);
            if (success) {
                lensTypes = yield select(getLensTypes);
            }
        }
        if (statusSuccess(lensTypes)) {
            var ref;
            /**
       * Select the cheapest product that has the 'default' attribute set to true
       * If there's no default product, select the cheapest one
       */ let lensTypeSku = (ref = lensTypes.result[0]) === null || ref === void 0 ? void 0 : ref.sku;
            for (const product of lensTypes.result){
                if (product.isDefault) {
                    lensTypeSku = product.sku;
                    break;
                }
            }
            if (lensTypeSku) {
                yield put(selectLensType({
                    frameSku,
                    lensTypeSku,
                    reason: 'default selection'
                }));
            }
        }
    } else {
        // If no default lens-type is selected we make sure to kick-off the rest of the loading sequence by:
        yield call(loadMissingPackages, lensType.sku);
    }
}

/**
 * @experiment rx_configurator_v2
 */ const LensTypeVariantStepContainer = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep  } = useConfiguratorContext();
    const frame = useSelector(getSelectedFrame);
    const lensTypes = useSelector(getLensTypes);
    const selectedLensType = useSelector(getSelectedLensType);
    const onChange = React__default.useCallback((sku)=>{
        if (!frame) {
            return;
        }
        dispatch(selectLensType({
            frameSku: frame.sku,
            lensTypeSku: sku,
            reason: 'user selection'
        }));
    }, [
        dispatch,
        frame
    ]);
    if (!statusSuccess(lensTypes)) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    const variantsList = selectedLensType === null || selectedLensType === void 0 ? void 0 : selectedLensType.variants;
    if (!variantsList || variantsList.length === 0) {
        return /*#__PURE__*/ React__default.createElement(Failed$2, null);
    }
    return /*#__PURE__*/ React__default.createElement(VariantSelectionStep, {
        onChange: onChange,
        onSubmit: goToNextStep,
        itemsList: variantsList,
        selectedItemSku: selectedLensType === null || selectedLensType === void 0 ? void 0 : selectedLensType.sku
    });
};
function Failed$2() {
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        title: getLabel('products.glasses.configurator.error'),
        className: "variant-selection-step__alert"
    });
}

const lensTypeVariantStep = {
    stepStatus: createSelector(getSelectedLensType, (selectedLensType)=>{
        var ref;
        return Number(selectedLensType === null || selectedLensType === void 0 ? void 0 : (ref = selectedLensType.variants) === null || ref === void 0 ? void 0 : ref.length) > 1 ? 'sub-step' : 'hidden';
    }),
    view: LensTypeVariantStepContainer
};

const typeToLabelMap = {
    NewPrescription: 'products.glasses.existingCustomerRadio.isNotExisting',
    ExistingCustomer: 'products.glasses.existingCustomerRadio.isExisting',
    EmailPrescription: 'products.glasses.existingCustomerRadio.isEmailPrescription',
    PrescriptionFile: 'products.glasses.existingCustomerRadio.isPrescriptionFile'
};
function useRadioItems(scopesToCheck) {
    const prescriptionTypes = usePrescriptionTypes();
    const shouldCheckUploadConfig = prescriptionTypes.includes('PrescriptionFile');
    const [radioItems, setRadioItems] = useState([]);
    const { getLabel  } = useIntl();
    const { configs  } = useUpload();
    function setOptionsWithLabel(items) {
        setRadioItems(items.map((key)=>({
                value: key,
                label: getLabel(typeToLabelMap[key])
            })
        ));
    }
    // if radio buttons has been set once, changing the config should not update them
    if (radioItems.length) {
        return {
            isWaiting: false,
            radioItems
        };
    }
    const statuses = scopesToCheck.map((s)=>{
        var ref;
        return ((ref = configs[s]) === null || ref === void 0 ? void 0 : ref.status) || 'failed';
    });
    const waitingStatuses = [
        LOADING,
        UNINIT
    ];
    const waitForUploadConfig = waitingStatuses.some((s)=>statuses.includes(s)
    );
    // if there is no need for upload config, then ignore it
    if (!shouldCheckUploadConfig) {
        setOptionsWithLabel(prescriptionTypes);
    } else if (!waitForUploadConfig) {
        const finalTypes = [
            ...prescriptionTypes
        ];
        // removing file options if config was not received
        if (statuses.some((s)=>s !== 'success'
        )) {
            const index = finalTypes.indexOf('PrescriptionFile');
            if (index >= 0) {
                finalTypes.splice(index, 1);
            }
        }
        setOptionsWithLabel(finalTypes);
    }
    return {
        isWaiting: waitForUploadConfig,
        radioItems
    };
}

const getOptions = (values, prescriptionAttribute)=>{
    const formatter = PrescriptionValueUtils.getFormatter(prescriptionAttribute);
    return Array.from(values).reduce((acc, value)=>{
        const formattedValue = formatter(value);
        if (formattedValue) {
            return swcHelpers.objectSpread({}, acc, {
                [formattedValue]: value
            });
        } else {
            console.error(`Error formatting prescription value ${value} for attribute: ${prescriptionAttribute}`);
            return acc;
        }
    }, {});
};
const PrescriptionSelect = /*#__PURE__*/ React.memo(({ name , parentId , values , selectClassName , onChange , errorMessageId , value , isValid , isDisabled ,  })=>{
    const { getLabel  } = useIntl();
    const options = React.useMemo(()=>getOptions(values, name)
    , [
        values,
        name
    ]);
    const sortOptions = React.useCallback((a, b)=>Number(a) - Number(b)
    , []);
    var ref;
    const formattedValue = (ref = PrescriptionValueUtils.formatPrescriptionValue(name, value)) !== null && ref !== void 0 ? ref : '';
    const valueAsString = React.useMemo(()=>({
            value: isPrescriptionValue(value) && values.has(value) ? formattedValue : ''
        })
    , [
        values,
        value,
        formattedValue
    ]);
    const { selectId , labelId , selectName  } = React.useMemo(()=>({
            selectId: `${parentId}-${name}-select`,
            labelId: `${parentId}-${name}-label`,
            selectName: `prescription-select-${name}`
        })
    , [
        parentId,
        name
    ]);
    const handleChange = React.useCallback((newValue)=>{
        onChange(name, newValue);
    }, [
        onChange,
        name
    ]);
    const isInvalid = isValid === false;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "prescription-column__label-wrapper"
    }, /*#__PURE__*/ React.createElement("label", {
        id: labelId,
        htmlFor: selectId,
        className: "prescription-column__label"
    }, getLabel(`products.glasses.prescription.${name}`)), /*#__PURE__*/ React.createElement(Tooltip, {
        id: `${parentId}-${name}-tooltip`,
        greyedOut: isDisabled,
        className: "prescription-column__tooltip",
        message: getLabel(`products.glasses.prescription.${name}.tooltip`)
    })), /*#__PURE__*/ React.createElement(Select, {
        id: selectId,
        "aria-labelledby": `${labelId} ${parentId}`,
        "aria-describedby": errorMessageId,
        "aria-invalid": isInvalid,
        className: classnames('prescription-column__select', selectClassName),
        options: options,
        sortOptionsBy: sortOptions,
        initialState: valueAsString,
        onChange: handleChange,
        name: selectName,
        "data-t": selectName,
        placeholder: "---"
    }));
});
const PrescriptionColumn = (_param)=>{
    var { id , className , hideSelectLabels , columnTitle , errorMessageId , parameters , selectedValues , validations , showValidation , onAttributeChange , isDisabled  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "id",
        "className",
        "hideSelectLabels",
        "columnTitle",
        "errorMessageId",
        "parameters",
        "selectedValues",
        "validations",
        "showValidation",
        "onAttributeChange",
        "isDisabled"
    ]);
    const sortedParams = sortPrescriptionParameters(parameters.map((p)=>p.name
    ));
    return /*#__PURE__*/ React.createElement("fieldset", {
        "data-t": "prescription-column-fieldset",
        disabled: isDisabled,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        "data-t": rest['data-t'],
        className: classnames('prescription-column', {
            'prescription-column--hide-labels': hideSelectLabels,
            'prescription-column--disabled': isDisabled
        })
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "subheading2",
        id: id,
        className: "prescription-column__title"
    }, columnTitle), sortedParams.map((paramName, index, array)=>{
        const parameter = parameters.find((p)=>p.name === paramName
        );
        if (!parameter) {
            return;
        }
        const parameterValue = selectedValues[parameter.name];
        const isParameterValid = showValidation ? validations === null || validations === void 0 ? void 0 : validations[parameter.name] : undefined;
        return /*#__PURE__*/ React.createElement(PrescriptionSelect, {
            key: parameter.name,
            name: parameter.name,
            parentId: id,
            value: !isDisabled ? parameterValue : undefined,
            isValid: isParameterValid,
            isDisabled: isDisabled,
            values: parameter.values,
            onChange: onAttributeChange,
            selectClassName: classnames({
                'prescription-column__select--first': index === 0,
                'prescription-column__select--last': index === array.length - 1
            })
        });
    })));
};
var PrescriptionColumn$1 = /*#__PURE__*/ React.memo(PrescriptionColumn);

const PupillaryDistanceLink = ({ className , labels  })=>{
    const { pdLinkLabel  } = labels;
    if (!pdLinkLabel) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement("p", {
        className: classnames('pupillary-distance-link', className)
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "glasses",
        className: "pupillary-distance-link__icon"
    }), pdLinkLabel);
};

const PupillaryDistanceLinkContainer = ({ className  })=>{
    const prescriptionType = useSelector(getPrescriptionType);
    const { hasLabel , getFormattedLabel  } = useIntl();
    const pdLinkLabelKey = CommerceToolsApi.isPrescriptionFile(prescriptionType) ? 'products.glasses.prescription.form.pdMeasurementLink' : 'products.glasses.prescription.form.pdLink';
    const labels = React__default.useMemo(()=>({
            pdLinkLabel: hasLabel(pdLinkLabelKey) ? getFormattedLabel(pdLinkLabelKey, {
                parseLink: true,
                openLinksInNewTab: true
            }) : ''
        })
    , [
        hasLabel,
        getFormattedLabel
    ]);
    return /*#__PURE__*/ React__default.createElement(PupillaryDistanceLink, {
        className: className,
        labels: labels
    });
};

const PrescriptionForm = (_param)=>{
    var { idExtension , className , prescription , setLeftParameter , setRightParameter , opticalParameters , prescriptionValidationState , isSubmitted , isDisabled , onSubmit  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "idExtension",
        "className",
        "prescription",
        "setLeftParameter",
        "setRightParameter",
        "opticalParameters",
        "prescriptionValidationState",
        "isSubmitted",
        "isDisabled",
        "onSubmit"
    ]);
    const { getLabel  } = useIntl();
    const isPhone = MediaQuery.useIsPhone();
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(StepForm, {
        className: classnames('prescription-form', className),
        "data-t": rest['data-t'],
        onSubmit: onSubmit
    }, /*#__PURE__*/ React__default.createElement(PrescriptionColumn$1, {
        className: "prescription-form__column",
        id: `right-configurator-${idExtension}`,
        columnTitle: getLabel(`products.glasses.rightEye`),
        parameters: opticalParameters,
        selectedValues: prescription.right,
        validations: prescriptionValidationState === null || prescriptionValidationState === void 0 ? void 0 : prescriptionValidationState.right,
        showValidation: isSubmitted,
        onAttributeChange: setRightParameter,
        isDisabled: isDisabled
    }), isPhone && /*#__PURE__*/ React__default.createElement(PupillaryDistanceLinkContainer, {
        className: "prescription-form__pd-link"
    }), /*#__PURE__*/ React__default.createElement(PrescriptionColumn$1, {
        className: "prescription-form__column",
        id: `left-configurator-${idExtension}`,
        columnTitle: getLabel(`products.glasses.leftEye`),
        parameters: opticalParameters,
        selectedValues: prescription.left,
        validations: prescriptionValidationState === null || prescriptionValidationState === void 0 ? void 0 : prescriptionValidationState.left,
        showValidation: isSubmitted,
        onAttributeChange: setLeftParameter,
        hideSelectLabels: true,
        isDisabled: isDisabled
    })), /*#__PURE__*/ React__default.createElement(PupillaryDistanceLinkContainer, {
        className: "prescription-form__pd-link"
    }));
};

const PrescriptionFormContainer = ({ className  })=>{
    const dispatch = useDispatch();
    const { goToNextStep , hasAttemptedNextStep  } = useConfiguratorContext();
    const frame = useSelector(getSelectedFrame);
    const handleChange = React__default.useCallback((side)=>(parameter, value)=>{
            if (!frame) {
                return;
            }
            dispatch(updatePrescriptionValue({
                side,
                frameSku: frame.sku,
                parameter,
                value
            }));
        }
    , [
        dispatch,
        frame === null || frame === void 0 ? void 0 : frame.sku
    ]);
    const prescription = useSelector(getPrescription$2);
    const prescriptionType = useSelector(getPrescriptionType);
    const manualPrescriptionValidationState = useSelector(getManualPrescriptionValidationState);
    const isSubmitted = hasAttemptedNextStep;
    const isEnabled = !prescriptionType || CommerceToolsApi.isNewPrescription(prescriptionType);
    const handleRightChange = React__default.useCallback(handleChange('right'), [
        handleChange
    ]);
    const handleLeftChange = React__default.useCallback(handleChange('left'), [
        handleChange
    ]);
    if (!statusSuccess(prescription) || !frame) {
        // Loading / error states are handled further up the tree
        return null;
    }
    const { left , right , parameters  } = prescription.result;
    const shouldDisplayValidationError = isSubmitted && isEnabled ? manualPrescriptionValidationState : undefined;
    return /*#__PURE__*/ React__default.createElement(PrescriptionForm, {
        className: classnames('prescription-step__form', className),
        opticalParameters: parameters,
        prescription: {
            left,
            right
        },
        prescriptionValidationState: shouldDisplayValidationError,
        idExtension: frame.sku,
        setLeftParameter: handleLeftChange,
        setRightParameter: handleRightChange,
        isSubmitted: isSubmitted,
        isDisabled: !isEnabled,
        onSubmit: goToNextStep
    });
};

var PrescriptionUploadForm = (_param)=>{
    var { className , onSubmit , onStatusChange , uploadState  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "onSubmit",
        "onStatusChange",
        "uploadState"
    ]);
    const { getLabel  } = useIntl();
    const uploadLayout = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT) ? 'vertical' : 'horizontal';
    const handlePDStatusChange = React__default.useCallback((status)=>onStatusChange(status, PD_SCOPE)
    , [
        onStatusChange
    ]);
    const handleRXStatusChange = React__default.useCallback((status)=>onStatusChange(status, RX_SCOPE)
    , [
        onStatusChange
    ]);
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(StepForm, {
        className: classnames('prescription-upload-form', className),
        "data-t": rest['data-t'],
        onSubmit: onSubmit
    }, /*#__PURE__*/ React__default.createElement(Upload, {
        variant: uploadLayout,
        id: "pd-upload",
        iconName: "upload-pd",
        title: getLabel('products.glasses.upload.pd.title'),
        "aria-describedby": PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID,
        onStatusChange: handlePDStatusChange,
        uploadStatus: uploadState[PD_SCOPE],
        referenceId: PD_SCOPE,
        scope: PD_SCOPE,
        className: "prescription-upload-form__uploader"
    }), /*#__PURE__*/ React__default.createElement(Upload, {
        variant: uploadLayout,
        id: "rx-upload",
        iconName: "upload-prescription",
        title: getLabel('products.glasses.upload.rx.title'),
        "aria-describedby": PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID,
        onStatusChange: handleRXStatusChange,
        uploadStatus: uploadState[RX_SCOPE],
        referenceId: RX_SCOPE,
        scope: RX_SCOPE,
        className: "prescription-upload-form__uploader"
    })));
};

const PrescriptionUploadFormContainer = ({ className  })=>{
    const dispatch = useDispatch();
    const { goToNextStep  } = useConfiguratorContext();
    const frame = useSelector(getSelectedFrame);
    const prescription = useSelector(getPrescription$2);
    const { scopes , setError , configs  } = useUpload();
    const { lastError , state , handlers , checkMissingFiles  } = useUploadHandler({
        sharedErrorElementId: PRESCRIPTION_STEP_UPLOAD_ERROR_ID,
        configs: scopes.map((scope)=>{
            var ref;
            const ref1 = statusSuccess(prescription) ? (ref = prescription.result.uploadReferences) === null || ref === void 0 ? void 0 : ref[scope] : undefined;
            return {
                scope,
                required: true,
                uploadStatus: ref1 ? Types.uploadStatusSuccess(ref1) : undefined
            };
        })
    });
    React__default.useEffect(()=>{
        var ref, ref2;
        if (((ref = configs[RX_SCOPE]) === null || ref === void 0 ? void 0 : ref.status) !== 'success') {
            dispatch(fileUploadResult('upload not possible - rx config'));
        }
        if (((ref2 = configs[PD_SCOPE]) === null || ref2 === void 0 ? void 0 : ref2.status) !== 'success') {
            dispatch(fileUploadResult('upload not possible - pd config'));
        }
    }, [
        configs,
        dispatch
    ]);
    React__default.useEffect(()=>{
        setError(lastError);
    // Adding setError in the deps array creates an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        lastError
    ]);
    const handleNextStepClick = React__default.useCallback((e)=>{
        e === null || e === void 0 ? void 0 : e.preventDefault();
        goToNextStep();
        /**
       * checkMissingFiles only updates the UI.
       * If the form is valid in state and goToNextStep is successful,
       * then it doesn't matter if checkMissingFiles runs or not
       */ const hasMissing = checkMissingFiles();
        if (hasMissing) {
            const isPDMissing = !Types.isUploadSuccess(state[PD_SCOPE]);
            const isRXMissing = !Types.isUploadSuccess(state[RX_SCOPE]);
            if (isPDMissing && isRXMissing) {
                dispatch(fileUploadResult('files missing'));
            } else {
                dispatch(fileUploadResult(isRXMissing ? 'rx missing' : 'pd missing'));
            }
        }
    }, [
        goToNextStep,
        checkMissingFiles,
        state,
        dispatch
    ]);
    const handleStatusChange = React__default.useCallback((callbackStatus, scope)=>{
        if (!frame) return;
        if (Types.isUploadSuccess(callbackStatus)) {
            toast.success('products.glasses.upload.success.message');
            dispatch(fileUploadResult(scope === PD_SCOPE ? 'pd success' : 'rx success'));
            dispatch(updateUploadReference({
                frameSku: frame.sku,
                scope,
                uploadReference: callbackStatus.uploadReference
            }));
        }
        /**
       * User deleted the file, so we want to remove our reference to it.
       */ if (Types.isUploadIdleAfterFileRemove(callbackStatus)) {
            dispatch(fileUploadResult(scope === PD_SCOPE ? 'pd remove' : 'rx remove'));
            dispatch(removeUploadReference({
                frameSku: frame.sku,
                scope
            }));
        }
        /**
       * User tried to overwrite a file, but it failed. Since the user intended to overwrite the
       * existing file and we show in the UI that the upload has failed, we remove the existing file
       * reference we had to not confuse the user. Worst case scenario they re-upload their previous file.
       */ if (Types.isUploadError(callbackStatus)) {
            dispatch(fileUploadResult(callbackStatus.error));
            dispatch(removeUploadReference({
                frameSku: frame.sku,
                scope
            }));
        }
        return handlers[scope](callbackStatus);
    }, [
        frame,
        handlers,
        dispatch
    ]);
    if (!statusSuccess(prescription) || !frame) {
        // error states are handled further up the tree
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(PrescriptionUploadForm, {
        className: className,
        onSubmit: handleNextStepClick,
        onStatusChange: handleStatusChange,
        uploadState: state
    });
};

const PupillaryDistanceContent = ({ className , description , image  })=>{
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    return /*#__PURE__*/ React__default.createElement("section", {
        className: classnames('pupillary-distance-content', className)
    }, image && /*#__PURE__*/ React__default.createElement("img", {
        className: "pupillary-distance-content__image",
        src: isSmallScreen ? image.mobileUrl : image.url,
        alt: image.description || ''
    }), description && /*#__PURE__*/ React__default.createElement("div", null, /*#__PURE__*/ React__default.createElement(RichTextArea, {
        className: "pupillary-distance-content__description",
        content: description
    })));
};

const PrescriptionUploadLayout = ({ className  })=>{
    const isPhone = MediaQuery.useIsPhone();
    const { getLabel , getFormattedLabel  } = useIntl();
    const { configuratorDocument  } = useRxGlassesConfiguratorContext();
    var ref;
    const { description , image  } = (ref = configuratorDocument === null || configuratorDocument === void 0 ? void 0 : configuratorDocument.prescriptionUploadStep) !== null && ref !== void 0 ? ref : {};
    const shouldShowPdContent = !!description || !!image;
    const supportedFilesLabelKey = 'products.glasses.upload.supportedFileTypes';
    const privacyPolicyLabelValue = getFormattedLabel('products.glasses.upload.privacyPolicyLink', {
        parseLink: true,
        openLinksInNewTab: true
    });
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames(`${className}__body ${className}__body--upload`, {
            [`${className}__body--upload-content`]: shouldShowPdContent
        })
    }, shouldShowPdContent && /*#__PURE__*/ React__default.createElement("div", {
        className: `${className}__section ${className}__pd-content`
    }, /*#__PURE__*/ React__default.createElement(PupillaryDistanceContent, {
        description: description,
        image: image
    })), isPhone ? /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, !shouldShowPdContent && /*#__PURE__*/ React__default.createElement("div", {
        className: `${className}__section`
    }, /*#__PURE__*/ React__default.createElement(PupillaryDistanceLinkContainer, {
        className: `${className}__pd-link`
    })), /*#__PURE__*/ React__default.createElement("div", {
        className: `${className}__section`
    }, /*#__PURE__*/ React__default.createElement(PrescriptionUploadFormContainer, {
        className: `${className}__upload-form`
    })), /*#__PURE__*/ React__default.createElement("div", {
        className: `${className}__section`
    }, /*#__PURE__*/ React__default.createElement(SupportedFiles, {
        label: getLabel(supportedFilesLabelKey)
    })), /*#__PURE__*/ React__default.createElement("div", {
        className: `${className}__section`
    }, /*#__PURE__*/ React__default.createElement(ExtraInfo, {
        className: className,
        label: privacyPolicyLabelValue
    }))) : /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement("div", {
        className: `${className}__section`
    }, /*#__PURE__*/ React__default.createElement(PrescriptionUploadFormContainer, {
        className: `${className}__upload-form`
    })), /*#__PURE__*/ React__default.createElement("div", {
        className: `${className}__section ${className}__extra-info-wrapper`
    }, /*#__PURE__*/ React__default.createElement(ExtraInfo, {
        className: className,
        label: privacyPolicyLabelValue
    })), /*#__PURE__*/ React__default.createElement("div", {
        className: `${className}__section`
    }, /*#__PURE__*/ React__default.createElement(SupportedFiles, {
        label: getLabel(supportedFilesLabelKey)
    }), !shouldShowPdContent && /*#__PURE__*/ React__default.createElement(PupillaryDistanceLinkContainer, {
        className: `${className}__pd-link`
    }))));
};
function ExtraInfo({ className , label  }) {
    return /*#__PURE__*/ React__default.createElement("p", {
        className: `${className}__extra-info`
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "info"
    }), /*#__PURE__*/ React__default.createElement("span", null, label));
}
function SupportedFiles({ label  }) {
    return /*#__PURE__*/ React__default.createElement("p", {
        id: PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID
    }, label);
}

const PrescriptionStep = (_param)=>{
    var { className , errorMessageKey , frame , frameImage , prescriptionType , changePrescriptionType , radioItems  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "errorMessageKey",
        "frame",
        "frameImage",
        "prescriptionType",
        "changePrescriptionType",
        "radioItems"
    ]);
    const isPhone = MediaQuery.useIsPhone();
    const { getLabel , hasLabel  } = useIntl();
    const isUploadSelected = CommerceToolsApi.isPrescriptionFile(prescriptionType);
    //creates a label like 'products.glasses.newPrescriptionRadio.alert'
    const alertLabelKey = prescriptionType ? `products.glasses.${prescriptionType.charAt(0).toLowerCase() + prescriptionType.substring(1)}Radio.alert` : '';
    const onRadioChange = React__default.useCallback((selected)=>{
        if (prescriptionType !== selected.value) {
            changePrescriptionType === null || changePrescriptionType === void 0 ? void 0 : changePrescriptionType(selected.value);
        }
    }, [
        changePrescriptionType,
        prescriptionType
    ]);
    const alertRef = /*#__PURE__*/ React__default.createRef();
    React__default.useEffect(()=>{
        if ('scrollBehavior' in document.documentElement.style) {
            var ref;
            (ref = alertRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        } else {
            var ref1;
            (ref1 = alertRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollIntoView();
        }
    }, [
        errorMessageKey
    ]);
    return /*#__PURE__*/ React__default.createElement(RxStepWrapper, {
        className: classnames('prescription-step', className),
        "data-t": rest['data-t'] || 'prescription-step'
    }, /*#__PURE__*/ React__default.createElement(ConfiguratorStepTitleAndDescription, null), /*#__PURE__*/ React__default.createElement(RadioButtons, {
        alignment: isPhone ? 'vertical' : 'horizontal',
        items: radioItems,
        scope: "prescription-type",
        onChange: onRadioChange,
        initialValue: prescriptionType !== null && prescriptionType !== void 0 ? prescriptionType : '',
        className: "prescription-step__radios"
    }), hasLabel(alertLabelKey) && /*#__PURE__*/ React__default.createElement(Alert, {
        type: "info",
        icon: "information-circle",
        title: getLabel(alertLabelKey),
        className: "prescription-step__alert"
    }), errorMessageKey && /*#__PURE__*/ React__default.createElement("div", {
        ref: alertRef
    }, /*#__PURE__*/ React__default.createElement(Alert, {
        id: isUploadSelected ? PRESCRIPTION_STEP_UPLOAD_ERROR_ID : undefined,
        type: "error",
        icon: "alert-circle",
        title: getLabel(errorMessageKey),
        className: "prescription-step__alert",
        notifyScreenReader: true
    })), isUploadSelected ? /*#__PURE__*/ React__default.createElement(PrescriptionUploadLayout, {
        className: "prescription-step"
    }) : /*#__PURE__*/ React__default.createElement("div", {
        className: "prescription-step__body"
    }, !isPhone && frameImage && /*#__PURE__*/ React__default.createElement("div", {
        className: "prescription-step__section prescription-step__image-wrapper"
    }, /*#__PURE__*/ React__default.createElement("img", {
        src: frameImage.url,
        alt: frame.title,
        className: "prescription-step__image"
    })), /*#__PURE__*/ React__default.createElement("div", {
        className: "prescription-step__section prescription-step__prescription-form"
    }, /*#__PURE__*/ React__default.createElement(PrescriptionFormContainer, null))));
};

const BASIC_VALIDATION_MESSAGE = 'products.glasses.prescription.form.validationError';
const PrescriptionStepContainer = ()=>{
    const { staticsUrl  } = useProductDetailContext();
    const { isBynderImagesEnabled  } = useFeatureToggles();
    const { hasAttemptedNextStep  } = useConfiguratorContext();
    const { isWaiting , radioItems  } = useRadioItems([
        RX_SCOPE,
        PD_SCOPE
    ]);
    const [errorMessageKey, setErrorMessageKey] = React__default.useState(null);
    const dispatch = useDispatch();
    const frame = useSelector(getSelectedFrame);
    const frameImage = useSelector((s)=>getFrameImage(s, {
            width: 590,
            staticsUrl,
            isBynderImagesEnabled
        })
    );
    const prescription = useSelector(getPrescription$2);
    const prescriptionType = useSelector(getPrescriptionType);
    const isPrescriptionStepValid = useSelector(getIsPrescriptionStepValid);
    const { error: uploadError  } = useUpload();
    const handlePrescriptionTypeChange = React__default.useCallback((value)=>{
        if (!frame) {
            return;
        }
        if (CommerceToolsApi.isPrescriptionType(value)) {
            dispatch(updatePrescriptionType({
                frameSku: frame.sku,
                prescriptionType: value,
                reason: 'user selection'
            }));
        }
    }, [
        dispatch,
        frame === null || frame === void 0 ? void 0 : frame.sku
    ]);
    /**
   * Check if the selected radio from state is still a possible option to show
   */ React__default.useEffect(()=>{
        // checking if prescriptionType exists in options
        if (radioItems.length && !radioItems.some(({ value  })=>value === prescriptionType
        )) {
            // reset selected item to first one
            handlePrescriptionTypeChange(radioItems[0].value);
        }
    }, [
        prescriptionType,
        radioItems
    ]);
    /**
   * Determine what error to show, if any
   */ React__default.useEffect(()=>{
        if (isPrescriptionStepValid) {
            setErrorMessageKey(null);
            return;
        }
        // If the user hits "Next Step" without selecting a prescription Type
        if (hasAttemptedNextStep && !prescriptionType) {
            setErrorMessageKey(BASIC_VALIDATION_MESSAGE);
            return;
        }
        // If Manual prescription form is invalid
        if (hasAttemptedNextStep && CommerceToolsApi.isNewPrescription(prescriptionType)) {
            setErrorMessageKey(BASIC_VALIDATION_MESSAGE);
            return;
        }
        // If Prescription Upload is selected and invalid
        if (CommerceToolsApi.isPrescriptionFile(prescriptionType)) {
            setErrorMessageKey(uploadError);
            return;
        }
        setErrorMessageKey(null);
    }, [
        prescriptionType,
        setErrorMessageKey,
        uploadError,
        hasAttemptedNextStep,
        isPrescriptionStepValid, 
    ]);
    if (isWaiting || !prescription || statusUninit(prescription) || statusLoading(prescription)) {
        return /*#__PURE__*/ React__default.createElement(Loading, null);
    }
    if (!frame || statusWarning(prescription) || statusFailed(prescription)) {
        return /*#__PURE__*/ React__default.createElement(Failed$1, null);
    }
    return /*#__PURE__*/ React__default.createElement(PrescriptionStep, {
        errorMessageKey: errorMessageKey,
        frame: frame,
        frameImage: frameImage,
        prescriptionType: prescriptionType,
        changePrescriptionType: handlePrescriptionTypeChange,
        radioItems: radioItems
    });
};
function Loading() {
    return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
}
function Failed$1() {
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        title: getLabel('products.glasses.configurator.error'),
        className: "prescription-step__error"
    });
}

const prescriptionStepBase = {
    onNext: onNext$1,
    view: PrescriptionStepContainer
};
function* onNext$1() {
    const prescriptionType = yield select(getPrescriptionType);
    // This should never happen, but we should handle it anyway. We'll block proceeding to the next step.
    if (!prescriptionType) {
        return new Error(`Prescription type is not defined`);
    }
    // Only validate prescription if user fills in their prescription manually or with a file upload.
    if (!CommerceToolsApi.isNewPrescription(prescriptionType) && !CommerceToolsApi.isPrescriptionFile(prescriptionType)) {
        return;
    }
    const isValid = yield select(getIsPrescriptionStepValid);
    if (!isValid) {
        return new Error(`Need valid prescription data for unknown customer`);
    }
}

function useRxUploadStatus(scopesToCheck, hasRxUploadOption) {
    const { configs  } = useUpload();
    if (!hasRxUploadOption) {
        return successState(null);
    }
    const statuses = scopesToCheck.map((s)=>{
        var ref;
        return ((ref = configs[s]) === null || ref === void 0 ? void 0 : ref.status) || 'failed';
    });
    if (statuses.every((s)=>s === SUCCESS
    )) {
        return successState(null);
    }
    if (statuses.some((s)=>s === FAILED
    )) {
        return failedState(new Error());
    }
    return loadingState();
}

const RxEntryRadioTile = ({ className , value , title , description , iconName , isSelected , onChange ,  })=>{
    return /*#__PURE__*/ React__default.createElement(SelectionBoxRadio, {
        className: classnames('rx-entry-radio-tile', className),
        name: "rx-entry-radio-tile",
        value: value,
        checked: isSelected,
        onChange: ()=>onChange(value)
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "rx-entry-radio-tile__wrapper"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "rx-entry-radio-tile__image"
    }), /*#__PURE__*/ React__default.createElement("div", {
        className: "rx-entry-radio-tile__body"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "rx-entry-radio-tile__heading"
    }, iconName && /*#__PURE__*/ React__default.createElement(Icon, {
        className: "rx-entry-radio-tile__icon",
        name: iconName
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        className: "rx-entry-radio-tile__title",
        component: "div",
        variant: "subheading1",
        visualHeadingOnly: true
    }, title)), description && /*#__PURE__*/ React__default.createElement(RichTextArea, {
        className: "rx-entry-radio-tile__description",
        content: description
    }))));
};

const PrescriptionEntrySelectionStep = ({ className , itemsList , selectedEntryItem , onChange , onSubmit ,  })=>{
    const isDesktop = MediaQuery.useIsDesktop();
    return /*#__PURE__*/ React.createElement(RxStepWrapper, {
        className: classnames('rx-entry-selection-step', className)
    }, /*#__PURE__*/ React.createElement(DesktopStepLayout, null, /*#__PURE__*/ React.createElement(StepForm, {
        onSubmit: onSubmit,
        className: "rx-entry-selection-step__wrapper"
    }, /*#__PURE__*/ React.createElement(ConfiguratorStepTitleAndDescription, {
        textAlignment: isDesktop ? 'left' : 'center'
    }), /*#__PURE__*/ React.createElement("div", {
        className: "rx-entry-selection-step__entry-list"
    }, /*#__PURE__*/ React.createElement("fieldset", {
        className: "rx-entry-selection-step__list"
    }, itemsList === null || itemsList === void 0 ? void 0 : itemsList.map((item)=>/*#__PURE__*/ React.createElement(RxEntryRadioTile, {
            className: "rx-entry-selection-step__list-item",
            isSelected: selectedEntryItem === item.key,
            onChange: onChange,
            value: item.key,
            key: item.key,
            title: item.title,
            description: item.description,
            iconName: item.icon
        })
    ))))));
};

/**
 * @experiment rx_configurator_v2
 */ const PrescriptionEntrySelectionStepContainer = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep  } = useConfiguratorContext();
    let rxEntryTypes = useSelector(getRxEntryTypes);
    const frame = useSelector(getSelectedFrame);
    const prescriptionType = useSelector(getPrescriptionType);
    const hasUpload = !!(rxEntryTypes === null || rxEntryTypes === void 0 ? void 0 : rxEntryTypes.some(({ key  })=>key === 'PrescriptionFile'
    ));
    const uploadStatus = useRxUploadStatus([
        RX_SCOPE,
        PD_SCOPE
    ], hasUpload);
    const onChange = React__default.useCallback((value)=>{
        if (!frame) {
            return;
        }
        if (CommerceToolsApi.isPrescriptionType(value) || isBookAppointmentEntrySelection(value)) {
            dispatch(updatePrescriptionType({
                frameSku: frame.sku,
                prescriptionType: value,
                reason: 'user selection'
            }));
        }
    }, [
        dispatch,
        frame === null || frame === void 0 ? void 0 : frame.sku
    ]);
    if (!frame || !rxEntryTypes || (rxEntryTypes === null || rxEntryTypes === void 0 ? void 0 : rxEntryTypes.length) === 0) {
        return /*#__PURE__*/ React__default.createElement(Failed, null);
    }
    if (statusLoading(uploadStatus)) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    if (statusFailed(uploadStatus)) {
        // remove upload from rxEntries
        rxEntryTypes = rxEntryTypes.filter(({ key  })=>key !== 'PrescriptionFile'
        );
    }
    return /*#__PURE__*/ React__default.createElement(PrescriptionEntrySelectionStep, {
        onChange: onChange,
        onSubmit: goToNextStep,
        itemsList: rxEntryTypes,
        selectedEntryItem: prescriptionType ? prescriptionType : rxEntryTypes[0].key
    });
};
function Failed() {
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        title: getLabel('products.glasses.configurator.error'),
        className: "prescription-step__error"
    });
}

/**
 * @experiment rx_configurator_v2
 */ const prescriptionEntrySelectionStepBase = {
    *onNext () {
        const prescriptionType = yield select(getPrescriptionType);
        // This should never happen, but we should handle it anyway. We'll block proceeding to the next step.
        if (!prescriptionType) {
            return new Error(`Prescription type is not defined`);
        }
        if (isBookAppointmentEntrySelection(prescriptionType)) {
            const routes = yield select(getRoutes);
            const bookAppointmentRoute = routes ? routes['book-appointment'] : undefined;
            if (!routes || !bookAppointmentRoute) {
                return new Error('Cannot redirect to Book Appointment. No book-appointment URL defined in the RxConfigurator');
            }
            window.location.assign(bookAppointmentRoute);
            // We are returning an error in order to prevent going to the next step.
            // Since this is the expected behavior, it's not a true "error" situation.
            return new Error('Canceling RxConfigurator flow. User chose to redirect to Book Appointment');
        }
    },
    view: PrescriptionEntrySelectionStepContainer,
    ctaLabel: createSelector(ctaLabelSelectorProps, getPrescriptionType, getRxEntryTypes, ({ defaultCtaLabel  }, prescriptionType, rxEntryTypes)=>{
        var ref;
        const defaultKey = {
            key: defaultCtaLabel
        };
        if (!prescriptionType || !rxEntryTypes || (rxEntryTypes === null || rxEntryTypes === void 0 ? void 0 : rxEntryTypes.length) === 0) {
            return defaultKey;
        }
        const label = (ref = rxEntryTypes.find((entry)=>prescriptionType === entry.key
        )) === null || ref === void 0 ? void 0 : ref.ctaLabel;
        /**
       * overrideLastCta
       * In case of AB testing for configurator step sequence when prescription entry selection
       * is the last step, the configurator will override the CTA button to add to cart.
       * by setting overrideLastCta to true, we will prevent the configurator to do so.
       */ return label ? {
            value: label,
            overrideLastCta: isBookAppointmentEntrySelection(prescriptionType)
        } : defaultKey;
    })
};

var StepWithAlerts = (_param)=>{
    var { children , alertLabel , className , errorMessage , errorMessageId , isLoading , isFailed  } = _param; swcHelpers.objectWithoutProperties(_param, [
        "children",
        "alertLabel",
        "className",
        "errorMessage",
        "errorMessageId",
        "isLoading",
        "isFailed"
    ]);
    const { getLabel  } = useIntl();
    const alertRef = React.useRef(null);
    const isDesktop = MediaQuery.useIsDesktop();
    React.useEffect(()=>{
        if ('scrollBehavior' in document.documentElement.style) {
            var ref;
            (ref = alertRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        } else {
            var ref1;
            (ref1 = alertRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollIntoView();
        }
    }, [
        errorMessage
    ]);
    if (isLoading) {
        return /*#__PURE__*/ React.createElement(LoaderScreen, null);
    }
    if (isFailed) {
        return /*#__PURE__*/ React.createElement(Alert, {
            type: "error",
            title: getLabel('products.glasses.configurator.error'),
            className: "step-with-alerts__alert"
        });
    }
    return /*#__PURE__*/ React.createElement(RxStepWrapper, {
        className: classnames('step-with-alerts', className)
    }, /*#__PURE__*/ React.createElement(DesktopStepLayout, null, /*#__PURE__*/ React.createElement("div", {
        className: "step-with-alerts__wrapper"
    }, /*#__PURE__*/ React.createElement(ConfiguratorStepTitleAndDescription, {
        textAlignment: isDesktop ? 'left' : 'center'
    }), alertLabel && /*#__PURE__*/ React.createElement(Alert, {
        type: "info",
        icon: "information-circle",
        title: alertLabel,
        className: "step-with-alerts__alert"
    }), errorMessage && /*#__PURE__*/ React.createElement("div", {
        ref: alertRef
    }, /*#__PURE__*/ React.createElement(Alert, {
        id: errorMessageId,
        type: "error",
        icon: "alert-circle",
        title: errorMessage,
        className: "step-with-alerts__alert",
        notifyScreenReader: true
    })), children)));
};

var PrescriptionFormStep = (_param)=>{
    var { description , image  } = _param, stepWithAlertsProps = swcHelpers.objectWithoutProperties(_param, [
        "description",
        "image"
    ]);
    const hasExtraInfo = Boolean(description || image);
    return /*#__PURE__*/ React__default.createElement(StepWithAlerts, swcHelpers.extends({}, stepWithAlertsProps), /*#__PURE__*/ React__default.createElement("div", {
        className: "rx-form-step"
    }, hasExtraInfo && /*#__PURE__*/ React__default.createElement(PupillaryDistanceContent, {
        className: "rx-form-step__pd-content",
        description: description,
        image: image
    }), /*#__PURE__*/ React__default.createElement(PrescriptionFormContainer, {
        className: "rx-form-step__form"
    })));
};

const PrescriptionFormStepContainer = ()=>{
    const { hasAttemptedNextStep  } = useConfiguratorContext();
    const [errorMessageKey, setErrorMessageKey] = React__default.useState(null);
    const { configuratorDocument  } = useRxGlassesConfiguratorContext();
    const { prescriptionFormStep  } = configuratorDocument || {};
    const { hasLabel , getLabel  } = useIntl();
    const frame = useSelector(getSelectedFrame);
    const prescription = useSelector(getPrescription$2);
    const isPrescriptionStepValid = useSelector(getIsPrescriptionStepValid);
    const alertLabelKey = 'products.glasses.newPrescriptionRadio.alert';
    React__default.useEffect(()=>{
        if (hasAttemptedNextStep && !isPrescriptionStepValid) {
            setErrorMessageKey('products.glasses.prescription.form.validationError');
            return;
        }
        setErrorMessageKey(null);
    }, [
        hasAttemptedNextStep,
        isPrescriptionStepValid
    ]);
    const isLoading = !prescription || statusUninit(prescription) || statusLoading(prescription);
    const isFailed = !frame || statusWarning(prescription) || statusFailed(prescription);
    return /*#__PURE__*/ React__default.createElement(PrescriptionFormStep, {
        description: prescriptionFormStep === null || prescriptionFormStep === void 0 ? void 0 : prescriptionFormStep.description,
        image: prescriptionFormStep === null || prescriptionFormStep === void 0 ? void 0 : prescriptionFormStep.image,
        isLoading: isLoading,
        isFailed: isFailed,
        errorMessage: errorMessageKey ? getLabel(errorMessageKey) : '',
        errorMessageId: PRESCRIPTION_STEP_FORM_ERROR_ID,
        alertLabel: hasLabel(alertLabelKey) ? getLabel(alertLabelKey) : ''
    });
};

/**
 * @experiment rx_configurator_v2
 */ const prescriptionFormStepBase = {
    *onNext () {
        const isValid = yield select(getIsPrescriptionStepValid);
        if (!isValid) {
            return new Error(`Need valid prescription data for unknown customer`);
        }
    },
    view: PrescriptionFormStepContainer,
    stepStatus: createSelector(getPrescriptionType, (prescriptionType)=>prescriptionType === 'NewPrescription' ? 'sub-step' : 'hidden'
    )
};

var PrescriptionUploadStep = (_param)=>{
    var { description , image  } = _param, stepWithAlertsProps = swcHelpers.objectWithoutProperties(_param, [
        "description",
        "image"
    ]);
    const isPhone = MediaQuery.useIsPhone();
    const { getLabel , getFormattedLabel  } = useIntl();
    const supportedFilesLabelKey = 'products.glasses.upload.supportedFileTypes';
    const privacyPolicyLabelValue = getFormattedLabel('products.glasses.upload.privacyPolicyLink', {
        parseLink: true,
        openLinksInNewTab: true
    });
    const hasExtraInfo = Boolean(description || image);
    return /*#__PURE__*/ React__default.createElement(StepWithAlerts, swcHelpers.extends({}, stepWithAlertsProps), /*#__PURE__*/ React__default.createElement("div", {
        className: "rx-upload-step"
    }, hasExtraInfo && /*#__PURE__*/ React__default.createElement(PupillaryDistanceContent, {
        description: description,
        image: image
    }), !hasExtraInfo && isPhone && /*#__PURE__*/ React__default.createElement(PupillaryDistanceLinkContainer, null), /*#__PURE__*/ React__default.createElement(PrescriptionUploadFormContainer, {
        className: "rx-upload-step__upload-form"
    }), /*#__PURE__*/ React__default.createElement(Text, {
        id: PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID
    }, getLabel(supportedFilesLabelKey)), !hasExtraInfo && !isPhone && /*#__PURE__*/ React__default.createElement(PupillaryDistanceLinkContainer, null), /*#__PURE__*/ React__default.createElement("div", {
        className: "rx-upload-step__privacy"
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "info"
    }), /*#__PURE__*/ React__default.createElement(Text, null, privacyPolicyLabelValue))));
};

const PrescriptionUploadStepContainer = ()=>{
    const { hasLabel , getLabel  } = useIntl();
    const [errorMessageKey, setErrorMessageKey] = React__default.useState();
    const { configuratorDocument  } = useRxGlassesConfiguratorContext();
    const { prescriptionUploadStep  } = configuratorDocument || {};
    const frame = useSelector(getSelectedFrame);
    const prescription = useSelector(getPrescription$2);
    const isPrescriptionStepValid = useSelector(getIsPrescriptionStepValid);
    const { error  } = useUpload();
    const alertLabelKey = 'products.glasses.prescriptionFileRadio.alert';
    React__default.useEffect(()=>{
        if (isPrescriptionStepValid) {
            setErrorMessageKey(null);
            return;
        }
        setErrorMessageKey(error);
    }, [
        error,
        isPrescriptionStepValid
    ]);
    const isLoading = !prescription || statusUninit(prescription) || statusLoading(prescription);
    const isFailed = !frame || statusWarning(prescription) || statusFailed(prescription);
    return /*#__PURE__*/ React__default.createElement(PrescriptionUploadStep, {
        description: prescriptionUploadStep === null || prescriptionUploadStep === void 0 ? void 0 : prescriptionUploadStep.description,
        image: prescriptionUploadStep === null || prescriptionUploadStep === void 0 ? void 0 : prescriptionUploadStep.image,
        isLoading: isLoading,
        isFailed: isFailed,
        errorMessage: errorMessageKey ? getLabel(errorMessageKey) : '',
        errorMessageId: PRESCRIPTION_STEP_UPLOAD_ERROR_ID,
        alertLabel: hasLabel(alertLabelKey) ? getLabel(alertLabelKey) : ''
    });
};

/**
 * @experiment rx_configurator_v2
 */ const prescriptionUploadStepBase = {
    *onNext () {
        const isValid = yield select(getIsPrescriptionStepValid);
        if (!isValid) {
            return new Error(`Need valid prescription data for unknown customer`);
        }
    },
    view: PrescriptionUploadStepContainer,
    stepStatus: createSelector(getPrescriptionType, (prescriptionType)=>prescriptionType === 'PrescriptionFile' ? 'sub-step' : 'hidden'
    )
};

const PrescriptionStepValidationStep = ({ className , prescriptionInfoFormState , showValidationError , verificationAllowed , onVerificationAllowedChange , onChange , onSubmit ,  })=>{
    const { getLabel  } = useIntl();
    const placeholderLabels = {
        dayPlaceholder: getLabel('common.placeholder.day.abbr'),
        monthPlaceholder: getLabel('common.placeholder.month.abbr'),
        yearPlaceholder: getLabel('common.placeholder.year.abbr')
    };
    const isDesktop = MediaQuery.useIsDesktop();
    const verificationCheckbox = React__default.useMemo(()=>({
            label: getLabel('products.glasses.validationStep.verificationAllowed.checkbox'),
            value: 'verificationAllowed'
        })
    , [
        getLabel
    ]);
    const handleFormChange = React__default.useCallback(debounce(250, (state)=>{
        onChange === null || onChange === void 0 ? void 0 : onChange(state.formState);
    }), [
        onChange
    ]);
    const handleConsentChange = React__default.useCallback((selectedItems)=>{
        onVerificationAllowedChange === null || onVerificationAllowedChange === void 0 ? void 0 : onVerificationAllowedChange(!!selectedItems.includes(verificationCheckbox));
    }, [
        onVerificationAllowedChange
    ]);
    const { opticianForm  } = useRxGlassesConfiguratorContext();
    const currentYear = new Date().getFullYear();
    const isDesignV2 = true;
    const Wrapper = DesktopStepLayout ;
    return /*#__PURE__*/ React__default.createElement(RxStepWrapper, {
        className: classnames('prescription-validation-step', className),
        "data-t": "prescription-validation-step"
    }, /*#__PURE__*/ React__default.createElement(Wrapper, null, /*#__PURE__*/ React__default.createElement(ConfiguratorStepTitleAndDescription, {
        textAlignment: isDesktop && isDesignV2 ? 'left' : 'center'
    }), showValidationError && /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        icon: "alert-circle",
        title: getLabel('products.glasses.validationStep.form.validationError'),
        className: "prescription-validation-step__alert"
    }), /*#__PURE__*/ React__default.createElement(ConnectedStepForm, {
        className: "prescription-validation-step__form",
        initialFormState: prescriptionInfoFormState,
        onChange: handleFormChange,
        onSubmit: onSubmit
    }, /*#__PURE__*/ React__default.createElement(DateOfBirthSelect, swcHelpers.extends({
        required: true,
        name: "expiryDate",
        label: getLabel('products.glasses.validationStep.expiryDate'),
        errorMessage: getLabel('products.glasses.validationStep.expiryDate.errorMessage'),
        validations: [
            Util.validations.isDate
        ],
        tooltipLabel: getLabel('products.glasses.validationStep.expiryDate.tooltip'),
        minYear: currentYear,
        maxYear: currentYear + 3
    }, placeholderLabels)), /*#__PURE__*/ React__default.createElement(DateOfBirthSelect, swcHelpers.extends({
        name: "examDate",
        label: getLabel('products.glasses.validationStep.examDate'),
        errorMessage: getLabel('products.glasses.validationStep.examDate.errorMessage'),
        tooltipLabel: getLabel('products.glasses.validationStep.examDate.tooltip'),
        validations: [
            Util.validations.isDate
        ],
        minYear: currentYear - 4
    }, placeholderLabels)), opticianForm && opticianForm(), /*#__PURE__*/ React__default.createElement(CheckboxList, {
        idPrefix: "prescription_validation__",
        items: [
            verificationCheckbox
        ],
        selectedItems: verificationAllowed ? [
            verificationCheckbox
        ] : [],
        onChange: handleConsentChange,
        getItemIdentifier: (item)=>item.value
        ,
        renderItem: (item)=>item.label
    }))));
};

const PrescriptionValidationStepContainer = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep , hasAttemptedNextStep  } = useConfiguratorContext();
    const frameSku = useSelector(getFrameSku);
    const prescriptionInfoFormState = useSelector(getAdditionalPrescriptionInfoFormState);
    const isVerificationAllowed = useSelector(getVerificationAllowed);
    const handleChange = React__default.useCallback((formState)=>{
        if (!frameSku) {
            return;
        }
        dispatch(updatePrescriptionInfo({
            frameSku,
            value: formState
        }));
    }, [
        frameSku,
        dispatch
    ]);
    const handleIsVerificationAllowedChange = React__default.useCallback((verificationAllowed)=>{
        if (!frameSku) {
            return;
        }
        dispatch(updateVerificationAllowed({
            frameSku,
            value: verificationAllowed
        }));
    }, [
        frameSku,
        dispatch
    ]);
    return /*#__PURE__*/ React__default.createElement(PrescriptionStepValidationStep, {
        prescriptionInfoFormState: prescriptionInfoFormState,
        verificationAllowed: isVerificationAllowed,
        onVerificationAllowedChange: handleIsVerificationAllowedChange,
        showValidationError: hasAttemptedNextStep,
        onChange: handleChange,
        onSubmit: goToNextStep
    });
};

const prescriptionValidationStepBase = {
    onNext,
    stepStatus: (s)=>{
        /**
     * Page should only show when the customer chose to enter their prescription manually via our form ("NewPrescription").
     */ const isStepEnabled = getIsExtraValidationStepEnabled(s);
        const prescriptionType = getPrescriptionType(s);
        const isNewPrescription = CommerceToolsApi.isNewPrescription(prescriptionType);
        if (!isStepEnabled) {
            return 'hidden';
        }
        return isNewPrescription ? 'active' : 'skip';
    },
    view: PrescriptionValidationStepContainer
};
function* onNext() {
    const isVerificationAllowed = yield select(getVerificationAllowed);
    return !isVerificationAllowed;
}

const labelKeys$1 = {
    lensType: {
        stepIndicatorTitle: 'products.glasses.configurator.step.lensType',
        title: 'products.glasses.lensType.title',
        description: 'products.glasses.lensType.description'
    },
    lensTypeVariant: {
        title: 'products.glasses.lensTypeVariant.title',
        description: 'products.glasses.lensTypeVariant.description'
    },
    prescription: {
        stepIndicatorTitle: 'products.glasses.configurator.step.prescription',
        title: 'products.glasses.prescription.title',
        description: 'products.glasses.prescription.description'
    },
    prescriptionEntrySelection: {
        stepIndicatorTitle: 'products.glasses.configurator.step.prescription',
        title: 'products.glasses.prescriptionEntry.title',
        description: 'products.glasses.prescriptionEntry.description'
    },
    prescriptionUpload: {
        title: 'products.glasses.prescriptionUpload.title',
        description: 'products.glasses.prescriptionUpload.description'
    },
    prescriptionForm: {
        title: 'products.glasses.prescriptionForm.title',
        description: 'products.glasses.prescriptionForm.description'
    },
    prescriptionValidation: {
        stepIndicatorTitle: 'products.glasses.configurator.step.prescriptionValidation',
        title: 'products.glasses.validationStep.title',
        description: 'products.glasses.validationStep.description'
    },
    lensPackage: {
        stepIndicatorTitle: 'products.glasses.configurator.step.lensPackage',
        title: 'products.glasses.lensPackage.title',
        description: 'products.glasses.lensPackage.description'
    },
    lensAddOn: {
        stepIndicatorTitle: 'products.glasses.configurator.step.lensAddOn',
        title: 'products.glasses.lensAddOn.title',
        description: 'products.glasses.lensAddOn.description'
    },
    lensAddOnVariant: {
        title: 'products.glasses.lensAddOnVariant.title',
        description: 'products.glasses.lensAddOnVariant.description'
    }
};
const stepsMap$2 = {
    lensType: swcHelpers.objectSpread({}, lensTypeStepBase, {
        labelKeys: labelKeys$1.lensType
    }),
    prescription: swcHelpers.objectSpread({}, prescriptionStepBase, {
        labelKeys: labelKeys$1.prescription
    }),
    prescriptionValidation: swcHelpers.objectSpread({}, prescriptionValidationStepBase, {
        labelKeys: labelKeys$1.prescriptionValidation
    }),
    lensPackage: swcHelpers.objectSpread({}, lensPackageStepBase, {
        labelKeys: labelKeys$1.lensPackage
    }),
    lensAddOn: swcHelpers.objectSpread({}, lensAddOnStepBase, {
        labelKeys: labelKeys$1.lensAddOn
    })
};
/**
 * @experiment rx_configurator_v2
 */ const stepsMapV2$1 = {
    lensType: swcHelpers.objectSpread({}, lensTypeStepBaseV2, {
        labelKeys: swcHelpers.objectSpread({}, labelKeys$1.lensType, {
            alternativeCta: 'products.glasses.lensType.selectVariant'
        })
    }),
    lensTypeVariant: swcHelpers.objectSpread({}, lensTypeVariantStep, {
        labelKeys: labelKeys$1.lensTypeVariant
    }),
    prescription: swcHelpers.objectSpread({}, prescriptionEntrySelectionStepBase, {
        labelKeys: labelKeys$1.prescriptionEntrySelection
    }),
    prescriptionUpload: swcHelpers.objectSpread({}, prescriptionUploadStepBase, {
        labelKeys: labelKeys$1.prescriptionUpload
    }),
    prescriptionForm: swcHelpers.objectSpread({}, prescriptionFormStepBase, {
        labelKeys: labelKeys$1.prescriptionForm
    }),
    prescriptionValidation: swcHelpers.objectSpread({}, prescriptionValidationStepBase, {
        labelKeys: labelKeys$1.prescriptionValidation
    }),
    lensPackage: swcHelpers.objectSpread({}, lensPackageStepBaseV2, {
        labelKeys: labelKeys$1.lensPackage
    }),
    lensAddOn: swcHelpers.objectSpread({}, lensAddOnStepBaseV2, {
        labelKeys: swcHelpers.objectSpread({}, labelKeys$1.lensAddOn, {
            alternativeCta: 'products.glasses.lensAddOn.selectVariant'
        })
    }),
    lensAddOnVariant: swcHelpers.objectSpread({}, lensAddOnVariantStep, {
        labelKeys: labelKeys$1.lensAddOnVariant
    })
};

const labelKeys = {
    lensType: {
        stepIndicatorTitle: 'products.rxsun.configurator.step.lensType',
        title: 'products.rxsun.lensType.title',
        description: 'products.rxsun.lensType.description'
    },
    lensTypeVariant: {
        title: 'products.rxsun.lensTypeVariant.title',
        description: 'products.rxsun.lensTypeVariant.description'
    },
    prescription: {
        stepIndicatorTitle: 'products.rxsun.configurator.step.prescription',
        title: 'products.rxsun.prescription.title',
        description: 'products.rxsun.prescription.description'
    },
    prescriptionEntrySelection: {
        stepIndicatorTitle: 'products.rxsun.configurator.step.prescription',
        title: 'products.rxsun.prescriptionEntry.title',
        description: 'products.rxsun.prescriptionEntry.description'
    },
    prescriptionUpload: {
        title: 'products.rxsun.prescriptionUpload.title',
        description: 'products.rxsun.prescriptionUpload.description'
    },
    prescriptionForm: {
        title: 'products.rxsun.prescriptionForm.title',
        description: 'products.rxsun.prescriptionForm.description'
    },
    prescriptionValidation: {
        stepIndicatorTitle: 'products.rxsun.configurator.step.prescriptionValidation',
        title: 'products.rxsun.validationStep.title',
        description: 'products.rxsun.validationStep.description'
    },
    lensPackage: {
        stepIndicatorTitle: 'products.rxsun.configurator.step.lensPackage',
        title: 'products.rxsun.lensPackage.title',
        description: 'products.rxsun.lensPackage.description'
    },
    lensAddOn: {
        stepIndicatorTitle: 'products.rxsun.configurator.step.lensAddOn',
        title: 'products.rxsun.lensAddOn.title',
        description: 'products.rxsun.lensAddOn.description'
    },
    lensAddOnVariant: {
        title: 'products.rxsun.lensAddOnVariant.title',
        description: 'products.rxsun.lensAddOnVariant.description'
    }
};
const stepsMap$1 = {
    lensType: swcHelpers.objectSpread({}, lensTypeStepBase, {
        labelKeys: labelKeys.lensType
    }),
    prescription: swcHelpers.objectSpread({}, prescriptionStepBase, {
        labelKeys: labelKeys.prescription
    }),
    prescriptionValidation: swcHelpers.objectSpread({}, prescriptionValidationStepBase, {
        labelKeys: labelKeys.prescriptionValidation
    }),
    lensPackage: swcHelpers.objectSpread({}, lensPackageStepBase, {
        labelKeys: labelKeys.lensPackage
    }),
    lensAddOn: swcHelpers.objectSpread({}, lensAddOnStepBase, {
        labelKeys: labelKeys.lensAddOn
    })
};
/**
 * @experiment rx_configurator_v2
 */ const stepsMapV2 = {
    lensType: swcHelpers.objectSpread({}, lensTypeStepBaseV2, {
        labelKeys: swcHelpers.objectSpread({}, labelKeys.lensType, {
            alternativeCta: 'products.rxsun.lensType.selectVariant'
        })
    }),
    lensTypeVariant: swcHelpers.objectSpread({}, lensTypeVariantStep, {
        labelKeys: labelKeys.lensTypeVariant
    }),
    prescription: swcHelpers.objectSpread({}, prescriptionEntrySelectionStepBase, {
        labelKeys: labelKeys.prescriptionEntrySelection
    }),
    prescriptionUpload: swcHelpers.objectSpread({}, prescriptionUploadStepBase, {
        labelKeys: labelKeys.prescriptionUpload
    }),
    prescriptionForm: swcHelpers.objectSpread({}, prescriptionFormStepBase, {
        labelKeys: labelKeys.prescriptionForm
    }),
    prescriptionValidation: swcHelpers.objectSpread({}, prescriptionValidationStepBase, {
        labelKeys: labelKeys.prescriptionValidation
    }),
    lensPackage: swcHelpers.objectSpread({}, lensPackageStepBaseV2, {
        labelKeys: labelKeys.lensPackage
    }),
    lensAddOn: swcHelpers.objectSpread({}, lensAddOnStepBaseV2, {
        labelKeys: labelKeys.lensAddOn
    }),
    lensAddOnVariant: swcHelpers.objectSpread({}, lensAddOnVariantStep, {
        labelKeys: swcHelpers.objectSpread({}, labelKeys.lensAddOnVariant, {
            alternativeCta: 'products.rxsun.lensAddOn.selectVariant'
        })
    })
};

/**
 * Please note that the first step cannot be a skippable step
 */ const stepSequence$1 = [
    'lensType',
    'prescription',
    'prescriptionValidation',
    'lensPackage',
    'lensAddOn', 
];
/**
 * @experiment rx_configurator_v2
 * Step Sequence for the V2 Configurator design
 */ const stepSequenceV2 = [
    'lensType',
    'lensTypeVariant',
    'prescription',
    'prescriptionUpload',
    'prescriptionForm',
    'prescriptionValidation',
    'lensPackage',
    'lensAddOn',
    'lensAddOnVariant', 
];
/**
 * @experiment rx_configuration_sequence_experiment
 * the alternative sequence is used for A/B testing
 * this can be removed after the experiment is over
 */ const stepSequenceAlternative = [
    'lensType',
    'lensPackage',
    'lensAddOn',
    'prescription',
    'prescriptionValidation', 
];
/**
 * @experiment rx_configurator_v2
 * Alternative Step Sequence for the V2 Configurator design
 */ const stepSequenceV2Alternative = [
    'lensType',
    'lensTypeVariant',
    'lensPackage',
    'lensAddOn',
    'lensAddOnVariant',
    'prescription',
    'prescriptionUpload',
    'prescriptionForm',
    'prescriptionValidation', 
];

const ConfigurationSummary = ({ labels , frame , addOn , lensType , lensPackage , bundlePrice , isPhone , isSmallScreen , hasVisitedStepLensPackage , hasVisitedStepAddOn ,  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, frame && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: /*#__PURE__*/ React.createElement(FrameInformationContainer, {
            showImage: isPhone,
            textOrientation: isPhone ? 'vertical' : 'horizontal'
        }),
        price: frame.price
    }), /*#__PURE__*/ React.createElement("div", {
        className: "glasses-configuration-summary",
        "data-t": "configuration-summary"
    }, lensType && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ConfigurationSummaryDivider, {
        isSmallScreen: isSmallScreen
    }), /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: labels.lensType,
        value: getBundleProductTitle(lensType),
        price: lensType.price,
        discountText: lensType.discountText
    })), hasVisitedStepLensPackage && lensPackage && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: labels.lensPackage,
        value: lensPackage.title,
        price: lensPackage.price,
        discountText: lensPackage.discountText
    }), hasVisitedStepAddOn && addOn && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: labels.addOn,
        value: getBundleProductTitle(addOn),
        price: addOn.price,
        discountText: addOn.discountText
    }), /*#__PURE__*/ React.createElement(ConfigurationSummaryDivider, {
        isSmallScreen: isSmallScreen
    }), /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: labels.totalPrice,
        price: bundlePrice,
        priceSize: "medium"
    })))
;

const ConfigurationSummaryContainer = ()=>{
    const { getLabel  } = useIntl();
    const { frame , lensType , lensPackage , addOn , bundlePrice , hasVisitedStepAddOn , hasVisitedStepLensPackage ,  } = useConfigurationSummary();
    const labels = React.useMemo(()=>({
            lensType: getLabel('products.glasses.configurator.lensType'),
            lensPackage: getLabel('products.glasses.configurator.lensPackage'),
            addOn: getLabel('products.glasses.configurator.addOn'),
            totalPrice: getLabel('products.glasses.configurator.totalPrice'),
            zeroPrice: getLabel('products.glasses.configurator.priceIsZero')
        })
    , [
        getLabel
    ]);
    const isPhone = MediaQuery.useIsPhone();
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    return /*#__PURE__*/ React.createElement(ConfigurationSummary, {
        frame: frame,
        lensType: lensType,
        lensPackage: lensPackage,
        addOn: addOn,
        bundlePrice: bundlePrice,
        labels: labels,
        isPhone: isPhone,
        isSmallScreen: isSmallScreen,
        hasVisitedStepLensPackage: hasVisitedStepLensPackage,
        hasVisitedStepAddOn: hasVisitedStepAddOn
    });
};

const RxGlassesExpanderContent = ({ prescriptionType , hasVisitedStepPrescription  })=>/*#__PURE__*/ React.createElement("div", {
        className: "rxglasses-expander-content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "rxglasses-expander-content__summary"
    }, /*#__PURE__*/ React.createElement(ConfigurationSummaryContainer, null)), !hasVisitedStepPrescription ? null : /*#__PURE__*/ React.createElement("div", {
        className: "rxglasses-expander-content__prescription"
    }, CommerceToolsApi.isPrescriptionFile(prescriptionType) ? /*#__PURE__*/ React.createElement(PrescriptionUploadSummaryContainer, null) : /*#__PURE__*/ React.createElement(PrescriptionSummaryContainer, null)))
;

const RxGlassesExpanderContentContainer = ()=>{
    const { id  } = useRxGlassesConfiguratorContext();
    const prescriptionType = useSelector(getPrescriptionType);
    const hasVisitedStepPrescription$1 = useSelector((s)=>hasVisitedStepPrescription(s, {
            id
        })
    );
    return /*#__PURE__*/ React.createElement(RxGlassesExpanderContent, {
        prescriptionType: prescriptionType,
        hasVisitedStepPrescription: hasVisitedStepPrescription$1
    });
};

var ConfigurationTotalPrice = (_param)=> {
    var { originalPrice , discountedPrice  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "originalPrice",
        "discountedPrice"
    ]);
    return React.createElement("div", {
        className: "configuration-total-price-wrapper"
    }, discountedPrice && discountedPrice !== originalPrice && /*#__PURE__*/ React.createElement(Price, swcHelpers.extends({}, rest, {
        type: "strikethrough",
        value: originalPrice,
        className: "configuration-total-price"
    })), /*#__PURE__*/ React.createElement(Price, swcHelpers.extends({}, rest, {
        value: discountedPrice !== null && discountedPrice !== void 0 ? discountedPrice : originalPrice,
        className: "configuration-total-price",
        type: discountedPrice ? 'discount' : 'default'
    })));
};

const ConfigurationTotalPriceContainer$1 = ()=>{
    const { id  } = useRxGlassesConfiguratorContext();
    const isPhone = MediaQuery.useIsPhone();
    const bundlePrice = useSelector((s)=>getBundlePrice(s, {
            id
        })
    );
    if (!bundlePrice || !bundlePrice.originalPrice) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ConfigurationTotalPrice, swcHelpers.extends({
        centAmount: true,
        size: isPhone ? 'medium' : 'large'
    }, bundlePrice));
};

const RxGlassesTopBar = ()=>{
    const isPhone = MediaQuery.useIsPhone();
    return /*#__PURE__*/ React.createElement("div", {
        className: "rxglasses-topbar"
    }, !isPhone && /*#__PURE__*/ React.createElement(FrameInformationContainer, null), /*#__PURE__*/ React.createElement(ConfigurationTotalPriceContainer$1, null));
};

const useConfiguratorStepSubmit = (configuratorNamespace)=>{
    const dispatch = useDispatch();
    const lineItemToBeAdded = useSelector(getAddToCartLineItem);
    const onAddToCartSuccess = React__default.useCallback(()=>{
        dispatch(addSuccess());
    }, [
        dispatch
    ]);
    const onValidationError = React__default.useCallback((validationCodes)=>{
        dispatch(addFailed(new Error(`Add to cart failed with following validation errors: ${validationCodes.join(', ')}`)));
        validationCodes.forEach((code)=>toast.failed(`cart.${code}`)
        );
    }, [
        dispatch
    ]);
    const onError = React__default.useCallback((errorCode)=>{
        dispatch(addFailed(new Error(`Add to cart failed with following error code: ${errorCode}`)));
        toast.failed(`cart.${errorCode}`);
    }, [
        dispatch
    ]);
    const [addToCart, addToCartResult] = Hooks.useAddToCart();
    // This makes sure the loading state resets when the addToCart call fails
    React__default.useEffect(()=>{
        if (addToCartResult === null || addToCartResult === void 0 ? void 0 : addToCartResult.error) {
            dispatch(addFailed(addToCartResult.error));
        }
    // Being a bit cautious about showing errors. We only dispatch error when error flips from `undefined` to error`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        typeof (addToCartResult === null || addToCartResult === void 0 ? void 0 : addToCartResult.error) !== 'undefined'
    ]);
    useSaga(React__default.useMemo(()=>function*() {
            while(true){
                /**
             * Will catch the end result for both carts-v1 and carts-v2 and signal that to the configurator
             */ const [failure] = yield race([
                    take([
                        addFailed.type
                    ]),
                    take([
                        addSuccess.type
                    ]), 
                ]);
                if (failure) {
                    yield put(Actions.finishFailed({
                        id: configuratorNamespace,
                        reason: new Error(failure.error.message)
                    }));
                    continue;
                }
                yield put(Actions.finishSuccess({
                    id: configuratorNamespace
                }));
            }
        }
    , [
        configuratorNamespace
    ]));
    return React__default.useCallback((event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        const draftLineItems = lineItemToBeAdded ? [
            lineItemToBeAdded
        ] : [];
        dispatch(add());
        addToCart(draftLineItems, onAddToCartSuccess, onValidationError, onError);
    }, [
        addToCart,
        lineItemToBeAdded,
        dispatch,
        onAddToCartSuccess,
        onValidationError,
        onError
    ]);
};

const scopes = [
    RX_SCOPE,
    PD_SCOPE
];
const contentProps$1 = {
    footerTopBarContent: /*#__PURE__*/ React.createElement(RxGlassesTopBar, null),
    footerExpanderContent: /*#__PURE__*/ React.createElement(RxGlassesExpanderContentContainer, null)
};
const RxGlassesConfigurator = (props)=>{
    const isDesktop = MediaQuery.useIsDesktop();
    const { routes  } = useProductDetailContext();
    const bundlePrice = useSelector((s)=>getBundlePrice(s, {
            id: props.id
        })
    );
    const prescriptionTypes = usePrescriptionTypes();
    const shouldCheckUploadConfig = prescriptionTypes.includes('PrescriptionFile');
    React.useEffect(()=>{
        bundlePrice && props.onPriceChange(bundlePrice);
    }, [
        bundlePrice,
        props.onPriceChange
    ]);
    useSaga(React.useMemo(()=>{
        return function*() {
            while(true){
                var ref;
                yield take((a)=>actions.isType(a, Actions.finishSuccess) && a.payload.id === props.id
                );
                if (props.onModalClose) {
                    yield call(props.onModalClose);
                }
                if ((ref = props.triggerButtonRef) === null || ref === void 0 ? void 0 : ref.current) {
                    yield call([
                        props.triggerButtonRef.current,
                        'focus'
                    ]);
                }
            }
        };
    }, [
        props.onModalClose,
        props.triggerButtonRef
    ]));
    useSaga(React.useMemo(()=>function*() {
            yield* listenForConfigurationChanges$1(props.id);
        }
    , [
        props.id
    ]));
    const finishHandler = useConfiguratorStepSubmit(props.id);
    /**
   * If the configurator isn't open, the contents of this entire component don't need to be rendered.
   */ if (!props.isOpen) {
        return null;
    }
    const isDesignV2 = true;
    const { resolvedStepSequence , resolvedStepsMap  } = resolveSteps({
        isRxSun: props.id === 'rxSun',
        isAlternateSequence: false,
        isDesignV2
    });
    return /*#__PURE__*/ React.createElement(RxGlassesConfiguratorProvider, {
        frame: props.frame,
        frameSku: props.frameSku,
        formatProductUrl: props.formatProductUrl,
        opticianForm: props.opticianForm,
        configuratorDocument: props.configuratorDocument,
        id: props.id,
        usps: props.usps,
        routes: routes
    }, /*#__PURE__*/ React.createElement(UploadProvider, {
        scopes: scopes,
        shouldFetchConfigs: shouldCheckUploadConfig
    }, /*#__PURE__*/ React.createElement(Configurator, swcHelpers.extends({
        id: props.id,
        className: "glasses-configurator-modal",
        preventVerticalScroll: isDesignV2,
        "data-t": "glasses-configurator-modal",
        stepSequence: resolvedStepSequence,
        stepsMap: resolvedStepsMap,
        lastStepCTALabelKey: "products.glasses.configurator.addToCart",
        isOpen: props.isOpen,
        onModalClose: props.onModalClose,
        onFinish: finishHandler
    }, isDesktop ? {} : contentProps$1))));
};
const resolveSteps = ({ isRxSun , isDesignV2 , isAlternateSequence  })=>{
    if (isDesignV2) {
        return {
            resolvedStepSequence: isAlternateSequence ? stepSequenceV2Alternative : stepSequenceV2,
            resolvedStepsMap: isRxSun ? stepsMapV2 : stepsMapV2$1
        };
    }
    return {
        resolvedStepSequence: isAlternateSequence ? stepSequenceAlternative : stepSequence$1,
        resolvedStepsMap: isRxSun ? stepsMap$1 : stepsMap$2
    };
};

const ProductDetailOpticsFeatures = ({ frame , antiReflex , antiScratch  })=>/*#__PURE__*/ React.createElement("ul", {
        className: "product-detail-optics-features"
    }, !!frame && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-optics-features__feature"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "checkmark-circle",
        viewBox: "-1 -1 26 26"
    }), frame), !!antiReflex && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-optics-features__feature"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "checkmark-circle",
        viewBox: "-1 -1 26 26"
    }), antiReflex), antiScratch && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-optics-features__feature"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "checkmark-circle",
        viewBox: "-1 -1 26 26"
    }), antiScratch))
;

const OfferingsList = ({ className , offeringItems , selectedValue , onChange ,  })=>{
    return /*#__PURE__*/ React__default.createElement("fieldset", {
        className: classnames('offerings-list', className)
    }, offeringItems.map(({ title , subTitle: subtitle , price , sku , icon  })=>{
        return /*#__PURE__*/ React__default.createElement(SelectionBoxRadio, {
            key: title,
            name: "offerings",
            value: sku,
            checked: selectedValue === sku,
            onChange: ()=>onChange(sku)
        }, /*#__PURE__*/ React__default.createElement(TileLayout, {
            title: title,
            subtitle: subtitle,
            price: price,
            iconName: icon
        }));
    }));
};

function convertToLocalizedOffering(locale, offering) {
    return swcHelpers.objectSpread({}, offering, {
        title: getLocalizedValue(offering.title, locale),
        subTitle: getLocalizedValue(offering.subTitle, locale)
    });
}
var OfferingsListContainer = (_param)=>{
    var { offerings , onSelectionChange , selectedValue  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "offerings",
        "onSelectionChange",
        "selectedValue"
    ]);
    const { locale  } = useIntl();
    const offeringItems = offerings.map(convertToLocalizedOffering.bind(null, locale));
    const handleOnChange = React__default.useCallback((sku)=>{
        const selectedOffering = offerings.find((offering)=>offering.sku === sku
        );
        selectedOffering && onSelectionChange(selectedOffering);
    }, [
        offerings,
        onSelectionChange
    ]);
    return /*#__PURE__*/ React__default.createElement(OfferingsList, swcHelpers.extends({
        offeringItems: offeringItems,
        selectedValue: selectedValue,
        onChange: handleOnChange
    }, rest));
};

function findOfferingByTitle(offerings, title) {
    return offerings.find((offering)=>new RegExp(title, 'i').test(Object.values(offering.title).join(','))
    );
}
function selectOffering(offerings, title) {
    return findOfferingByTitle(offerings, title) || offerings[0];
}

const Frames = ({ activeSku , dispatch , ean , addToCartRef , formatProductUrl , onCTAClick , onPriceChange , product , productTypeUsps , configuratorDocument , showStickyButton , staticsUrl , variant , specificationConfiguration , price: sspTotalPrice , opticianForm , children , stickyTop , secondaryCallToAction , handleConversionEvent , productImageGallery , disclaimer , bookAppointmentRoute , storesRoute ,  })=>{
    var ref2;
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { currency , getLabel , hasLabel , locale  } = useIntl();
    const reviews = useReviewsContext();
    const productViewHistory = useProductViewHistory();
    const { reimbursableLogos , isReimbursable , filteredOfferings  } = useProductDetailContext();
    const brandLink = useBrandLink(product);
    const variants = React.useMemo(()=>[
            product.masterVariant,
            ...product.variants
        ]
    , [
        product
    ]);
    const openConfiguratorButtonRef = React.useRef(null);
    const { Slots  } = useProductDetailSlots();
    const { isBynderImagesEnabled , isPrescriptionGlassesEnabled , isProductLabelEnabled ,  } = useFeatureToggles();
    const [isConfiguratorOpen, setIsConfiguratorOpen] = React.useState(false);
    const offerings = React.useMemo(()=>{
        if (!product.offerings) return [];
        // filter offerings based on the isReimbursable
        return product.offerings.filter((offering)=>isReimbursable ? offering.isInsuranceReimbursable : !offering.isInsuranceReimbursable
        );
    }, [
        product.offerings,
        isReimbursable
    ]);
    const [selectedOffering1, setSelectedOffering] = React.useState(()=>{
        return selectOffering(offerings, (filteredOfferings === null || filteredOfferings === void 0 ? void 0 : filteredOfferings[0]) || '');
    });
    const [ctaAction, setCtaAction] = React.useState(()=>getCtaAction(variant, selectedOffering1, isPrescriptionGlassesEnabled)
    );
    const altTag = getProductAltTag(variant.name, variants.find((v)=>v.sku === activeSku
    ) || variants[0], 'Frames', locale);
    const activeVariant = getActiveVariant$1(product, activeSku);
    const { price: variantPrice  } = variant;
    const displayPrice = getFramesDisplayPrice(variantPrice, selectedOffering1 === null || selectedOffering1 === void 0 ? void 0 : selectedOffering1.price, !isPrescriptionGlassesEnabled ? sspTotalPrice : undefined);
    // Add SKU to viewed product history
    React.useEffect(()=>{
        // We only want 1 SKU(variant) per product to be in the view history
        productViewHistory.remove(variants.map((v)=>v.sku || ''
        ));
        productViewHistory.add(variant.sku);
    // Adding productViewHistory to deps will cause an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        variants.length,
        variant.sku
    ]);
    // Make sure the ReviewsDisplay component gets updated with the currently active SKU
    React.useEffect(()=>{
        if (reviews.enabled) {
            reviews.dispatch(Actions$1.updateReviewDisplay({
                variantId: activeSku
            }));
        }
    }, [
        activeSku,
        reviews,
        reviews.enabled
    ]);
    React.useEffect(()=>{
        pushPdpEventToDataLayer(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, activeSku, currency);
    }, [
        activeSku
    ]);
    React.useEffect(()=>{
        if (selectedOffering1) {
            pushOfferingSelectionEvent(selectedOffering1, {
                isDefaultSelection: true
            });
        }
    // this useEffect should be executed only once, so no dependency is needed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleOfferingSelection = React.useCallback((selectedOffering)=>{
        setSelectedOffering(selectedOffering);
        pushOfferingSelectionEvent(selectedOffering);
        // update URL with selected offering
        const url = new URL(window.location.href);
        url.searchParams.set('offerings', getLocalizedValue(selectedOffering.title, locale));
        window.history.replaceState(null, '', url.toString());
    }, // changes on any of the dependencies has no effect on this function
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const handleCtaClick = React.useCallback(()=>{
        onCTAClick();
        // in case of add to cart, we need to push the event to data layer
        if (ctaAction === 'ADD_TO_CART' && selectedOffering1) {
            pushAddToCartEvent(product, activeSku, selectedOffering1, currency);
        }
    }, [
        ctaAction,
        onCTAClick,
        activeSku,
        selectedOffering1,
        product,
        currency
    ]);
    React.useEffect(()=>{
        const activeAction = getCtaAction(variant, selectedOffering1, isPrescriptionGlassesEnabled);
        setCtaAction(activeAction);
    }, [
        activeSku,
        activeVariant,
        isPrescriptionGlassesEnabled,
        selectedOffering1,
        variant
    ]);
    const handleConfiguratorClose = React.useCallback(()=>{
        var ref;
        setIsConfiguratorOpen(false);
        openConfiguratorButtonRef === null || openConfiguratorButtonRef === void 0 ? void 0 : (ref = openConfiguratorButtonRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    }, [
        openConfiguratorButtonRef
    ]);
    const handleConfiguratorOpen = React.useCallback(()=>{
        handleConversionEvent();
        setIsConfiguratorOpen(true);
    }, []);
    const callToActionButton = CommerceToolsApi.isRegularProductAction(ctaAction) ? /*#__PURE__*/ React.createElement(NonRxProductCTA, {
        storesRoute: storesRoute,
        action: ctaAction,
        handleConversionEvent: handleConversionEvent,
        addToCartConfig: {
            activeSku,
            offeringSku: selectedOffering1 === null || selectedOffering1 === void 0 ? void 0 : selectedOffering1.sku,
            bundleLineItemSkus: selectedOffering1 === null || selectedOffering1 === void 0 ? void 0 : selectedOffering1.bundledProducts,
            variantUrl: formatProductUrl({
                productType: variant.productType,
                sku: activeSku || '',
                slug: product.slug
            }),
            onCTAClick: handleCtaClick
        }
    }) : /*#__PURE__*/ React.createElement(RxGlassesCTA, {
        bookAppointmentRoute: bookAppointmentRoute,
        action: ctaAction,
        handleConversionEvent: handleConversionEvent,
        buttonRef: openConfiguratorButtonRef,
        onClickWhenOrderable: handleConfiguratorOpen
    });
    var ref1;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main product-detail__main--optical"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "desktop-hidden product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitle, {
        title: `${variant.brand} ${variant.modelName}`,
        subtitle: variant.brand,
        href: brandLink
    }), isSmallScreen && /*#__PURE__*/ React.createElement(ReviewSnippet, {
        productId: product.masterVariant.sku,
        variantId: activeSku
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, isBynderImagesEnabled ? productImageGallery : /*#__PURE__*/ React.createElement(ProductVisualSwitcher, {
        productImages: variant.images || [],
        alt: altTag,
        sku: activeSku,
        ean: ean,
        vtoProductEnabled: product.masterVariant.vtoEnabled
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__description"
    }, /*#__PURE__*/ React.createElement(ProductDetailDescription, {
        title: getLabel('products.contactLenses.header.details'),
        header: variant.header,
        description: variant.description,
        usps: /*#__PURE__*/ React.createElement(List, {
            icon: "checkmark",
            items: variant.usps
        })
    }, /*#__PURE__*/ React.createElement(ProductDetailOpticsFeatures, {
        frame: getLabel('products.frame'),
        antiReflex: getLabel('products.lens.features.antiReflex'),
        antiScratch: getLabel('products.lens.features.antiScratch')
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__specification"
    }, /*#__PURE__*/ React.createElement(ProductDetailSpecification, {
        configuration: specificationConfiguration,
        variant: activeVariant
    })), disclaimer && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__disclaimer"
    }, /*#__PURE__*/ React.createElement(Panel, {
        title: disclaimer.title
    }, disclaimer.description)), /*#__PURE__*/ React.createElement("section", {
        className: "product-detail__aside",
        "aria-label": `${variant.brand} ${variant.modelName}`
    }, /*#__PURE__*/ React.createElement(Sticky, {
        top: stickyTop || 0,
        bottomBoundary: ".product-detail",
        enabled: !isSmallScreen
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "mobile-hidden"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitle, {
        title: `${variant.brand} ${variant.modelName}`,
        subtitle: variant.brand,
        href: brandLink
    })), activeVariant.isInsuranceReimbursable && /*#__PURE__*/ React.createElement(ProductReimbursableLogo, {
        logos: reimbursableLogos,
        variant: isReimbursable ? 'alternative' : 'default'
    }), !isProductLabelEnabled && variant.tag && variant.tag.value && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__product-tag"
    }, /*#__PURE__*/ React.createElement(ProductTag, {
        tag: variant.tag
    })), !!variantPrice && /*#__PURE__*/ React.createElement("div", {
        role: "group",
        "aria-label": getLabel('products.screenreader.priceInformation')
    }, !!(selectedOffering1 === null || selectedOffering1 === void 0 ? void 0 : selectedOffering1.bundleContentDescription) && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__offering-bundle-description"
    }, getLocalizedValue(selectedOffering1.bundleContentDescription, locale)), /*#__PURE__*/ React.createElement("div", {
        className: classnames('product-detail__specification-prices', {
            'product-detail__specification-prices--has-discount': !!variant.discountText
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__price-container"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, swcHelpers.extends({}, displayPrice))), isProductLabelEnabled && /*#__PURE__*/ React.createElement(ProductDiscountLabel, {
        title: variant.discountText
    }), !isProductLabelEnabled && variant.discounted && /*#__PURE__*/ React.createElement(Discount, {
        label: variant.discountText,
        discount: variant.discounted,
        isWide: true
    })), Slots.AfterPrice ? /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__after-price-slot"
    }, /*#__PURE__*/ React.createElement(Slots.AfterPrice, null)) : null), !isSmallScreen && /*#__PURE__*/ React.createElement(ReviewSnippet, {
        productId: product.masterVariant.sku,
        variantId: activeSku
    }), hasLabel('products.frames.contents') && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__specification-contents"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "product-detail__specification-contents__header"
    }, getLabel('products.including')), /*#__PURE__*/ React.createElement("p", null, getLabel('products.frames.contents'))), /*#__PURE__*/ React.createElement(VariantPicker, {
        variantItems: getVariants$1(variants, getLocalizedValue(product.slug, locale), staticsUrl, variant.productType, locale, isBynderImagesEnabled),
        activeVariantSku: variant.sku,
        activeVariantLabel: variant.frameColorLabel,
        enableStockIndicator: isPrescriptionGlassesEnabled,
        channelAvailability: variant.channelAvailability,
        stockCount: (ref1 = (ref2 = variant.availability) === null || ref2 === void 0 ? void 0 : ref2.availableQuantity) !== null && ref1 !== void 0 ? ref1 : 0,
        isAllowBackOrder: !!variant.allowBackOrder,
        formatProductUrl: formatProductUrl,
        dispatch: dispatch
    }), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details",
        ref: addToCartRef
    }, offerings && selectedOffering1 && /*#__PURE__*/ React.createElement(OfferingsListContainer, {
        selectedValue: selectedOffering1.sku,
        offerings: offerings,
        onSelectionChange: handleOfferingSelection
    }), callToActionButton, secondaryCallToAction && secondaryCallToAction(variant), Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null, activeVariant.vtoEnabled && /*#__PURE__*/ React.createElement(TryOnButton, null), isSmallScreen && showStickyButton && !!variantPrice && /*#__PURE__*/ React.createElement(StickyCallToAction, {
        button: callToActionButton,
        price: /*#__PURE__*/ React.createElement(Price, {
            value: displayPrice.discountedPrice ? displayPrice.discountedPrice : displayPrice.originalPrice,
            currency: currency,
            centAmount: true,
            type: displayPrice.discountedPrice ? 'discount' : 'default'
        })
    })), productTypeUsps && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), /*#__PURE__*/ React.createElement(ProductDetailUsps, {
        items: productTypeUsps
    }))))), children && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__configuration"
    }, children), /*#__PURE__*/ React.createElement(RxGlassesConfigurator, {
        id: "glasses",
        frame: product,
        frameSku: activeSku,
        isOpen: isConfiguratorOpen,
        triggerButtonRef: openConfiguratorButtonRef,
        onModalClose: handleConfiguratorClose,
        onPriceChange: onPriceChange,
        formatProductUrl: formatProductUrl,
        opticianForm: opticianForm,
        configuratorDocument: configuratorDocument,
        usps: productTypeUsps
    }));
};
function getActiveOfferingActionObject(offering, activeSku) {
    if (!offering || !activeSku) return;
    if (Array.isArray(offering.actions)) {
        /**
     * 'offerings' will only be an array once we're using GraphQL to fetch the product data.
     */ return offering === null || offering === void 0 ? void 0 : offering.actions.find((a)=>a.variant === activeSku
        );
    } else {
        const action = offering.actions[activeSku];
        if (!action) return;
        return {
            variant: activeSku,
            action
        };
    }
}
function getCtaAction(variant, offering, isPrescriptionGlassesEnabled) {
    const fallbackAction = variant.channelAvailability === 'ONLINE' && isPrescriptionGlassesEnabled ? 'OPEN_CONFIGURATOR' : 'OPEN_CONFIGURATOR_UNAVAILABLE';
    if (!offering) {
        return fallbackAction;
    }
    if (offering && CommerceToolsApi.isDeprecatedOffering(offering)) {
        return offering.action;
    }
    const activeOffering = getActiveOfferingActionObject(offering, variant.sku);
    if (!activeOffering) {
        return fallbackAction;
    }
    return activeOffering.action;
}

function productIsAvailableForSubscription(product) {
    var ref, ref1, ref2;
    return !!((ref2 = product === null || product === void 0 ? void 0 : (ref = product.masterVariant) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.find(({ name  })=>name === 'isAvailableForSubscription'
    )) === null || ref2 === void 0 ? void 0 : ref2.value);
}

/**
 * Helper to map the enum values to numbers for easy comparison
 * use number conversion to map monthly -> 0, quarterly -> 1
 */ const toSortable = (ratePlan)=>({
        shipping: +(ratePlan.shippingSchedule === DeliveryFrequency.Quarterly),
        billing: +(ratePlan.billingPeriod === BillingFrequency.Quarterly)
    })
;
/**
 * This sorter can be used on alist of rateplans to sort them based on
 * the delivery and billing frequencies. The delivery frequency is checked first.
 * In case of a tie, the billing frequency is checked. Sort is not stable.
 * @param a first rateplan
 * @param b second rateplan
 * @returns -1, 0 or 1 in line with requirements for JS sort implementations
 */ function sortRateplans(a, b) {
    const [_a, _b] = [
        a,
        b
    ].map(toSortable);
    // if shipping is a tie, 0 is coerced to false and the check falls through
    // to the second part.
    return _a.shipping - _b.shipping || _a.billing - _b.billing;
}

function getNounLabel(value) {
    if (value === 1) return 'singular';
    else return 'plural';
}

function removeDuplicatesByPropertyValue(objArr, prop) {
    return objArr.filter((obj, pos, arr)=>arr.map((rp)=>rp[prop]
        ).indexOf(obj[prop]) === pos
    );
}

const toRawUsageLevel = (usageLevel)=>({
        one_day_a_week: Types$1.UsageLevel.ONE_DAY_A_WEEK,
        two_days_a_week: Types$1.UsageLevel.TWO_DAYS_A_WEEK,
        three_four_days_a_week: Types$1.UsageLevel.THREE_FOUR_DAYS_A_WEEK,
        more_than_five_days_a_week: Types$1.UsageLevel.MORE_THAN_FIVE_DAYS_A_WEEK
    })[usageLevel]
;
const toUsageLevel = (usageLevel)=>({
        [Types$1.UsageLevel.ONE_DAY_A_WEEK]: UsageLevel.One,
        [Types$1.UsageLevel.TWO_DAYS_A_WEEK]: UsageLevel.Two,
        [Types$1.UsageLevel.THREE_FOUR_DAYS_A_WEEK]: UsageLevel.ThreeFour,
        [Types$1.UsageLevel.MORE_THAN_FIVE_DAYS_A_WEEK]: UsageLevel.FivePlus
    })[usageLevel]
;
const toBillingFrequency$1 = (raw)=>{
    return ({
        [Types$1.BillingFrequency.MONTHLY]: BillingFrequency.Monthly,
        [Types$1.BillingFrequency.QUARTERLY]: BillingFrequency.Quarterly
    })[raw];
};
const toDeliveryFrequency$1 = (raw)=>{
    return ({
        [Types$1.DeliveryFrequency.MONTHLY]: DeliveryFrequency.Monthly,
        [Types$1.DeliveryFrequency.QUARTERLY]: DeliveryFrequency.Quarterly
    })[raw];
};
const toRatePlans = (rawRatePlan)=>{
    if (!rawRatePlan) return undefined;
    return rawRatePlan.map((ratePlan)=>({
            externalId: ratePlan.externalId,
            effectiveStartDate: ratePlan.effectiveStartDate,
            effectiveEndDate: ratePlan.effectiveEndDate,
            billingPeriod: toBillingFrequency$1(ratePlan.billingPeriod),
            shippingSchedule: toDeliveryFrequency$1(ratePlan.shippingSchedule),
            includedUnits: ratePlan.includedUnits,
            totalPrice: ratePlan.totalPrice,
            usageLevel: ratePlan.usageLevel ? toUsageLevel(ratePlan.usageLevel) : null,
            packageQuantity: ratePlan.variant.packageQuantity
        })
    );
};

const contactLensProductByRatePlansRatePlansFragment = gql`
  fragment ContactLensProductByRatePlansRatePlansFragment on ContactLensRatePlan {
    id: externalId
    externalId
    effectiveStartDate
    effectiveEndDate
    billingPeriod
    shippingSchedule
    includedUnits
    usageLevel
    totalPrice {
      currencyCode
      centAmount
    }
    variant {
      gan
      packageQuantity
    }
  }
`;
const contactLensProductByRatePlansFragment = gql`
  fragment ContactLensProductByRatePlansFragment on ContactLensProduct {
    productMasterKey
    ratePlans(usageLevel: $usageLevel) {
      ...ContactLensProductByRatePlansRatePlansFragment
    }
  }
  ${contactLensProductByRatePlansRatePlansFragment}
`;
var GET_PRODUCT_RATEPLANS = gql`
  query getProductRatePlansByMasterKey($productMasterKey: ID!, $usageLevel: UsageLevel) {
    productByMasterKey(productMasterKey: $productMasterKey) {
      ...ContactLensProductByRatePlansFragment
    }
  }
  ${contactLensProductByRatePlansFragment}
`;

const useProductRateplans = (productMasterKey, selectedUsageLevel)=>{
    // Usage level is null for non-dailies
    const usageLevel = selectedUsageLevel && toRawUsageLevel(selectedUsageLevel);
    const [getProductRatePlans, { data , loading , error  }] = useLazyQuery(GET_PRODUCT_RATEPLANS);
    useEffect(()=>{
        if (productMasterKey) {
            getProductRatePlans({
                variables: {
                    productMasterKey,
                    usageLevel
                }
            });
        }
    }, [
        productMasterKey,
        getProductRatePlans,
        usageLevel
    ]);
    const product = (data === null || data === void 0 ? void 0 : data.productByMasterKey) && data.productByMasterKey;
    if (!product || !product.ratePlans) {
        return {
            data: undefined,
            loading,
            error
        };
    }
    return {
        data: toRatePlans(product.ratePlans),
        loading,
        error
    };
};

const CardTrack = (_param)=>{
    var { className , children , itemSize ='large'  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "children",
        "itemSize"
    ]);
    const baseClassNames = classnames('configurator-card-track', className);
    const containerClassNames = classnames('configurator-card-track__container', {
        [`item-size-${itemSize}`]: !!itemSize
    });
    return /*#__PURE__*/ React__default.createElement("div", {
        className: baseClassNames,
        "data-t": rest['data-t']
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: containerClassNames
    }, React__default.Children.map(children, (child)=>{
        return /*#__PURE__*/ React__default.createElement("div", {
            className: "card-track-item"
        }, child);
    })));
};

const createSolutionProduct = (solution, variantGroup, solutions)=>{
    var ref, ref1, ref2;
    const position = (solutions === null || solutions === void 0 ? void 0 : solutions.findIndex(({ sku  })=>sku === solution.sku
    )) + 1;
    const originalPrice = calcPrice(((ref = solution.price) === null || ref === void 0 ? void 0 : ref.originalPrice) || 0);
    const discountedPrice = ((ref1 = solution.price) === null || ref1 === void 0 ? void 0 : ref1.discountedPrice) ? calcPrice(((ref2 = solution.price) === null || ref2 === void 0 ? void 0 : ref2.discountedPrice) || 0) : '';
    return {
        name: solution.title,
        id: solution.sku,
        price: originalPrice,
        brand: variantGroup,
        category: 'Solutions',
        variant: 'Solutions',
        dimension140: solution === null || solution === void 0 ? void 0 : solution.sku,
        dimension143: 'subscription',
        dimension144: 'single',
        dimension145: 'true',
        metric140: originalPrice,
        metric141: discountedPrice,
        metric142: '0',
        list: 'cls configurator',
        position
    };
};
function pushEvent$1(event, ecommerce) {
    DataLayer.pushEcommerceEvent({
        event,
        atfEcommerce: {
            ecommerce
        }
    });
}
const pushSolutionClick = (selectedSolution, variantGroup, currency, solutions)=>{
    if (selectedSolution.sku === NO_SOLUTION_SKU) {
        return;
    }
    const ecommerce = {
        currencyCode: currency,
        click: {
            actionField: {
                list: 'cls configurator'
            },
            products: [
                createSolutionProduct(selectedSolution, variantGroup, solutions)
            ]
        }
    };
    pushEvent$1('gvProductClick', ecommerce);
};
const pushSolutionImpressions = (solutions, variantGroup, currency)=>{
    const ecommerce = {
        currencyCode: currency,
        impressions: solutions// Slice off the "No solution" option
        .slice(1).map((solution)=>createSolutionProduct(solution, variantGroup, solutions)
        )
    };
    pushEvent$1('gvProductImpressions', ecommerce);
};
const pushClickUspBack = ()=>{
    DataLayer.pushEvent({
        event: 'ContactLensesConfigEvent',
        eventAction: 'click on button',
        eventLabel: 'USP back (mobile)'
    });
};
const pushClickUspNext = ()=>{
    DataLayer.pushEvent({
        event: 'ContactLensesConfigEvent',
        eventAction: 'click on button',
        eventLabel: 'USP forward (mobile)'
    });
};

var ClsStepWrapper = (_param)=>{
    var { children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    const usps = useSelector(getClsUsps);
    return /*#__PURE__*/ React__default.createElement(StepWrapper, {
        "data-t": rest['data-t'],
        className: classnames('contact-lenses-step', className),
        usps: usps,
        onNextSlide: pushClickUspNext,
        onPrevSlide: pushClickUspBack
    }, children);
};

const DeliveryFrequencyStep = (_param)=>{
    var { deliveryFrequencies , selectedDeliveryFrequency , className , onChange , onSubmit  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "deliveryFrequencies",
        "selectedDeliveryFrequency",
        "className",
        "onChange",
        "onSubmit"
    ]);
    const handleChange = React.useCallback((deliveryFrequency)=>{
        onChange({
            deliveryFrequency
        });
    }, [
        onChange
    ]);
    const singleDeliveryFrequency = deliveryFrequencies.length == 1 ? deliveryFrequencies[0] : null;
    const cardClassName = classnames('cls-delivery-frequency-card', className);
    return /*#__PURE__*/ React.createElement(ClsStepWrapper, {
        className: className,
        "data-t": rest['data-t']
    }, /*#__PURE__*/ React.createElement(StepForm, {
        onSubmit: onSubmit
    }, /*#__PURE__*/ React.createElement(ConfiguratorStepTitleAndDescription, null), /*#__PURE__*/ React.createElement(CardTrack, {
        itemSize: "large"
    }, singleDeliveryFrequency ? /*#__PURE__*/ React.createElement(SingleItemRadioCard, {
        cardClassName: cardClassName,
        className: "cls-delivery-frequency-card--single",
        title: singleDeliveryFrequency.title,
        description: singleDeliveryFrequency.description,
        icon: `calendar-${singleDeliveryFrequency.deliveryFrequency}`
    }) : deliveryFrequencies.map((item)=>/*#__PURE__*/ React.createElement(RadioCard, {
            key: item.deliveryFrequency,
            withDivider: true,
            className: cardClassName,
            id: `${item.deliveryFrequency}-radio`,
            isChecked: item.deliveryFrequency === selectedDeliveryFrequency,
            onChange: handleChange,
            value: item.deliveryFrequency,
            title: item.title,
            description: item.description,
            icon: `calendar-${item.deliveryFrequency}`
        })
    ))));
};

const DeliveryFrequencyStepContainer = ()=>{
    const dispatch = useDispatch();
    const { getLabel , getFormattedLabel  } = useIntl();
    const { goToNextStep  } = useConfiguratorContext();
    const variantGroup = useSelector(getVariantGroup) || 'UNKNOWN';
    const selectedDeliveryFrequency = useSelector(getSelectedDeliveryFrequency);
    const selectedUsageLevel = useSelector(getUsageFrequency);
    const ratePlans = useSelector(getRatePlans);
    const { data , loading , error  } = useProductRateplans(variantGroup, selectedUsageLevel);
    React__default.useEffect(()=>{
        if (data && !statusSuccess(ratePlans)) {
            dispatch(fetchRatePlansSuccess({
                ratePlans: data
            }));
        }
        if (error && !statusFailed(ratePlans)) {
            dispatch(fetchRatePlansFailed({
                error
            }));
        }
    }, [
        data,
        dispatch,
        ratePlans,
        error
    ]);
    const onChange = React__default.useCallback((args)=>{
        dispatch(selectDeliveryFrequency$1({
            variantGroup,
            deliveryFrequency: args.deliveryFrequency
        }));
    }, [
        dispatch,
        variantGroup
    ]);
    if (loading) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    if (statusFailed(ratePlans) || !data) {
        return /*#__PURE__*/ React__default.createElement(Alert, {
            type: "error",
            title: getLabel('products.contactLenses.subscription.steps.deliveryFrequency.error')
        });
    }
    const uniqueRatePlans = removeDuplicatesByPropertyValue(data, 'shippingSchedule');
    const deliveryFrequencySelectionList = uniqueRatePlans.map((ratePlan)=>({
            deliveryFrequency: ratePlan.shippingSchedule,
            packageQuantity: ratePlan.packageQuantity,
            title: getLabel(`products.contactLenses.subscription.steps.deliveryFrequency.${ratePlan.shippingSchedule}.title`),
            description: getFormattedLabel(`products.contactLenses.subscription.steps.deliveryFrequency.description.${getNounLabel(ratePlan.includedUnits)}Packs.${getNounLabel(ratePlan.packageQuantity)}Lenses`, {
                labelData: {
                    numberOfPacks: ratePlan.includedUnits,
                    numberOfLenses: ratePlan.packageQuantity
                }
            })
        })
    ).sort((a, b)=>a.deliveryFrequency.localeCompare(b.deliveryFrequency)
    );
    return /*#__PURE__*/ React__default.createElement(DeliveryFrequencyStep, {
        deliveryFrequencies: deliveryFrequencySelectionList,
        selectedDeliveryFrequency: selectedDeliveryFrequency,
        onChange: onChange,
        onSubmit: goToNextStep
    });
};

const deliveryFrequency = {
    *onEnter () {
        yield call(selectDefaultDeliveryFrequency);
    },
    *onNext () {
        const deliveryFrequency1 = yield select(getSelectedDeliveryFrequency);
        if (!deliveryFrequency1) {
            return new Error('Selecting a delivery frequency is required.');
        }
    },
    view: DeliveryFrequencyStepContainer
};
function* selectDefaultDeliveryFrequency() {
    const selectedDeliveryFrequency = yield select(getSelectedDeliveryFrequency);
    if (!selectedDeliveryFrequency) {
        let ratePlans = yield select(getRatePlans);
        if (statusUninit(ratePlans) || statusLoading(ratePlans)) {
            // If it's still loading we're going to wait a bit for the loading to finish
            const [success] = yield race([
                take(fetchRatePlansSuccess.type),
                take(fetchRatePlansFailed.type),
                delay(30000, true), 
            ]);
            if (success) {
                ratePlans = yield select(getRatePlans);
            }
        }
        if (statusSuccess(ratePlans)) {
            const variantGroup = yield select(getVariantGroup);
            //Use a rateplan with monthly shipping and billing frequency by default (if possible)
            yield put(selectDeliveryFrequency$1({
                variantGroup,
                deliveryFrequency: [
                    ...ratePlans.result.sort(sortRateplans)
                ][0].shippingSchedule
            }));
            // selectDeliveryFrequency triggers selectDeliveryFrequencySuccess which triggers
            // selectRatePlan, and only after success or failed can we know for sure that the
            // data layer event can successfully be called
            yield race([
                take(selectRatePlanSuccess.type),
                take(selectRatePlanFailed.type),
                delay(30000, true), 
            ]);
        }
    }
}

const toRawBillingFrequency = (billingFrequency)=>({
        [BillingFrequency.Monthly]: Types$1.BillingFrequency.MONTHLY,
        [BillingFrequency.Quarterly]: Types$1.BillingFrequency.QUARTERLY
    })[billingFrequency]
;
const toRawDeliveryFrequency = (deliveryFrequency)=>({
        [DeliveryFrequency.Monthly]: Types$1.DeliveryFrequency.MONTHLY,
        [DeliveryFrequency.Quarterly]: Types$1.DeliveryFrequency.QUARTERLY
    })[deliveryFrequency]
;
const toBillingFrequency = (raw)=>{
    const map = {
        [Types$1.BillingFrequency.MONTHLY]: BillingFrequency.Monthly,
        [Types$1.BillingFrequency.QUARTERLY]: BillingFrequency.Quarterly
    };
    return map[raw];
};
const toDeliveryFrequency = (raw)=>{
    const map = {
        [Types$1.DeliveryFrequency.MONTHLY]: DeliveryFrequency.Monthly,
        [Types$1.DeliveryFrequency.QUARTERLY]: DeliveryFrequency.Quarterly
    };
    return map[raw];
};

var ref$1;
const toRecommendedSolutions = (raw)=>{
    var ref1;
    return swcHelpers.objectSpread({}, raw, {
        ratePlans: (ref$1 = (ref1 = raw.ratePlans) === null || ref1 === void 0 ? void 0 : ref1.map((rp)=>swcHelpers.objectSpread({}, rp, {
                billingPeriod: toBillingFrequency(rp.billingPeriod),
                shippingSchedule: toDeliveryFrequency(rp.shippingSchedule),
                packageQuantity: 0
            })
        )) !== null && ref$1 !== void 0 ? ref$1 : []
    });
};

gql`
  fragment RecommendedSolutionsContactLensProductSolutionProductFragment on SolutionProduct {
    brand
    name
    description
    ratePlans(billingFrequency: $billingFrequency, deliveryFrequency: $deliveryFrequency) {
      id: externalId
      externalId
      effectiveStartDate
      effectiveEndDate
      billingPeriod
      shippingSchedule
      includedUnits
      totalPrice {
        currencyCode
        centAmount
      }
    }
    variants {
      gan
      sku
      media {
        images {
          url
          label
          dimensions {
            w
            h
          }
        }
      }
      contactLensCareType
      volume
      volumeUnit
    }
  }
`;
gql`
  fragment RecommendedSolutionsContactLensProductFragment on ContactLensProduct {
    productMasterKey
    recommendedSolutions {
      ...RecommendedSolutionsContactLensProductSolutionProductFragment
    }
  }
`;
var GET_RECOMMENDED_SOLUTIONS = gql`
  query getRecommendedSolutionsByMasterKey(
    $masterKey: ID!
    $billingFrequency: BillingFrequency!
    $deliveryFrequency: DeliveryFrequency!
  ) {
    productByMasterKey(productMasterKey: $masterKey) {
      ...RecommendedSolutionsContactLensProductFragment
    }
  }
`;

const useRecommendedSolutions = (brandKey, billingFrequency, deliveryFrequency)=>{
    const { locale  } = useIntl();
    const mappedBillingFrequency = billingFrequency && toRawBillingFrequency(billingFrequency);
    const mappedDeliveryFrequency = deliveryFrequency && toRawDeliveryFrequency(deliveryFrequency);
    const [runQuery, { data , loading , error  }] = useLazyQuery(GET_RECOMMENDED_SOLUTIONS);
    useEffect(()=>{
        if (brandKey && mappedBillingFrequency && mappedDeliveryFrequency) {
            runQuery({
                context: {
                    headers: {
                        'Accept-Language': locale
                    }
                },
                variables: {
                    billingFrequency: mappedBillingFrequency,
                    deliveryFrequency: mappedDeliveryFrequency,
                    masterKey: brandKey
                }
            });
        }
    }, [
        brandKey,
        locale,
        mappedBillingFrequency,
        mappedDeliveryFrequency,
        runQuery
    ]);
    const result = useMemo(()=>{
        return (data === null || data === void 0 ? void 0 : data.productByMasterKey) && data.productByMasterKey.recommendedSolutions.map(toRecommendedSolutions);
    }, [
        data
    ]);
    if (!result) {
        return {
            data: undefined,
            loading,
            error
        };
    }
    return {
        data: result,
        loading,
        error
    };
};

const useSolutions = ()=>{
    const { getLabel , currency  } = useIntl();
    const dispatch = useDispatch();
    const variantGroup = useSelector(getVariantGroup) || 'UNKNOWN';
    const billingFrequency = useSelector(getSelectedBillingPeriod);
    const deliveryFrequency = useSelector(getSelectedDeliveryFrequency);
    const { data: recommendedSolutions , loading  } = useRecommendedSolutions(variantGroup, billingFrequency, deliveryFrequency);
    const selectedSolution = useSelector(getSelectedSolution);
    const parsedSolutions = useMemo(()=>{
        const noSolution = {
            sku: NO_SOLUTION_SKU,
            gan: '',
            title: getLabel('products.contactLenses.subscription.steps.solution.noSolution'),
            price: {
                currency,
                originalPrice: 0
            }
        };
        if (recommendedSolutions) {
            const parsed = recommendedSolutions.filter((solution)=>{
                var ref;
                return (ref = solution.ratePlans) === null || ref === void 0 ? void 0 : ref.length;
            }).map((solution)=>{
                var ref, ref1, ref2;
                const variant = solution.variants[0];
                const masterImage = (ref = solution.variants[0].media) === null || ref === void 0 ? void 0 : ref.images.find((image)=>image.label !== ''
                );
                const totalPrice = (ref1 = solution.ratePlans) === null || ref1 === void 0 ? void 0 : ref1[0].totalPrice;
                var _label, _contactLensCareType, _name, ref3, ref4;
                return {
                    sku: solution.variants[0].sku,
                    gan: solution.variants[0].gan,
                    image: masterImage && {
                        label: (_label = masterImage.label) !== null && _label !== void 0 ? _label : '',
                        url: `${masterImage.url}`,
                        dimensions: masterImage.dimensions
                    },
                    description: `${(_contactLensCareType = variant.contactLensCareType) !== null && _contactLensCareType !== void 0 ? _contactLensCareType : ''}, ${variant.volume}${variant.volumeUnit}`,
                    title: (_name = solution.name) !== null && _name !== void 0 ? _name : '',
                    ratePlan: (ref2 = solution.ratePlans) === null || ref2 === void 0 ? void 0 : ref2[0],
                    price: {
                        currency: (ref3 = totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.currencyCode) !== null && ref3 !== void 0 ? ref3 : 'EUR',
                        originalPrice: (ref4 = totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.centAmount) !== null && ref4 !== void 0 ? ref4 : 0
                    }
                };
            });
            parsed.unshift(noSolution);
            return parsed;
        }
        return [
            noSolution
        ];
    }, [
        getLabel,
        currency,
        recommendedSolutions
    ]);
    const onSolutionChange = useCallback(({ solution  })=>{
        const selected = parsedSolutions.find(({ sku  })=>sku === solution
        );
        if (!selected) return;
        dispatch(selectSolution({
            solution: selected,
            variantGroup
        }));
        // Analytics event
        pushSolutionClick(selected, variantGroup, currency, parsedSolutions);
    }, [
        parsedSolutions,
        dispatch,
        variantGroup,
        currency
    ]);
    useEffect(()=>{
        // Analytics event
        if (parsedSolutions.length > 1 && variantGroup && currency) {
            pushSolutionImpressions(parsedSolutions, variantGroup, currency);
        }
    }, [
        parsedSolutions,
        variantGroup,
        currency
    ]);
    useEffect(()=>{
        if (recommendedSolutions && !selectedSolution) {
            onSolutionChange({
                solution: NO_SOLUTION_SKU
            });
        }
    }, [
        recommendedSolutions,
        onSolutionChange,
        selectedSolution
    ]);
    return {
        loading,
        onSolutionChange,
        recommendedSolutions: parsedSolutions,
        selectedSolution: selectedSolution === null || selectedSolution === void 0 ? void 0 : selectedSolution.gan
    };
};

const SolutionStep = (_param)=>{
    var { onSolutionChange , onSubmit , labels , solutions , selectedSolution  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "onSolutionChange",
        "onSubmit",
        "labels",
        "solutions",
        "selectedSolution"
    ]);
    const handleSolutionChange = React.useCallback((solution)=>{
        onSolutionChange({
            solution
        });
    }, [
        onSolutionChange
    ]);
    const isSolutionNoSolutionValue = (solution)=>{
        return solution.sku.startsWith('-');
    };
    const solutionRadioCardClassname = (solution)=>{
        return classnames('solution-step__radio', {
            'solution-step__radio--none': solution && isSolutionNoSolutionValue(solution)
        });
    };
    const singleSolution = solutions.length == 1 ? solutions[0] : null;
    return /*#__PURE__*/ React.createElement(ClsStepWrapper, {
        "data-t": rest['data-t']
    }, /*#__PURE__*/ React.createElement(StepForm, {
        onSubmit: onSubmit
    }, /*#__PURE__*/ React.createElement(ConfiguratorStepTitleAndDescription, null), /*#__PURE__*/ React.createElement(CardTrack, {
        itemSize: "small"
    }, singleSolution ? /*#__PURE__*/ React.createElement(SingleItemRadioCard, {
        withDivider: !isSolutionNoSolutionValue(singleSolution),
        cardClassName: "solution-step__single",
        className: solutionRadioCardClassname(singleSolution),
        image: singleSolution === null || singleSolution === void 0 ? void 0 : singleSolution.image,
        title: singleSolution === null || singleSolution === void 0 ? void 0 : singleSolution.title,
        description: singleSolution === null || singleSolution === void 0 ? void 0 : singleSolution.description,
        price: isSolutionNoSolutionValue(singleSolution) ? undefined : singleSolution === null || singleSolution === void 0 ? void 0 : singleSolution.price
    }) : solutions.map((sol)=>{
        // master image needs to resized to properly sized Image object.
        // This is not done in the useSolution hook as more components
        // require access to this base image to do their own sizing.
        const sizedImage = sol.image ? swcHelpers.objectSpread({}, sol.image, {
            url: `${sol.image.url}?w=175`,
            dimensions: {
                w: 175,
                h: 100
            }
        }) : undefined;
        return /*#__PURE__*/ React.createElement(RadioCard, {
            key: sol.sku,
            withDivider: !isSolutionNoSolutionValue(sol),
            className: solutionRadioCardClassname(sol),
            "data-t": `${sol.sku}-radio`,
            id: sol.sku,
            isChecked: sol.gan === selectedSolution,
            value: sol.sku,
            onChange: handleSolutionChange,
            image: sizedImage,
            title: sol === null || sol === void 0 ? void 0 : sol.title,
            description: sol === null || sol === void 0 ? void 0 : sol.description,
            price: isSolutionNoSolutionValue(sol) ? undefined : sol === null || sol === void 0 ? void 0 : sol.price,
            priceComment: isSolutionNoSolutionValue(sol) ? undefined : labels.priceComment
        });
    }))));
};

const SolutionStepContainer = ()=>{
    const { getLabel  } = useIntl();
    const { recommendedSolutions , loading , onSolutionChange , selectedSolution  } = useSolutions();
    const { goToNextStep  } = useConfiguratorContext();
    const labels = useMemo(()=>({
            priceComment: getLabel('products.contactLenses.subscription.steps.solution.text')
        })
    , [
        getLabel
    ]);
    if (loading) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    return /*#__PURE__*/ React__default.createElement(SolutionStep, {
        labels: labels,
        solutions: recommendedSolutions,
        onSolutionChange: onSolutionChange,
        onSubmit: goToNextStep,
        selectedSolution: selectedSolution
    });
};

const solution = {
    *onEnter () {
        const solution1 = yield select(getSelectedSolution);
        // This race will force the saga to wait until the solutions are fetched and
        // a default solution is selected, so the analytics event will fire correctly
        if (!solution1) {
            yield race([
                take(selectSolution.type),
                delay(30000, true)
            ]);
        }
    },
    view: SolutionStepContainer,
    stepStatus: (s)=>s.contactLensSubscription.configurator.recommendedCategoryKey === undefined ? 'hidden' : 'active'
};

const SubscriptionPlanStep = (_param)=>{
    var { billingPeriods , selectedBillingPeriod , onBillingPeriodChange , selectedStartDate , onStartDateChange , onSubmit , startDates , labels , showDisclaimer =false  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "billingPeriods",
        "selectedBillingPeriod",
        "onBillingPeriodChange",
        "selectedStartDate",
        "onStartDateChange",
        "onSubmit",
        "startDates",
        "labels",
        "showDisclaimer"
    ]);
    const handleBillingPeriodChange = React.useCallback((billingPeriod)=>{
        onBillingPeriodChange({
            billingPeriod
        });
    }, [
        onBillingPeriodChange
    ]);
    const singleBillingPeriod = billingPeriods.length == 1 ? billingPeriods[0] : null;
    return /*#__PURE__*/ React.createElement(ClsStepWrapper, {
        className: rest.className,
        "data-t": rest['data-t']
    }, /*#__PURE__*/ React.createElement(StepForm, {
        onSubmit: onSubmit
    }, /*#__PURE__*/ React.createElement(ConfiguratorStepTitleAndDescription, null), /*#__PURE__*/ React.createElement(CardTrack, {
        itemSize: "large"
    }, singleBillingPeriod ? /*#__PURE__*/ React.createElement(SingleItemRadioCard, {
        withDivider: true,
        cardClassName: "subscription-plan-step--single",
        icon: `calendar-${singleBillingPeriod.billingPeriod}`,
        title: singleBillingPeriod.title || 'NO_TITLE',
        description: singleBillingPeriod.description || 'NO_DESC',
        price: singleBillingPeriod.price
    }) : billingPeriods.map((item)=>/*#__PURE__*/ React.createElement(RadioCard, {
            key: item.billingPeriod,
            withDivider: true,
            className: "subscription-plan-step__radio",
            "data-t": `${item.billingPeriod}-radio`,
            id: item.billingPeriod,
            isChecked: item.billingPeriod === selectedBillingPeriod,
            value: item.billingPeriod,
            onChange: handleBillingPeriodChange,
            icon: `calendar-${item.billingPeriod}`,
            title: item.title || 'NO_TITLE',
            description: item.description || 'NO_DESC',
            price: item.price
        })
    )), /*#__PURE__*/ React.createElement("div", {
        className: "subscription-plan-step__date-picker"
    }, /*#__PURE__*/ React.createElement(DatePicker, {
        onChange: onStartDateChange,
        label: labels.datePickerLabel,
        required: true,
        initialValue: selectedStartDate,
        minDate: startDates === null || startDates === void 0 ? void 0 : startDates.min,
        maxDate: startDates === null || startDates === void 0 ? void 0 : startDates.max,
        dateFormat: "d MMMM yyyy"
    }), /*#__PURE__*/ React.createElement(Text, {
        variant: "caption"
    }, labels.datePickerText)), showDisclaimer && /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        className: "subscription-plan-step__disclaimer"
    }, labels.disclaimer)));
};

const MAX_DATE_SHIFT = {
    period: 'month',
    amount: 3
};
const SubscriptionPlanStepContainer = ()=>{
    const dispatch = useDispatch();
    const { getLabel , getFormattedLabel  } = useIntl();
    const { goToNextStep  } = useConfiguratorContext();
    const variantGroup = useSelector(getVariantGroup) || 'UNKNOWN';
    const ratePlans = useSelector(getRatePlans);
    const selectedDeliveryFrequency = useSelector(getSelectedDeliveryFrequency);
    const selectedBillingPeriod = useSelector(getSelectedBillingPeriod);
    const selectedStartDate = useSelector(getSelectedStartDate);
    const eyeSides = useSelector(getEyeSides);
    // min = today at midnight,
    // max = today shifted by MAX_DATE_SHIFT constant
    const startDates = React__default.useMemo(()=>({
            min: new Date(new Date().setHours(0, 0, 0, 0)),
            max: DateUtils.shiftDate(new Date(), MAX_DATE_SHIFT.period, MAX_DATE_SHIFT.amount)
        })
    , []);
    // show disclaimer when delivery frequency is set to quarterly,
    // but billing period set to monthly.
    // The user has to pay 3 months upfront as a one-time fee in
    // this case and we don't want to surprise them
    const shouldShowDisclaimer = React__default.useMemo(()=>selectedDeliveryFrequency === 'quarterly' && selectedBillingPeriod === 'monthly'
    , [
        selectedBillingPeriod,
        selectedDeliveryFrequency
    ]);
    const labels = React__default.useMemo(()=>({
            datePickerLabel: getLabel('products.contactLenses.subscription.steps.startDate.title'),
            datePickerText: getLabel('products.contactLenses.subscription.steps.startDate.description'),
            disclaimer: getFormattedLabel('products.contactLenses.subscription.steps.subscriptionPlan.disclaimer', {
                parseHTML: true
            })
        })
    , [
        getFormattedLabel,
        getLabel
    ]);
    const onBillingPeriodChange = React__default.useCallback(({ billingPeriod  })=>{
        dispatch(selectBillingPeriod$1({
            variantGroup,
            billingPeriod
        }));
    }, [
        dispatch,
        variantGroup
    ]);
    const onStartDateChange = React__default.useCallback((startDate)=>{
        if (selectedStartDate === startDate) return;
        dispatch(selectStartDate$2({
            variantGroup,
            startDate
        }));
        dispatch(selectStartDate$1({
            startDate
        }));
    }, [
        dispatch,
        variantGroup
    ]);
    if (!statusSuccess(ratePlans)) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    const billingPeriods = ratePlans.result// Only include rate plans that match the selected usage and delivery frequencies
    .filter((ratePlan)=>ratePlan.shippingSchedule === selectedDeliveryFrequency
    ).map((ratePlan)=>({
            billingPeriod: ratePlan.billingPeriod,
            price: {
                originalPrice: ratePlan.totalPrice.centAmount * eyeSides.length,
                currency: ratePlan.totalPrice.currencyCode
            },
            title: getLabel(`products.contactLenses.subscription.steps.subscriptionPlan.${ratePlan.billingPeriod}.title`),
            description: getLabel(`products.contactLenses.subscription.steps.subscriptionPlan.${ratePlan.billingPeriod}.description`)
        })
    ).sort((a, b)=>a.billingPeriod.localeCompare(b.billingPeriod)
    );
    return /*#__PURE__*/ React__default.createElement(SubscriptionPlanStep, {
        billingPeriods: billingPeriods,
        selectedBillingPeriod: selectedBillingPeriod,
        onBillingPeriodChange: onBillingPeriodChange,
        selectedStartDate: selectedStartDate,
        onStartDateChange: onStartDateChange,
        onSubmit: goToNextStep,
        startDates: startDates,
        labels: labels,
        showDisclaimer: shouldShowDisclaimer
    });
};

const subscriptionPlan = {
    *onEnter () {
        yield call(selectDefaultBillingPeriod);
        yield call(selectDefaultStartDate);
    },
    *onNext () {
        const billingPeriod = yield select(getSelectedBillingPeriod);
        if (!billingPeriod) {
            return new Error('Selecting a billing period is required.');
        }
        const startDate = yield select(getSelectedStartDate);
        if (!startDate) {
            return new Error('Selecting a start date is required.');
        }
    },
    view: SubscriptionPlanStepContainer
};
function* selectDefaultBillingPeriod() {
    const selectedBillingPeriod = yield select(getSelectedBillingPeriod);
    if (!selectedBillingPeriod) {
        let ratePlans = yield select(getRatePlans);
        if (statusUninit(ratePlans) || statusLoading(ratePlans)) {
            // If it's still loading we're going to wait a bit for the loading to finish
            const [success] = yield race([
                take(fetchRatePlansSuccess.type),
                take(fetchRatePlansFailed.type),
                delay(30000, true), 
            ]);
            if (success) {
                ratePlans = yield select(getRatePlans);
            }
        }
        if (statusSuccess(ratePlans)) {
            var ref;
            const variantGroup = yield select(getVariantGroup);
            const selectedDeliveryFrequency = yield select(getSelectedDeliveryFrequency);
            const filteredRatePlans = ratePlans.result.filter((ratePlan)=>ratePlan.shippingSchedule === selectedDeliveryFrequency
            );
            yield put(selectBillingPeriod$1({
                variantGroup,
                billingPeriod: (ref = [
                    ...filteredRatePlans.sort(sortRateplans)
                ][0]) === null || ref === void 0 ? void 0 : ref.billingPeriod
            }));
            yield race([
                take(selectRatePlanSuccess.type),
                take(selectRatePlanFailed.type),
                delay(30000, true), 
            ]);
        }
    }
}
function* selectDefaultStartDate() {
    const selectedStartDate = yield select(getSelectedStartDate);
    if (!selectedStartDate) {
        const variantGroup = yield select(getVariantGroup);
        const startDate = new Date();
        yield put(selectStartDate$2({
            variantGroup,
            startDate
        }));
        yield race([
            take(selectStartDateSuccess.type),
            take(selectStartDateFailed.type),
            delay(30000, true), 
        ]);
    }
}

const steps = {
    deliveryFrequency,
    solution,
    subscriptionPlan
};
const stepSequence = [
    'deliveryFrequency',
    'subscriptionPlan',
    'solution'
];
const stepsMap = {
    deliveryFrequency: swcHelpers.objectSpread({}, steps.deliveryFrequency, {
        labelKeys: {
            stepIndicatorTitle: 'products.contactLenses.configurator.step.deliveryFrequency',
            title: 'products.contactLenses.subscription.steps.deliveryFrequency.title',
            description: 'products.contactLenses.subscription.steps.deliveryFrequency.description'
        }
    }),
    subscriptionPlan: swcHelpers.objectSpread({}, steps.subscriptionPlan, {
        labelKeys: {
            stepIndicatorTitle: 'products.contactLenses.configurator.step.subscriptionPlan',
            title: 'products.contactLenses.subscription.steps.subscriptionPlan.title',
            description: 'products.contactLenses.subscription.steps.subscriptionPlan.description'
        }
    }),
    solution: swcHelpers.objectSpread({}, steps.solution, {
        labelKeys: {
            stepIndicatorTitle: 'products.contactLenses.configurator.step.solution',
            title: 'products.contactLenses.subscription.steps.solution.title',
            description: 'products.contactLenses.subscription.steps.solution.description'
        }
    })
};

const ClsConfiguratorContext = /*#__PURE__*/ React.createContext({});
const useClsConfiguratorContext = ()=>React.useContext(ClsConfiguratorContext)
;
var ClsConfiguratorProvider = (_param)=>{
    var { children , id  } = _param, startClsConfigurationProps = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "id"
    ]);
    const value = {
        id
    };
    const dispatch = useDispatch();
    React.useEffect(()=>{
        dispatch(startContactLensSubscriptionConfiguration(startClsConfigurationProps));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ React.createElement(ClsConfiguratorContext.Provider, {
        value: value
    }, children);
};

const ExpanderContentItem = ({ imageUrl , includedUnits , lenses , name , packageQuantity , replacementFrequency , solution ,  })=>{
    var ref, ref1;
    const { getLabel , getFormattedLabel  } = useIntl();
    const cylinder = getLabel(`products.contactLenses.prescription.cylinder`);
    const diameter = getLabel(`products.contactLenses.prescription.diameter`);
    const baseCurve = getLabel(`products.contactLenses.prescription.baseCurve`);
    const power = getLabel(`products.contactLenses.prescription.power`);
    const axis = getLabel(`products.contactLenses.prescription.axis`);
    const addition = getLabel(`products.contactLenses.prescription.addition`);
    const leftEye = getLabel(`products.contactLenses.leftEye`);
    const rightEye = getLabel(`products.contactLenses.rightEye`);
    const solutionRatePlan = solution === null || solution === void 0 ? void 0 : solution.ratePlan;
    const solutionRatePlanLabel = (solutionRatePlan === null || solutionRatePlan === void 0 ? void 0 : solutionRatePlan.shippingSchedule) && (solutionRatePlan === null || solutionRatePlan === void 0 ? void 0 : solutionRatePlan.includedUnits) ? getFormattedLabel(`products.contactLenses.configurator.footer.solutionRatePlan.${solutionRatePlan === null || solutionRatePlan === void 0 ? void 0 : solutionRatePlan.shippingSchedule}`, {
        labelData: {
            includedUnits: solutionRatePlan.includedUnits
        }
    }) : null;
    const quantityDescription = packageQuantity && includedUnits && getFormattedLabel(`products.contactLenses.subscription.steps.deliveryFrequency.description.${getNounLabel(includedUnits)}Packs.${getNounLabel(packageQuantity)}Lenses`, {
        labelData: {
            numberOfPacks: includedUnits,
            numberOfLenses: packageQuantity
        }
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: "cls-configurator-footer-expander-content__products"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "cls-configurator-footer-expander-content__product"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "cls-configurator-footer-expander-content__product-image"
    }, imageUrl ? /*#__PURE__*/ React.createElement("img", {
        src: imageUrl,
        alt: name
    }) : null, /*#__PURE__*/ React.createElement("div", {
        className: "cls-configurator-footer-expander-content__product-image__overlay"
    }, lenses && lenses.map((lens)=>lens.eyeSide ? /*#__PURE__*/ React.createElement(EyeSideIndicator, {
            key: `${lens.sku}-${lens.eyeSide}`,
            className: "cls-configurator-footer-expander-content__product-image__overlay-button",
            side: lens.eyeSide
        }) : null
    ))), /*#__PURE__*/ React.createElement("div", {
        className: "cls-configurator-footer-expander-content__product-info"
    }, name && /*#__PURE__*/ React.createElement(Heading, {
        className: "cls-configurator-footer-expander-content__product-info-head",
        color: "primary",
        variant: "subheading1"
    }, name), /*#__PURE__*/ React.createElement(Text, {
        className: "cls-configurator-footer-expander-content__product-info-body"
    }, replacementFrequency), /*#__PURE__*/ React.createElement(Text, {
        className: "cls-configurator-footer-expander-content__product-info-body"
    }, quantityDescription), lenses && lenses.map((lens)=>{
         return React.createElement("div", {
            key: lens.eyeSide,
            className: "cls-configurator-footer-expander-content__product-info-details"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "cls-configurator-footer-expander-content__product-info-details__title"
        }, /*#__PURE__*/ React.createElement(Text, {
            variant: "body-head"
        }, lens.eyeSide === 'left' ? `${leftEye}` : `${rightEye}`)), /*#__PURE__*/ React.createElement("span", {
            className: "cls-configurator-footer-expander-content__product-info-attributes"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "cls-configurator-footer-expander-content__product-info-attributes__detail"
        }, `${diameter}: ${lens === null || lens === void 0 ? void 0 : lens.attributes.diameter} `), /*#__PURE__*/ React.createElement("span", {
            className: "cls-configurator-footer-expander-content__product-info-attributes__detail"
        }, `${baseCurve}:
              ${lens === null || lens === void 0 ? void 0 : lens.attributes.baseCurve} `), /*#__PURE__*/ React.createElement("span", {
            className: "cls-configurator-footer-expander-content__product-info-attributes__detail"
        }, `${power}: ${lens === null || lens === void 0 ? void 0 : lens.attributes.power} `), (lens === null || lens === void 0 ? void 0 : lens.attributes.cylinder) && /*#__PURE__*/ React.createElement("span", {
            className: "cls-configurator-footer-expander-content__product-info-attributes__detail"
        }, `${cylinder}: ${lens === null || lens === void 0 ? void 0 : lens.attributes.cylinder} `), (lens === null || lens === void 0 ? void 0 : lens.attributes.axis) && /*#__PURE__*/ React.createElement("span", {
            className: "cls-configurator-footer-expander-content__product-info-attributes__detail"
        }, `${axis}: ${lens === null || lens === void 0 ? void 0 : lens.attributes.axis} `), (lens === null || lens === void 0 ? void 0 : lens.attributes.addition) && /*#__PURE__*/ React.createElement("span", {
            className: "cls-configurator-footer-expander-content__product-info-attributes__detail"
        }, `${addition}: ${lens === null || lens === void 0 ? void 0 : lens.attributes.addition} `)));
    }))), solution && (solution === null || solution === void 0 ? void 0 : solution.sku) !== NO_SOLUTION_SKU ? /*#__PURE__*/ React.createElement("div", {
        className: "cls-configurator-footer-expander-content__product"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "cls-configurator-footer-expander-content__product-image"
    }, ((ref = solution.image) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ React.createElement("img", {
        src: `${(ref1 = solution.image) === null || ref1 === void 0 ? void 0 : ref1.url}?w=100&fm=jpeg&auto=format`,
        alt: solution.title
    })), /*#__PURE__*/ React.createElement("div", {
        className: "cls-configurator-footer-expander-content__product-info"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "cls-configurator-footer-expander-content__product-info-head",
        color: "primary",
        variant: "subheading1"
    }, solution.title), /*#__PURE__*/ React.createElement(Text, {
        className: "cls-configurator-footer-expander-content__product-info-body"
    }, solutionRatePlanLabel), /*#__PURE__*/ React.createElement(Text, {
        className: "cls-configurator-footer-expander-content__product-info-body"
    }, solution.description))) : null);
};

const ADDED_DAYS = 7;
const useFooter = ()=>{
    const { locale , getLabel  } = useIntl();
    const { configurator  } = selectors;
    const { staticsUrl  } = useProductDetailContext();
    const { isBynderImagesEnabled  } = useFeatureToggles();
    const { id  } = useClsConfiguratorContext();
    const billingPeriod = useSelector(configurator.getSelectedBillingPeriod);
    const eyeSides = useSelector(configurator.getEyeSides);
    const currentStep = useSelector((s)=>Selectors.getCurrentStep(s, {
            id
        })
    );
    const startDate = useSelector(configurator.getSelectedStartDate);
    const lensVariants = useSelector(configurator.getLensVariants);
    const product = useSelector(configurator.getProduct);
    const ratePlans = useSelector(configurator.getSelectedRatePlan);
    const selectedDeliveryFrequency = useSelector(configurator.getSelectedDeliveryFrequency);
    const totalPrice = useSelector((s)=>configurator.getConfigurationTotalPrice(s, {
            id
        })
    );
    const solution = useSelector(configurator.getSelectedSolution);
    const total = getLabel(`products.contactLenseBundles.price.total`);
    const deliveryFrequencyLabel = getLabel(`cart.delivery`);
    const deliveryEstimate = getLabel(`products.contactLenses.subscription.steps.deliveryEstimate`);
    const subscriptionPlan = getLabel(`products.contactLenses.configurator.step.subscriptionPlan`);
    const startDateLabel = getLabel(`products.contactLenses.subscription.steps.startDate`);
    const everyMonth = getLabel('products.contactLenses.subscription.steps.deliveryFrequency.monthly.title').toLowerCase();
    const everyQuarter = getLabel('products.contactLenses.subscription.steps.deliveryFrequency.quarterly.title').toLowerCase();
    const deliveryDate = startDate && DateUtils.shiftDate(new Date(startDate), 'day', ADDED_DAYS);
    const name = product && getLocalizedValue(product.name, locale);
    const sku = (product === null || product === void 0 ? void 0 : product.masterVariant.sku) || '';
    const image = product && getProductImageData(product, sku, 100, staticsUrl, isBynderImagesEnabled);
    const replacementFrequency = product && getLocalizedAttrValue(product.masterVariant, 'replacementFrequency', locale);
    const packageQuantity = ratePlans === null || ratePlans === void 0 ? void 0 : ratePlans.packageQuantity;
    const includedUnits = ratePlans === null || ratePlans === void 0 ? void 0 : ratePlans.includedUnits;
    const lenses = Object.values(lensVariants).filter((variant)=>eyeSides.includes(variant.eyeSide)
    );
    return {
        billingPeriod,
        currentStep,
        deliveryDate,
        deliveryEstimate,
        deliveryFrequencyLabel,
        everyMonth,
        everyQuarter,
        image,
        includedUnits,
        lenses,
        locale,
        name,
        packageQuantity,
        replacementFrequency,
        selectedDeliveryFrequency,
        startDate,
        startDateLabel,
        subscriptionPlan,
        total,
        totalPrice,
        solution
    };
};

const FREQUENCY_STEP = 'deliveryFrequency';
const BILLING_MONTHLY = 'monthly';
const ExpanderContent = ()=>{
    const { billingPeriod , currentStep , deliveryDate , deliveryEstimate , deliveryFrequencyLabel , everyMonth , everyQuarter , image , includedUnits , lenses , locale , name , packageQuantity , replacementFrequency , solution , selectedDeliveryFrequency , startDate , startDateLabel , subscriptionPlan , total , totalPrice ,  } = useFooter();
    if (!totalPrice) {
        return null;
    }
    if (!includedUnits || !packageQuantity) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "cls-configurator-footer-expander-content__loader"
        }, /*#__PURE__*/ React.createElement(Loader, null));
    }
    return /*#__PURE__*/ React.createElement("section", {
        className: "cls-configurator-footer-expander-content"
    }, /*#__PURE__*/ React.createElement(ExpanderContentItem, {
        imageUrl: image === null || image === void 0 ? void 0 : image.url,
        includedUnits: includedUnits,
        lenses: lenses,
        name: name,
        packageQuantity: packageQuantity,
        replacementFrequency: replacementFrequency,
        solution: solution
    }), /*#__PURE__*/ React.createElement("div", {
        className: "cls-configurator-footer-expander-content__subscription"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "cls-configurator-footer-expander-content__subscription__title"
    }, subscriptionPlan), (currentStep === null || currentStep === void 0 ? void 0 : currentStep.name) !== FREQUENCY_STEP && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Alert, {
        "data-t": "delivery-alert",
        icon: "delivery"
    }, `${deliveryEstimate} `, /*#__PURE__*/ React.createElement(DateTime, {
        locale: locale,
        dateTime: deliveryDate ? deliveryDate : ''
    })), /*#__PURE__*/ React.createElement("div", {
        className: "cls-configurator-footer-expander-content__subscription-info"
    }, /*#__PURE__*/ React.createElement("span", null, `${startDateLabel}: `), /*#__PURE__*/ React.createElement(DateTime, {
        locale: locale,
        dateTime: startDate ? startDate : ''
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "cls-configurator-footer-expander-content__subscription-info"
    }, /*#__PURE__*/ React.createElement("span", null, `${deliveryFrequencyLabel}: `), /*#__PURE__*/ React.createElement("span", {
        className: "cls-configurator-footer-expander-content__subscription-info__delivery"
    }, selectedDeliveryFrequency)), (currentStep === null || currentStep === void 0 ? void 0 : currentStep.name) !== FREQUENCY_STEP && /*#__PURE__*/ React.createElement("div", {
        className: "cls-configurator-footer-expander-content__subscription-info"
    }, /*#__PURE__*/ React.createElement("span", null, `${total}: `), /*#__PURE__*/ React.createElement("span", {
        className: "cls-configurator-footer-expander-content__subscription-info__amount"
    }, /*#__PURE__*/ React.createElement(Price, {
        "data-t": "total-price",
        className: "cls-configurator-footer-expander-content__subscription-info__amount-total",
        currency: totalPrice.currency,
        value: totalPrice.originalPrice
    }), billingPeriod === BILLING_MONTHLY ? everyMonth : everyQuarter))));
};

const ConfigurationTotalPriceContainer = ()=>{
    const isPhone = MediaQuery.useIsPhone();
    const { id  } = useClsConfiguratorContext();
    const totalPrice = useSelector((s)=>getConfigurationTotalPrice(s, {
            id
        })
    );
    if (!totalPrice) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ConfigurationTotalPrice, swcHelpers.extends({
        centAmount: true,
        size: isPhone ? 'small' : 'large'
    }, totalPrice));
};

const SubscriptionInformation = ({ title , subtitle , imageUrl , showImage =true , textOrientation ='vertical' ,  })=>/*#__PURE__*/ React.createElement("div", {
        "data-t": "subscription-information",
        className: `subscription-information subscription-information--${textOrientation}`
    }, showImage && imageUrl && /*#__PURE__*/ React.createElement("img", {
        src: imageUrl,
        alt: title,
        className: "subscription-information__image"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "subscription-information__text"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "subheading1",
        className: "subscription-information__title"
    }, title), /*#__PURE__*/ React.createElement("span", {
        className: "frame-information__subtitle"
    }, subtitle)))
;

const SubscriptionInformationContainer = (props)=>{
    const { locale  } = useIntl();
    const { staticsUrl  } = useProductDetailContext();
    const { isBynderImagesEnabled  } = useFeatureToggles();
    const product = useSelector(getProduct);
    if (!product) {
        return null;
    }
    const brand = getLocalizedValue(product.name, locale);
    const replacementFrequency = getLocalizedAttrValue(product.masterVariant, 'replacementFrequency', locale);
    const image = getProductImageData(product, product.masterVariant.sku, 100, staticsUrl, isBynderImagesEnabled);
    return /*#__PURE__*/ React.createElement(SubscriptionInformation, swcHelpers.extends({}, props, {
        title: brand,
        subtitle: replacementFrequency,
        imageUrl: image === null || image === void 0 ? void 0 : image.url
    }));
};

const TopBar = ()=>/*#__PURE__*/ React.createElement("div", {
        className: "cls-configurator-footer-topbar"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "cls-configurator-footer-topbar__aside"
    }, /*#__PURE__*/ React.createElement(SubscriptionInformationContainer, null)), /*#__PURE__*/ React.createElement("div", {
        className: "cls-configurator-footer-topbar__main"
    }, /*#__PURE__*/ React.createElement(ConfigurationTotalPriceContainer, null)))
;

const errorCodePrefix = 'validations';
const errorLabelMap = {
    [`${errorCodePrefix}.maxVariantsPerProductTypeQuantityExceeded`]: `${LABEL_PREFIX}.subscriptionLimitCart`
};
const mapErrorLabels = (errorLabels)=>{
    // only map error labels with validation prefixes
    const validationErrorLabels = errorLabels.filter((code)=>code.includes(errorCodePrefix)
    );
    var _label;
    // cart prefix is used here because error labels from cart do not come back with the cart prefix
    const mappedErrorLabels = validationErrorLabels.map((label)=>(_label = errorLabelMap[label]) !== null && _label !== void 0 ? _label : `cart.${label}`
    );
    return mappedErrorLabels;
};

var ErrorMessage;
(function(ErrorMessage) {
    ErrorMessage["Generic"] = 'Add to cart failed';
    ErrorMessage["InsufficientData"] = 'Insufficient data to create cart';
    ErrorMessage["ValidationError"] = 'Failed to validate cart';
})(ErrorMessage || (ErrorMessage = {}));
const useCreateCartCallback = (configuratorId)=>{
    const dispatch = useDispatch();
    const lineItemDraft = useSelector(getLineItemDraft);
    const [addToCart$1] = Hooks.useAddToCart();
    useSaga(React__default.useMemo(()=>function*() {
            while(true){
                /**
             * Will catch the end result for the cart and signal that to the configurator
             */ const [failure] = yield race([
                    take(addToCartFailed.type),
                    take(addToCartSuccess.type), 
                ]);
                if (failure) {
                    yield put(Actions.finishFailed({
                        id: configuratorId,
                        reason: new Error(failure.error.message)
                    }));
                    continue;
                }
                yield put(Actions.finishSuccess({
                    id: configuratorId
                }));
            }
        }
    , [
        configuratorId
    ]));
    const handleError = React__default.useCallback((errorMessage, errorLabels)=>{
        if (errorLabels === null || errorLabels === void 0 ? void 0 : errorLabels.length) {
            errorLabels.forEach((label)=>toast.failed(label)
            );
        } else {
            toast.failed(`${LABEL_PREFIX}.addToCartFailed`);
        }
        dispatch(addToCartFailed(new Error(errorMessage)));
    }, [
        dispatch
    ]);
    const onSuccess = React__default.useCallback(()=>{
        dispatch(addToCartSuccess());
    }, [
        dispatch
    ]);
    const onValidationError = React__default.useCallback((codes)=>{
        const errorMessage = `${ErrorMessage.ValidationError}: ${codes.join(', ')}`;
        const errorLabels = mapErrorLabels(codes);
        return handleError(errorMessage, errorLabels);
    }, [
        handleError
    ]);
    const onError = React__default.useCallback((code)=>handleError(`${ErrorMessage.Generic}: ${code}`)
    , [
        handleError
    ]);
    return React__default.useCallback((arg)=>{
        var ref;
        arg === null || arg === void 0 ? void 0 : (ref = arg.preventDefault) === null || ref === void 0 ? void 0 : ref.call(arg);
        dispatch(addToCart());
        if (lineItemDraft === null) {
            return handleError(ErrorMessage.InsufficientData);
        }
        addToCart$1([
            lineItemDraft
        ], onSuccess, onValidationError, onError);
    }, [
        dispatch,
        addToCart$1,
        lineItemDraft,
        handleError,
        onSuccess,
        onValidationError,
        onError
    ]);
};

const contentProps = {
    footerTopBarContent: /*#__PURE__*/ React__default.createElement(TopBar, null),
    footerExpanderContent: /*#__PURE__*/ React__default.createElement(ExpanderContent, null)
};
const ClsConfigurator = (_param)=>{
    var { isOpen , onModalClose , triggerButtonRef  } = _param, clsProviderProps = swcHelpers.objectWithoutProperties(_param, [
        "isOpen",
        "onModalClose",
        "triggerButtonRef"
    ]);
    useSaga(React__default.useMemo(()=>{
        return function*() {
            while(true){
                yield take([
                    (a)=>actions.isType(a, Actions.finishSuccess) && a.payload.id === CONFIGURATOR_ID
                    , 
                ]);
                if (onModalClose) {
                    yield call(onModalClose);
                }
                if (triggerButtonRef === null || triggerButtonRef === void 0 ? void 0 : triggerButtonRef.current) {
                    yield call([
                        triggerButtonRef.current,
                        'focus'
                    ]);
                }
            }
        };
    }, [
        onModalClose,
        triggerButtonRef
    ]));
    useSaga(React__default.useMemo(()=>function*() {
            yield listenForConfigurationChanges(CONFIGURATOR_ID);
        }
    , []));
    const finishHandler = useCreateCartCallback(CONFIGURATOR_ID);
    if (!isOpen) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(ClsConfiguratorProvider, swcHelpers.extends({
        id: CONFIGURATOR_ID
    }, clsProviderProps), /*#__PURE__*/ React__default.createElement(Configurator, swcHelpers.extends({
        id: CONFIGURATOR_ID,
        "data-t": "cls-configurator-modal",
        stepSequence: stepSequence,
        stepsMap: stepsMap,
        lastStepCTALabelKey: "products.contactLenses.configurator.footer.addToCart",
        isOpen: isOpen,
        onModalClose: onModalClose,
        onFinish: finishHandler
    }, contentProps)));
};

function createSubscriptionPriceSpecification(activeVariant, pricePerMonth) {
    const currency = pricePerMonth.currencyCode;
    const subscriptionPriceSpecification = {
        '@type': 'CompoundPriceSpecification',
        name: 'Price',
        price: calcPrice(pricePerMonth.centAmount),
        priceCurrency: currency,
        valueAddedTaxIncluded: true
    };
    return subscriptionPriceSpecification;
}
const createViewProductEvent = ({ product , activeSKU , staticsUrl , url , locale , isSubscriptionSelected , pricePerMonth , extra , isBynderImagesEnabled  })=>{
    var ref, ref1;
    const activeVariant = [
        product.masterVariant,
        ...product.variants
    ].find((variant)=>variant.sku === activeSKU
    ) || product.masterVariant;
    const subscriptionProductSku = (ref1 = (ref = activeVariant.attributes) === null || ref === void 0 ? void 0 : ref.find(({ name  })=>name === 'subscriptionProductSKU'
    )) === null || ref1 === void 0 ? void 0 : ref1.value;
    const vat = getNestedProperty(product, 'taxCategory.obj.rates', []).find((rate)=>rate.includedInPrice
    );
    const offers = [
        {
            '@type': 'Offer',
            priceSpecification: isSubscriptionSelected && pricePerMonth ? createSubscriptionPriceSpecification(activeVariant, pricePerMonth) : createPriceSpecification(activeVariant, vat.amount)
        }, 
    ];
    const { name: name1 , image , description , brand , category , sku  } = parseProductData(product, activeVariant, staticsUrl, locale, isBynderImagesEnabled);
    const action = {
        '@context': 'https://schema.org',
        '@type': ActionType.Action,
        name: 'product_detail',
        // The object currently has the same structure as what is sent by the `Product` SD component.
        object: swcHelpers.objectSpread({
            '@type': 'Product',
            '@id': `${url}#product`,
            url,
            sku: isSubscriptionSelected ? subscriptionProductSku : sku,
            skuMaster: product.masterVariant.sku,
            purchaseModel: isSubscriptionSelected ? 'subscription' : 'single purchase',
            image,
            name: name1 && String(name1) || sku
        }, optionalKey('description', description), optionalKey('brand', brand), optionalKey('category', category), optionalKey('offers', offers), extra)
    };
    return action;
};
const viewProductSdEvent = (params)=>{
    const action = createViewProductEvent(params);
    pushSdAction(action);
};

const ConfiguratorButton = ({ calculatedPrice , calculatedDiscountPrice , isPrescriptionEnabled , hasLenses , btnRef , onClick ,  })=>{
    const { getLabel , currency  } = useIntl();
    const caption = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
        component: "span",
        variant: "body"
    }, getLabel('products.actions.openContactLensSubscriptionConfigurator')), isPrescriptionEnabled && hasLenses && /*#__PURE__*/ React.createElement(Text, {
        component: "span",
        variant: "body",
        className: "product-detail__add-to-cart"
    }, /*#__PURE__*/ React.createElement(Price, {
        value: calculatedDiscountPrice || calculatedPrice,
        currency: currency,
        centAmount: true
    }), ' ', getLabel('common.frequency.perMonth')));
    return /*#__PURE__*/ React.createElement(Button, {
        size: "large",
        caption: caption,
        "data-t": "btn-open-cls-configurator",
        onClick: onClick,
        btnRef: btnRef
    });
};

const CTAButton$1 = ({ onPrescriptionClick , handleMiniCartChange , isPrescriptionEnabled , isSubscription , calculatedDiscountPrice , calculatedPrice , lineItemsForCart , excludedFromCheckout , hasLenses , onClick , pricePerMonth , renderAddToCartButton , handleConversionEvent ,  })=>{
    const { getLabel , currency  } = useIntl();
    const { routes  } = useProductDetailContext();
    const storesRoute = routes.stores;
    const addToCartCallback = React.useCallback(()=>{
        handleMiniCartChange && handleMiniCartChange();
        onClick && onClick();
    }, [
        handleMiniCartChange,
        onClick
    ]);
    const isPhone = MediaQuery.useIsPhone();
    const buttonSize = isPhone ? 'small' : 'medium';
    /*
   * If subscription product and configuration is valid, show button with monthly costs that triggers the MiniCart
   * */ if (isSubscription && hasLenses) {
        const caption = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
            component: "span",
            variant: "body"
        }, getLabel('products.actions.addToCart')), pricePerMonth && /*#__PURE__*/ React.createElement(Text, {
            component: "span",
            variant: "body",
            className: "product-detail__add-to-cart"
        }, '(', /*#__PURE__*/ React.createElement(Price, {
            value: pricePerMonth.centAmount,
            currency: currency,
            centAmount: true
        }), ' / ', getLabel('common.frequency.perMonth'), ')'));
        const addToCartProps = {
            'data-t': 'btn-subscription',
            caption,
            onSuccess: addToCartCallback,
            lineItemDrafts: lineItemsForCart.map(({ sku , quantity , custom , customAttributes  })=>({
                    sku,
                    quantity,
                    type: 'contact-lenses-bundle-benelux',
                    typeDetails: swcHelpers.objectSpread({}, custom, customAttributes)
                })
            )
        };
        return renderAddToCartButton ? renderAddToCartButton(addToCartProps) : /*#__PURE__*/ React.createElement(AddToCart, swcHelpers.extends({}, addToCartProps));
    }
    if (isPrescriptionEnabled && hasLenses) {
        const caption = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
            component: "span",
            variant: "body"
        }, getLabel('products.actions.addToCart')), /*#__PURE__*/ React.createElement(Text, {
            component: "span",
            variant: "body",
            className: "product-detail__add-to-cart"
        }, /*#__PURE__*/ React.createElement(Price, {
            value: calculatedDiscountPrice ? calculatedDiscountPrice : calculatedPrice,
            currency: currency,
            centAmount: true
        })));
        const addToCartProps = {
            caption,
            onSuccess: addToCartCallback,
            lineItemDrafts: lineItemsForCart.map(({ sku , quantity , custom , customAttributes  })=>({
                    sku,
                    quantity,
                    type: 'contact-lenses',
                    typeDetails: swcHelpers.objectSpread({}, custom, customAttributes)
                })
            )
        };
        return renderAddToCartButton ? renderAddToCartButton(addToCartProps) : /*#__PURE__*/ React.createElement(AddToCart, swcHelpers.extends({}, addToCartProps));
    }
    if (excludedFromCheckout) {
        return /*#__PURE__*/ React.createElement(Button, {
            size: buttonSize,
            caption: getLabel('products.actions.excludedFromCheckout'),
            "data-t": "btn-excluded-from-checkout",
            href: storesRoute,
            onClick: handleConversionEvent
        });
    }
    if (!isPrescriptionEnabled) {
        return /*#__PURE__*/ React.createElement(Button, {
            size: buttonSize,
            caption: getLabel('products.actions.bookAppointment'),
            href: storesRoute,
            "data-t": "btn-book-appointment",
            onClick: handleConversionEvent
        });
    }
    return /*#__PURE__*/ React.createElement(Button, {
        size: buttonSize,
        className: "add-to-cart",
        caption: getLabel('products.actions.addToCart'),
        "data-t": "btn-enter-prescription",
        onClick: onPrescriptionClick
    });
};

const calculatePrescription = (config, isPrescriptionInfoEnabled, variant, formatProductUrl, slug, isPrescriptionValid)=>{
    if (!config || !Object.keys(config).length || !config.packPrice) {
        return {
            selectedProducts: [],
            packageQuantity: 0,
            totalDiscount: undefined,
            totalPrice: 0,
            totalSubscriptionPrice: 0
        };
    }
    const { leftEyeBoxSKU , leftEyeChecked , leftEyeBoxQuantity , leftEyeBoxAvailableQuantity , rightEyeBoxSKU , rightEyeChecked , rightEyeBoxQuantity , rightEyeBoxAvailableQuantity , hasHardQuantityLimit , subscriptionPrice , packPrice: { value: { centAmount: centAmount  } ,  } , prescriptionInfo ,  } = config;
    const hasDiscount = !!config.packPrice.discounted && !!config.packPrice.discounted.value && !!config.packPrice.discounted.value.centAmount;
    const discountedPackPrice = config.packPrice.discounted;
    const discountedCentAmount = discountedPackPrice && discountedPackPrice.value.centAmount;
    const selectedProducts = [];
    const calculatedPrices = [];
    const calculatedDiscountedPrices = [];
    if (isPrescriptionValid && leftEyeBoxQuantity && (leftEyeBoxAvailableQuantity || !hasHardQuantityLimit) && leftEyeChecked && leftEyeBoxSKU) {
        const totalPriceLeft = leftEyeBoxQuantity * centAmount;
        const leftLensSKU = {
            sku: leftEyeBoxSKU,
            quantity: leftEyeBoxQuantity,
            customAttributes: {
                eyeSide: 'left'
            }
        };
        if (isPrescriptionInfoEnabled && prescriptionInfo) {
            const { prescriptionExpiryDate , prescriptionExamDate , externalOptician , internalOptician ,  } = prescriptionInfo;
            leftLensSKU.customAttributes = swcHelpers.objectSpread({}, leftLensSKU.customAttributes, {
                prescriptionExpiryDate,
                prescriptionExamDate,
                externalOptician,
                internalOptician
            });
        }
        selectedProducts.push(leftLensSKU);
        calculatedPrices.push(totalPriceLeft);
        if (hasDiscount) {
            const totalDiscountLeft = totalPriceLeft - discountedCentAmount * leftEyeBoxQuantity;
            calculatedDiscountedPrices.push(totalDiscountLeft);
        }
    }
    if (isPrescriptionValid && rightEyeBoxQuantity && (rightEyeBoxAvailableQuantity || !hasHardQuantityLimit) && rightEyeChecked && rightEyeBoxSKU) {
        const totalPriceRight = rightEyeBoxQuantity * centAmount;
        const rightLensSKU = {
            sku: rightEyeBoxSKU,
            quantity: rightEyeBoxQuantity,
            customAttributes: {
                eyeSide: 'right'
            }
        };
        if (isPrescriptionInfoEnabled && prescriptionInfo) {
            const { prescriptionExpiryDate , prescriptionExamDate , externalOptician , internalOptician ,  } = prescriptionInfo;
            rightLensSKU.customAttributes = swcHelpers.objectSpread({}, rightLensSKU.customAttributes, {
                prescriptionExpiryDate,
                prescriptionExamDate,
                externalOptician,
                internalOptician
            });
        }
        selectedProducts.push(rightLensSKU);
        calculatedPrices.push(totalPriceRight);
        if (hasDiscount) {
            const totalDiscountRight = totalPriceRight - discountedCentAmount * rightEyeBoxQuantity;
            calculatedDiscountedPrices.push(totalDiscountRight);
        }
    }
    const calculatedPrice = calculatedPrices.reduce((a, b)=>a + b
    , 0);
    const totalDiscount = calculatedDiscountedPrices.reduce((a, b)=>a + b
    , 0);
    const calculatedDiscountPrice = totalDiscount && calculatedPrice - totalDiscount;
    // selectedProducts is eye side lenses i.e. max is two.
    // Hence multiplying the subscripton price for one eye.
    const totalSubscriptionPrice = (subscriptionPrice !== null && subscriptionPrice !== void 0 ? subscriptionPrice : 0) * selectedProducts.length;
    const packageQuantity = config && config.packSize || variant.packageQuantity;
    const lineItemsForCart = selectedProducts.map((product)=>{
        const productType = 'Contact-lenses';
        const newProduct = swcHelpers.objectSpread({}, product);
        if (product.customAttributes && product.customAttributes.eyeSide) {
            const variantUrl = formatProductUrl({
                productType,
                sku: product.sku,
                slug
            });
            newProduct.productUrl = `${variantUrl}#product`;
        }
        return newProduct;
    });
    return {
        selectedProducts: lineItemsForCart,
        totalPrice: calculatedPrice,
        totalSubscriptionPrice,
        totalDiscount: calculatedDiscountPrice,
        packageQuantity
    };
};

/**
 * Returns the product and lens features from a given variant
 */ const getContactLensFeatures = (variant, getLabel)=>{
    const productFeatures = [
        {
            labelKey: 'products.contactLenses.materialType',
            attribute: 'materialType',
            isLocalised: true
        },
        {
            labelKey: 'products.contactLenses.lensType',
            attribute: 'lensType',
            isLocalised: true
        },
        {
            labelKey: 'products.contactLenses.material',
            attribute: 'material',
            isLocalised: true
        },
        {
            labelKey: 'products.contactLenses.waterContent',
            attribute: 'waterContent',
            isLocalised: true
        },
        {
            labelKey: 'products.contactLenses.features.uv',
            attribute: 'features.uv',
            isLocalised: true
        }, 
    ];
    const hydration = {
        label: getLabel('products.contactLenses.features.hydration'),
        variantHasAttribute: (()=>!!variant.features.hydration
        )()
    };
    const softness = {
        label: getLabel('products.contactLenses.features.softness'),
        variantHasAttribute: (()=>!!variant.features.softness
        )()
    };
    const breathability = {
        label: getLabel('products.contactLenses.features.breathability'),
        variantHasAttribute: (()=>!!variant.features.breathability
        )()
    };
    const fatigue = {
        label: getLabel('products.contactLenses.features.eyeFatigue'),
        variantHasAttribute: (()=>!!variant.features.fatigue
        )()
    };
    const uv = {
        label: getLabel('products.contactLenses.features.uv'),
        variantHasAttribute: (()=>!!variant.features.uv
        )()
    };
    const basics = {
        label: getLabel('products.contactLenses.features.basics'),
        variantHasAttribute: (()=>!!variant.features.basics
        )()
    };
    const lensFeatures = {
        hydration,
        softness,
        breathability,
        fatigue,
        uv,
        basics
    };
    return {
        productFeatures,
        lensFeatures
    };
};

const getAvailability = (config)=>{
    if (!config.selectedVariants) {
        return {
            selectedVariantsData: [],
            availability: []
        };
    }
    const selectedVariantsData = Object.values(config.selectedVariants);
    const availability = selectedVariantsData.map((variant)=>{
        if (variant && variant.availability && (config.leftEyeChecked && variant.sku === config.leftEyeBoxSKU || config.rightEyeChecked && variant.sku === config.rightEyeBoxSKU)) {
            return variant.availability;
        }
        return undefined;
    });
    return {
        selectedVariantsData,
        availability
    };
};

/**
 * returns the validity for the configurator and the prescription info section
 */ const validateConfigurator = (config, isPrescriptionInfoEnabled)=>{
    var ref;
    const leftEyeValid = config.leftEyeChecked ? !!config.leftEyeBoxSKU : true;
    const rightEyeValid = config.rightEyeChecked ? !!config.rightEyeBoxSKU : true;
    const isConfiguratorValid = leftEyeValid && rightEyeValid;
    const isPrescriptionInfoValid = isPrescriptionInfoEnabled ? (config === null || config === void 0 ? void 0 : (ref = config.prescriptionInfo) === null || ref === void 0 ? void 0 : ref.valid) || false : true;
    return {
        isConfiguratorValid,
        isPrescriptionInfoValid
    };
};

/**
 * Calls the different helper functions in order to retrieve the complete state
 * needed for the Lenses component
 */ const getPrescriptionState = (config, isPrescriptionInfoEnabled, variant, formatProductUrl, slug)=>{
    const { availability , selectedVariantsData  } = getAvailability(config);
    const formErrorState = validateConfigurator(config, isPrescriptionInfoEnabled);
    const { isPrescriptionInfoValid , isConfiguratorValid  } = formErrorState;
    const prescriptionResult = calculatePrescription(config, isPrescriptionInfoEnabled, variant, formatProductUrl, slug, isPrescriptionInfoValid && isConfiguratorValid);
    return {
        availability,
        formErrorState,
        prescriptionResult,
        selectedVariantsData
    };
};

const useLenses = ({ product , isPrescriptionEnabled , isPrescriptionInfoEnabled , variant , formatProductUrl  })=>{
    var ref;
    const packageQuantity = Number(getAttrValue(product.masterVariant, 'packageQuantity'));
    /**
   * Stores the pack price, this updates when a different pack size is selected
   */ const [packPrice, setPackPrice] = React.useState((ref = product.masterVariant.prices) === null || ref === void 0 ? void 0 : ref[0]);
    const [subscriptionPrice, setSubscriptionPrice] = React.useState();
    /**
   * Stores the pack price, usage frequency and subscription pack size when a
   * different pack size is selected. These values are passed into the contact
   * lens configurator.
   */ const [subscriptionConfiguratorInput, setSubscriptionConfiguratorInput, ] = React.useState({
        eyeSides: []
    });
    /**
   * Selected prescription state which keeps track of the selected lenses
   * and the corresponding prices
   */ const [lensesState, setLensesState] = React.useState({
        packageQuantity,
        selectedProducts: [],
        totalPrice: 0,
        totalSubscriptionPrice: 0,
        totalDiscount: undefined
    });
    /**
   * Keeps track of the availability and the selected lenses,
   * these are used in the DeliveryIndicator
   */ const [availability1, setAvailability] = React.useState([]);
    const [selectedLensVariants, setSelectedLensVariants] = React.useState([]);
    /**
   * Keeps track of the error states for the configurator and prescriptionInfo,
   * the error count is used for re-rendering the error Alert components
   */ const [formValidations, setFormValidations] = React.useState({
        errorCount: 0,
        showError: false,
        isConfiguratorValid: false,
        isPrescriptionInfoValid: !isPrescriptionEnabled
    });
    /**
   * Keeps track of the when to show the MiniCart
   */ const [showMiniCart1, setShowMiniCart] = React.useState(false);
    /**
   * Click handler assigned to the enter prescription button
   * Clicking this button always means the user has not filled in
   * the requested forms completely.
   */ const handlePrescriptionClick = React.useCallback(()=>{
        setFormValidations(swcHelpers.objectSpread({}, formValidations, {
            showError: true,
            errorCount: formValidations.errorCount + 1
        }));
    }, [
        formValidations
    ]);
    /**
   * Contact lens configurator callback
   * This will derive the different states based on the form
   */ const handleFormChange = React.useCallback((config)=>{
        const { prescriptionResult , availability , formErrorState , selectedVariantsData ,  } = getPrescriptionState(config, !!isPrescriptionInfoEnabled, variant, formatProductUrl, product.slug);
        const eyeSides = [
            {
                side: 'left',
                checked: config.leftEyeChecked
            },
            {
                side: 'right',
                checked: config.rightEyeChecked
            }, 
        ].filter((eyeSide)=>eyeSide.checked
        ).map((eyeSide)=>eyeSide.side
        );
        setPackPrice(config.packPrice);
        setSubscriptionPrice(config.subscriptionPrice);
        setLensesState(prescriptionResult);
        setAvailability(availability);
        setSelectedLensVariants(selectedVariantsData);
        setFormValidations(swcHelpers.objectSpread({}, formValidations, formErrorState, {
            showError: false
        }));
        setSubscriptionConfiguratorInput({
            packSize: config.subscriptionPackSize,
            usageFrequency: config.dailiesUsageLevel,
            eyeSides
        });
    }, [
        formValidations,
        formatProductUrl,
        isPrescriptionInfoEnabled,
        product,
        variant
    ]);
    /**
   * MiniCart change handler, will fire when user proceeds to purchase lenses
   */ const handleMiniCartChange = React.useCallback(()=>{
        setShowMiniCart((showMiniCart)=>{
            return !showMiniCart;
        });
    }, []);
    const priceTotals = React.useMemo(()=>({
            calculatedPrice: lensesState.totalPrice,
            calculatedDiscountPrice: lensesState.totalDiscount,
            selectedProducts: lensesState.selectedProducts,
            subscriptionCalculatedPrice: lensesState.totalSubscriptionPrice
        })
    , [
        lensesState
    ]);
    const state = React.useMemo(()=>({
            availability: availability1,
            hasLenses: !!lensesState.selectedProducts.length,
            formValidations,
            packPrice,
            subscriptionPrice,
            subscriptionConfiguratorInput,
            priceTotals,
            selectedLensVariants,
            showMiniCart: showMiniCart1
        })
    , [
        availability1,
        lensesState,
        formValidations,
        packPrice,
        subscriptionPrice,
        subscriptionConfiguratorInput,
        priceTotals,
        selectedLensVariants,
        showMiniCart1, 
    ]);
    const handles = React.useMemo(()=>({
            handleFormChange,
            handleMiniCartChange,
            handlePrescriptionClick
        })
    , []);
    return React.useMemo(()=>[
            state,
            handles
        ]
    , [
        handles,
        state
    ]);
};

const ContactLensesConfigEvent = 'ContactLensesConfigEvent';
const pushSelectBoxQuantity = (totalPrice, frequency, quantity)=>{
    DataLayer.pushEvent({
        event: ContactLensesConfigEvent,
        eventAction: 'select box quantity',
        eventLabel: undefined,
        RxContactLenses: {
            productConfig: {
                price: `${totalPrice.centAmount / 100}`,
                box: {
                    frequency,
                    quantity
                }
            }
        }
    });
};
const pushSubscriptionBoxSizeChange = (ratePlan)=>{
    pushSelectBoxQuantity(ratePlan.totalPrice, ratePlan.usageLevel || '', `${ratePlan.packageQuantity}`);
};
const pushPrescriptionChange = (attribute, value, side)=>{
    DataLayer.pushEvent({
        event: ContactLensesConfigEvent,
        eventAction: 'select rx attribute',
        eventLabel: `${attribute} ${side}`,
        RxContactLenses: {
            productConfig: {
                lens: {
                    [side === 'left' ? 'OS' : 'OD']: {
                        [attribute]: value
                    }
                }
            }
        }
    });
};

var GridNavigationDirection;
(function(GridNavigationDirection) {
    GridNavigationDirection["UP"] = 'up';
    GridNavigationDirection["DOWN"] = 'down';
    GridNavigationDirection["LEFT"] = 'left';
    GridNavigationDirection["RIGHT"] = 'right';
})(GridNavigationDirection || (GridNavigationDirection = {}));
function useGridNavigation(isActive, grid, targetElement, close) {
    React.useEffect(()=>{
        function handleKeyDownEvent(event) {
            switch(event.key){
                case 'Down':
                case 'ArrowDown':
                    event.preventDefault();
                    dispatch({
                        type: GridNavigationDirection.DOWN
                    });
                    break;
                case 'Up':
                case 'ArrowUp':
                    event.preventDefault();
                    dispatch({
                        type: GridNavigationDirection.UP
                    });
                    break;
                case 'Left':
                case 'ArrowLeft':
                    event.preventDefault();
                    dispatch({
                        type: GridNavigationDirection.LEFT
                    });
                    break;
                case 'Right':
                case 'ArrowRight':
                    event.preventDefault();
                    dispatch({
                        type: GridNavigationDirection.RIGHT
                    });
                    break;
                case 'Esc':
                case 'Escape':
                    close();
                    break;
            }
        }
        const target = targetElement.current;
        if (isActive && target) {
            target.addEventListener('keydown', handleKeyDownEvent, false);
            return ()=>target.removeEventListener('keydown', handleKeyDownEvent, false)
            ;
        }
    }, [
        isActive,
        targetElement.current
    ]);
    const [state, dispatch] = React.useReducer(navigationReducer, {
        colIndex: 0,
        rowIndex: 0,
        grid
    });
    function setState(rowIndex, colIndex) {
        dispatch({
            type: 'SET',
            payload: {
                rowIndex,
                colIndex
            }
        });
    }
    return [
        {
            colIndex: state.colIndex,
            rowIndex: state.rowIndex
        },
        setState
    ];
}function navigationReducer(state, action) {
    switch(action.type){
        case GridNavigationDirection.UP:
            {
                const rowIndex = state.rowIndex - 1;
                if (rowIndex < 0) {
                    return state;
                }
                return swcHelpers.objectSpread({}, state, {
                    rowIndex
                });
            }
        case GridNavigationDirection.DOWN:
            {
                const rowIndex = state.rowIndex + 1;
                if (rowIndex >= state.grid[state.colIndex]) {
                    return state;
                }
                return swcHelpers.objectSpread({}, state, {
                    rowIndex
                });
            }
        case GridNavigationDirection.LEFT:
            {
                const colIndex = state.colIndex - 1;
                if (colIndex < 0) {
                    return state;
                }
                const newState = swcHelpers.objectSpread({}, state, {
                    colIndex
                });
                if (state.rowIndex >= state.grid[colIndex]) {
                    newState.rowIndex = state.grid[colIndex] - 1;
                }
                return newState;
            }
        case GridNavigationDirection.RIGHT:
            {
                const colIndex = state.colIndex + 1;
                if (colIndex >= state.grid.length) {
                    return state;
                }
                const newState = swcHelpers.objectSpread({}, state, {
                    colIndex
                });
                if (state.rowIndex >= state.grid[colIndex]) {
                    newState.rowIndex = state.grid[colIndex] - 1;
                }
                return newState;
            }
        case 'SET':
            {
                const { colIndex , rowIndex  } = action.payload;
                if (colIndex >= state.grid.length || rowIndex >= state.grid[colIndex]) {
                    return state;
                }
                return swcHelpers.objectSpread({}, state, action.payload);
            }
        default:
            {
                throw new Error();
            }
    }
}

const PrescriptionDropdown = ({ allOptions , onChange , disabled , leftColumnOptions , name , placeholder , rightColumnOptions , className  })=>{
    const isDisabled = disabled || allOptions.length <= 1;
    const grid = [];
    if (leftColumnOptions.length > 0) {
        grid.push(leftColumnOptions.length);
    }
    if (rightColumnOptions.length > 0) {
        grid.push(rightColumnOptions.length);
    }
    const rowCount = grid.reduce((prev, curr)=>prev > curr ? prev : curr
    , 0);
    const dropdownRef = React.useRef(null);
    const gridRef = React.useRef(null);
    const [value1, setValue] = React.useState(placeholder || '');
    const [isOpen, setIsOpen] = React.useState(false);
    const [{ rowIndex: rowIndex1 , colIndex: colIndex1  }, setGridFocus] = useGridNavigation(isOpen, grid, dropdownRef, ()=>setIsOpen(false)
    );
    useOnClickOutside(dropdownRef, ()=>setIsOpen(false)
    );
    /**
   * Effect that adds focus to a selected element,
   * Focus is changed after navigating with the keyboard controls,
   * on mouse hover or whenever the drodpown is opened
   */ React.useEffect(()=>{
        const elementRef = gridRef && gridRef.current;
        const selectedRow = elementRef && elementRef.querySelector(`.prescription-dropdown__grid-row-${rowIndex1}`);
        const cellIndex = grid.length === 1 ? leftColumnOptions.length > 0 ? 0 : 1 : colIndex1;
        const selectedChild = selectedRow && selectedRow.childNodes[cellIndex];
        if (selectedRow && selectedChild) {
            selectedChild.focus();
        }
    }, [
        rowIndex1,
        colIndex1,
        isOpen,
        grid,
        leftColumnOptions
    ]);
    /**
   * When only one option is given,
   * pre-select it
   */ React.useEffect(()=>{
        if (allOptions.length === 1) {
            selectOption(allOptions[0], 0, 0);
        }
    }, [
        allOptions.length
    ]);
    const dropdownClass = classnames('prescription-dropdown', className, {
        'prescription-dropdown--disabled': isDisabled
    });
    const columnHeaderClass = classnames('prescription-dropdown__grid-cell', 'prescription-dropdown__grid-header', 'prescription-dropdown__grid-cell--disabled');
    const buttonWithDropdownClass = classnames('prescription-dropdown__button', {
        'prescription-dropdown__button--disabled': isDisabled
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: dropdownClass,
        ref: dropdownRef
    }, /*#__PURE__*/ React.createElement(ButtonWithDropdown, {
        isActive: isOpen,
        label: renderLabel(value1 || placeholder),
        isFullWidth: true,
        title: name,
        onClick: ()=>!isDisabled && setIsOpen(!isOpen)
        ,
        className: buttonWithDropdownClass
    }, /*#__PURE__*/ React.createElement("div", {
        className: "prescription-dropdown__container"
    }, /*#__PURE__*/ React.createElement("div", {
        role: "grid",
        className: "prescription-dropdown__grid",
        "aria-label": name,
        ref: gridRef
    }, /*#__PURE__*/ React.createElement("div", {
        className: "prescription-dropdown__grid-row",
        role: "row"
    }, leftColumnOptions.length > 0 && /*#__PURE__*/ React.createElement("div", {
        "aria-label": "-",
        role: "columnheader",
        className: columnHeaderClass
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "minus",
        className: "prescription-dropdown__icon"
    })), rightColumnOptions.length > 0 && /*#__PURE__*/ React.createElement("div", {
        "aria-label": "+",
        role: "columnheader",
        className: columnHeaderClass
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "plus",
        className: "prescription-dropdown__icon"
    }))), renderGrid()))));
    function renderGrid() {
        const rows = [];
        for(let i = 0; i < rowCount; i++){
            const left = leftColumnOptions[i];
            const right = rightColumnOptions[i];
            const row = /*#__PURE__*/ React.createElement("div", {
                className: `prescription-dropdown__grid-row prescription-dropdown__grid-row-${i}`,
                role: "row",
                key: i
            }, left ? renderCell(left, i, 0) : renderEmptyCell(), right ? renderCell(right, i, 1) : renderEmptyCell());
            rows.push(row);
        }
        return rows;
    }
    function renderEmptyCell() {
        const emptyCellClass = classnames('prescription-dropdown__grid-cell', 'prescription-dropdown__grid-cell--disabled');
        return /*#__PURE__*/ React.createElement("div", {
            role: "gridcell",
            className: emptyCellClass
        });
    }
    function renderCell(option, rowIndex = 0, colIndex = 0) {
        const gridCellClass = classnames('prescription-dropdown__grid-cell', {
            'prescription-dropdown__grid-cell--single-column': grid.length === 1
        });
        return /*#__PURE__*/ React.createElement("button", {
            role: "gridcell",
            className: gridCellClass,
            onClick: ()=>selectOption(option, rowIndex, colIndex)
            ,
            onMouseEnter: ()=>setGridFocus(rowIndex, colIndex)
        }, option.value);
    }
    function selectOption(option, rowIndex, colIndex) {
        setValue(option.value);
        setGridFocus(rowIndex, colIndex);
        setIsOpen(false);
        const validatedSelection = swcHelpers.objectSpread({}, option, {
            isValid: option.value !== ''
        });
        onChange && onChange(validatedSelection);
    }
    function renderLabel(value) {
        if (!value) {
            return null;
        }
        const valueClass = classnames('prescription-dropdown__value', {
            'prescription-dropdown__value--invalid': !value || value === placeholder,
            'prescription-dropdown__value--disabled': allOptions.length <= 1
        });
        return /*#__PURE__*/ React.createElement("span", {
            className: "prescription-dropdown__button-label"
        }, /*#__PURE__*/ React.createElement("span", {
            className: valueClass,
            "data-t": "prescription-dropdown-value"
        }, value));
    }
};

const SelectQuantity = ({ id , isDisabled , maximumQuantity , onChange , packSize: packSize1 , quantity , showLabel  })=>{
    const { getLabel  } = useIntl();
    // helper to create the label options for the select box
    const createSelectOption = (boxAmount, packSize)=>{
        const label = `${packSize * boxAmount} ${getLabel('products.unit.contactLenses', {
            defaultValue: 'lenses'
        })}`;
        return `${boxAmount} (${label})`;
    };
    // create an array of length by maxmimumQuantity, fill it with options based on the index count
    const options1 = React__default.useMemo(()=>{
        return Array(maximumQuantity).fill(0).reduce((options, _, index)=>{
            const boxAmount = index + 1;
            const name = createSelectOption(boxAmount, packSize1);
            options[name] = boxAmount;
            return options;
        }, {});
    }, [
        maximumQuantity,
        packSize1
    ]);
    // prefill the selectbox if we have a quantity higher than 0.
    const optionKeys = Object.keys(options1);
    const initialSelection = quantity !== 0 ? {
        value: optionKeys[quantity - 1]
    } : {
        value: optionKeys[0]
    };
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "select-quantity"
    }, showLabel && /*#__PURE__*/ React__default.createElement("label", {
        className: "select-quantity__label",
        htmlFor: id
    }, getLabel('products.contactLenses.quantitySelect.label', {
        defaultValue: 'Number of boxes'
    })), /*#__PURE__*/ React__default.createElement(Select, {
        id: id,
        name: "quantity-selector",
        className: "select-quantity__select",
        options: options1,
        initialState: initialSelection,
        disabled: isDisabled,
        onChange: onChange,
        "data-t": "select-quantity"
    }));
};

const MAX_QUANTITY_LIMIT = 99;
class Prescription extends (React.Component) {
    componentDidMount() {
        const { attributes , products  } = this.props;
        const initialFilters = this.getInitialFilters(attributes);
        this.setState({
            activeFilters: initialFilters,
            attributes
        });
        if (products.length === 1) {
            this.getSkuByAttributes(initialFilters);
        }
    }
    componentDidUpdate(prevProps) {
        var ref, ref1;
        if (this.props.isSubscriptionSelected && prevProps.isSubscriptionSelected !== this.props.isSubscriptionSelected) {
            // Reset back to 1 as quantity should not be updated in subscription lenses
            this.props.onQuantityChange(1);
            this.props.onSelection(true);
        }
        if (((ref = this.props.products) === null || ref === void 0 ? void 0 : ref.length) === 1 && (prevProps === null || prevProps === void 0 ? void 0 : (ref1 = prevProps.products) === null || ref1 === void 0 ? void 0 : ref1.length) === 0) {
            let initialFilters = this.state.activeFilters;
            if (!initialFilters || !Object.keys(initialFilters).length) {
                initialFilters = this.getInitialFilters(this.props.attributes);
            }
            this.getSkuByAttributes(initialFilters);
        }
    }
    /**
   * This method checks if there is only one option available.
   * If this is the case, return only this value.
   * This will make sure the select boxes are prefilled with the only available option.
   */ getInitialState(options) {
        if (!options) {
            return undefined;
        }
        if (options instanceof Set && options.size === 1) {
            const value = options.values().next().value;
            return {
                value
            };
        }
        if (Array.isArray(options) && options.length === 1) {
            const value = options[0].value;
            return {
                value
            };
        }
        return {
            value: ''
        };
    }
    renderStockIndicator() {
        const { availableQuantity , isStockEnabled  } = this.props;
        if (!isStockEnabled || !this.state.foundProduct) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(StockIndicator, {
            stockCount: availableQuantity,
            allowBackOrder: this.state.allowBackOrder,
            // Setting channelAvailability to ONLINE since CL's are always orderable
            channelAvailability: 'ONLINE'
        });
    }
    render() {
        const { isActive , availableQuantity , id , currentBreakpoint , intl , quantity , className , isSubscriptionSelected , isAvailableForSubscription ,  } = this.props;
        const { foundProduct , allowBackOrder , attributes  } = this.state;
        const contentLabel = id === 'left' ? 'contactLenses.leftEye' : 'contactLenses.rightEye';
        const isMobile = currentBreakpoint === MediaQuery.BreakpointName.PHONE || currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT;
        const checkboxClass = classnames('prescription__checkbox', {
            'prescription__checkbox--indented': id === 'right' && !isMobile,
            'prescription__checkbox--selectable': !isSubscriptionSelected || isAvailableForSubscription
        });
        const stockIndicatorClass = classnames('prescription__stock-indicator', {
            'prescription__stock-indicator--indented': id === 'right' && !isMobile
        });
        // Render selector elements
        const selectors = [
            attributes.color && this.renderSelectElement('color'),
            attributes.power && this.renderPowerSelector(isMobile),
            attributes.baseCurve && this.renderSelectElement('baseCurve'),
            attributes.diameter && this.renderSelectElement('diameter'),
            attributes.axis && this.renderSelectElement('axis'),
            attributes.addition && this.renderSelectElement('addition'),
            attributes.cylinder && this.renderSelectElement('cylinder'), 
        ].filter(Boolean);
        // Group selectors in blocks of dropdowns an read-only elements for styling
        const groupedSelectors = [];
        let lastItem;
        selectors.forEach((item)=>{
            const lastIndex = groupedSelectors.length - 1;
            if (lastItem && item && lastItem[0] === item[0]) {
                groupedSelectors[lastIndex].push(item[1]);
            } else if (item) {
                groupedSelectors.push([
                    item[1]
                ]);
            }
            lastItem = item;
        });
        return /*#__PURE__*/ React.createElement("div", {
            className: `prescription ${className}`,
            "data-t": this.props['data-t']
        }, (!isSubscriptionSelected || isAvailableForSubscription) && /*#__PURE__*/ React.createElement(CheckboxWithLabel, {
            label: intl.getLabel(`products.${contentLabel}`),
            className: checkboxClass,
            value: id,
            checked: !!isActive,
            onChange: (event)=>{
                this.props.onSelection(event.checked);
            },
            "data-t": "prescription-checkbox"
        }), groupedSelectors.map((group, i)=>{
            return /*#__PURE__*/ React.createElement("div", {
                key: i,
                className: "prescription__selectors"
            }, group);
        }), !isSubscriptionSelected && /*#__PURE__*/ React.createElement(SelectQuantity, {
            maximumQuantity: this.getQuantitySelectorMaximumQuantity(),
            id: `prescription-quantity-selector-${id}`,
            onChange: this.props.onQuantityChange,
            showLabel: id === 'right' || isMobile,
            packSize: this.props.packSize,
            quantity: quantity,
            isDisabled: Boolean(!isActive || foundProduct && !foundProduct.attributes.allowBackOrder && !allowBackOrder && !availableQuantity)
        }), (!isSubscriptionSelected || !isAvailableForSubscription) && /*#__PURE__*/ React.createElement("div", {
            className: stockIndicatorClass
        }, this.renderStockIndicator()));
    }
    constructor(...args){
        super(...args);
        this.state = {
            activeFilters: {},
            attributes: {},
            allowBackOrder: this.props.allowBackOrder
        };
        this.getInitialFilters = (filterAttributes)=>{
            const initialFilters = {};
            for (const attribute of Object.keys(filterAttributes)){
                const currentAttribute = Array.from(filterAttributes[attribute].values);
                if (currentAttribute.length === 1 && attribute !== 'packageQuantity') {
                    initialFilters[attribute] = currentAttribute[0];
                    // TODO fix the missing types in here some other time (been there for 1+ year now)
                    this.props.handleLensBundleChange(this.props.id, attribute, currentAttribute[0]);
                }
            }
            return initialFilters;
        };
        this.handleAttributeChange = (key, value)=>{
            if (value) {
                const newFilter = swcHelpers.objectSpread({}, this.state.activeFilters, {
                    [key]: value
                });
                const attribute = this.state.attributes[key];
                if (!attribute) {
                    return;
                }
                attribute.selected = value;
                this.setState({
                    activeFilters: newFilter,
                    attributes: swcHelpers.objectSpread({}, this.state.attributes, {
                        [key]: attribute
                    })
                }, ()=>{
                    key !== 'packageQuantity' && this.props.handleLensBundleChange(this.props.id, key, value);
                    // Omit packageQuantity just like it is removed from filter.
                    const length = Object.keys(this.state.attributes).length;
                    const attributeLength = this.state.attributes.packageQuantity ? length - 1 : length;
                    if (Object.keys(newFilter).length === attributeLength) {
                        this.getSkuByAttributes(newFilter);
                    }
                });
                pushPrescriptionChange(key, value, this.props.id);
            } else {
                this.setFoundProduct(undefined);
            }
        };
        this.setFoundProduct = (product)=>{
            this.setState({
                foundProduct: product,
                allowBackOrder: product && typeof product.attributes.allowBackOrder === 'boolean' ? product.attributes.allowBackOrder : this.props.allowBackOrder
            });
            this.props.onFoundProduct(product);
        };
        this.getSkuByAttributes = (filters)=>{
            const enrichedFilters = swcHelpers.objectSpread({}, filters, {
                packageQuantity: this.props.packSize
            });
            const foundProduct = this.props.products.find(({ attributes  })=>{
                let valid = true;
                for (const filter of Object.keys(enrichedFilters)){
                    const value = enrichedFilters[filter];
                    valid = filter in attributes && attributes[filter] === value;
                    if (!valid) {
                        break;
                    }
                }
                return valid;
            });
            if (foundProduct) {
                this.setFoundProduct(foundProduct);
            } else {
                toast.failed(`products.contactLenses.prescription.alert.${this.props.id}Eye`);
            }
        };
        this.getSortedArrayFromSet = (set, _locale = undefined)=>{
            return Array.from(set).sort((a, b)=>a.localeCompare(b, _locale, {
                    numeric: true
                })
            ).map((item)=>({
                    label: item.toString(),
                    value: item
                })
            );
        };
        this.getFilterOptions = (options = [])=>{
            const arr = options instanceof Set ? this.getSortedArrayFromSet(options) : options;
            return arr.reduce((prev, curr)=>{
                prev[curr.label] = curr.value;
                return prev;
            }, {});
        };
        this.getQuantitySelectorMaximumQuantity = ()=>{
            const { availableQuantity , maxOrderableQuantity  } = this.props;
            const { allowBackOrder  } = this.state;
            if (!allowBackOrder) {
                if (maxOrderableQuantity && availableQuantity) {
                    return maxOrderableQuantity > availableQuantity ? availableQuantity : maxOrderableQuantity;
                }
                if (availableQuantity !== undefined) {
                    return availableQuantity;
                }
            }
            if (maxOrderableQuantity) {
                return maxOrderableQuantity;
            }
            return MAX_QUANTITY_LIMIT;
        };
        this.formatPowerValues = (values)=>{
            return this.getSortedArrayFromSet(values).map(({ value  })=>({
                    label: value,
                    value
                })
            ).sort((a, b)=>powerToFloat(a) - powerToFloat(b)
            );
        };
        this.renderToolTip = (type)=>{
            const { intl , currentBreakpoint , id  } = this.props;
            /**
     * Decide if we have to show labels or not,
     *  - On mobile we always want to show the labels including the tooltip
     *  - On tablet landscape and up we want the dashed tooltip,
     *    which includes the label, but only for the Prescription for the right eye-side
     */ const isMobile = currentBreakpoint === MediaQuery.BreakpointName.PHONE || currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT;
            const showTooltip = isMobile || id === 'right';
            return /*#__PURE__*/ React.createElement(React.Fragment, null, isMobile && /*#__PURE__*/ React.createElement("span", {
                className: "prescription__input-label"
            }, intl.getLabel(`products.contactLenses.prescription.${type}`)), showTooltip && /*#__PURE__*/ React.createElement(Tooltip, {
                dashed: !isMobile,
                className: "prescription__input-tooltip",
                id: `${type}-${id}`,
                label: intl.getLabel(`products.contactLenses.prescription.${type}`),
                message: intl.getLabel(`products.contactLenses.prescription.${type}.tooltip`)
            }));
        };
        this.sortPowerOptions = (a, b)=>{
            return powerValueToFloat(a) - powerValueToFloat(b);
        };
        this.renderReadOnly = (key, value)=>[
                false,
                /*#__PURE__*/ React.createElement("div", {
                    className: "prescription__readonly-input-wrapper",
                    key: key,
                    "data-t": `prescription-${key}`
                }, this.renderToolTip(key), /*#__PURE__*/ React.createElement("span", {
                    className: "prescription__readonly"
                }, value)), 
            ]
        ;
        this.renderSelectElement = (key)=>{
            var ref;
            const { attributes , id , intl , isActive , hasError  } = this.props;
            const { activeFilters , foundProduct  } = this.state;
            const attibuteValues = (ref = attributes[key]) === null || ref === void 0 ? void 0 : ref.values;
            const filter = activeFilters[key];
            const initialState = filter ? {
                value: filter
            } : this.getInitialState(attibuteValues);
            const onlyOneOptionAvailble = (attibuteValues === null || attibuteValues === void 0 ? void 0 : attibuteValues.size) === 1 && initialState;
            const selectElementClass = classnames('prescription__select', {
                'prescription__select--error': hasError && !foundProduct && isActive
            });
            if (onlyOneOptionAvailble && initialState) {
                return this.renderReadOnly(key, initialState.value);
            }
            return [
                true,
                /*#__PURE__*/ React.createElement("div", {
                    className: "prescription__input-wrapper",
                    key: key
                }, this.renderToolTip(key), /*#__PURE__*/ React.createElement(Select, {
                    id: `${key}-${id}`,
                    className: selectElementClass,
                    name: intl.getLabel(`products.contactLenses.prescription.${key}`),
                    options: this.getFilterOptions(attibuteValues),
                    sortOptionsBy: key === 'power' ? this.sortPowerOptions : undefined,
                    initialState: initialState,
                    placeholder: "---",
                    onChange: (value)=>this.handleAttributeChange(key, value)
                    ,
                    disabled: !isActive,
                    "data-t": `prescription-${key}`
                })), 
            ];
        };
        this.renderPowerSelector = (isMobile)=>{
            const { attributes , intl , isActive , hasError  } = this.props;
            const { activeFilters , foundProduct  } = this.state;
            const allOptions = attributes.power ? this.formatPowerValues(attributes.power.values) : [];
            const positiveOptions = allOptions.filter((power)=>powerToFloat(power) >= 0
            );
            const negativeOptions = allOptions.filter((power)=>powerToFloat(power) <= 0
            );
            negativeOptions.reverse() // 🙈 mutation; reversed for the UI (eg render 0 - -5 instead of -5 - 0)
            ;
            const onlyOneOptionAvailble = allOptions.length <= 1;
            const selectElementClass = classnames('prescription__select', {
                'prescription__select--error': hasError && !foundProduct && isActive
            });
            // value to set within PrescriptionDropdown via placeholder prop when selected
            // needed because of the isMobile render check below
            const initialValue = (activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.power) || '---';
            if (onlyOneOptionAvailble) {
                return this.renderReadOnly('power', initialValue);
            }
            return !isMobile ? [
                true,
                /*#__PURE__*/ React.createElement("div", {
                    key: "power",
                    className: "prescription__input-wrapper prescription__power-dropdown"
                }, this.renderToolTip('power'), /*#__PURE__*/ React.createElement(PrescriptionDropdown, {
                    name: intl.getLabel('products.contactLenses.prescription.power'),
                    className: selectElementClass,
                    allOptions: allOptions,
                    leftColumnOptions: negativeOptions,
                    rightColumnOptions: positiveOptions,
                    placeholder: initialValue,
                    onChange: ({ value  })=>this.handleAttributeChange('power', value)
                    ,
                    disabled: !isActive,
                    "data-t": "prescription-power"
                })), 
            ] : this.renderSelectElement('power');
        };
    }
}
Prescription.defaultProps = {
    allowBackOrder: true,
    isActive: true
};
var Prescription$1 = withIntl(MediaQuery.WithBreakpoints(Prescription));
function powerToFloat(power) {
    return powerValueToFloat(power === null || power === void 0 ? void 0 : power.value);
}
function powerValueToFloat(powerValue) {
    return parseFloat(powerValue.replace(/[^\d.+-]/g, ''));
}

const PrescriptionContainer = (props)=>{
    const { isContactLensStockEnabled  } = useFeatureToggles();
    const { attributes: { actions  } ,  } = useLensBundle();
    // Use void function to scope logic to only lens bundle enabled products
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const handleLensBundleChange = props.hasSubscriptions ? actions.setAttribute : ()=>{};
    // Preliminary sorting of selected packSize
    const products = React__default.useMemo(()=>props.products.filter((product)=>product.attributes.packageQuantity === props.packSize
        )
    , [
        props.products,
        props.packSize
    ]);
    return /*#__PURE__*/ React__default.createElement(Prescription$1, swcHelpers.extends({}, props, {
        isStockEnabled: isContactLensStockEnabled,
        products: products,
        handleLensBundleChange: handleLensBundleChange
    }));
};

var OpticianType;
(function(OpticianType) {
    OpticianType["Internal"] = 'internal';
    OpticianType["External"] = 'external';
})(OpticianType || (OpticianType = {}));
const { PreferredStoreFinder  } = Components;
const Optician = ({ selectedStore , onStoreChange , selectedOpticianType , onOpticianTypeChange , opticianForm: OpticianForm ,  })=>{
    const { getLabel  } = useIntl();
    const radioOptions = React__default.useMemo(()=>[
            {
                value: OpticianType.Internal,
                label: getLabel('products.contactLens.info.optician.internal')
            },
            {
                value: OpticianType.External,
                label: getLabel('products.contactLens.info.optician.external')
            }, 
        ]
    , [
        getLabel
    ]);
    const handleRadiosChange = React__default.useCallback(({ value  })=>{
        onOpticianTypeChange(value);
    }, [
        onOpticianTypeChange
    ]);
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "prescription-info-optician"
    }, /*#__PURE__*/ React__default.createElement("span", {
        className: "prescription-info-optician__label"
    }, getLabel('products.contactLens.info.optician.label'), /*#__PURE__*/ React__default.createElement(Tooltip, {
        message: getLabel('products.contactLens.info.optician.hint'),
        id: "validation-optician-tooltip"
    })), /*#__PURE__*/ React__default.createElement(RadioButtons, {
        formName: "optician-type",
        scope: "opticianType",
        alignment: "vertical",
        onChange: handleRadiosChange,
        initialValue: selectedOpticianType,
        items: radioOptions
    }), selectedOpticianType === OpticianType.Internal && /*#__PURE__*/ React__default.createElement("div", {
        className: "prescription-info-optician__store-finder"
    }, /*#__PURE__*/ React__default.createElement(PreferredStoreFinder, {
        selected: selectedStore,
        onStoreSelect: onStoreChange
    })), selectedOpticianType === OpticianType.External && /*#__PURE__*/ React__default.createElement("div", {
        className: "prescription-info-optician__store-form"
    }, OpticianForm));
};

const createExternalOpticianInfo = (formState)=>{
    const obj = Object.entries(formState).reduce((acc, [key, field])=>swcHelpers.objectSpread({}, acc, {
            [key]: field ? field.value : ''
        })
    , {});
    return JSON.stringify(obj);
};
const isInfoValid = (state, opticianType, isPrescriptionExtraInfoEnabled = true)=>{
    const { prescriptionExpiryDate , externalOptician , internalOptician , consent  } = state;
    // when isPrescriptionExtraInfoEnabled is false, having consent is enough to continue
    if (!isPrescriptionExtraInfoEnabled && consent) {
        return true;
    }
    if (!prescriptionExpiryDate || !consent) {
        return false;
    }
    if (opticianType === OpticianType.Internal && !internalOptician) {
        return false;
    }
    if (opticianType === OpticianType.External && !externalOptician) {
        return false;
    }
    return true;
};
const onlyHistory = ()=>{
    return Util.createMaxDate(new Date(), 0);
};
const getMaxExpiryDate = ()=>{
    const maxYears = 5;
    const date = new Date();
    date.setFullYear(date.getFullYear() + maxYears);
    return date;
};
const PrescriptionInfo = ({ onChange , opticianForm , dateFormat ='MMMM d, yyyy' , isPrescriptionExtraInfoEnabled =true , prescriptionInfoAdditionalContent ,  })=>{
    const { getLabel  } = useIntl();
    const [examDate, setExamDate] = React__default.useState();
    const [expiryDate, setExpiryDate] = React__default.useState();
    const [opticianType, setOpticianType] = React__default.useState(OpticianType.Internal);
    const [selectedStore, setSelectedStore] = React__default.useState();
    const [opticianInfo, setOpticanInfo] = React__default.useState();
    const [consent, setConsent] = React__default.useState(false);
    const handleExamDateChange = React__default.useCallback((date)=>{
        setExamDate(date);
    }, []);
    const handleExpiryDateChange = React__default.useCallback((date)=>{
        setExpiryDate(date);
    }, []);
    const handleOpticianTypeChange = React__default.useCallback((type)=>{
        setOpticianType(type);
    }, []);
    const handleStoreChange = React__default.useCallback((store)=>{
        setSelectedStore(store);
    }, []);
    const handleOpticianFormChange = React__default.useCallback((form)=>{
        if (form.formValid) {
            setOpticanInfo(form.formState);
        }
    }, []);
    const handleConsentChange = React__default.useCallback(({ checked  })=>{
        setConsent(checked);
    }, []);
    const state = React__default.useMemo(()=>swcHelpers.objectSpread({
            prescriptionExamDate: examDate && examDate.toISOString(),
            prescriptionExpiryDate: expiryDate && expiryDate.toISOString()
        }, opticianType === OpticianType.Internal ? {
            internalOptician: selectedStore && selectedStore.code.toString()
        } : {
            externalOptician: opticianInfo && createExternalOpticianInfo(opticianInfo)
        }, {
            consent
        })
    , [
        examDate,
        expiryDate,
        opticianType,
        opticianInfo,
        consent,
        selectedStore
    ]);
    React__default.useEffect(()=>{
        if (onChange) {
            onChange(swcHelpers.objectSpread({}, state, {
                valid: isInfoValid(state, opticianType, isPrescriptionExtraInfoEnabled)
            }));
        }
    }, [
        onChange,
        state,
        opticianType
    ]);
    const OpticianForm = /*#__PURE__*/ React__default.createElement(Form, {
        name: "opticianForm",
        "data-t": "optician-form",
        className: "prescription-info-optician__form",
        initialFormState: opticianInfo,
        onChange: handleOpticianFormChange
    }, opticianForm && opticianForm());
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "prescription-info"
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        className: "prescription-info__heading",
        variant: "smallest"
    }, getLabel('products.contactLenses.info.title')), /*#__PURE__*/ React__default.createElement(RequiredFieldsLabel, null), prescriptionInfoAdditionalContent, isPrescriptionExtraInfoEnabled && /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement("div", {
        className: "prescription-info__dates"
    }, /*#__PURE__*/ React__default.createElement(DatePicker, {
        label: getLabel('products.contactLenses.info.eyeTestDate.label'),
        placeholder: getLabel('common.selectDate'),
        optionalText: getLabel('checkout.form.field.optional'),
        initialValue: examDate,
        onChange: handleExamDateChange,
        required: false,
        maxDate: onlyHistory(),
        dateFormat: dateFormat
    }), /*#__PURE__*/ React__default.createElement(DatePicker, {
        label: getLabel('products.contactLenses.info.expiryDate.label'),
        tooltip: getLabel('products.contactLenses.info.expiryDate.hint'),
        errorMessage: getLabel('products.contactLenses.info.expiryDate.errorMessage'),
        placeholder: getLabel('common.selectDate'),
        initialValue: expiryDate,
        onChange: handleExpiryDateChange,
        maxDate: getMaxExpiryDate(),
        dateFormat: dateFormat
    })), /*#__PURE__*/ React__default.createElement(Optician, {
        opticianForm: OpticianForm,
        selectedStore: selectedStore,
        onStoreChange: handleStoreChange,
        selectedOpticianType: opticianType,
        onOpticianTypeChange: handleOpticianTypeChange
    })), /*#__PURE__*/ React__default.createElement("div", {
        className: "prescription-info__consent"
    }, /*#__PURE__*/ React__default.createElement(CheckboxWithLabel, {
        className: "prescription-info__checkbox",
        id: "prescription-info-consent",
        value: "prescription-info-consent",
        checked: consent,
        onChange: handleConsentChange,
        label: getLabel('products.contactLenses.info.consent'),
        errorMessage: ""
    })));
};

const MonthlyPrice = ({ currency , price , labels  })=>/*#__PURE__*/ React__default.createElement("div", {
        className: "contact-lens-configurator__monthly-price"
    }, /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Price, {
        value: price.centAmount,
        currency: currency,
        className: "contact-lens-configurator__pack-size-price"
    }), ' / ', /*#__PURE__*/ React__default.createElement(Text, {
        variant: "caption",
        component: "span"
    }, labels.perMonth)))
;

const MonthlyPriceContainer = ()=>{
    const { currency , getLabel  } = useIntl();
    const { pricePerMonth  } = useLensBundle();
    const labels = React__default.useMemo(()=>({
            perMonth: getLabel('common.frequency.perMonth')
        })
    , [
        getLabel
    ]);
    if (!pricePerMonth) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(MonthlyPrice, {
        currency: currency,
        labels: labels,
        price: pricePerMonth
    });
};

const ProductDetailUnitInfo = ({ amount , valueUnits , perBox , 'data-t': dataT = 'product-detail-unit-info'  })=>/*#__PURE__*/ React.createElement("span", {
        className: "product-detail-unit-info",
        "data-t": dataT
    }, /*#__PURE__*/ React.createElement("span", {
        className: "product-detail-unit-info__amount"
    }, amount, " ", amount > 1 ? valueUnits.plural : valueUnits.singular), /*#__PURE__*/ React.createElement("span", {
        className: "product-detail-unit-info__unit"
    }, " ", perBox, " "))
;

const QuantityItem = ({ className , label , subtext , aside  })=>/*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement("div", {
        className: `${className}__quantity`
    }, /*#__PURE__*/ React__default.createElement("span", {
        className: `${className}__amount`
    }, label), subtext && /*#__PURE__*/ React__default.createElement("span", {
        className: `${className}__subtext`
    }, subtext)), aside && /*#__PURE__*/ React__default.createElement("span", {
        className: `${className}__aside`
    }, aside))
;

const QuantityContainer = ({ items , selected , itemView , handleClick  })=>{
    const Component = itemView || QuantityItem;
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "quantity-container"
    }, items.map((item)=>/*#__PURE__*/ React__default.createElement("button", {
            key: item.value,
            className: classnames('quantity-container__item', {
                _is_selected: selected.value === item.value
            }),
            onClick: ()=>handleClick(item)
            ,
            "data-t": item.value
        }, /*#__PURE__*/ React__default.createElement(Component, {
            className: "quantity-container",
            label: item.label,
            subtext: item.subtext,
            aside: item.aside
        }))
    ));
};

const PackageQuantityItem = ({ label , subtext , aside , className  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: `${className}__content`
    }, /*#__PURE__*/ React.createElement("div", {
        className: `${className}__quantity`
    }, /*#__PURE__*/ React.createElement("span", {
        className: `${className}__amount`
    }, label), subtext && /*#__PURE__*/ React.createElement("span", {
        className: `${className}__subtext`
    }, subtext)), aside && /*#__PURE__*/ React.createElement("span", {
        className: `${className}__aside`
    }, aside));
};

const getSelectedItem = (items, selectedSize)=>{
    const item = items.find(({ value  })=>value === selectedSize
    );
    return item || items[0] || {
        value: '',
        label: ''
    };
};
const PackageQuantityDropdown = ({ label , title , items , selectedSize , itemView , onChange , 'data-t': dataT = 'package-quantity-dropdown' ,  })=>{
    const [selected, setSelected] = React.useState(()=>getSelectedItem(items, selectedSize)
    );
    const [isOpen1, setIsOpen] = React.useState(false);
    const dropdownRef = React.useRef(null);
    useOnClickOutside(dropdownRef, ()=>setIsOpen(false)
    );
    const buttonLabel = React.useMemo(()=>{
        const Component = itemView || PackageQuantityItem;
        return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({
            className: "package-quantity-dropdown"
        }, selected));
    }, [
        selected,
        itemView
    ]);
    const handleSelect = React.useCallback((option)=>{
        setSelected(option);
        setIsOpen(false);
        onChange(option);
    }, []);
    const handleClick = React.useCallback(()=>{
        setIsOpen((isOpen)=>!isOpen
        );
    }, []);
    React.useEffect(()=>{
        setSelected(getSelectedItem(items, selectedSize));
    }, [
        setSelected,
        items,
        selectedSize
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "package-quantity-dropdown",
        ref: dropdownRef,
        "data-t": dataT
    }, Boolean(label) && /*#__PURE__*/ React.createElement("div", {
        className: "package-quantity-dropdown__label"
    }, label), /*#__PURE__*/ React.createElement(ButtonWithDropdown, {
        title: title,
        label: buttonLabel,
        className: "package-quantity-dropdown__button",
        onClick: handleClick,
        isActive: isOpen1,
        isFullWidth: true
    }, /*#__PURE__*/ React.createElement(QuantityContainer, {
        itemView: itemView,
        items: items,
        handleClick: handleSelect,
        selected: selected
    })));
};

const joinExistingStrings = (strings, separator)=>{
    return strings.filter((value)=>!!value
    ).join(separator || '');
};

const PackageQuantity = ({ 'data-t': dataT = 'package-quantity' , className , packageQuantities , item , dropdown ,  })=>/*#__PURE__*/ React__default.createElement("div", {
        className: classnames([
            'contact-lens-configurator__package-quantity',
            className
        ]),
        "data-t": dataT
    }, packageQuantities.length === 1 ? item : dropdown)
;

var LabelPosition;
(function(LabelPosition) {
    LabelPosition["Left"] = 'left';
    LabelPosition["Right"] = 'right';
})(LabelPosition || (LabelPosition = {}));
const PriceAside = ({ value , currency , discountValue , asideLabel , asideLabelPosition =LabelPosition.Right ,  })=>{
    if (!value) return null;
    const isZeroPercentDiscount = value === discountValue;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, asideLabel && asideLabelPosition === LabelPosition.Left && /*#__PURE__*/ React.createElement("span", {
        className: "contact-lens-configurator__reminder"
    }, asideLabel, " "), /*#__PURE__*/ React.createElement(Price, {
        value: value,
        currency: currency,
        className: classnames('contact-lens-configurator__pack-size-price', {
            'contact-lens-configurator__pack-size-price--original': discountValue && !isZeroPercentDiscount
        })
    }), discountValue && !isZeroPercentDiscount && /*#__PURE__*/ React.createElement(Price, {
        value: discountValue,
        currency: currency,
        className: "contact-lens-configurator__pack-size-price contact-lens-configurator__pack-size-price--discounted"
    }), asideLabel && asideLabelPosition === LabelPosition.Right && /*#__PURE__*/ React.createElement("span", {
        className: "contact-lens-configurator__reminder"
    }, " ", asideLabel));
};

const usePackageQuantity = (packageTypes, mapper)=>{
    const { currency , getLabel , hasLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            lenses: getLabel('products.unit.contactLenses'),
            lens: getLabel('products.unit.contactLens'),
            box: getLabel('products.unit.contactLensBox'),
            boxes: getLabel('products.unit.contactLensBoxes'),
            perEye: hasLabel('products.perEye') ? getLabel('products.perEye') : '',
            perBoxLabel: getLabel('products.perBox'),
            perMonth: getLabel('common.frequency.perMonth')
        })
    , [
        getLabel,
        hasLabel
    ]);
    const packageQuantities = React.useMemo(()=>{
        return packageTypes.map((pack)=>mapper(pack, labels, currency)
        );
    }, [
        packageTypes,
        mapper,
        labels,
        currency
    ]);
    return {
        labels,
        packageQuantities
    };
};

const PackageQuantityContainer$1 = ({ onChange , packageTypes , selectedSize  })=>{
    const { getLabel  } = useIntl();
    const mapper = (pack, labels, currency)=>{
        var ref;
        const price = pack.price;
        const value = pack.packageQuantity.toString();
        return {
            label: `${value} ${labels.lenses}`,
            value,
            subtext: joinExistingStrings([
                labels.perBoxLabel,
                labels.perEye
            ], ', '),
            aside: /*#__PURE__*/ React__default.createElement(PriceAside, {
                value: price.value.centAmount,
                currency: currency,
                discountValue: price === null || price === void 0 ? void 0 : (ref = price.discounted) === null || ref === void 0 ? void 0 : ref.value.centAmount,
                asideLabel: labels.perEye
            })
        };
    };
    const packageQuantityLabel = getLabel('products.contactLenses.boxQuantity');
    const { labels: labels1 , packageQuantities  } = usePackageQuantity(packageTypes, mapper);
    return /*#__PURE__*/ React__default.createElement(PackageQuantity, {
        packageQuantities: packageQuantities,
        item: /*#__PURE__*/ React__default.createElement(ProductDetailUnitInfo, {
            amount: +packageQuantities[0].value,
            valueUnits: {
                singular: labels1.lens,
                plural: labels1.lenses
            },
            perBox: packageQuantities[0].subtext
        }),
        dropdown: /*#__PURE__*/ React__default.createElement(PackageQuantityDropdown, {
            label: packageQuantityLabel,
            title: packageQuantities[0].value,
            items: packageQuantities,
            selectedSize: selectedSize,
            onChange: onChange
        })
    });
};

const PackageQuantityContainer = ({ handlePackSizeChange , selectedSize , packageTypes ,  })=>{
    const { getLabel  } = useIntl();
    const mapper = (pack, labels, currency)=>{
        const price = pack.totalPrice;
        const value = pack.packageQuantity.toString();
        return {
            label: `${value} ${labels.lenses}`,
            value,
            subtext: joinExistingStrings([
                labels.perBoxLabel,
                labels.perEye
            ], ', '),
            aside: /*#__PURE__*/ React.createElement(PriceAside, {
                value: price.centAmount,
                currency: currency,
                asideLabel: joinExistingStrings([
                    labels.perMonth,
                    labels.perEye
                ], ', ')
            })
        };
    };
    const packageQuantityLabel = getLabel('products.contactLenses.boxQuantity');
    const { packageQuantities  } = usePackageQuantity(packageTypes, mapper);
    const handleChange = React.useCallback(({ value  })=>{
        handlePackSizeChange(+value || 0);
    }, [
        handlePackSizeChange
    ]);
    if (packageQuantities.length === 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(PackageQuantity, {
        packageQuantities: packageQuantities,
        item: /*#__PURE__*/ React.createElement(PackageQuantityItem, {
            className: "package-quantity-dropdown",
            label: packageQuantities[0].label,
            subtext: packageQuantities[0].subtext,
            aside: packageQuantities[0].aside
        }),
        dropdown: /*#__PURE__*/ React.createElement(PackageQuantityDropdown, {
            label: packageQuantityLabel,
            title: packageQuantities[0].value,
            items: packageQuantities,
            selectedSize: `${selectedSize}`,
            onChange: handleChange
        })
    });
};

const DailyPackageQuantityItem = ({ label , subtext , aside  })=>/*#__PURE__*/ React__default.createElement("div", {
        "data-t": "daily-package-quantity-item",
        className: "daily-package-quantity-item"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "daily-package-quantity-item__label"
    }, label), /*#__PURE__*/ React__default.createElement("div", null, /*#__PURE__*/ React__default.createElement("div", {
        className: "daily-package-quantity-item__subtext"
    }, subtext), /*#__PURE__*/ React__default.createElement("div", {
        className: "daily-package-quantity-item__aside"
    }, aside)))
;

const DailyPackageQuantityContainer = ({ handlePackSizeChange , selectedSize , packageTypes , noLabel =false , noPrice =false ,  })=>{
    const { getLabel  } = useIntl();
    const mapper = (pack, labels, currency)=>{
        const { totalPrice , usageLevel  } = pack;
        const value = usageLevel || '';
        return {
            value,
            label: getLabel(`products.contactLenses.usageLevel.${value}`),
            subtext: noPrice ? null : /*#__PURE__*/ React.createElement(PriceAside, {
                value: totalPrice.centAmount,
                currency: currency,
                asideLabel: getLabel('common.startingAt'),
                asideLabelPosition: LabelPosition.Left
            }),
            aside: noPrice ? null : joinExistingStrings([
                labels.perMonth,
                labels.perEye
            ], ', ')
        };
    };
    const packageQuantityLabel = getLabel('products.contactLenses.usageLevel.question');
    const { packageQuantities  } = usePackageQuantity(packageTypes, mapper);
    const handleChange = React.useCallback(({ value  })=>{
        handlePackSizeChange(value);
    }, [
        handlePackSizeChange
    ]);
    if (packageQuantities.length === 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(PackageQuantity, {
        className: "contact-lens-configurator__package-quantity--daily",
        packageQuantities: packageQuantities,
        item: /*#__PURE__*/ React.createElement(DailyPackageQuantityItem, {
            className: "package-quantity-dropdown",
            label: packageQuantities[0].label,
            subtext: packageQuantities[0].subtext,
            aside: packageQuantities[0].aside
        }),
        dropdown: /*#__PURE__*/ React.createElement(PackageQuantityDropdown, {
            label: noLabel ? '' : packageQuantityLabel,
            title: packageQuantities[0].value,
            items: packageQuantities,
            itemView: DailyPackageQuantityItem,
            selectedSize: `${selectedSize}`,
            onChange: handleChange
        })
    });
};

const getPriceForPack = (packSize, packageTypes)=>{
    const matchedVariant = packageTypes.find((packageType)=>packageType.packageQuantity === packSize
    );
    // not using multiple prices for now
    return matchedVariant && matchedVariant.price;
};

class ConfigureContactLenses$1 extends React.Component {
    componentDidMount() {
        this.setInitialPackSize(this.props.packageTypes[0], this.props.ratePlans[0]);
    }
    // @TODO remove this when we rewrite this component to functional
    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.isSubscriptionSelected === false && nextProps.isSubscriptionSelected && nextProps.ratePlans.length && this.state.packSize) {
            pushSubscriptionStartEvent(this.props.ratePlans[0].includedUnits, this.state.packSize, this.props.ratePlans[0].totalPrice.centAmount, this.state.selectedVariants, this.state.dailiesUsageLevel);
        }
    }
    showErrorAlert() {
        const { intl , formValidations  } = this.props;
        return /*#__PURE__*/ React.createElement(ScrollIntoView, {
            key: formValidations.errorCount
        }, /*#__PURE__*/ React.createElement(Alert, {
            type: "error",
            icon: "alert-circle"
        }, intl.getFormattedLabel('products.contactLenses.prescription.text', {
            parseLink: true
        })));
    }
    render() {
        const { attributes , prescriptionModalContent , intl , maxOrderableQuantity , allowBackOrder , isPrescriptionInfoEnabled , isPrescriptionExtraInfoEnabled , opticianForm , dateFormat , formValidations , prescriptionInfoAdditionalContent , variantData , packageTypes , isAvailableForSubscription , isDaily , isSubscriptionSelected , promotionalText , hasSubscriptions , ratePlans ,  } = this.props;
        const { leftEyeChecked , leftEyeBoxQuantity , leftEyeBoxAvailableQuantity , rightEyeChecked , rightEyeBoxQuantity , rightEyeBoxAvailableQuantity , packSize , prescriptionModalOpen ,  } = this.state;
        return /*#__PURE__*/ React.createElement("div", {
            className: "contact-lens-configurator"
        }, /*#__PURE__*/ React.createElement(React.Fragment, null, promotionalText && /*#__PURE__*/ React.createElement(Text, {
            variant: "body"
        }, promotionalText), isSubscriptionSelected ? isAvailableForSubscription ? isDaily ? /*#__PURE__*/ React.createElement(DailyPackageQuantityContainer, {
            packageTypes: ratePlans,
            selectedSize: this.state.dailiesUsageLevel,
            handlePackSizeChange: this.handleUsageLevelChange
        }) : /*#__PURE__*/ React.createElement(PackageQuantityContainer, {
            packageTypes: ratePlans,
            selectedSize: `${this.state.subscriptionPackSize}`,
            handlePackSizeChange: this.handleSubscriptionPackSizeChange
        }) : /*#__PURE__*/ React.createElement(MonthlyPriceContainer, null) : /*#__PURE__*/ React.createElement(PackageQuantityContainer$1, {
            onChange: this.handlePackSizeChange,
            selectedSize: `${this.state.packSize}`,
            packageTypes: packageTypes
        }), /*#__PURE__*/ React.createElement("div", {
            className: "contact-lens-configurator__error-message"
        }, formValidations.showError && !formValidations.isConfiguratorValid && this.showErrorAlert()), /*#__PURE__*/ React.createElement("div", {
            className: "contact-lens-configurator__prescription"
        }, /*#__PURE__*/ React.createElement(PrescriptionContainer, {
            isSubscriptionSelected: isSubscriptionSelected,
            hasSubscriptions: hasSubscriptions,
            isActive: rightEyeChecked,
            id: "right",
            onSelection: this.handleRightEyeChecked,
            isAvailableForSubscription: isAvailableForSubscription,
            quantity: rightEyeBoxQuantity,
            availableQuantity: rightEyeBoxAvailableQuantity,
            attributes: attributes,
            products: variantData,
            packSize: packSize,
            onFoundProduct: this.handleRightEyeProductSelection,
            onQuantityChange: this.handleRightEyeQuantity,
            "data-t": "prescription-right-eye",
            maxOrderableQuantity: maxOrderableQuantity,
            allowBackOrder: allowBackOrder,
            className: "contact-lens-configurator__prescription-right",
            hasError: formValidations.showError
        }), /*#__PURE__*/ React.createElement(PrescriptionContainer, {
            isSubscriptionSelected: isSubscriptionSelected,
            hasSubscriptions: hasSubscriptions,
            isActive: leftEyeChecked,
            id: "left",
            onSelection: this.handleLeftEyeChecked,
            isAvailableForSubscription: isAvailableForSubscription,
            quantity: leftEyeBoxQuantity,
            availableQuantity: leftEyeBoxAvailableQuantity,
            attributes: attributes,
            products: variantData,
            packSize: packSize,
            onFoundProduct: this.handleLeftEyeProductSelection,
            onQuantityChange: this.handleLeftEyeQuantity,
            "data-t": "prescription-left-eye",
            maxOrderableQuantity: maxOrderableQuantity,
            allowBackOrder: allowBackOrder,
            className: "contact-lens-configurator__prescription-left",
            hasError: formValidations.showError
        })), prescriptionModalContent && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("button", {
            className: "contact-lens-configurator__prescription-link",
            onClick: this.onPrescriptionModalOpen
        }, intl.getLabel('products.contactLenses.prescription.link')), prescriptionModalOpen && /*#__PURE__*/ React.createElement(Modal, {
            showIcon: true,
            isOpen: prescriptionModalOpen,
            onModalClose: this.onPrescriptionModalClose
        }, /*#__PURE__*/ React.createElement("div", {
            className: "contact-lens-configurator__prescription-modal"
        }, /*#__PURE__*/ React.createElement(RichTextArea, {
            content: prescriptionModalContent
        })))), isPrescriptionInfoEnabled && /*#__PURE__*/ React.createElement(React.Fragment, null, formValidations.showError && !formValidations.isPrescriptionInfoValid && (formValidations.isConfiguratorValid ? /*#__PURE__*/ React.createElement(ScrollIntoView, {
            key: formValidations.errorCount
        }, /*#__PURE__*/ React.createElement(Alert, {
            icon: "info",
            message: intl.getLabel('products.contactLens.info.invalidMessage')
        })) : /*#__PURE__*/ React.createElement(Alert, {
            icon: "info",
            message: intl.getLabel('products.contactLens.info.invalidMessage')
        })), /*#__PURE__*/ React.createElement(PrescriptionInfo, {
            opticianForm: opticianForm,
            dateFormat: dateFormat,
            onChange: this.handlePrescriptionInfoChange,
            isPrescriptionExtraInfoEnabled: isPrescriptionExtraInfoEnabled,
            prescriptionInfoAdditionalContent: prescriptionInfoAdditionalContent
        }))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            selectedVariants: {},
            leftEyeChecked: true,
            leftEyeBoxQuantity: 1,
            prescriptionModalOpen: false,
            rightEyeChecked: true,
            rightEyeBoxQuantity: 1,
            packSize: 0
        };
        this.setInitialPackSize = ({ packageQuantity  }, rateplan)=>{
            packageQuantity && this.handlePackSizeChange(packageQuantity);
            if (rateplan === null || rateplan === void 0 ? void 0 : rateplan.usageLevel) {
                this.handleUsageLevelChange(rateplan.usageLevel);
            } else {
                (rateplan === null || rateplan === void 0 ? void 0 : rateplan.packageQuantity) && this.handleSubscriptionPackSizeChange(rateplan.packageQuantity);
            }
        };
        this.handleChange = (key, value)=>{
            const { handleFormChange  } = this.props;
            this.setState((prevState)=>swcHelpers.objectSpread({}, prevState, {
                    [key]: value
                })
            , ()=>handleFormChange && handleFormChange(this.state)
            );
        };
        this.handleLeftEyeChecked = this.handleChange.bind(this, 'leftEyeChecked');
        this.handleRightEyeChecked = this.handleChange.bind(this, 'rightEyeChecked');
        this.handleLeftEyeQuantity = this.handleChange.bind(this, 'leftEyeBoxQuantity');
        this.handleRightEyeQuantity = this.handleChange.bind(this, 'rightEyeBoxQuantity');
        this.handleSubscriptionPriceChange = this.handleChange.bind(this, 'subscriptionPrice');
        this.handlePackSizeChange = (packSize)=>{
            var ref;
            let newPackSize;
            switch(typeof packSize){
                case 'string':
                    newPackSize = parseInt(packSize);
                    break;
                case 'number':
                    newPackSize = packSize;
                    break;
                case 'object':
                    newPackSize = +packSize.value;
                    break;
                default:
                    return;
            }
            this.setState({
                packPrice: getPriceForPack(newPackSize, this.props.packageTypes)
            }, ()=>this.handleChange('packSize', newPackSize)
            );
            this.state.packPrice && pushSelectBoxQuantity((ref = this.state.packPrice) === null || ref === void 0 ? void 0 : ref.value, this.state.dailiesUsageLevel, `${this.state.packSize}`);
        };
        this.handleSubscriptionPackSizeChange = (packSize)=>{
            const ratePlan = this.props.ratePlans.find(({ packageQuantity  })=>packageQuantity === +packSize
            );
            const subscriptionPrice = (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.totalPrice.centAmount) || 0;
            // Check for existing packSize in the state, so we don't push on the initial page load
            if (ratePlan && this.state.packSize) {
                pushSubscriptionBoxSizeChange(ratePlan);
            }
            this.setState({
                subscriptionPrice
            }, ()=>this.handleChange('subscriptionPackSize', packSize)
            );
        };
        this.handleUsageLevelChange = (selectedUsageLevel)=>{
            const ratePlan = this.props.ratePlans.find(({ usageLevel  })=>usageLevel === selectedUsageLevel
            );
            const subscriptionPrice = (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.totalPrice.centAmount) || 0;
            this.setState({
                subscriptionPrice
            }, ()=>this.handleChange('dailiesUsageLevel', selectedUsageLevel)
            );
            ratePlan && pushSubscriptionBoxSizeChange(ratePlan);
        };
        this.handleProductSelection = (side, product)=>{
            this.setState({
                selectedVariants: swcHelpers.objectSpread({}, this.state.selectedVariants, {
                    [side]: product
                })
            });
            const skuKey = side === 'left' ? 'leftEyeBoxSKU' : 'rightEyeBoxSKU';
            const SKU = product && product.sku;
            this.handleChange(skuKey, SKU);
            const availableQuantityKey = side === 'left' ? 'leftEyeBoxAvailableQuantity' : 'rightEyeBoxAvailableQuantity';
            const availableQuantity = product && Helpers.getAvailableQuantity(product.availability);
            this.handleChange(availableQuantityKey, availableQuantity);
        };
        this.handleLeftEyeProductSelection = this.handleProductSelection.bind(this, 'left');
        this.handleRightEyeProductSelection = this.handleProductSelection.bind(this, 'right');
        this.setScroll = ()=>{
            const body = document && document.body;
            if (body) {
                this.state.prescriptionModalOpen && !body.classList.contains('body--no-scroll') ? body.classList.add('body--no-scroll') : body.classList.remove('body--no-scroll');
            }
        };
        this.onPrescriptionModalOpen = (event)=>{
            event.preventDefault();
            this.setState({
                prescriptionModalOpen: true
            }, ()=>{
                this.setScroll();
            });
        };
        this.onPrescriptionModalClose = ()=>{
            this.setState({
                prescriptionModalOpen: false
            }, ()=>{
                this.setScroll();
            });
        };
        this.handlePrescriptionInfoChange = (prescriptionState)=>{
            this.handleChange('prescriptionInfo', prescriptionState);
        };
    }
}
var ConfigureContactLenses$2 = withIntl(ConfigureContactLenses$1);

const getSortedPackageTypes = (masterPackageType, packageTypes)=>{
    // Put the master package type first,
    // this will guarantee the default selected
    const newPackageTypes = [
        masterPackageType,
        ...packageTypes
    ];
    // remove duplicates
    return newPackageTypes.reduce((prev, curr)=>{
        const duplicate = prev.some((packageType)=>packageType.packageQuantity === curr.packageQuantity
        );
        if (!duplicate) {
            prev.push(curr);
        }
        return prev;
    }, []);
};

// only dailies should have a usageLevel attribute present
const isRateplansDaily = (ratePlans)=>!ratePlans.length ? false : ratePlans.every(({ usageLevel  })=>!!usageLevel
    )
;

const contactLensProductByUsageLevelRatePlansFragment = gql`
  fragment ContactLensProductByUsageLevelRatePlansFragment on ContactLensProduct {
    productMasterKey
    ratePlansDistinctByUsageLevel {
      id: externalId
      externalId
      effectiveStartDate
      effectiveEndDate
      billingPeriod
      shippingSchedule
      includedUnits
      usageLevel
      totalPrice(normalize: PER_MONTH) {
        currencyCode
        centAmount
      }
      variant {
        gan
        packageQuantity
      }
    }
  }
`;
var GET_DISTINCT_RATEPLANS_BY_USAGE_LEVEL = gql`
  query getDistinctRatePlansByMasterKey($productMasterKey: ID!) {
    productByMasterKey(productMasterKey: $productMasterKey) {
      ...ContactLensProductByUsageLevelRatePlansFragment
    }
  }

  ${contactLensProductByUsageLevelRatePlansFragment}
`;

var useDistinctRateplans = ((masterKey, returnWithoutFetch)=>{
    var ref;
    // HOTFIX: return early without fetch if flag is enabled
    // This circumvents the rateplan query being called on pdp
    // of products without cls enabled. Remove once cls is on production.
    if (returnWithoutFetch) {
        return {
            data: [],
            loading: false
        };
    }
    const { data , loading , error  } = useQuery(GET_DISTINCT_RATEPLANS_BY_USAGE_LEVEL, {
        variables: {
            productMasterKey: masterKey
        }
    });
    var ref1;
    // spread to avoid mutating original array
    const byUsageLevel = (ref1 = (ref = data === null || data === void 0 ? void 0 : data.productByMasterKey) === null || ref === void 0 ? void 0 : ref.ratePlansDistinctByUsageLevel) !== null && ref1 !== void 0 ? ref1 : [];
    const ratePlans = [
        ...byUsageLevel
    ].sort((a, b)=>{
        if (a.usageLevel && b.usageLevel) {
            const levels = {
                [Types$1.UsageLevel.ONE_DAY_A_WEEK]: 1,
                [Types$1.UsageLevel.TWO_DAYS_A_WEEK]: 2,
                [Types$1.UsageLevel.THREE_FOUR_DAYS_A_WEEK]: 3,
                [Types$1.UsageLevel.MORE_THAN_FIVE_DAYS_A_WEEK]: 4
            };
            return levels[a.usageLevel] - levels[b.usageLevel];
        }
        return a.variant.packageQuantity - b.variant.packageQuantity;
    });
    return {
        data: toRatePlans(ratePlans !== null && ratePlans !== void 0 ? ratePlans : null) || [],
        loading,
        error
    };
});

const allowedAttributes = [
    'addition',
    'axis',
    'baseCurve',
    'color',
    'cylinder',
    'diameter',
    'power',
    'packageQuantity', 
];
const ConfigureContactLensesContainer = (props)=>{
    const [attributes1, setAttributes] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(true);
    const [packageTypes1, setPackageTypes] = React.useState([]);
    const [variantData, setVariantData] = React.useState([]);
    // HOTFIX to only fetch data if product has subscriptions enabled
    // remove second param once cls is running on production
    const { data: ratePlans , loading: ratePlansLoading  } = useDistinctRateplans(props.variantGroup, !props.isAvailableForSubscription);
    React.useEffect(()=>{
        const getLensData = function() {
            var _ref = swcHelpers.asyncToGenerator(function*() {
                const { productsUrl  } = props.apiConfig;
                try {
                    const lensData = yield Products.getContactLenses(productsUrl, {
                        variantGroup: props.variantGroup
                    });
                    return parseLensData(lensData);
                } catch (err) {
                    console.warn('No variant data provided', err);
                    setIsLoading(false);
                }
            });
            return function getLensData() {
                return _ref.apply(this, arguments);
            };
        }();
        getLensData();
    }, []);
    const parseLensData = (lensData)=>{
        const availableAttributes = {};
        const { contactLensesVariants , masterPackageType , packageTypes  } = lensData;
        contactLensesVariants.forEach(({ attributes  })=>{
            for (const key of Object.keys(attributes)){
                if (allowedAttributes.includes(key)) {
                    const value = attributes[key];
                    if (!availableAttributes[key]) {
                        availableAttributes[key] = {
                            selected: '',
                            values: new Set()
                        };
                    }
                    availableAttributes[key].values.add(value);
                }
            }
        });
        setAttributes(availableAttributes);
        setPackageTypes(getSortedPackageTypes(masterPackageType, packageTypes));
        setVariantData(contactLensesVariants);
        setIsLoading(false);
    };
    return isLoading || ratePlansLoading ? /*#__PURE__*/ React.createElement(Loader, {
        className: "contact-lens-configurator__loader"
    }) : /*#__PURE__*/ React.createElement(ConfigureContactLenses$2, swcHelpers.extends({}, props, {
        attributes: attributes1,
        packageTypes: packageTypes1,
        variantData: variantData,
        ratePlans: ratePlans,
        isDaily: isRateplansDaily(ratePlans)
    }));
};
var ConfigureContactLenses = withApiConfig(ConfigureContactLensesContainer);

const ProductDetailLensesFeatures = ({ hydration , softness , breathability , fatigue , basics , uv , color ,  })=>{
    if (!hydration && !softness && !breathability && !fatigue && !basics && !uv && !color) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("ul", {
        className: "product-detail-lenses-features"
    }, basics && basics.variantHasAttribute && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--basics"
    }, /*#__PURE__*/ React.createElement(FeatureIcon, {
        name: "basics",
        color: color,
        size: 38
    }), basics.label), hydration && hydration.variantHasAttribute && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--hydration"
    }, /*#__PURE__*/ React.createElement(FeatureIcon, {
        name: "hydratation",
        color: color,
        size: 38
    }), hydration.label), softness && softness.variantHasAttribute && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--softness"
    }, /*#__PURE__*/ React.createElement(FeatureIcon, {
        name: "softness",
        color: color,
        size: 38
    }), softness.label), breathability && breathability.variantHasAttribute && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--breathability"
    }, /*#__PURE__*/ React.createElement(FeatureIcon, {
        name: "breathability",
        color: color,
        size: 38
    }), breathability.label), fatigue && fatigue.variantHasAttribute && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--fatigue"
    }, /*#__PURE__*/ React.createElement(FeatureIcon, {
        name: "fatigue",
        color: color,
        size: 38
    }), fatigue.label), uv && uv.variantHasAttribute && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-lenses-features__feature product-detail-lenses-features__feature--uv"
    }, /*#__PURE__*/ React.createElement(FeatureIcon, {
        name: "uv",
        color: color,
        size: 38
    }), uv.label));
};

const Description$1 = ({ colorFeatureIcons , labels , lensFeatures , productFeatures , specificationVariant ,  })=>/*#__PURE__*/ React.createElement(ProductDetailDescription, {
        title: labels.title,
        header: labels.header,
        description: labels.description
    }, /*#__PURE__*/ React.createElement(ProductDetailLensesFeatures, swcHelpers.extends({
        color: colorFeatureIcons
    }, lensFeatures)), /*#__PURE__*/ React.createElement(ProductDetailSpecification, {
        configuration: productFeatures,
        variant: specificationVariant
    }))
;

const DescriptionContainer = ({ colorFeatureIcons , specificationVariant , variant , specificationConfiguration ,  })=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            description: variant.description,
            header: variant.header,
            title: getLabel('products.contactLenses.header.details')
        })
    , [
        getLabel,
        variant
    ]);
    const { productFeatures , lensFeatures  } = React.useMemo(()=>getContactLensFeatures(variant, getLabel)
    , [
        getLabel,
        variant
    ]);
    return /*#__PURE__*/ React.createElement(Description$1, {
        colorFeatureIcons: colorFeatureIcons,
        labels: labels,
        lensFeatures: lensFeatures,
        productFeatures: specificationConfiguration || productFeatures,
        specificationVariant: specificationVariant
    });
};

const SubscriptionOffer = ({ className , clsUsps  })=>{
    const { getLabel  } = useIntl();
    const label = getLabel('products.contactLenses.subscriptionOffer.label');
    const tooltipLabel = getLabel('products.contactLenses.subscriptionOffer.tooltip');
    if (!label) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames([
            'subscription-offer',
            className
        ])
    }, /*#__PURE__*/ React.createElement("label", {
        className: "subscription-offer__label"
    }, /*#__PURE__*/ React.createElement("span", null, label), tooltipLabel && /*#__PURE__*/ React.createElement(Tooltip, {
        id: "subscription-offer_tooltip",
        message: tooltipLabel
    })), clsUsps && /*#__PURE__*/ React.createElement("div", {
        className: "subscription-offer__usps"
    }, /*#__PURE__*/ React.createElement(ProductDetailUsps, {
        items: clsUsps,
        layout: "grid"
    })));
};

const Lenses = ({ addToCartRef , contactLensesConfiguratorConfig , ctaButton , currency , deliveryIndicatorConfig , descriptionConfig , hasSubscriptions =false , isSmallScreen , isProductLabelEnabled , labels , packPrice , subscriptionPrice , productImageAlt , productTypeUsps , clsUsps , showStickyButton , stickerText , stickyTop , variant , variantGroup , activeTabIndex , setActiveTabIndex , isSubscriptionSelected , isAvailableForSubscription , productImageGallery , clsConfigurator =null , disclaimer , calculatedPrice , calculatedDiscountPrice ,  })=>{
    var ref;
    const { isBynderImagesEnabled , isDeliveryFullDateEnabled  } = useFeatureToggles();
    const { getLabel  } = useIntl();
    const packPriceDiscount = packPrice === null || packPrice === void 0 ? void 0 : (ref = packPrice.discounted) === null || ref === void 0 ? void 0 : ref.value.centAmount;
    const hasPackPriceDiscount = typeof packPriceDiscount === 'number';
    const { Slots  } = useProductDetailSlots();
    const discountLabel = /*#__PURE__*/ React.createElement(React.Fragment, null, isProductLabelEnabled && /*#__PURE__*/ React.createElement(ProductDiscountLabel, {
        title: variant.discountText
    }), !isProductLabelEnabled && variant.discounted && /*#__PURE__*/ React.createElement(Discount, {
        label: variant.discountText,
        discount: variant.discounted,
        isWide: true
    }));
    var ref1;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main product-detail-lenses"
    }, isSmallScreen && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitle, {
        title: variant.brand,
        subtitle: variant.replacementFrequency
    }), /*#__PURE__*/ React.createElement(ReviewSnippet, {
        productId: variantGroup
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, isBynderImagesEnabled ? productImageGallery : /*#__PURE__*/ React.createElement(ProductVisualSwitcher, {
        productImages: variant.images,
        alt: productImageAlt,
        sticker: stickerText && /*#__PURE__*/ React.createElement(ProductDiscountLabel, {
            title: variant.discountText ? variant.discountText : stickerText,
            modifier: "product-detail"
        })
    })), /*#__PURE__*/ React.createElement("section", {
        className: "product-detail__aside product-detail-lenses__aside",
        "aria-label": `${variant.brand} ${variant.replacementFrequency}`
    }, /*#__PURE__*/ React.createElement(Sticky, {
        top: stickyTop || 0,
        bottomBoundary: ".product-detail-lenses",
        enabled: !isSmallScreen
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, !isSmallScreen && /*#__PURE__*/ React.createElement(ProductDetailTitle, {
        title: variant.brand,
        subtitle: variant.replacementFrequency
    }), !isProductLabelEnabled && variant.tag && variant.tag.value && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__product-tag"
    }, /*#__PURE__*/ React.createElement(ProductTag, {
        tag: variant.tag
    })), packPrice && !isSubscriptionSelected && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: classnames('product-detail__specification-prices', {
            'product-detail__specification-prices--has-discount': hasPackPriceDiscount
        }),
        role: "group",
        "aria-label": getLabel('products.screenreader.priceInformation')
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__price-container"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        originalPrice: packPrice.value.centAmount,
        currency: currency,
        discountedPrice: packPriceDiscount
    })), discountLabel), Slots.AfterPrice ? /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__after-price-slot"
    }, /*#__PURE__*/ React.createElement(Slots.AfterPrice, null)) : null), subscriptionPrice && isSubscriptionSelected && /*#__PURE__*/ React.createElement("div", {
        className: classnames('product-detail__specification-prices', {
            'product-detail__specification-prices--has-discount': false
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__price-container"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        originalPrice: subscriptionPrice,
        currency: currency
    })), discountLabel), !isSmallScreen && /*#__PURE__*/ React.createElement(ReviewSnippet, {
        productId: variantGroup
    }), !variant.excludedFromCheckout && isSubscriptionSelected && isAvailableForSubscription && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), /*#__PURE__*/ React.createElement(SubscriptionOffer, {
        clsUsps: clsUsps
    })), variant.excludedFromCheckout && /*#__PURE__*/ React.createElement(Text, null, variant.packageQuantity, ' ', variant.packageQuantity === 1 ? labels.lens : labels.lenses, " ", labels.perBox), !variant.excludedFromCheckout && (hasSubscriptions || isAvailableForSubscription) && /*#__PURE__*/ React.createElement(Tabs, {
        onChange: setActiveTabIndex,
        activeTabIndex: activeTabIndex,
        variant: "secondary"
    }, /*#__PURE__*/ React.createElement(Tab, {
        label: labels.oneTimeTitle
    }), /*#__PURE__*/ React.createElement(Tab, {
        label: labels.subscriptionTitle
    })), !variant.excludedFromCheckout && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__configuration product-detail-lenses__configuration"
    }, /*#__PURE__*/ React.createElement(ConfigureContactLenses, swcHelpers.extends({}, contactLensesConfiguratorConfig, {
        isSubscriptionSelected: isSubscriptionSelected,
        isAvailableForSubscription: isAvailableForSubscription,
        hasSubscriptions: hasSubscriptions,
        variantGroup: variantGroup
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details",
        ref: addToCartRef
    }, !variant.excludedFromCheckout && isDeliveryFullDateEnabled && !isSubscriptionSelected && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details__delivery-indicator"
    }, /*#__PURE__*/ React.createElement(DeliveryIndicator, swcHelpers.extends({}, deliveryIndicatorConfig, {
        view: "text"
    }))), ctaButton, Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null, isSmallScreen && showStickyButton && !!variant.price && (isSubscriptionSelected && !isAvailableForSubscription ? /*#__PURE__*/ React.createElement(StickyCallToAction, {
        button: ctaButton
    }) : /*#__PURE__*/ React.createElement(StickyCallToAction, {
        button: ctaButton,
        price: /*#__PURE__*/ React.createElement(Price, {
            value: (ref1 = packPriceDiscount ? packPriceDiscount : packPrice === null || packPrice === void 0 ? void 0 : packPrice.value.centAmount) !== null && ref1 !== void 0 ? ref1 : 0,
            currency: currency,
            centAmount: true,
            type: packPriceDiscount ? 'discount' : 'default'
        }),
        perBox: labels.perBox
    }))), /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), !variant.excludedFromCheckout && !isSubscriptionSelected && !isDeliveryFullDateEnabled && /*#__PURE__*/ React.createElement(DeliveryIndicator, swcHelpers.extends({}, deliveryIndicatorConfig, {
        view: "icon"
    })), productTypeUsps && /*#__PURE__*/ React.createElement(ProductDetailUsps, {
        items: productTypeUsps
    })))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-lenses__description"
    }, /*#__PURE__*/ React.createElement(DescriptionContainer, swcHelpers.extends({}, descriptionConfig, {
        variant: variant
    }))), disclaimer && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__disclaimer product-detail-lenses__disclaimer"
    }, /*#__PURE__*/ React.createElement(Panel, {
        title: disclaimer.title
    }, disclaimer.description)), clsConfigurator);
};

const LensesContainer = ({ activeSku , addToCartRef , allowBackOrder , colorFeatureIcons , clsUsps , dateFormat , deliveryResolverFactory , formatProductUrl , isPrescriptionExtraInfoEnabled =true , isPrescriptionInfoEnabled =false , maxOrderableQuantity , onCTAClick , onPriceChange , opticianForm , prescriptionInfoAdditionalContent , prescriptionModalContent , product , productTypeUsps , showStickyButton , staticsUrl , stickerText , stickyTop , variant: variant1 , hasSubscriptions , specificationConfiguration , renderAddToCartButton , handleConversionEvent , productImageGallery , disclaimer ,  })=>{
    const { excludedFromCheckout , promotionalText  } = variant1;
    const { masterVariant  } = product;
    const { currency , getLabel , locale  } = useIntl();
    const { isContactLensEnabled: isPrescriptionEnabled , isDeliveryFullDateEnabled ,  } = useFeatureToggles();
    const dispatch = useDispatch();
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { isBynderImagesEnabled  } = useFeatureToggles();
    const productViewHistory = useProductViewHistory();
    const [activeTabIndex, setActiveTabIndex] = React.useState(0);
    const [isConfiguratorOpen, setIsConfiguratorOpen] = React.useState(false);
    const { isProductLabelEnabled  } = useFeatureToggles();
    const productCatKey = getAttrValue(masterVariant, 'recommendedProductCatKey');
    const recommendedCategoryKey = isString(productCatKey) ? productCatKey : undefined;
    const variantGroup = String(getAttrValue(masterVariant, 'brandKey'));
    /**
   * "Old" way of handling subscriptions, currently in use by the BeNe opco's.
   */ const isSubscriptionSelected = activeTabIndex === 1;
    /**
   * Enables the new subscription configurator based on a boolean variant attribute.
   */ const isAvailableForSubscription = productIsAvailableForSubscription(product);
    const [lensState, lensActions] = useLenses({
        product,
        isPrescriptionEnabled,
        isPrescriptionInfoEnabled,
        variant: variant1,
        formatProductUrl
    });
    const { lineItems: bundleLineItems , pricePerMonth  } = useLensBundle();
    const lineItemsForCart = isSubscriptionSelected ? bundleLineItems : lensState.priceTotals.selectedProducts;
    /**
   * Add SKU to view history
   * Only adds the masterProduct so we don't get duplicates
   */ React.useEffect(()=>{
        if (Boolean(getAttrValue(masterVariant, 'masterProduct')) && masterVariant.sku) {
            productViewHistory.add(masterVariant.sku);
        }
    }, []);
    /**
   * Callback to update the AddToCartNotification in ProductDetail
   * should execute when either the solutions or the lenses update
   */ React.useEffect(()=>{
        onPriceChange(lensState.priceTotals);
    }, [
        onPriceChange,
        lensState.priceTotals
    ]);
    /**
   * Triggers the product_detail SD action when the user clicks on the subscription tab
   */ React.useEffect(()=>{
        viewProductSdEvent({
            product,
            activeSKU: variant1.sku,
            staticsUrl,
            url: `${window.location}${formatProductUrl({
                productType: 'Contact-lenses',
                slug: product.slug
            })}`,
            locale,
            isSubscriptionSelected,
            pricePerMonth,
            isBynderImagesEnabled
        });
        const purchaseType = isSubscriptionSelected ? DataLayer.DataLayerTypes.PurchaseType.Subscription : DataLayer.DataLayerTypes.PurchaseType.OneTime;
        const productType = isSubscriptionSelected ? DataLayer.DataLayerTypes.LineItemType.Bundle : DataLayer.DataLayerTypes.LineItemType.Single;
        pushPdpEventToDataLayer(purchaseType, product, variant1.sku, currency, productType, lensState.subscriptionPrice);
    }, [
        activeTabIndex
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    const setActiveTab = (index)=>{
        pushTabClickEvent(!isSubscriptionSelected);
        setActiveTabIndex(index);
    };
    const openConfiguratorButtonRef = React.useRef(null);
    const handleConfiguratorOpen = React.useCallback(()=>{
        if (lensState.formValidations.isConfiguratorValid) {
            handleConversionEvent();
            setIsConfiguratorOpen(true);
        } else {
            lensActions.handlePrescriptionClick() // Show the alert
            ;
        }
    }, [
        lensActions,
        lensState,
        dispatch
    ]);
    const handleConfiguratorClose = React.useCallback(()=>{
        var ref;
        setIsConfiguratorOpen(false);
        openConfiguratorButtonRef === null || openConfiguratorButtonRef === void 0 ? void 0 : (ref = openConfiguratorButtonRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        dispatch(resetConfigurationState());
    }, [
        openConfiguratorButtonRef,
        dispatch
    ]);
    const getSelectedLensVariants = React.useMemo(()=>{
        const isLensVariant = (variant)=>!!variant
        ;
        const selectedVariants = lensState.selectedLensVariants.filter(isLensVariant);
        // When both eye sides have the same variant, find will return the same eye side for both of the sides. Through the
        // use of a check for identical variants, we can ensure no duplicate `ContactLensVariantWithEyeSide` will end up in
        // the return value.
        const areEyeSideVariantsIdentical = selectedVariants.length === 2 && selectedVariants[0].sku === selectedVariants[1].sku;
        const getEyeSideForVariant = (variant)=>{
            var ref, ref1;
            return (ref = lensState.priceTotals.selectedProducts.find(({ sku  })=>{
                return sku === (variant === null || variant === void 0 ? void 0 : variant.sku);
            })) === null || ref === void 0 ? void 0 : (ref1 = ref.customAttributes) === null || ref1 === void 0 ? void 0 : ref1.eyeSide;
        };
        const getEyeSideForIdenticalVariant = (_variant, index)=>index === 0 ? 'left' : 'right'
        ;
        return swcHelpers.objectSpread({}, selectedVariants.map((variant, index)=>swcHelpers.objectSpread({}, variant, {
                eyeSide: areEyeSideVariantsIdentical ? getEyeSideForIdenticalVariant(variant, index) : getEyeSideForVariant(variant)
            })
        ));
    }, [
        lensState
    ]);
    const clsConfigurator = /*#__PURE__*/ React.createElement(ClsConfigurator, {
        formatProductUrl: formatProductUrl,
        input: lensState.subscriptionConfiguratorInput,
        isOpen: isConfiguratorOpen,
        lensVariants: getSelectedLensVariants,
        product: product,
        staticsUrl: staticsUrl,
        variantGroup: variantGroup,
        onModalClose: handleConfiguratorClose,
        recommendedCategoryKey: recommendedCategoryKey,
        triggerButtonRef: openConfiguratorButtonRef,
        clsUsps: clsUsps
    });
    const ctaButton = isAvailableForSubscription && activeTabIndex === 1 ? /*#__PURE__*/ React.createElement(ConfiguratorButton, {
        onClick: handleConfiguratorOpen,
        btnRef: openConfiguratorButtonRef,
        calculatedPrice: lensState.priceTotals.subscriptionCalculatedPrice,
        isPrescriptionEnabled: isPrescriptionEnabled,
        hasLenses: lensState.hasLenses
    }) : /*#__PURE__*/ React.createElement(CTAButton$1, {
        calculatedDiscountPrice: lensState.priceTotals.calculatedDiscountPrice,
        calculatedPrice: lensState.priceTotals.calculatedPrice,
        lineItemsForCart: lineItemsForCart,
        excludedFromCheckout: excludedFromCheckout,
        isPrescriptionEnabled: isPrescriptionEnabled,
        isSubscription: isSubscriptionSelected,
        hasLenses: lensState.hasLenses,
        onPrescriptionClick: lensActions.handlePrescriptionClick,
        handleMiniCartChange: lensActions.handleMiniCartChange,
        onClick: onCTAClick,
        pricePerMonth: pricePerMonth,
        renderAddToCartButton: renderAddToCartButton,
        handleConversionEvent: handleConversionEvent
    });
    const contactLensesConfiguratorConfig = {
        allowBackOrder,
        dateFormat,
        formValidations: lensState.formValidations,
        handleFormChange: lensActions.handleFormChange,
        isPrescriptionExtraInfoEnabled,
        isPrescriptionInfoEnabled,
        maxOrderableQuantity,
        opticianForm,
        prescriptionInfoAdditionalContent,
        prescriptionModalContent,
        promotionalText,
        hasSubscriptions
    };
    let deliveryIndicatorConfig = {
        fallbackLabel: getLabel('products.deliveryIndicator.selectPrescription'),
        className: 'product-detail__delivery-indicator'
    };
    if (isDeliveryFullDateEnabled) {
        deliveryIndicatorConfig = swcHelpers.objectSpread({}, deliveryIndicatorConfig, {
            items: lineItemsForCart.map((item)=>({
                    sku: item.sku,
                    quantity: item.quantity || 1
                })
            )
        });
    } else {
        deliveryIndicatorConfig = swcHelpers.objectSpread({}, deliveryIndicatorConfig, {
            // TODO: Add availability info when bundles have that
            availability: !isSubscriptionSelected ? lensState.availability : [
                undefined
            ],
            deliveryResolver: deliveryResolverFactory && deliveryResolverFactory(lensState.selectedLensVariants)
        });
    }
    const descriptionConfig = {
        colorFeatureIcons,
        specificationVariant: getActiveVariant$1(product, activeSku),
        specificationConfiguration
    };
    const labels = {
        perBox: getLabel('products.perBox'),
        perMonth: getLabel('common.frequency.perMonth'),
        descriptionTitle: getLabel('products.contactLenses.header.details'),
        subscriptionTitle: getLabel('products.contactLenses.subscription.title'),
        oneTimeTitle: getLabel('products.contactLenses.oneTime.title'),
        lens: getLabel('products.unit.contactLens'),
        lenses: getLabel('products.unit.contactLenses')
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Lenses, {
        addToCartRef: addToCartRef,
        clsUsps: clsUsps,
        contactLensesConfiguratorConfig: contactLensesConfiguratorConfig,
        ctaButton: ctaButton,
        currency: currency,
        deliveryIndicatorConfig: deliveryIndicatorConfig,
        descriptionConfig: descriptionConfig,
        formatProductUrl: formatProductUrl,
        hasSubscriptions: hasSubscriptions,
        isSmallScreen: isSmallScreen,
        isProductLabelEnabled: isProductLabelEnabled,
        labels: labels,
        packPrice: lensState.packPrice,
        subscriptionPrice: lensState.subscriptionPrice,
        productImageAlt: getLocalizedValue(product.name, locale),
        productTypeUsps: productTypeUsps,
        showStickyButton: showStickyButton,
        staticsUrl: staticsUrl,
        stickerText: stickerText,
        stickyTop: stickyTop,
        variant: variant1,
        variantGroup: variantGroup,
        activeTabIndex: activeTabIndex,
        setActiveTabIndex: setActiveTab,
        isSubscriptionSelected: isSubscriptionSelected,
        isAvailableForSubscription: isAvailableForSubscription,
        productImageGallery: productImageGallery,
        clsConfigurator: clsConfigurator,
        disclaimer: disclaimer,
        calculatedPrice: lensState.priceTotals.calculatedPrice,
        calculatedDiscountPrice: lensState.priceTotals.calculatedDiscountPrice
    }));
};

const isPowerAttribute = (attr)=>{
    return attr.name === 'power';
};
const findPowerAttribute = (variant)=>{
    var ref1;
    return variant === null || variant === void 0 ? void 0 : (ref1 = variant.attributes) === null || ref1 === void 0 ? void 0 : ref1.find(isPowerAttribute);
};
var _sku, ref;
const mappedDropdownItems = (variants)=>{
    return variants.reduce((acc, curr)=>{
        var ref2;
        return findPowerAttribute(curr) ? acc.push({
            value: (_sku = curr.sku) !== null && _sku !== void 0 ? _sku : '',
            label: (ref = (ref2 = findPowerAttribute(curr)) === null || ref2 === void 0 ? void 0 : ref2.value) !== null && ref !== void 0 ? ref : ''
        }) : null, acc;
    }, []);
};
const sortedDropdownItems = (mappedItems)=>mappedItems.sort((a, b)=>+a.value - +b.value
    )
;
const PowerSelector = ({ activeSku , handleVariantPick , variants  })=>{
    var ref3;
    const items = React.useMemo(()=>mappedDropdownItems(variants)
    , [
        variants
    ]);
    const sortedItems = React.useMemo(()=>sortedDropdownItems(items)
    , [
        items
    ]);
    const selectedSize = (ref3 = items.find((item)=>item.value === activeSku
    )) === null || ref3 === void 0 ? void 0 : ref3.value;
    return /*#__PURE__*/ React.createElement(PackageQuantityDropdown, {
        title: "ready-readers-power-selector",
        onChange: (selectedVariant)=>handleVariantPick(selectedVariant.label, undefined, selectedVariant.value)
        ,
        selectedSize: selectedSize,
        items: sortedItems
    });
};

const getFeatures$1 = (getLabel, variant)=>({
        blueFilter: {
            label: getLabel('products.readyreaders.features.blueFilter'),
            hasAttribute: Boolean(variant.features.blueFilter)
        },
        isOfferedWithPrescriptions: {
            label: getLabel('products.readyreaders.features.isOfferedWithPrescriptions'),
            hasAttribute: Boolean(variant.features.isOfferedWithPrescriptions)
        }
    })
;
const ReadyReadersFeatures = ({ variant , labels  })=>{
    const { getLabel  } = useIntl();
    const featureList = getFeatures$1(getLabel, variant);
    const featureListItems = Object.keys(featureList).map((feature)=>featureList[feature].hasAttribute && /*#__PURE__*/ React__default.createElement("li", {
            className: "ready-readers-features__feature",
            key: feature
        }, /*#__PURE__*/ React__default.createElement(FeatureIcon, {
            name: feature,
            color: 'grey',
            size: 38
        }), featureList[feature].label)
    );
    if (featureListItems.filter(Boolean).length === 0) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.informationBlockHeader), /*#__PURE__*/ React__default.createElement("ul", {
        className: "ready-readers-features",
        "aria-label": "features"
    }, featureListItems));
};

const ReadyReaders = ({ activeSku , activeVariant , addToCartRef , brandLink , currency , formatProductUrl , frameSize , handleConversionEvent , handleVariantPick , isMobile , isOrderable , isProductLabelEnabled , labels , onCTAClick , product , productImageAlt , productImageGallery , productTypeUsps , specificationConfiguration , stickyTop , stockCount , stockResolver , variant , variants , storesRoute  })=>{
    const { isBynderImagesEnabled , isFrameSizeEnabled , isFrameSizeVTOEnabled  } = useFeatureToggles();
    const { channelAvailability  } = variant;
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main product-detail-ready-readers"
    }, isMobile && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitle, {
        title: `${variant.brand} ${variant.modelName}`,
        subtitle: variant.brand,
        href: brandLink
    }), /*#__PURE__*/ React.createElement(ReviewSnippet, {
        productId: variant.sku
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, isBynderImagesEnabled ? productImageGallery : /*#__PURE__*/ React.createElement(ProductVisualSwitcher, {
        productImages: variant.images,
        alt: productImageAlt
    })), /*#__PURE__*/ React.createElement("aside", {
        className: "product-detail__aside"
    }, /*#__PURE__*/ React.createElement(Sticky, {
        top: stickyTop || 0,
        bottomBoundary: ".product-detail",
        enabled: !isMobile
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "mobile-hidden"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitle, {
        title: `${variant.brand} ${variant.modelName}`,
        subtitle: variant.brand,
        href: brandLink
    })), !isProductLabelEnabled && variant.tag && variant.tag.value && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__product-tag"
    }, /*#__PURE__*/ React.createElement(ProductTag, {
        tag: variant.tag
    })), !!variant.price && /*#__PURE__*/ React.createElement("div", {
        className: classnames('product-detail__specification-prices', {
            'product-detail__specification-prices--has-discount': !!variant.discountText
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__price-container"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        originalPrice: variant.price.originalPrice,
        discountedPrice: variant.price.discountedPrice,
        currency: currency
    })), isProductLabelEnabled && /*#__PURE__*/ React.createElement(ProductDiscountLabel, {
        title: variant.discountText
    }), !isProductLabelEnabled && variant.discounted && /*#__PURE__*/ React.createElement(Discount, {
        label: variant.discountText,
        discount: variant.discounted,
        isWide: true
    })), !isMobile && /*#__PURE__*/ React.createElement(ReviewSnippet, {
        productId: variant.sku
    }), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-ready-readers__power_selector"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-ready-readers__label"
    }, labels.power, /*#__PURE__*/ React.createElement(StockIndicator, {
        stockCount: stockCount,
        allowBackOrder: isOrderable,
        channelAvailability: variant.channelAvailability
    })), /*#__PURE__*/ React.createElement(PowerSelector, {
        handleVariantPick: handleVariantPick,
        variants: variants,
        activeSku: activeSku
    })), isFrameSizeEnabled && frameSize && /*#__PURE__*/ React.createElement(FrameSize, {
        sku: activeSku,
        name: productImageAlt,
        isVTOEnabled: activeVariant.vtoEnabled && isFrameSizeVTOEnabled,
        frameSize: frameSize
    }), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details"
    }, /*#__PURE__*/ React.createElement("div", {
        ref: addToCartRef
    }, /*#__PURE__*/ React.createElement(NonRxProductCTA, {
        storesRoute: storesRoute,
        action: channelAvailability === 'ONLINE' ? 'ADD_TO_CART' : 'ADD_TO_CART_UNAVAILABLE',
        handleConversionEvent: handleConversionEvent,
        addToCartConfig: {
            activeSku,
            variantUrl: formatProductUrl({
                productType: variant.productType,
                sku: activeSku || '',
                slug: product.slug
            }),
            onCTAClick
        }
    })), activeVariant.vtoEnabled && /*#__PURE__*/ React.createElement(TryOnButton, null), productTypeUsps && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), /*#__PURE__*/ React.createElement(ProductDetailUsps, {
        items: productTypeUsps
    })))))), /*#__PURE__*/ React.createElement("section", {
        className: "product-detail-ready-readers__description",
        "aria-label": "product-information-block",
        "data-t": "ready-readers-description"
    }, /*#__PURE__*/ React.createElement(ReadyReadersFeatures, {
        variant: variant,
        labels: labels
    }), /*#__PURE__*/ React.createElement(ProductDetailDescription, {
        title: getLabel('products.contactLenses.header.details'),
        header: variant.header,
        description: variant.description,
        usps: /*#__PURE__*/ React.createElement(List, {
            icon: "checkmark",
            items: variant.usps
        })
    }), /*#__PURE__*/ React.createElement(ProductDetailSpecification, {
        configuration: specificationConfiguration,
        variant: activeVariant
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__disclaimer"
    }));
};

const ReadyReadersContainer = ({ activeSku , addToCartRef , formatProductUrl , frameSize , handleConversionEvent , handleVariantPick: onVariantPick , onCTAClick , product , productImageGallery , productTypeUsps , showStickyButton , specificationConfiguration , stickyTop , stockResolver , variant , storesRoute  })=>{
    var ref;
    const { currency , getLabel , locale  } = useIntl();
    const { isProductLabelEnabled  } = useFeatureToggles();
    const brandLink = useBrandLink(product);
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const activeVariant = getActiveVariant$1(product, activeSku);
    const productImageAlt = getLocalizedValue(product.name, locale);
    var ref1;
    const stockCount = (ref1 = (ref = variant.availability) === null || ref === void 0 ? void 0 : ref.availableQuantity) !== null && ref1 !== void 0 ? ref1 : 0;
    const isOrderable = (variant === null || variant === void 0 ? void 0 : variant.channelAvailability) === 'ONLINE';
    const variants = React.useMemo(()=>[
            product.masterVariant,
            ...product.variants
        ]
    , [
        product.masterVariant,
        product.variants, 
    ]);
    const handleVariantPick = React.useCallback((selectedSize, ...args)=>{
        onVariantPick(...args);
        DataLayer.pushEvent({
            event: 'readyreaders',
            eventAction: 'pdp select lens power',
            eventLabel: selectedSize
        });
    }, [
        onVariantPick
    ]);
    const labels = React.useMemo(()=>({
            informationBlockHeader: getLabel('products.readyreaders.informationBlockHeader'),
            power: getLabel('products.readyreaders.power')
        })
    , [
        getLabel
    ]);
    React.useEffect(()=>{
        pushPdpEventToDataLayer(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, activeSku, currency);
    }, [
        activeSku
    ]);
    return /*#__PURE__*/ React.createElement(ReadyReaders, {
        activeSku: activeSku,
        activeVariant: activeVariant,
        addToCartRef: addToCartRef,
        brandLink: brandLink,
        currency: currency,
        formatProductUrl: formatProductUrl,
        frameSize: frameSize,
        handleConversionEvent: handleConversionEvent,
        handleVariantPick: handleVariantPick,
        isMobile: isMobile,
        isOrderable: isOrderable,
        isProductLabelEnabled: isProductLabelEnabled,
        labels: labels,
        onCTAClick: onCTAClick,
        product: product,
        productImageAlt: productImageAlt,
        productImageGallery: productImageGallery,
        productTypeUsps: productTypeUsps,
        showStickyButton: showStickyButton,
        specificationConfiguration: specificationConfiguration,
        stickyTop: stickyTop,
        stockCount: stockCount,
        stockResolver: stockResolver,
        variant: variant,
        variants: variants,
        storesRoute: storesRoute
    });
};

const CTAButton = ({ isOrderable , renderAddToCartButton , calculatedPrice , currency , activeSku , selectedQuantity , addToCartCallback  })=>{
    const { getLabel  } = useIntl();
    const { routes  } = useProductDetailContext();
    const caption = /*#__PURE__*/ React.createElement(Text, {
        component: "span",
        variant: "body"
    }, `${getLabel('products.solutions.addToBasket')} `, isNumber(calculatedPrice) && calculatedPrice > 0 && /*#__PURE__*/ React.createElement(Price, {
        value: calculatedPrice,
        currency: currency
    }));
    const props = {
        caption,
        onSuccess: addToCartCallback,
        lineItemDrafts: [
            {
                sku: activeSku,
                quantity: selectedQuantity !== null && selectedQuantity !== void 0 ? selectedQuantity : 1,
                type: 'regular'
            }
        ]
    };
    if (!isOrderable) {
        return /*#__PURE__*/ React.createElement(Button, {
            caption: getLabel('products.actions.excludedFromCheckout'),
            href: routes.stores
        });
    }
    return renderAddToCartButton ? renderAddToCartButton(props) : /*#__PURE__*/ React.createElement(AddToCart, swcHelpers.extends({}, props));
};

const getPackageObject = (variant)=>{
    const price = getPrice$2(variant);
    var ref, ref1;
    return {
        label: String(getAttrValue(variant, 'packageOption')),
        value: String(variant.sku),
        subtext: '',
        aside: /*#__PURE__*/ React__default.createElement(ProductDetailPrice, {
            originalPrice: (ref = price === null || price === void 0 ? void 0 : price.originalPrice) !== null && ref !== void 0 ? ref : 0,
            discountedPrice: (ref1 = price === null || price === void 0 ? void 0 : price.discountedPrice) !== null && ref1 !== void 0 ? ref1 : 0,
            currency: price === null || price === void 0 ? void 0 : price.currency,
            customSize: "small"
        })
    };
};
const PackageSelector = ({ label , handleVariantPick , variants , selectedPackage  })=>{
    const packageItems = React__default.useMemo(()=>variants.map(getPackageObject)
    , [
        variants
    ]);
    const handlePackSizeChange = React__default.useCallback((packageOption, event)=>{
        handleVariantPick(event, packageOption.value, packageOption.label);
    }, [
        handleVariantPick
    ]);
    return /*#__PURE__*/ React__default.createElement(PackageQuantityDropdown, {
        onChange: handlePackSizeChange,
        title: packageItems[0].value,
        label: label,
        items: packageItems,
        selectedSize: selectedPackage
    });
};

const CHANGE_SOLUTION_VOLUME_OR_VARIANT = 'click_solution_pdp';
var EventAction;
(function(EventAction) {
    EventAction["SelectVolume"] = 'select solutions volume';
    EventAction["QuantityIncrease"] = 'solutions quantity increase';
    EventAction["QuantityDecrease"] = 'solutions quantity decrease';
})(EventAction || (EventAction = {}));
const triggerDataLayerEvent$1 = (eventAction, eventLabel)=>{
    DataLayer.pushEvent({
        event: CHANGE_SOLUTION_VOLUME_OR_VARIANT,
        eventAction,
        eventLabel
    });
};

const getSolutionsFeatures = (variant, getLabel)=>{
    const productFeatures = [
        {
            labelKey: 'products.solutions.lensTypeTarget',
            attribute: 'lensTypeTarget',
            isLocalised: true
        },
        {
            labelKey: 'products.solutions.caseIncluded',
            attribute: 'caseIncluded'
        },
        {
            labelKey: 'products.solutions.minimumCycleTime',
            attribute: 'minimumCycleTime',
            isLocalised: true
        },
        {
            labelKey: 'products.solutions.preservativeFree',
            attribute: 'preservativeFree'
        },
        {
            labelKey: 'products.solutions.maxTimeFrameInLensCase',
            attribute: 'maxTimeFrameInLensCase',
            isLocalised: true
        },
        {
            labelKey: 'products.solutions.expirationAfterOpening',
            attribute: 'expirationAfterOpening',
            isLocalised: true
        }, 
    ];
    const disinfect = {
        label: getLabel('products.solutions.features.cbDisinfect'),
        variantHasAttribute: !!variant.features.disinfect
    };
    const hydration = {
        label: getLabel('products.solutions.features.cbHydration'),
        variantHasAttribute: !!variant.features.hydration
    };
    const comfort = {
        label: getLabel('products.solutions.features.cbComfort'),
        variantHasAttribute: !!variant.features.comfort
    };
    const cleaning = {
        label: getLabel('products.solutions.features.cbCleaning'),
        variantHasAttribute: !!variant.features.cleaning
    };
    const sensitivity = {
        label: getLabel('products.solutions.features.cbSensitivity'),
        variantHasAttribute: !!variant.features.sensitivity
    };
    const rinsing = {
        label: getLabel('products.solutions.features.cbRinsing'),
        variantHasAttribute: !!variant.features.rinsing
    };
    const solutionsFeatures = {
        disinfect,
        hydration,
        comfort,
        cleaning,
        sensitivity,
        rinsing
    };
    return {
        productFeatures,
        solutionsFeatures
    };
};

const getFeatures = Object.keys;
const SolutionsFeatures = (props)=>{
    if (Object.values(props).every((feature)=>!feature.variantHasAttribute
    )) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement("ul", {
        className: "product-detail-solutions-features"
    }, getFeatures(props).map((feature, i)=>{
        var ref;
        return ((ref = props[feature]) === null || ref === void 0 ? void 0 : ref.variantHasAttribute) && /*#__PURE__*/ React__default.createElement("li", {
            className: "product-detail-solutions-features__feature product-detail-solutions-features__feature--basics",
            key: feature
        }, /*#__PURE__*/ React__default.createElement(FeatureIcon, {
            name: feature,
            color: 'grey',
            size: 38
        }), props[feature].label);
    }));
};

const SolutionsProductDetails = (props)=>{
    if (Object.values(props).every((productDetails)=>productDetails === ''
    )) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "subheading1"
    }, props.headerTitle), /*#__PURE__*/ React__default.createElement("ul", null, Object.keys(props).filter((el)=>el !== 'headerTitle'
    ).map((key)=>props[key] ? /*#__PURE__*/ React__default.createElement("li", {
            key: key
        }, props[key]) : null
    )));
};

const Description = ({ variant , specificationVariant , specificationConfiguration  })=>{
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            description: variant.description,
            header: variant.header || getLabel('products.solutions.header.header'),
            title: getLabel('products.solutions.header.details') || 'Product Details',
            targetUsers: variant.targetUsers,
            convenience: variant.convenience,
            keyInstructions: variant.keyInstructions,
            disclaimer: getLabel('products.solutions.features.disclaimer')
        })
    , [
        getLabel,
        variant
    ]);
    const { productFeatures , solutionsFeatures  } = React__default.useMemo(()=>getSolutionsFeatures(variant, getLabel)
    , [
        getLabel,
        variant
    ]);
    return /*#__PURE__*/ React__default.createElement(ProductDetailDescription, {
        title: labels.header,
        description: labels.description
    }, /*#__PURE__*/ React__default.createElement(SolutionsFeatures, swcHelpers.extends({}, solutionsFeatures)), /*#__PURE__*/ React__default.createElement(SolutionsProductDetails, {
        targetUsers: labels.targetUsers,
        convenience: labels.convenience,
        keyInstructions: labels.keyInstructions,
        headerTitle: labels.title
    }), /*#__PURE__*/ React__default.createElement(ProductDetailSpecification, {
        configuration: specificationConfiguration || productFeatures,
        variant: specificationVariant
    }), labels.disclaimer);
};

const Solutions = ({ addToCartRef , availableQuantity , ctaButton , stickyTop , currency , brandLink , isSmallScreen , isProductLabelEnabled , labels , showStickyButton , productTypeUsps , variant , brandModel , descriptionConfig , productImageAlt , packageSelector , selectedQuantity , onDecreaseQuantity , onIncreaseQuantity , isOrderable , maxOrderableQuantity , productImageGallery , disclaimer , quantity , calculatedTotalPrice ,  })=>{
    const { isBynderImagesEnabled , isDeliveryFullDateEnabled  } = useFeatureToggles();
    const { getLabel  } = useIntl();
    const { Slots  } = useProductDetailSlots();
    var _discountedPrice;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main product-detail-solutions"
    }, isSmallScreen && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitle, {
        title: `${variant.modelName} ${brandModel}`,
        subtitle: variant.brand,
        href: brandLink
    }), /*#__PURE__*/ React.createElement(ReviewSnippet, {
        productId: variant.sku
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, isBynderImagesEnabled ? productImageGallery : /*#__PURE__*/ React.createElement(ProductVisualSwitcher, {
        productImages: variant.images,
        alt: productImageAlt
    })), /*#__PURE__*/ React.createElement("section", {
        className: "product-detail__aside",
        "aria-label": `${variant.modelName} ${variant.modelName}`
    }, /*#__PURE__*/ React.createElement(Sticky, {
        top: stickyTop || 0,
        bottomBoundary: ".product-detail",
        enabled: !isSmallScreen
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "mobile-hidden"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitle, {
        title: `${variant.modelName} ${brandModel}`,
        subtitle: variant.brand,
        href: brandLink
    })), !isProductLabelEnabled && variant.tag && variant.tag.value && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__product-tag"
    }, /*#__PURE__*/ React.createElement(ProductTag, {
        tag: variant.tag
    })), !!variant.price && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: classnames('product-detail__specification-prices', {
            'product-detail__specification-prices--has-discount': !!variant.discountText
        }),
        role: "group",
        "aria-label": getLabel('products.screenreader.priceInformation')
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__price-container"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        originalPrice: variant.price.originalPrice,
        discountedPrice: variant.price.discountedPrice,
        currency: currency
    })), isProductLabelEnabled && /*#__PURE__*/ React.createElement(ProductDiscountLabel, {
        title: variant.discountText
    }), !isProductLabelEnabled && variant.discounted && /*#__PURE__*/ React.createElement(Discount, {
        label: variant.discountText,
        discount: variant.discounted,
        isWide: true
    })), Slots.AfterPrice ? /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__after-price-slot"
    }, /*#__PURE__*/ React.createElement(Slots.AfterPrice, null)) : null), !isSmallScreen && /*#__PURE__*/ React.createElement(ReviewSnippet, {
        productId: variant.sku
    }), packageSelector, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-solutions__quantity-picker"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-solutions__quantity-picker__label"
    }, labels.selectAmount), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-solutions__quantity-picker__wrapper"
    }, /*#__PURE__*/ React.createElement(QuantitySelector, {
        quantity: selectedQuantity || 1,
        minimumQuantity: 1,
        maximumQuantity: maxOrderableQuantity,
        onDecreaseQuantity: onDecreaseQuantity,
        onIncreaseQuantity: onIncreaseQuantity,
        isDisabled: !isOrderable
    }), /*#__PURE__*/ React.createElement(StockIndicator, {
        stockCount: availableQuantity,
        allowBackOrder: isOrderable,
        channelAvailability: variant.channelAvailability
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details"
    }, isDeliveryFullDateEnabled && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details__delivery-indicator"
    }, /*#__PURE__*/ React.createElement(DeliveryIndicator, {
        view: "text",
        items: [
            {
                sku: variant.sku,
                quantity
            }
        ]
    })), /*#__PURE__*/ React.createElement("div", {
        ref: addToCartRef
    }, ctaButton), Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null), isSmallScreen && showStickyButton && variant.price && /*#__PURE__*/ React.createElement(StickyCallToAction, {
        button: ctaButton,
        price: /*#__PURE__*/ React.createElement(Price, {
            value: (_discountedPrice = variant.price.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : variant.price.originalPrice,
            currency: currency,
            centAmount: true
        })
    }), productTypeUsps && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), /*#__PURE__*/ React.createElement(ProductDetailUsps, {
        items: productTypeUsps
    }))))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-solutions__description"
    }, /*#__PURE__*/ React.createElement(Description, swcHelpers.extends({}, descriptionConfig, {
        variant: variant
    }))), disclaimer && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__disclaimer product-detail-lenses__disclaimer"
    }, /*#__PURE__*/ React.createElement(Panel, {
        title: disclaimer.title
    }, disclaimer.description)));
};

const SolutionsContainer = ({ activeSku , addToCartRef , productTypeUsps , stickyTop , variant , product , showStickyButton , specificationConfiguration , handleVariantPick , renderAddToCartButton , maxOrderableQuantity , onCTAClick , productImageGallery , disclaimer ,  })=>{
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { currency , locale , getLabel  } = useIntl();
    const { availability  } = variant;
    const variants = React.useMemo(()=>[
            product.masterVariant,
            ...product.variants
        ]
    , [
        product.masterVariant,
        product.variants, 
    ]);
    const { isProductLabelEnabled  } = useFeatureToggles();
    const productViewHistory = useProductViewHistory();
    React.useEffect(()=>{
        productViewHistory.remove(variants.map((v)=>v.sku || ''
        ));
        productViewHistory.add(variant.sku);
    // Adding productViewHistory to deps will cause an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        variants,
        variant.sku
    ]);
    const reviews = useReviewsContext();
    React.useEffect(()=>{
        if (reviews.enabled) {
            reviews.dispatch(Actions$1.updateReviewDisplay({
                variantId: activeSku
            }));
        }
    }, [
        activeSku,
        reviews
    ]);
    React.useEffect(()=>{
        pushPdpEventToDataLayer(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, activeSku, currency);
    }, [
        activeSku
    ]);
    const [selectedQuantity, setSelectedQuantity] = React.useState(1);
    var ref;
    const availableQuantity = (ref = availability === null || availability === void 0 ? void 0 : availability.availableQuantity) !== null && ref !== void 0 ? ref : 0;
    const maxOrderableQuantityCalculated = maxOrderableQuantity !== null && maxOrderableQuantity !== void 0 ? maxOrderableQuantity : 5;
    const isOrderable = (variant === null || variant === void 0 ? void 0 : variant.channelAvailability) === 'ONLINE';
    const onIncreaseQuantity = React.useCallback(()=>(setSelectedQuantity((prevSelectedQuantity)=>prevSelectedQuantity + 1
        ), triggerDataLayerEvent$1(EventAction.QuantityIncrease))
    , []);
    const onDecreaseQuantity = React.useCallback(()=>(setSelectedQuantity((prevSelectedQuantity)=>prevSelectedQuantity - 1
        ), triggerDataLayerEvent$1(EventAction.QuantityDecrease))
    , []);
    const brandLink = useBrandLink(product);
    const brandModel = `${variant.contactLensCareType} ${variant.packageOption}`;
    const labels = {
        selectAmount: getLabel('products.solutions.selectAmount'),
        selectVolume: getLabel('products.solutions.selectVolume')
    };
    const descriptionConfig = {
        specificationVariant: getActiveVariant$1(product, activeSku),
        specificationConfiguration
    };
    var _discountedPrice;
    const calculatedTotalPrice = selectedQuantity > 1 ? selectedQuantity * ((_discountedPrice = variant.price.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : variant.price.originalPrice) : null;
    const ctaButton = /*#__PURE__*/ React.createElement(CTAButton, {
        isOrderable: isOrderable,
        renderAddToCartButton: renderAddToCartButton,
        activeSku: activeSku,
        calculatedPrice: calculatedTotalPrice,
        currency: currency,
        selectedQuantity: selectedQuantity,
        addToCartCallback: onCTAClick
    });
    const packageSelector = React.useMemo(()=>{
        const handleVariantPickAndEvent = (event, sku, pickedSolutionsVolume)=>{
            handleVariantPick(event, sku);
            triggerDataLayerEvent$1(EventAction.SelectVolume, pickedSolutionsVolume);
        };
        return variants.length > 1 ? /*#__PURE__*/ React.createElement(PackageSelector, {
            variants: variants,
            label: labels.selectVolume,
            selectedPackage: activeSku,
            handleVariantPick: handleVariantPickAndEvent
        }) : null;
    }, [
        activeSku,
        labels.selectVolume,
        handleVariantPick,
        variants
    ]);
    return /*#__PURE__*/ React.createElement(Solutions, {
        addToCartRef: addToCartRef,
        availableQuantity: availableQuantity,
        brandLink: brandLink,
        brandModel: brandModel,
        currency: currency,
        ctaButton: ctaButton,
        isSmallScreen: isSmallScreen,
        labels: labels,
        productTypeUsps: productTypeUsps,
        showStickyButton: showStickyButton,
        stickyTop: stickyTop,
        variant: variant,
        descriptionConfig: descriptionConfig,
        productImageAlt: getLocalizedValue(product.name, locale),
        packageSelector: packageSelector,
        selectedQuantity: selectedQuantity,
        onDecreaseQuantity: onDecreaseQuantity,
        onIncreaseQuantity: onIncreaseQuantity,
        isOrderable: isOrderable,
        isProductLabelEnabled: isProductLabelEnabled,
        maxOrderableQuantity: maxOrderableQuantityCalculated,
        productImageGallery: productImageGallery,
        disclaimer: disclaimer,
        quantity: selectedQuantity,
        calculatedTotalPrice: calculatedTotalPrice
    });
};

const RX_SUN_CONFIG_EVENT = 'RxSunConfigEvent';
const triggerDataLayerEvent = (eventAction, options)=>{
    const { isWithRx  } = options;
    DataLayer.pushEvent({
        event: RX_SUN_CONFIG_EVENT,
        eventAction,
        eventLabel: isWithRx ? 'prescription lenses' : 'non-prescription lenses'
    });
};

const WITH_RX = 'with-rx';
const WITHOUT_RX = 'without-rx';
const isRxRadioSelection = (value)=>value === WITH_RX || value === WITHOUT_RX
;
const Sunglasses = ({ activeSku , dispatch , ean , addToCartRef , formatProductUrl , product , productTypeUsps , showStickyButton , staticsUrl , variant , specificationConfiguration , deliveryResolver , stickyTop , onCTAClick , onPriceChange , opticianForm , configuratorDocument , secondaryCallToAction , handleConversionEvent , productImageGallery , disclaimer , brandPromotions , storesRoute , bookAppointmentRoute ,  })=>{
    var ref2;
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { getLabel , currency , locale  } = useIntl();
    const productViewHistory = useProductViewHistory();
    const reviews = useReviewsContext();
    const brandLink = useBrandLink(product);
    const [selectWithRxLens, setSelectWithRxLens] = React.useState(WITHOUT_RX);
    const [isConfiguratorOpen, setIsConfiguratorOpen] = React.useState(false);
    const { isBynderImagesEnabled , isDeliveryFullDateEnabled , isProductLabelEnabled ,  } = useFeatureToggles();
    const { Slots  } = useProductDetailSlots();
    const variants = [
        product.masterVariant,
        ...product.variants
    ];
    const { channelAvailability , allowBackOrder , excludedFromCheckout , price , isOfferedWithPrescriptions , tag ,  } = variant;
    // Add SKU to viewed product history
    React.useEffect(()=>{
        // We only want 1 SKU(variant) per product to be in the view history
        productViewHistory.remove(variants.map((v)=>v.sku || ''
        ));
        productViewHistory.add(variant.sku);
    }, [
        variants.length,
        variant.sku
    ]);
    // Make sure the ReviewsDisplay component gets updated with the currently active SKU
    React.useEffect(()=>{
        if (reviews.enabled) {
            reviews.dispatch(Actions$1.updateReviewDisplay({
                variantId: activeSku
            }));
        }
    }, [
        activeSku,
        reviews.enabled
    ]);
    React.useEffect(()=>{
        triggerDataLayerEvent('view step', {
            isWithRx: selectWithRxLens === WITH_RX
        });
    // Deps intentionally left empty. This effect should only run once.
    }, []);
    React.useEffect(()=>{
        pushPdpEventToDataLayer(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, activeSku, currency);
    }, [
        activeSku
    ]);
    const shouldOpenConfigurator = isOfferedWithPrescriptions && selectWithRxLens === WITH_RX;
    const onRxRadioChange = React.useCallback((newSelection)=>{
        if (isRxRadioSelection(newSelection) && selectWithRxLens !== newSelection) {
            setSelectWithRxLens(newSelection);
            triggerDataLayerEvent('click on button', {
                isWithRx: newSelection === WITH_RX
            });
        }
    }, [
        selectWithRxLens
    ]);
    /**
   * RxGlassesConfigurator utils
   */ const openConfiguratorButtonRef = React.useRef(null);
    const handleConfiguratorClose = React.useCallback(()=>{
        var ref;
        setIsConfiguratorOpen(false);
        openConfiguratorButtonRef === null || openConfiguratorButtonRef === void 0 ? void 0 : (ref = openConfiguratorButtonRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    }, [
        openConfiguratorButtonRef
    ]);
    const handleConfiguratorOpen = React.useCallback(()=>{
        handleConversionEvent();
        setIsConfiguratorOpen(true);
    }, []);
    const CTAButton = shouldOpenConfigurator ? /*#__PURE__*/ React.createElement(RxGlassesCTA, {
        bookAppointmentRoute: bookAppointmentRoute,
        action: channelAvailability === 'ONLINE' ? 'OPEN_CONFIGURATOR' : 'OPEN_CONFIGURATOR_UNAVAILABLE',
        onClickWhenOrderable: handleConfiguratorOpen,
        buttonRef: openConfiguratorButtonRef,
        handleConversionEvent: handleConversionEvent
    }) : /*#__PURE__*/ React.createElement(NonRxProductCTA, {
        storesRoute: storesRoute,
        action: channelAvailability === 'ONLINE' ? 'ADD_TO_CART' : 'ADD_TO_CART_UNAVAILABLE',
        handleConversionEvent: handleConversionEvent,
        addToCartConfig: {
            activeSku,
            variantUrl: formatProductUrl({
                productType: variant.productType,
                sku: activeSku || '',
                slug: product.slug
            }),
            onCTAClick
        }
    });
    const activeVariant = getActiveVariant$1(product, activeSku);
    const productFeatures = getProductFeatures(variant);
    var ref1, _discountedPrice;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main product-detail__main--sunglasses"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "desktop-hidden product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitle, {
        title: `${variant.brand} ${variant.modelName}`,
        subtitle: variant.brand,
        href: brandLink
    }), /*#__PURE__*/ React.createElement(BrandPromotion, {
        brandPromotions: brandPromotions || [],
        brandName: variant.brand,
        className: "product-detail__brand-promotion"
    }), isSmallScreen && /*#__PURE__*/ React.createElement(ReviewSnippet, {
        productId: product.masterVariant.sku,
        variantId: activeSku
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, isOfferedWithPrescriptions && /*#__PURE__*/ React.createElement(PrescriptionAvailabilityIndicator, {
        className: "product-detail__prescription-availability-indicator"
    }), isBynderImagesEnabled ? productImageGallery : /*#__PURE__*/ React.createElement(ProductVisualSwitcher, {
        productImages: variant.images,
        alt: getProductAltTag(variant.name, variants.find((v)=>v.sku === activeSku
        ) || variants[0], 'Sunglasses', locale),
        vtoProductEnabled: product.masterVariant.vtoEnabled,
        sku: activeSku,
        ean: ean
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__description"
    }, /*#__PURE__*/ React.createElement(ProductDetailDescription, {
        title: getLabel('products.contactLenses.header.details'),
        header: variant.header,
        description: variant.description,
        usps: /*#__PURE__*/ React.createElement(List, {
            icon: "checkmark",
            items: variant.usps
        })
    }, /*#__PURE__*/ React.createElement(ProductDetailFeatures, {
        productFeatures: productFeatures
    }), brandPromotions && /*#__PURE__*/ React.createElement(BrandPromotion, {
        brandPromotions: brandPromotions || [],
        brandName: variant.brand,
        className: "product-detail__brand-promotion--clickable",
        isClickable: true
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__specification"
    }, /*#__PURE__*/ React.createElement(ProductDetailSpecification, {
        configuration: specificationConfiguration,
        variant: activeVariant
    })), disclaimer && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__disclaimer"
    }, /*#__PURE__*/ React.createElement(Panel, {
        title: disclaimer.title
    }, disclaimer.description)), /*#__PURE__*/ React.createElement("section", {
        className: "product-detail__aside",
        "aria-label": `${variant.brand} ${variant.modelName}`
    }, /*#__PURE__*/ React.createElement(Sticky, {
        top: stickyTop || 0,
        bottomBoundary: '.product-detail',
        enabled: !isSmallScreen
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mobile-hidden"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitle, {
        title: `${variant.brand} ${variant.modelName}`,
        subtitle: variant.brand,
        href: brandLink
    }), /*#__PURE__*/ React.createElement(BrandPromotion, {
        brandPromotions: brandPromotions || [],
        brandName: variant.brand,
        className: "product-detail__brand-promotion"
    })), !isProductLabelEnabled && tag && tag.value && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__product-tag"
    }, /*#__PURE__*/ React.createElement(ProductTag, {
        tag: tag
    })), /*#__PURE__*/ React.createElement("div", {
        className: classnames('product-detail__specification-prices', {
            'product-detail__specification-prices--has-discount': !!variant.discountText
        }),
        role: "group",
        "aria-label": getLabel('products.screenreader.priceInformation')
    }, price && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__price-container"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        originalPrice: price.originalPrice,
        discountedPrice: price.discountedPrice,
        currency: currency
    })), isProductLabelEnabled && /*#__PURE__*/ React.createElement(ProductDiscountLabel, {
        title: variant.discountText
    }), !isProductLabelEnabled && variant.discounted && /*#__PURE__*/ React.createElement(Discount, {
        label: variant.discountText,
        discount: variant.discounted,
        isWide: true
    }))), Slots.AfterPrice ? /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__after-price-slot"
    }, /*#__PURE__*/ React.createElement(Slots.AfterPrice, null)) : null, !isSmallScreen && /*#__PURE__*/ React.createElement(ReviewSnippet, {
        productId: product.masterVariant.sku,
        variantId: activeSku
    }), /*#__PURE__*/ React.createElement(VariantPicker, {
        variantItems: getVariants$1(variants, getLocalizedValue(product.slug, locale), staticsUrl, variant.productType, locale, isBynderImagesEnabled),
        activeVariantSku: variant.sku,
        activeVariantLabel: getSunVariantPickerLabel(variant),
        enableStockIndicator: !excludedFromCheckout,
        stockCount: (ref1 = (ref2 = variant.availability) === null || ref2 === void 0 ? void 0 : ref2.availableQuantity) !== null && ref1 !== void 0 ? ref1 : 0,
        isAllowBackOrder: !!variant.allowBackOrder,
        formatProductUrl: formatProductUrl,
        channelAvailability: variant.channelAvailability,
        dispatch: dispatch
    }), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details"
    }, isOfferedWithPrescriptions && /*#__PURE__*/ React.createElement(SunglassesRxableSelect, {
        onChange: onRxRadioChange,
        selectedValue: selectWithRxLens
    }), !excludedFromCheckout && isDeliveryFullDateEnabled && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details__delivery-indicator"
    }, /*#__PURE__*/ React.createElement(DeliveryIndicator, {
        view: "text",
        items: [
            {
                sku: activeSku,
                quantity: 1
            }
        ]
    })), /*#__PURE__*/ React.createElement("div", {
        ref: addToCartRef
    }, CTAButton, secondaryCallToAction && secondaryCallToAction(variant), activeVariant.vtoEnabled && /*#__PURE__*/ React.createElement(TryOnButton, null)), Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null), isSmallScreen && showStickyButton && variant.price && /*#__PURE__*/ React.createElement(StickyCallToAction, {
        button: CTAButton,
        price: /*#__PURE__*/ React.createElement(Price, {
            value: (_discountedPrice = variant.price.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : variant.price.originalPrice,
            currency: currency,
            centAmount: true,
            type: variant.price.discountedPrice ? 'discount' : 'default'
        })
    }), (!excludedFromCheckout || productTypeUsps) && /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), !excludedFromCheckout && !isDeliveryFullDateEnabled && /*#__PURE__*/ React.createElement(DeliveryIndicator, {
        availability: [
            activeVariant.availability
        ],
        deliveryResolver: deliveryResolver,
        view: "icon",
        className: "product-detail__delivery-indicator"
    }), productTypeUsps && /*#__PURE__*/ React.createElement(ProductDetailUsps, {
        items: productTypeUsps
    }))), /*#__PURE__*/ React.createElement(RxGlassesConfigurator, {
        id: "rxSun",
        frame: product,
        frameSku: activeSku,
        isOpen: isConfiguratorOpen,
        triggerButtonRef: openConfiguratorButtonRef,
        onModalClose: handleConfiguratorClose,
        onPriceChange: onPriceChange,
        formatProductUrl: formatProductUrl,
        opticianForm: opticianForm,
        configuratorDocument: configuratorDocument,
        usps: productTypeUsps
    }));
};

const ProductDetail = ({ frameSize , colorFeatureIcons , children , isPrescriptionInfoEnabled , isPrescriptionExtraInfoEnabled , allowBackOrder , maxOrderableQuantity , deliveryResolver , deliveryResolverFactory , prescriptionModalContent , opticianForm , dateFormat , price , productTypeUsps , additionalUsps , configuratorDocument , formatProductUrl , specificationConfiguration , prescriptionInfoAdditionalContent , secondaryCallToAction , vtoBanner , disclaimer , brandPromotions ,  })=>{
    const { routes , activeSku , activeVariant , product , productType , staticsUrl , dispatch , renderAddToCartButton ,  } = useProductDetailContext();
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const algoliaAnalytics = useAlgoliaAnalytics();
    const { queryId: storedQueryId  } = algoliaAnalytics.algoliaAnalyticsData || {};
    const algoliaQueryId = React.useRef(storedQueryId);
    const containerRef = React.useRef(null);
    const [ctaRef, ctaInview] = useInView();
    const showStickyButton = isMobile && !ctaInview;
    const { getLabel , hasLabel , locale , currency  } = useIntl();
    const [topOffset, setTopOffset] = React.useState(0);
    const [calculatedAddToCartPrice1, setCalculatedAddToCartPrice, ] = React.useState(null);
    React.useEffect(()=>{
        if (storedQueryId) {
            algoliaQueryId.current = storedQueryId;
        }
    }, [
        storedQueryId
    ]);
    React.useEffect(()=>{
        // make sure the queryId will not be used when a user doesn't click the CTA. For example: user clicks on a product suggestion and clicks the CTA there.
        algoliaQueryId.current && algoliaAnalytics.clearQueryId();
    }, [
        algoliaQueryId.current
    ]);
    React.useEffect(()=>{
        // set offset based on headerHeight
        setTopOffset(calculateHeaderHeight());
    }, []);
    const ean1 = React.useMemo(()=>{
        const ean = getAttrValue(product.masterVariant, 'supplierEAN');
        if (typeof ean === 'string') {
            return ean;
        }
        return undefined;
    }, [
        product
    ]);
    const stickerText = React.useMemo(()=>{
        if (CommerceToolsApi.isSunglasses(productType)) {
            return getLabel('sunglasses.sticker.text', {
                hideLabelKey: true
            });
        }
        if (CommerceToolsApi.isLenses(productType)) {
            const pricePerDay = getAttrValue(product.masterVariant, 'pricePerDay');
            const centAmount = isPlainObject(pricePerDay) ? pricePerDay.centAmount : 0;
            return pricePerDay && hasLabel('products.perDay') ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Price, {
                value: centAmount,
                className: "product-discount-label__price-per-day",
                currency: currency
            }), /*#__PURE__*/ React.createElement("span", {
                className: "product-discount-label__price-per-day-unit"
            }, getLabel('products.perDay'))) : getLabel('contactLenses.sticker.text', {
                hideLabelKey: true
            });
        }
        return '';
    }, [
        productType,
        product
    ]);
    const ImageGallery = React.useMemo(()=>/*#__PURE__*/ React.createElement(ProductImageGalleryContainer, {
            activeVariant: activeVariant,
            product: product,
            vtoBanner: vtoBanner
        })
    , [
        activeVariant,
        product,
        vtoBanner
    ]);
    const handleVariantPick = React.useCallback((event, sku)=>{
        dispatch(ProductDetailActions.updateActiveVariant({
            sku
        }));
        const newUrl = formatProductUrl({
            sku,
            slug: product.slug,
            productType
        });
        // will pass the current queryString in the url of the variant picker
        const queryString = typeof window !== 'undefined' ? window.location.search : '';
        window.history.replaceState(null, '', `${newUrl}${queryString}`);
        // Allow customers to open another variant in a new tab or window, otherwise prevent navigation
        if (event && !isModifiedClickEvent(event)) {
            event.preventDefault();
        }
    }, [
        dispatch,
        formatProductUrl,
        product.slug,
        productType
    ]);
    /**
   * This callback is used in the Prescription Glasses configurator
   * to supply the full bundle price (Frame, LensType, Package, and Add-ons)
   * to the AddToCartNotification
   */ const handlePrescriptionGlassesPriceChange = React.useCallback((bundlePrice)=>{
        setCalculatedAddToCartPrice(bundlePrice);
    }, []);
    /**
   * This handler is called from the Lenses page whenever the
   * price changes from their prescription selection.
   * This price object is supplied to the AddToCartNotification
   */ const handleLensPriceChange = React.useCallback(({ calculatedPrice , calculatedDiscountPrice  })=>{
        const { originalPrice , discountedPrice  } = calculatedAddToCartPrice1 ? calculatedAddToCartPrice1 : {
            originalPrice: 0,
            discountedPrice: undefined
        };
        if (originalPrice !== calculatedPrice || discountedPrice !== calculatedDiscountPrice) {
            const calculatedAddToCartPrice = {
                originalPrice: calculatedPrice,
                discountedPrice: calculatedDiscountPrice
            };
            setCalculatedAddToCartPrice(calculatedAddToCartPrice);
        }
    }, []);
    /**
   * Sends a conversion event to Algolia
   */ const handleConversionEvent = React.useCallback(()=>{
        algoliaAnalytics.handleConversionEvent(activeSku, algoliaQueryId.current);
    }, [
        activeSku,
        algoliaAnalytics
    ]);
    if (!productType || !activeVariant) {
        return null;
    }
    const commonProps = {
        activeSku,
        ean: ean1,
        addToCartRef: ctaRef,
        dispatch,
        formatProductUrl,
        frameSize,
        product,
        productTypeUsps,
        showStickyButton,
        staticsUrl,
        specificationConfiguration,
        stickyTop: topOffset,
        onCTAClick: handleConversionEvent,
        renderAddToCartButton,
        handleConversionEvent,
        disclaimer
    };
    const variantUrl = formatProductUrl({
        productType: activeVariant.productType,
        sku: activeVariant.sku,
        slug: product.slug
    });
    const productUrl = `${variantUrl}#product`;
    const subscriptionProductSKU = getAttrValue(product.masterVariant, 'subscriptionProductSKU');
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail"
    }, /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        className: "site-container product-detail__container"
    }, CommerceToolsApi.isLenses(activeVariant) && /*#__PURE__*/ React.createElement(LensBundleProvider, {
        subscriptionProductSKU: subscriptionProductSKU
    }, /*#__PURE__*/ React.createElement(LensesContainer, swcHelpers.extends({}, commonProps, {
        colorFeatureIcons: colorFeatureIcons,
        stickerText: stickerText,
        variant: activeVariant,
        onPriceChange: handleLensPriceChange,
        specificationConfiguration: specificationConfiguration,
        clsUsps: additionalUsps,
        productImageGallery: ImageGallery,
        /**
               * Stock configurations props
               */ maxOrderableQuantity: maxOrderableQuantity,
        deliveryResolverFactory: deliveryResolverFactory,
        allowBackOrder: allowBackOrder,
        /**
               * Prescription props
               */ isPrescriptionInfoEnabled: isPrescriptionInfoEnabled,
        prescriptionModalContent: prescriptionModalContent,
        opticianForm: opticianForm,
        dateFormat: dateFormat,
        isPrescriptionExtraInfoEnabled: isPrescriptionExtraInfoEnabled,
        prescriptionInfoAdditionalContent: prescriptionInfoAdditionalContent,
        hasSubscriptions: !!subscriptionProductSKU
    }))) || CommerceToolsApi.isFrames(activeVariant) && /*#__PURE__*/ React.createElement(Frames, swcHelpers.extends({}, commonProps, {
        bookAppointmentRoute: routes['book-appointment'],
        configuratorDocument: configuratorDocument,
        onPriceChange: handlePrescriptionGlassesPriceChange,
        variant: activeVariant,
        specificationConfiguration: specificationConfiguration,
        price: price,
        opticianForm: opticianForm,
        secondaryCallToAction: secondaryCallToAction,
        productImageGallery: ImageGallery,
        storesRoute: routes.stores
    }), children) || CommerceToolsApi.isSunglasses(activeVariant) && /*#__PURE__*/ React.createElement(Sunglasses, swcHelpers.extends({}, commonProps, {
        onPriceChange: handlePrescriptionGlassesPriceChange,
        configuratorDocument: configuratorDocument,
        opticianForm: opticianForm,
        variant: activeVariant,
        specificationConfiguration: specificationConfiguration,
        deliveryResolver: deliveryResolver,
        secondaryCallToAction: secondaryCallToAction,
        productImageGallery: ImageGallery,
        brandPromotions: brandPromotions,
        storesRoute: routes.stores,
        bookAppointmentRoute: routes['book-appointment']
    })) || CommerceToolsApi.isSolutions(activeVariant) && /*#__PURE__*/ React.createElement(SolutionsContainer, swcHelpers.extends({}, commonProps, {
        variant: activeVariant,
        handleVariantPick: handleVariantPick,
        specificationConfiguration: specificationConfiguration,
        maxOrderableQuantity: maxOrderableQuantity,
        productImageGallery: ImageGallery
    })) || CommerceToolsApi.isReadyReaders(activeVariant) && /*#__PURE__*/ React.createElement(ReadyReadersContainer, swcHelpers.extends({}, commonProps, {
        formatProductUrl: formatProductUrl,
        handleConversionEvent: handleConversionEvent,
        handleVariantPick: handleVariantPick,
        productImageGallery: ImageGallery,
        specificationConfiguration: specificationConfiguration,
        variant: activeVariant,
        storesRoute: routes.stores
    })) || CommerceToolsApi.isAccessories(activeVariant) && /*#__PURE__*/ React.createElement(AccessoriesContainer, swcHelpers.extends({}, commonProps, {
        formatProductUrl: formatProductUrl,
        handleConversionEvent: handleConversionEvent,
        productImageGallery: ImageGallery,
        specificationConfiguration: specificationConfiguration,
        variant: activeVariant,
        storesRoute: routes.stores
    }))), /*#__PURE__*/ React.createElement(WebPage, {
        url: productUrl,
        pageType: "ProductDetail",
        name: activeVariant.brand,
        description: activeVariant.description
    }));
};

function getProductSeoInfo(staticsUrl, locale, product, productTypeLabel, isBynderImagesEnabled, sku) {
    if (!(product === null || product === void 0 ? void 0 : product.masterVariant)) {
        return {};
    }
    const activeVariant = getActiveVariant$1(product, sku);
    const productTitle = getProductTitle(activeVariant, product, locale);
    const title = productTypeLabel ? productTypeLabel.concat(' ', productTitle) : productTitle;
    const description = getProductDescription(product, activeVariant, locale);
    const imageUrl = getProductImageUrl(activeVariant, staticsUrl, isBynderImagesEnabled);
    return {
        title,
        description,
        imageUrl
    };
}
function getProductTitle(variant, product, locale) {
    var ref, ref1;
    if (variant.metaTitle) {
        return getLocalizedValue(variant.metaTitle, locale);
    } else if (product.metaTitle) {
        return getLocalizedValue(product.metaTitle, locale);
    }
    var ref2;
    const productType = (ref2 = (ref = product.productType) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref2 !== void 0 ? ref2 : '';
    return getProductTitle$1(productType, product, variant, locale);
}
function getProductDescription(product, variant, locale) {
    if (variant.metaDescription) {
        return getLocalizedValue(variant.metaDescription, locale);
    } else if (product.metaDescription) {
        return getLocalizedValue(product.metaDescription, locale);
    }
    const description = getLocalizedAttrValue(variant, 'description', locale) || getLocalizedAttrValue(product.masterVariant, 'description', locale);
    return description;
}
function getProductImageUrl(variant, staticsUrl, isBynderImagesEnabled) {
    var ref, ref3;
    if (isBynderImagesEnabled) {
        var ref4;
        const imageUrl = getFrontImage((ref4 = variant.media) === null || ref4 === void 0 ? void 0 : ref4.images).url;
        return `${imageUrl}?q=70&w=1200&h=630&fit=fill&fm=jpeg`;
    }
    var ref5;
    const imageUrl = (ref5 = variant === null || variant === void 0 ? void 0 : (ref = variant.images) === null || ref === void 0 ? void 0 : (ref3 = ref[0]) === null || ref3 === void 0 ? void 0 : ref3.url) !== null && ref5 !== void 0 ? ref5 : '';
    return `${staticsUrl}${imageUrl}?q=70&w=1200&h=630&fit=fill&fm=jpeg`;
}

const CrossSellItem = ({ imageUrl , onUpdate , price , quantity , SKU , subTitle , title , intl , maxQuantity ,  })=>{
    const increaseQuantity = React.useCallback(()=>{
        onUpdate('increment', SKU);
    }, [
        onUpdate,
        SKU
    ]);
    const decreaseQuantity = React.useCallback(()=>{
        onUpdate('decrement', SKU);
    }, [
        onUpdate,
        SKU
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('cross-sell-item', {
            _is_active: quantity > 0
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "cross-sell-item__image-holder"
    }, /*#__PURE__*/ React.createElement("img", {
        className: "cross-sell-item__image",
        src: `${imageUrl}?w=300&auto=format`,
        alt: title
    })), /*#__PURE__*/ React.createElement("div", {
        className: "cross-sell-item__title"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        className: "cross-sell-item__title-heading"
    }, title)), subTitle ? /*#__PURE__*/ React.createElement("span", {
        className: "cross-sell-item__subtitle"
    }, subTitle) : null, price && /*#__PURE__*/ React.createElement(PriceTag, {
        className: "cross-sell-item__price",
        currency: intl.currency,
        discountedPrice: price.discountedPrice,
        originalPrice: price.originalPrice
    }), /*#__PURE__*/ React.createElement("div", {
        className: "cross-sell-item__quantity-selector"
    }, /*#__PURE__*/ React.createElement(QuantitySelector, {
        maximumQuantity: maxQuantity,
        quantity: quantity,
        minimumQuantity: 0,
        onDecreaseQuantity: decreaseQuantity,
        onIncreaseQuantity: increaseQuantity
    })));
};
var CrossSellItem$1 = withIntl(CrossSellItem);

const CrossSellBlock = ({ onUpdateItem , products , maxQuantity  })=>{
    const crossSellItems = products && products.map(({ imageUrl , price , quantity , SKU , subTitle , title  })=>/*#__PURE__*/ React.createElement(CrossSellItem$1, {
            imageUrl: imageUrl,
            key: SKU,
            onUpdate: onUpdateItem,
            price: price,
            quantity: quantity,
            SKU: SKU,
            subTitle: subTitle,
            title: title,
            maxQuantity: maxQuantity
        })
    );
    return /*#__PURE__*/ React.createElement("div", {
        className: "cross-sell"
    }, crossSellItems);
};

class LensPacksItem extends React.Component {
    getDioptries(str) {
        return str.replace(/[a-zA-Z]/g, '').replace(/\s+/g, '').replace(/[{()}]/g, '');
    }
    render() {
        const { isSelected , intl , currentBreakpoint , price , item , useIncludedLensPack  } = this.props;
        // TODO: type this properly without any but it's way to messy atm
        // Special instance where the enum key is needed
        const packAttribute = item.attributes.find((attribute)=>attribute.name === 'pack'
        );
        const type = isPlainObject(packAttribute) ? packAttribute.value.key : '';
        const packName = isPlainObject(packAttribute) && getLocalizedValue(packAttribute.value, intl.locale);
        const thicknessValue = getLocalizedAttrValue(item, 'thickness', intl.locale);
        const thickness = thicknessValue.split('(')[0];
        const dioptries = this.getDioptries(thicknessValue);
        const voucher = getAttrValue(item, 'voucher');
        const voucherValue = isPlainObject(voucher) ? Number(voucher.centAmount) : 0;
        const isSelectedClass = isSelected ? '_is_selected' : '';
        if (currentBreakpoint === MediaQuery.BreakpointName.PHONE || currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE) {
            return /*#__PURE__*/ React.createElement("label", {
                className: `lens-packs-accordion-item lens-packs-accordion-item--${type} ${isSelectedClass}`
            }, /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-accordion-item__header"
            }, /*#__PURE__*/ React.createElement("input", {
                className: "lens-packs-accordion-item__radio",
                type: "radio",
                name: "ssp-lens-pack",
                value: type,
                "aria-checked": isSelected,
                checked: isSelected,
                onChange: this.handleChange
            }), /*#__PURE__*/ React.createElement(Heading, {
                variant: "smallest"
            }, packName)), /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-accordion-item__body"
            }, /*#__PURE__*/ React.createElement("ul", null, item.benefits.map((benefit)=>benefit.value && /*#__PURE__*/ React.createElement("li", {
                    key: benefit.name
                }, benefit.label)
            )), /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-accordion-item__price"
            }, item.isIncluded ? intl.getLabel('products.included') : /*#__PURE__*/ React.createElement(React.Fragment, null, "+", ' ', /*#__PURE__*/ React.createElement(Price, {
                value: price.value.centAmount,
                centAmount: true,
                currency: intl.currency
            }))), !item.isIncluded && !!voucherValue && /*#__PURE__*/ React.createElement("p", {
                className: "lens-packs-accordion-item__voucher"
            }, intl.getLabel('products.ssp.voucher.label'), /*#__PURE__*/ React.createElement(Price, {
                value: voucherValue,
                centAmount: true,
                currency: intl.currency
            }))));
        } else {
            const visualFieldValue = getLocalizedAttrValue(item, 'visualField', intl.locale);
            const higherTitle = visualFieldValue ? 'lens-packs-cell--title--with-visual-field' : '';
            return /*#__PURE__*/ React.createElement("label", {
                className: `lens-packs-column ${isSelectedClass}`
            }, /*#__PURE__*/ React.createElement("div", {
                className: `lens-packs-cell lens-packs-cell--type lens-packs-cell--${type}`
            }, /*#__PURE__*/ React.createElement(Heading, {
                variant: "smallest"
            }, packName)), /*#__PURE__*/ React.createElement("div", {
                className: `lens-packs-cell lens-packs-cell--title ${higherTitle}`
            }, /*#__PURE__*/ React.createElement(Heading, {
                variant: "subheading1"
            }, thickness), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("small", {
                className: "lens-packs-cell__dioptry"
            }, "(", dioptries, " ", intl.getLabel('products.unit.dioptries'), ")")), visualFieldValue && /*#__PURE__*/ React.createElement("small", {
                className: "lens-packs-cell__visual-field"
            }, visualFieldValue)), item.benefits.map((benefit)=>{
                const checked = benefit.value ? 'check' : 'no-check';
                return /*#__PURE__*/ React.createElement("div", {
                    key: benefit.name,
                    className: `lens-packs-cell lens-packs-cell--${checked}`
                });
            }), /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-cell lens-packs-cell--footer"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-cell__price"
            }, useIncludedLensPack && item.isIncluded ? intl.getLabel('products.included') : /*#__PURE__*/ React.createElement("span", null, useIncludedLensPack && '+ ', ' ', /*#__PURE__*/ React.createElement(Price, {
                value: price.value.centAmount,
                centAmount: true,
                currency: intl.currency
            }))), !item.isIncluded && !!voucherValue && /*#__PURE__*/ React.createElement("p", {
                className: "lens-packs-cell__voucher"
            }, /*#__PURE__*/ React.createElement("small", null, intl.getLabel('products.ssp.voucher.label')), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement(Price, {
                value: voucherValue,
                centAmount: true,
                currency: intl.currency
            })), /*#__PURE__*/ React.createElement("input", {
                className: "lens-packs-cell__radio",
                type: "radio",
                name: "ssp-lens-pack",
                value: type,
                "aria-checked": isSelected,
                checked: isSelected,
                onChange: this.handleChange
            })));
        }
    }
    constructor(...args){
        super(...args);
        this.handleChange = ()=>{
            this.props.onChange(this.props.value);
        };
    }
}
var LensPacksItem$1 = withIntl(MediaQuery.WithBreakpoints(LensPacksItem));

class LensPacks extends React.Component {
    render() {
        const { packs , currentBreakpoint , intl  } = this.props;
        const hasBasicClass = packs.length === 6 ? 'lens-packs--has-basic' : '';
        const benefitLabels = packs.length > 0 && packs[0].benefits.map((benefit)=>benefit.label
        ) || [];
        if (currentBreakpoint === MediaQuery.BreakpointName.PHONE || currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE) {
            return /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-accordion"
            }, this.renderItems(), intl.getLabel('products.disclaimer', {
                hideLabelKey: true
            }) !== '' && /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-accordion__disclaimer"
            }, intl.getLabel('products.disclaimer')));
        } else {
            return /*#__PURE__*/ React.createElement("div", {
                className: `lens-packs ${hasBasicClass}`
            }, /*#__PURE__*/ React.createElement("label", {
                className: "lens-packs-column lens-packs-column--labels"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-cell lens-packs-cell--type lens-packs-cell--empty"
            }), /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-cell lens-packs-cell--title lens-packs-cell--empty"
            }), benefitLabels.map((label)=>{
                return /*#__PURE__*/ React.createElement("div", {
                    key: label,
                    className: "lens-packs-cell lens-packs-cell--label"
                }, /*#__PURE__*/ React.createElement("span", null, label));
            }), /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-cell lens-packs-cell--footer lens-packs-cell--empty"
            })), this.renderItems(), intl.getLabel('products.ssp.voucher.disclaimer', {
                hideLabelKey: true
            }) !== '' && /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs__disclaimer"
            }, intl.getLabel('products.ssp.voucher.disclaimer')));
        }
    }
    constructor(...args){
        super(...args);
        this.onPackChange = (packType)=>{
            this.props.onChange && this.props.onChange(packType);
        };
        this.renderItems = ()=>{
            const { packs , selectedPack , useIncludedLensPack  } = this.props;
            return packs.map((pack)=>{
                if (!pack.packType) {
                    console.error('No packType found');
                    return;
                }
                const price = pack.prices && pack.prices.length && pack.prices[0];
                if (!price) {
                    console.error(`No price found for pack with packType "${pack.packType}"`);
                    return;
                }
                return /*#__PURE__*/ React.createElement(LensPacksItem$1, {
                    key: pack.id,
                    item: pack,
                    value: pack.packType,
                    price: price,
                    isSelected: pack.packType === selectedPack,
                    onChange: this.onPackChange,
                    useIncludedLensPack: useIncludedLensPack
                });
            });
        };
    }
}
var LensPacks$1 = withIntl(MediaQuery.WithBreakpoints(LensPacks));

const createImpressionEvent$1 = (product, position, location, currency)=>{
    return {
        event: 'gvProductImpressions',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                impressions: [
                    swcHelpers.objectSpread({}, mapProductToDataLayerProductObject(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, product.masterVariant.sku || 'undefined'), {
                        list: location,
                        position
                    }), 
                ]
            }
        }
    };
};
const createInteractionEvent = (product, position, location, currency)=>{
    return {
        event: 'gvProductClick',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                click: {
                    actionField: {
                        list: location
                    },
                    products: [
                        swcHelpers.objectSpread({}, mapProductToDataLayerProductObject(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, product.masterVariant.sku || 'undefined'), {
                            position
                        }), 
                    ]
                }
            }
        }
    };
};

const context = {
    trackImpression: ()=>undefined
    ,
    trackInteraction: ()=>undefined
};
const ProductPromotionEventContext = /*#__PURE__*/ createContext(context);
const useProductPromotionEventContext = ()=>{
    return React.useContext(ProductPromotionEventContext);
};
const ProductPromotionEventProvider = ({ children , location  })=>{
    const { currency  } = useIntl();
    const handleImpression = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createImpressionEvent$1(product, position, location, currency));
    }, [
        currency,
        location
    ]);
    const handleInteraction = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createInteractionEvent(product, position, location, currency));
    }, [
        currency,
        location
    ]);
    return /*#__PURE__*/ React.createElement(ProductPromotionEventContext.Provider, {
        value: {
            trackImpression: handleImpression,
            trackInteraction: handleInteraction
        }
    }, children);
};

const ProductBanner = ({ products , formatProductUrl , className , isLoading =true , error , 'data-t': dataT , reimbursableLogos , onProductInteraction , onProductImpression ,  })=>{
    const isBigScreen = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    const isPhone = MediaQuery.useIsPhone();
    const itemsPerSlide = MediaQuery.useIsDesktop() ? 4 : 3;
    const classNames = classnames('product-banner', className);
    const { getLabel  } = useIntl();
    const productBlockProps = React.useMemo(()=>({
            formatProductUrl,
            showVariants: true,
            reimbursableLogos
        })
    , [
        formatProductUrl,
        reimbursableLogos
    ]);
    const renderProductBlock = React.useCallback((product, index)=>{
        return isLightProductModel(product) ? /*#__PURE__*/ React.createElement(AlgoliaProductBlock, swcHelpers.extends({
            onClick: ()=>{
                return onProductInteraction === null || onProductInteraction === void 0 ? void 0 : onProductInteraction(product, index);
            },
            onImpression: ()=>{
                return onProductImpression === null || onProductImpression === void 0 ? void 0 : onProductImpression(product, index);
            },
            key: product.id,
            product: product
        }, productBlockProps)) : /*#__PURE__*/ React.createElement(CommerceToolsProductBlock, swcHelpers.extends({
            onClick: ()=>{
                return onProductInteraction === null || onProductInteraction === void 0 ? void 0 : onProductInteraction(product, index);
            },
            onImpression: ()=>{
                return onProductImpression === null || onProductImpression === void 0 ? void 0 : onProductImpression(product, index);
            },
            key: product.id,
            product: product
        }, productBlockProps));
    }, [
        onProductImpression,
        onProductInteraction,
        productBlockProps
    ]);
    const carouselItems = React.useMemo(()=>{
        if (!isBigScreen || !products) {
            return [];
        }
        const items = [];
        const max = Math.ceil(products.length / itemsPerSlide);
        for(let i = 0; i < max; i++){
            const start = i * itemsPerSlide;
            const end = (i + 1) * itemsPerSlide;
            items.push(/*#__PURE__*/ React.createElement("div", {
                key: `product-banner-slide-${i}`,
                className: "product-banner__carousel-item"
            }, products.slice(start, end).map((product, index)=>renderProductBlock(product, index)
            )));
        }
        return items;
    }, [
        isBigScreen,
        products,
        itemsPerSlide,
        renderProductBlock
    ]);
    if (error) {
        return /*#__PURE__*/ React.createElement("div", {
            className: classNames,
            "data-t": dataT || 'product-banner'
        }, /*#__PURE__*/ React.createElement(Alert, {
            type: "warning",
            message: getLabel('products.banner.errorMessage')
        }));
    }
    if (isLoading) {
        return /*#__PURE__*/ React.createElement("div", {
            className: classNames,
            "data-t": dataT || 'product-banner'
        }, /*#__PURE__*/ React.createElement(Loader, null));
    }
    // Render a regular carousel on large screens and a slider carousel on smaller screens
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames,
        "data-t": dataT || 'product-banner'
    }, isBigScreen ? /*#__PURE__*/ React.createElement(Carousel, {
        pagination: false,
        navigation: true
    }, carouselItems) : /*#__PURE__*/ React.createElement(SliderCarousel, {
        itemWidth: isPhone ? 186 : 246
    }, products.map(renderProductBlock)));
};

const ProductBannerContainer = ({ skus , formatProductUrl , className  })=>{
    const { isLoading , products , error  } = useGetProductsBySku(skus);
    const classNames = classnames('product-banner', className);
    const { trackImpression , trackInteraction  } = useProductPromotionEventContext();
    return /*#__PURE__*/ React.createElement(ProductBanner, {
        products: products,
        formatProductUrl: formatProductUrl,
        isLoading: isLoading,
        error: error,
        className: classNames,
        onProductImpression: trackImpression,
        onProductInteraction: trackInteraction
    });
};

const ProductCatalogBreadcrumbs = ({ breadcrumbs  })=>{
    return /*#__PURE__*/ React__default.createElement(Container, {
        className: "product-catalog-breadcrumbs"
    }, /*#__PURE__*/ React__default.createElement(Breadcrumbs, {
        pages: breadcrumbs
    }));
};

// this little helper will get the price
// activeVariant is for the PDP page: e.g. Slots.AfterPrice, Slots.AfterCTA
// cart is for the checkout page: e.g. Slots.AfterTotal
const getPrice = (priceType, activeVariant, cart)=>{
    // get price for PDP page
    if (priceType === 'item' && activeVariant) {
        var ref, ref1;
        var ref2;
        return (ref2 = (ref = activeVariant.price) === null || ref === void 0 ? void 0 : ref.discountedPrice) !== null && ref2 !== void 0 ? ref2 : (ref1 = activeVariant.price) === null || ref1 === void 0 ? void 0 : ref1.originalPrice;
    }
    // get price for checkout page
    if (priceType === 'cart' && cart) {
        return cart.prices.totalPrice;
    }
    // this value will make component not render at all
    return 0;
};
// when enabledProduct is undefined this component will render for every product type
// when enabledProduct is set e.g. ['sunglasses'] it will render ONLY for this product type
const getExcludedProductType = (enabledProductTypes, productType)=>{
    if (!enabledProductTypes || !productType) {
        return false;
    }
    return !enabledProductTypes.some((product)=>product.toLowerCase() === productType.toLowerCase()
    );
};
const PromoteInstallments = ({ siteLogos , numberOfInstallments , minimumPrice , priceType , productType , enabledProductTypes , textAlign  })=>{
    const { currency , locale  } = useIntl();
    const { activeVariant  } = useProductDetailContext();
    const { cart  } = Context.useCart();
    const price = getPrice(priceType, activeVariant, cart);
    const excludedProductType = getExcludedProductType(enabledProductTypes, productType);
    const installmentPrice = formatPrice(locale, price / numberOfInstallments, currency, true);
    // conditions to render component
    if (price < minimumPrice || excludedProductType) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(PromoteInstallmentsLabel, {
        installmentPrice: installmentPrice,
        numberOfInstallments: numberOfInstallments,
        textAlign: textAlign,
        modalBodySlot: /*#__PURE__*/ React__default.createElement(PromoteInstallmentsModalSlot, {
            siteLogos: siteLogos,
            price: price,
            numberOfInstallments: numberOfInstallments
        })
    });
};

const Solution = ({ name , solutionType , volume , image , price , minimumQuantity , quantity , onQuantityChange  })=>{
    const isActive = quantity > 0 ? '_is_active' : '';
    return /*#__PURE__*/ React.createElement("div", {
        className: `solution ${isActive || ''}`
    }, /*#__PURE__*/ React.createElement("img", {
        src: image.url,
        alt: name
    }), /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        className: "solution__brand"
    }, name), /*#__PURE__*/ React.createElement("span", {
        className: "solution__type"
    }, solutionType, ", ", volume), /*#__PURE__*/ React.createElement(Price, {
        value: price,
        className: "solution__price"
    }), /*#__PURE__*/ React.createElement(QuantitySelector, {
        quantity: quantity,
        minimumQuantity: minimumQuantity,
        onDecreaseQuantity: ()=>onQuantityChange(quantity, 'decrease')
        ,
        onIncreaseQuantity: ()=>onQuantityChange(quantity, 'increase')
    }));
};

const ProductDiscountBar = ({ title  })=>/*#__PURE__*/ React.createElement("div", {
        className: "product-discount-bar"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "product-discount-bar__title"
    }, title))
;

const ProductFrameMeasurements = ({ product  })=>{
    const { activeSku  } = useProductDetailContext();
    const variant = getActiveVariant$1(product, activeSku);
    const bridgeWidth = Number(getAttrValue(variant, 'bridgeWidth'));
    const frameWidth = Number(getAttrValue(variant, 'frameWidth'));
    const lensHeight = Number(getAttrValue(variant, 'lensHeight'));
    const lensWidth = Number(getAttrValue(variant, 'lensWidth'));
    const templeLength = Number(getAttrValue(variant, 'templeLength'));
    const frameMeasurements = getFrameMeasurements(bridgeWidth, frameWidth, lensHeight, lensWidth, templeLength);
    if (!frameMeasurements) return null;
    return /*#__PURE__*/ React.createElement(FrameMeasurements, {
        measurements: frameMeasurements
    });
};

const ClickableImageWrapper = ({ onClick , url , labelId , hideFromKeyboardUser , children  })=>{
    const sharedProps = {
        className: 'promotion-block__link',
        'data-t': 'promotion-block-image',
        'aria-labelledby': labelId,
        onClick
    };
    if (hideFromKeyboardUser) {
        /**
     * Accessibility note:
     * If there is a CTA button shown in the PromotionBlock, then this wrapper makes the promotion image clickable
     * for a mouse user but NOT for keyboard or screen reader users. This is because the CTA <Button> natively
     * provides the same functionality and having both the image and button in the tab order is redundant for a non-mouse user
     *
     * If there is no CTA button, then the clickable image is not hidden from non-mouse users.
     *
     * In general DO NOT put an onClick on a div, unless it's a situation like this.
     *
     */ const sharedHiddenProps = swcHelpers.objectSpread({}, sharedProps, {
            'aria-hidden': true
        });
        return url ? /*#__PURE__*/ React.createElement("a", swcHelpers.extends({
            href: url,
            tabIndex: -1
        }, sharedHiddenProps), children) : // Generally, don't put onClick on a div. See above for an explanation for this exception
        /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, sharedHiddenProps), children);
    } else {
        return url ? /*#__PURE__*/ React.createElement("a", swcHelpers.extends({
            href: url
        }, sharedProps), children) : /*#__PURE__*/ React.createElement("button", swcHelpers.extends({}, sharedProps), children);
    }
};
const PromotionBlock = /*#__PURE__*/ React.forwardRef(({ id , title , description , image , links , size , onClick , ctaLabel , manageContentButton  }, ref)=>{
    const imageUrl = MediaQuery.useIsPhone() ? image === null || image === void 0 ? void 0 : image.mobileUrl : image === null || image === void 0 ? void 0 : image.url;
    if (!imageUrl) {
        return null;
    }
    const buttonStyles = (links === null || links === void 0 ? void 0 : links.style) ? Util$1.createButtonStyles(links.style) : {};
    const classNames = classnames('promotion-block', {
        'promotion-block--overlay': !!title || !!description,
        'promotion-block--large': size === 'large',
        'promotion-block--without-text': !title || !description
    });
    const promotionInfoId = `promotion-info-${id}`;
    const { url  } = links || {};
    const showCta = Boolean(!!ctaLabel && (url || onClick));
    return /*#__PURE__*/ React.createElement("div", {
        "data-t": "promotion-block",
        ref: ref,
        className: classNames
    }, manageContentButton, /*#__PURE__*/ React.createElement(ClickableImageWrapper, {
        onClick: onClick,
        url: url,
        hideFromKeyboardUser: showCta,
        labelId: promotionInfoId
    }, /*#__PURE__*/ React.createElement(Image, {
        url: imageUrl,
        cover: true,
        className: "promotion-block__image"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "promotion-block__inner"
    }, (title || description) && /*#__PURE__*/ React.createElement("div", {
        className: "promotion-block__text",
        id: promotionInfoId
    }, title && /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "medium",
        className: "promotion-block__title"
    }, title), description && /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        className: "promotion-block__subtitle"
    }, description)), showCta && /*#__PURE__*/ React.createElement(Button, swcHelpers.extends({}, buttonStyles, {
        className: "promotion-block__button",
        "data-t": "promotion-block-button",
        size: "custom",
        "aria-describedby": promotionInfoId,
        onClick: onClick,
        href: url,
        caption: ctaLabel
    }))));
});

const createImpressionEvent = (currency)=>{
    return {
        event: 'gvProductImpressions',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                impressions: []
            }
        }
    };
};
const createImpressionObject = (product, position)=>{
    var ref;
    return swcHelpers.objectSpread({}, mapProductToDataLayerProductObject(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, product.masterVariant.sku || 'undefined'), {
        list: `category: ${(ref = product.productType.obj) === null || ref === void 0 ? void 0 : ref.name}`,
        position
    });
};

const usePlpDatalayerEvents = ()=>{
    const { currency  } = useIntl();
    const impressionEvent = createImpressionEvent(currency);
    const { atfEcommerce: { ecommerce: { impressions  } ,  } ,  } = impressionEvent;
    const addImpressionEvent = React.useCallback((product, position)=>{
        impressions.push(createImpressionObject(product, position));
    }, []);
    const pushImpressionsToDatalayer = ()=>DataLayer.pushEvent(impressionEvent)
    ;
    const pushProductClickToDatalayer = React.useCallback((product, position)=>{
        var ref;
        DataLayer.pushEvent(createInteractionEvent(product, position, `category: ${(ref = product.productType.obj) === null || ref === void 0 ? void 0 : ref.name}`, currency));
    }, []);
    return {
        addImpressionEvent,
        pushImpressionsToDatalayer,
        pushProductClickToDatalayer
    };
};

const ProductListingGrid = ({ hasBigPromo , hasSmallPromo , children  })=>{
    const breakpoint = MediaQuery.useBreakpoint();
    const classNames = classnames('product-listing-grid', {
        'product-listing-grid--with-promos': hasBigPromo && hasSmallPromo,
        'product-listing-grid--with-big-promo': hasBigPromo && !hasSmallPromo,
        'product-listing-grid--single-promo': breakpoint === MediaQuery.BreakpointName.PHONE && (hasBigPromo && !hasSmallPromo || !hasBigPromo && hasSmallPromo),
        'product-listing-grid--col-2': breakpoint === MediaQuery.BreakpointName.PHONE,
        'product-listing-grid--col-3': breakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || breakpoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE,
        'product-listing-grid--col-4': breakpoint === MediaQuery.BreakpointName.DESKTOP
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames
    }, children);
};

const ProductListingGridCell = ({ children , isWide =false  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('product-listing-grid-cell', {
            'product-listing-grid-cell--wide': isWide
        })
    }, children)
;

function usePromoIndices(productCount, hasPromotionSmall) {
    const currentBreakpoint = MediaQuery.useBreakpoint();
    switch(currentBreakpoint){
        case MediaQuery.BreakpointName.PHONE:
        case MediaQuery.BreakpointName.TABLET_PORTRAIT:
        case MediaQuery.BreakpointName.TABLET_LANDSCAPE:
            return {
                smallPromoIndex: 4,
                bigPromoIndex: hasPromotionSmall ? 13 : 4
            };
        case MediaQuery.BreakpointName.DESKTOP:
            return {
                smallPromoIndex: 5,
                bigPromoIndex: hasPromotionSmall ? productCount > 16 ? 17 : 13 : 5
            };
        default:
            return {
                smallPromoIndex: -1,
                bigPromoIndex: -1
            };
    }
}

const ProductListingPage = ({ products , pageSize , pageNumber , promotionSmall , promotionBig , formatProductUrl , reimbursableLogos , forwardedQueryParams ,  })=>{
    const { getLabel  } = useIntl();
    const { addImpressionEvent , pushImpressionsToDatalayer , pushProductClickToDatalayer ,  } = usePlpDatalayerEvents();
    const { smallPromoIndex , bigPromoIndex  } = usePromoIndices(products.length, !!promotionSmall);
    const isSmallScreen = MediaQuery.useIsPhone();
    const onProductBlockClick = React.useCallback((product, index, handleSearchAnalytics)=>{
        handleSearchAnalytics(product.objectID, index);
        pushProductClickToDatalayer(product, index);
    }, []);
    const dividerLabel = `${getLabel('common.page')} ${pageNumber}`;
    const showPromos = products.length >= pageSize;
    React.useEffect(()=>{
        pushImpressionsToDatalayer();
    }, []);
    const augmentedProductList = React.useMemo(()=>{
        return products.reduce((result, product, index)=>{
            if (showPromos && !!promotionSmall && result.length === smallPromoIndex) {
                var ref;
                const smallPromoIdentifier = 'promo-small';
                var ref1;
                result.push(/*#__PURE__*/ React.createElement(ProductListingGridCell, {
                    key: smallPromoIdentifier,
                    isWide: isSmallScreen
                }, /*#__PURE__*/ React.createElement(PromotionBlock, swcHelpers.extends({}, promotionSmall, {
                    id: smallPromoIdentifier,
                    size: isSmallScreen ? 'large' : 'small',
                    ctaLabel: (ref1 = (ref = promotionSmall.links) === null || ref === void 0 ? void 0 : ref.label) !== null && ref1 !== void 0 ? ref1 : ''
                }))));
            }
            if (showPromos && !!promotionBig && result.length === bigPromoIndex) {
                var ref2;
                const bigPromoIdentifier = 'promo-big';
                var ref3;
                result.push(/*#__PURE__*/ React.createElement(ProductListingGridCell, {
                    key: bigPromoIdentifier,
                    isWide: true
                }, /*#__PURE__*/ React.createElement(PromotionBlock, swcHelpers.extends({}, promotionBig, {
                    id: bigPromoIdentifier,
                    size: "large",
                    ctaLabel: (ref3 = (ref2 = promotionBig.links) === null || ref2 === void 0 ? void 0 : ref2.label) !== null && ref3 !== void 0 ? ref3 : ''
                }))));
                result.push(null);
            }
            result.push(/*#__PURE__*/ React.createElement(ProductListingGridCell, {
                key: product.masterVariant.sku
            }, /*#__PURE__*/ React.createElement(AlgoliaAnalytics, null, (handleSearchAnalytics)=>{
                 return React.createElement(AlgoliaProductBlock, {
                    className: "product-listing-product-block",
                    product: product,
                    formatProductUrl: formatProductUrl,
                    onClick: ()=>onProductBlockClick(product, index, handleSearchAnalytics)
                    ,
                    reimbursableLogos: reimbursableLogos,
                    additionalUrlParams: forwardedQueryParams,
                    onImpression: ()=>{
                        return addImpressionEvent === null || addImpressionEvent === void 0 ? void 0 : addImpressionEvent(product, index);
                    }
                });
            })));
            return result;
        }, []);
    }, [
        products,
        showPromos,
        promotionSmall,
        smallPromoIndex,
        promotionBig,
        bigPromoIndex,
        isSmallScreen,
        formatProductUrl,
        reimbursableLogos,
        forwardedQueryParams,
        addImpressionEvent,
        onProductBlockClick, 
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        "data-t": `product-listing-page-${pageNumber}`,
        className: classnames('product-listing-page', {
            'product-listing-page--with-divider': pageNumber !== 1
        })
    }, pageNumber !== 1 && /*#__PURE__*/ React.createElement("div", {
        className: "product-listing-page__divider"
    }, dividerLabel), /*#__PURE__*/ React.createElement(ProductListingGrid, {
        hasSmallPromo: showPromos && !!promotionSmall,
        hasBigPromo: showPromos && !!promotionBig
    }, augmentedProductList));
};

const ProductListingSkeleton = ({ pageSize  })=>{
    const { getLabel  } = useIntl();
    const skeletonGrid = React.useMemo(()=>Array.from({
            length: pageSize
        }).map((_, i)=>/*#__PURE__*/ React.createElement(ProductListingGridCell, {
                key: `skeleton-cell-${i}`
            }, /*#__PURE__*/ React.createElement(SkeletonLoader, {
                className: "product-listing-skeleton-loader"
            }, /*#__PURE__*/ React.createElement("svg", {
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                height: "220",
                "aria-label": getLabel('common.loadingText')
            }, /*#__PURE__*/ React.createElement("rect", {
                width: "100%",
                height: "100",
                rx: "5",
                fill: "currentColor"
            }), /*#__PURE__*/ React.createElement("rect", {
                width: "80%",
                height: "15",
                rx: "5",
                fill: "currentColor",
                x: "10%",
                y: "140"
            }), /*#__PURE__*/ React.createElement("rect", {
                width: "80%",
                height: "15",
                rx: "5",
                fill: "currentColor",
                x: "10%",
                y: "165"
            }), /*#__PURE__*/ React.createElement("rect", {
                width: "50%",
                height: "15",
                rx: "5",
                fill: "currentColor",
                x: "25%",
                y: "200"
            }))))
        )
    , [
        getLabel,
        pageSize
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-listing-skeleton"
    }, /*#__PURE__*/ React.createElement(ProductListingGrid, null, skeletonGrid));
};

const ProductListing = ({ products , showMoreButton , promotionBig , promotionSmall , staticsUrl , formatProductUrl , reimbursableLogos , forwardedQueryParams ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-listing"
    }, /*#__PURE__*/ React.createElement(Container, {
        className: "product-listing__container"
    }, products.pages.map((page, i)=>{
        const pageNr = i + 1;
        return page === null ? /*#__PURE__*/ React.createElement(ProductListingSkeleton, {
            key: `product-listing-skeleton-${pageNr}`,
            pageSize: products.size
        }) : /*#__PURE__*/ React.createElement(ProductListingPage, {
            key: `product-listing-page-${pageNr}`,
            products: page,
            pageSize: products.size,
            pageNumber: pageNr,
            promotionBig: promotionBig,
            promotionSmall: promotionSmall,
            formatProductUrl: formatProductUrl,
            reimbursableLogos: reimbursableLogos,
            forwardedQueryParams: forwardedQueryParams
        });
    }), showMoreButton && /*#__PURE__*/ React.createElement("div", {
        className: "product-listing__show-more"
    }, showMoreButton)));
};

const ProductPlaceholder = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-placeholder"
    }, /*#__PURE__*/ React.createElement("svg", {
        width: "282",
        height: "244",
        viewBox: "0 0 282 244",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "282",
        height: "149",
        rx: "5",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("rect", {
        x: "26",
        y: "169",
        width: "230",
        height: "15",
        rx: "5",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("rect", {
        x: "26",
        y: "194",
        width: "230",
        height: "15",
        rx: "5",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("rect", {
        x: "71",
        y: "229",
        width: "140",
        height: "15",
        rx: "5",
        fill: "currentColor"
    })));
};

const ProductPromotions = ({ products , supertitle , title , formatProductUrl , renderLocation , 'data-t': dataT , isLoading ,  })=>{
    const { currency  } = useIntl();
    const handleImpression = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createImpressionEvent$1(product, position, `promotion recommendation ${renderLocation}`, currency));
    }, [
        currency,
        renderLocation
    ]);
    const handleInteraction = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createInteractionEvent(product, position, `promotion recommendation ${renderLocation}`, currency));
    }, [
        currency,
        renderLocation
    ]);
    if (products.length === 0 && !isLoading) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-promotions",
        "data-t": dataT || 'product-promotions'
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        component: "span",
        color: "text-secondary",
        className: "product-promotions__supertitle"
    }, supertitle), /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium",
        component: "h2"
    }, title), /*#__PURE__*/ React.createElement(ProductBanner, {
        products: products,
        isLoading: isLoading,
        formatProductUrl: formatProductUrl,
        onProductImpression: handleImpression,
        onProductInteraction: handleInteraction
    })));
};

// PRODUCT
function getFrameData(product) {
    const gender = getLocalizedAttrValues(product.masterVariant, 'gender', 'en');
    // Check if it's a kids glasses
    const isKidsGlasses = gender.some((a)=>a.toLowerCase() === 'kids'
    );
    const framePrice = product.masterVariant.prices && product.masterVariant.prices[0].value.centAmount || 0;
    const brand = getLocalizedAttrValue(product.masterVariant, 'brand', 'en');
    return {
        brand,
        framePrice,
        gender,
        isKidsGlasses
    };
}
// LENS PACKS
function getLensPacks(product, isKids) {
    const attributes = product.masterVariant.attributes;
    const lensDetails = attributes && attributes.find((attr)=>attr.name === 'lensDetails'
    );
    if (!lensDetails) {
        return {
            monofocalLensPacks: [],
            multifocalLensPacks: []
        };
    }
    function movePackNameUp(lensPack) {
        const packType = (lensPack.attributes || []).find((attr)=>attr.name === 'pack'
        ).value.key;
        return swcHelpers.objectSpread({}, lensPack, {
            packType: packType || ''
        });
    }
    const lensPacksData = lensDetails.value.obj.masterData.current;
    const includedLensPack = movePackNameUp(swcHelpers.objectSpread({}, lensPacksData.masterVariant, {
        isIncluded: true
    }));
    const lensPacks = lensPacksData.variants.map((pack)=>movePackNameUp(swcHelpers.objectSpread({}, pack, {
            isIncluded: false
        }))
    );
    const monofocalLensPacks = lensPacks.filter((pack)=>{
        const lens = pack.attributes.find((attr)=>attr.name === 'lens'
        );
        return lens.value.key === 'singleVision';
    });
    monofocalLensPacks.unshift(includedLensPack);
    let multifocalLensPacks = [];
    if (!isKids) {
        multifocalLensPacks = lensPacks.filter((pack)=>{
            const lens = pack.attributes.find((attr)=>attr.name === 'lens'
            );
            return lens.value.key === 'multifocal';
        });
    }
    return {
        includedLensPack,
        monofocalLensPacks,
        multifocalLensPacks
    };
}
// CALCULATIONS
function calcGlassesPrice(opticalData, glassesType) {
    if (glassesType === 'frameAndMonofocal') {
        return opticalData.frameAndMonofocalPrice;
    }
    if (glassesType === 'frameAndMultifocal') {
        return opticalData.frameAndMultifocalPrice;
    }
    return opticalData.framePrice;
}
/**
 * Calculates the +/- price for a selected glasses type compared to the initial type.
 */ function calcGlassesPriceDifference(opticalData, glassesType, initialGlassesType = 'frameAndMonofocal') {
    const priceMapping = {
        frameOnly: opticalData.framePrice,
        frameAndMonofocal: opticalData.frameAndMonofocalPrice,
        frameAndMultifocal: opticalData.frameAndMultifocalPrice
    };
    return priceMapping[glassesType] - priceMapping[initialGlassesType];
}
function calcLensPackPrice(opticalData, glassesType, lensPack, useIncludedLensPack = false) {
    const { brand , isKidsGlasses  } = opticalData;
    let lensPackPrice = 0;
    if (glassesType === 'frameOnly') {
        return lensPackPrice;
    }
    const { monofocalLensPacks , multifocalLensPacks  } = opticalData;
    const activePackList = glassesType === 'frameAndMonofocal' ? monofocalLensPacks : multifocalLensPacks;
    const selectedPack = activePackList.find((pack)=>pack.packType === lensPack
    );
    if (!selectedPack) {
        return lensPackPrice;
    }
    if (!useIncludedLensPack) {
        var ref;
        return (ref = getPriceOfLensPack(selectedPack)) !== null && ref !== void 0 ? ref : 0;
    }
    if (opticalData.includedLensPack && opticalData.includedLensPack.packType === lensPack && glassesType === 'frameAndMonofocal') {
        // if the lensPack is already included, then set lensPackPrice to 0
        lensPackPrice = 0;
    } else if (glassesType === 'frameAndMonofocal' && lensPack === 'basic' && (brand.toLowerCase() === 'seen' || isKidsGlasses)) {
        // 'basic' is included on Seen and kids glasses --> when pack is included, set lensPackPrice to 0
        lensPackPrice = 0;
    } else if (glassesType === 'frameAndMonofocal' && lensPack === 'basic' && brand.toLowerCase() !== 'seen' && !isKidsGlasses) {
        // 'bronze' is also included on other brands --> when pack is included, set lensPackPrice to 0
        lensPackPrice = 0;
    } else if (glassesType === 'frameAndMultifocal' && (brand.toLowerCase() === 'seen' || isKidsGlasses)) {
        // 'basic' pack price is also included on Seen and 'kids' glasses when MULTIfocal
        // The price of 'basic' needs to be subtracted from every lenspack to make calculations be correct
        const basicMultiPack = getInitialLensPack(opticalData.multifocalLensPacks, 'basic');
        var ref1;
        const basicMultiPackPrice = (ref1 = getPriceOfLensPack(basicMultiPack)) !== null && ref1 !== void 0 ? ref1 : 0;
        var ref2;
        lensPackPrice = ((ref2 = getPriceOfLensPack(selectedPack)) !== null && ref2 !== void 0 ? ref2 : 0) - basicMultiPackPrice;
    } else if (glassesType === 'frameAndMultifocal' && !isKidsGlasses) {
        // 'bronze' pack price is included on non-Seen and non-'kids' glasses when MULTIfocal
        // The price of 'bronze' needs to be subtracted from every lenspack to make calculations be correct
        const basicMultiPack = getInitialLensPack(opticalData.multifocalLensPacks, 'basic');
        var ref3;
        const basicMultiPackPrice = (ref3 = getPriceOfLensPack(basicMultiPack)) !== null && ref3 !== void 0 ? ref3 : 0;
        var ref4;
        lensPackPrice = ((ref4 = getPriceOfLensPack(selectedPack)) !== null && ref4 !== void 0 ? ref4 : 0) - basicMultiPackPrice;
    } else {
        var ref5;
        lensPackPrice = (ref5 = getPriceOfLensPack(selectedPack)) !== null && ref5 !== void 0 ? ref5 : 0;
    }
    return lensPackPrice;
}
function calcSelectedExtrasPrice(extrasData, selectedExtras) {
    const price = 0;
    if (selectedExtras) {
        return extrasData.filter(({ value  })=>selectedExtras.indexOf(value) >= 0
        ).reduce((sum, item)=>sum + item.price || 0
        , 0);
    }
    return price;
}
// HELPERS
function findAndSortBenefits(packs, intl, sorting) {
    const map = sorting.reduce((main, value, index)=>swcHelpers.objectSpread({}, main, {
            [value]: index
        })
    , {});
    return packs.map((pack)=>{
        const benefits = pack.attributes && pack.attributes.filter((attr)=>/(cb[A-Z])\w+/.exec(attr.name) && attr.name in map
        ).sort((a, b)=>map[a.name] - map[b.name]
        ).map((benefit)=>{
            const labelKey = `products.ssp.lenses.${benefit.name}`;
            const label = intl && intl.getLabel && intl.getLabel(labelKey) || '';
            return swcHelpers.objectSpread({}, benefit, {
                label
            });
        });
        if (!benefits) {
            return swcHelpers.objectSpread({}, pack, {
                benefits: []
            });
        }
        return swcHelpers.objectSpread({}, pack, {
            benefits
        });
    });
}
function getInitialLensPack(lensPackData, selector) {
    const selection = lensPackData.find((pack)=>pack.packType === selector
    );
    return selection ? selection : lensPackData[0];
}
function getPriceOfLensPack(lensPack) {
    var ref, ref6, ref7;
    return lensPack === null || lensPack === void 0 ? void 0 : (ref = lensPack.prices) === null || ref === void 0 ? void 0 : (ref6 = ref[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.value) === null || ref7 === void 0 ? void 0 : ref7.centAmount;
}

const isGlassesType = (input)=>input === 'frameOnly' || input === 'frameAndMonofocal' || input === 'frameAndMultifocal'
;
var ExtraTypes;
(function(ExtraTypes) {
    ExtraTypes['tinted-lenses-pack'] = 'tinted-lenses-pack';
    ExtraTypes['manufactured-lenses'] = 'manufactured-lenses';
    ExtraTypes['screen-protection-pack'] = 'screen-protection-pack';
    ExtraTypes['polarized-pack'] = 'polarized-pack';
    ExtraTypes['personalized-pack'] = 'personalized-pack';
    ExtraTypes['light-adaptive-pack'] = 'light-adaptive-pack';
    ExtraTypes['gradient-pack'] = 'gradient-pack';
})(ExtraTypes || (ExtraTypes = {}));
const isExtraType = (input)=>input in ExtraTypes
;
const Aside = ({ currency , price , prefix , className  })=>/*#__PURE__*/ React.createElement("div", {
        className: className
    }, prefix, " ", /*#__PURE__*/ React.createElement(Price, {
        value: price,
        centAmount: true,
        currency: currency
    }))
;
class SSP extends React.Component {
    filterByAllowed(glasses, lensPack, extras) {
        // Get allowed extras based on the value and assign to newExtras
        let allowedExtras = this.props.lensExtrasResolver(glasses, lensPack, extras, this.opticalData);
        let newExtras = extras.filter((item)=>allowedExtras.indexOf(item) > -1
        );
        // With the newExtras, check allowedExtras again and filter it with the newExtras itself
        allowedExtras = this.props.lensExtrasResolver(glasses, lensPack, newExtras, this.opticalData);
        newExtras = extras.filter((item)=>allowedExtras.indexOf(item) > -1
        );
        return newExtras;
    }
    componentDidMount() {
        this.setState({
            isLoading: false
        });
        // Need to call onChange on mount to send initial values to parent on load
        this.props.onChange && this.props.onChange(this.state);
    }
    render() {
        const { monofocalLensPacks , multifocalLensPacks  } = this.opticalData;
        const { className , useIncludedLensPack , intl  } = this.props;
        const { selectedGlasses , selectedExtras  } = this.state;
        const selectedLensPack = this.state.selectedLensPack || 'bronze';
        const activePacks = selectedGlasses === 'frameAndMonofocal' ? monofocalLensPacks : multifocalLensPacks;
        this.extrasData = this.setExtrasData(selectedGlasses, selectedLensPack, selectedExtras);
        // Monofocal table will show only benefits that match this array and sort them accordingly
        const monoSorting = [
            'cbAntiBreakage',
            'cbAntiScratch',
            'cbAntiReflective',
            'cbHidrorrepelent',
            'cbReducedEyeFatigue',
            'cbThinnerLighter',
            'cbIdealForRimless',
            'cbUVprotection',
            'cbBetterContrast',
            'cbHDtechnology',
            'cbIndividualLenses', 
        ];
        // Multifocal table will show only benefits that match this array and sort them accordingly
        const multiSorting = [
            'visualField',
            'cbPerfectSight',
            'cbAntiBreakage',
            'cbAntiScratch',
            'cbAntiReflective',
            'cbHidrorrepelent',
            'cbThinnerLighter',
            'cbIdealForRimless',
            'cbUVprotection',
            'cbBetterContrast',
            'cbHDtechnology',
            'cbIndividualLenses', 
        ];
        const glassesItems = this.createGlassesItems();
        const sorting = selectedGlasses === 'frameAndMonofocal' ? monoSorting : multiSorting;
        const packsWithBenefits = findAndSortBenefits(activePacks, intl, sorting);
        const withVisualField = packsWithBenefits.filter((pack)=>pack.attributes
        ).map((pack)=>pack.attributes
        ).reduce((a, b)=>a.concat(b)
        , []).some((attr)=>attr.name === 'visualField'
        );
        const withVoucherValues = packsWithBenefits.length > 0 && packsWithBenefits.map((pack)=>{
            const voucherAttr = getAttrValue(pack, 'voucher');
            return isPlainObject(voucherAttr) ? getNestedProperty(voucherAttr, 'centAmount', 0) : 0;
        }).some((value)=>value > 0
        );
        const SSPclasses = classnames({
            ssp: true,
            'ssp--with-voucher': withVoucherValues,
            'ssp--with-visual-field': withVisualField,
            className
        });
        const selectedItems = this.state.selectedExtras.reduce((acc, name)=>{
            const extra = this.extrasData.find((e)=>e.value === name
            );
            return extra ? [
                ...acc,
                extra
            ] : acc;
        }, []);
        return /*#__PURE__*/ React.createElement("div", {
            className: SSPclasses
        }, /*#__PURE__*/ React.createElement("div", {
            className: "site-container ssp__container"
        }, this.state.isLoading ? /*#__PURE__*/ React.createElement(Loader, null) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Heading, {
            variant: "small",
            className: "ssp__section-title"
        }, intl.getLabel('products.ssp.glasses.title')), /*#__PURE__*/ React.createElement(SelectionGroup, {
            items: glassesItems,
            selectedItem: this.state.selectedGlasses,
            onChange: this.handleGlassesTypeChange
        }), this.state.selectedGlasses !== 'frameOnly' && /*#__PURE__*/ React.createElement(React.Fragment, null, intl.getLabel('products.ssp.lenses.title') && /*#__PURE__*/ React.createElement(Heading, {
            variant: "small",
            className: "ssp__section-title"
        }, intl.getLabel('products.ssp.lenses.title')), /*#__PURE__*/ React.createElement(LensPacks$1, {
            packs: packsWithBenefits,
            selectedPack: this.state.selectedLensPack || 'bronze',
            selectedGlasses: this.state.selectedGlasses,
            onChange: this.handleLensPackChange,
            useIncludedLensPack: useIncludedLensPack
        }), this.extrasData.length > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, intl.getLabel('products.ssp.extras.title') && /*#__PURE__*/ React.createElement(Heading, {
            variant: "small",
            className: "ssp__section-title"
        }, intl.getLabel('products.ssp.extras.title')), /*#__PURE__*/ React.createElement(CheckboxList, {
            checkboxAlignment: "middle",
            className: "ssp__lens-extras",
            itemClassName: "ssp__lens-extras-item",
            idPrefix: "ssp-lens-extra__",
            items: this.extrasData,
            selectedItems: selectedItems,
            getItemIdentifier: (item)=>item.value
            ,
            isItemDisabled: (item)=>item.disabled
            ,
            renderItem: (item)=>/*#__PURE__*/ React.createElement("div", {
                    className: classnames('ssp-lens-extra__content', {
                        'ssp-lens-extra__content--disabled': item.disabled
                    })
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "ssp-lens-extra__main"
                }, /*#__PURE__*/ React.createElement("span", {
                    className: "ssp-lens-extra__title"
                }, item.title), /*#__PURE__*/ React.createElement("span", {
                    className: "ssp-lens-extra__text"
                }, item.text)), /*#__PURE__*/ React.createElement(Aside, {
                    prefix: "+",
                    price: item.price,
                    currency: intl.currency,
                    className: "ssp-lens-extra__price"
                }))
            ,
            onChange: this.handleExtrasChange
        }))))));
    }
    constructor(props){
        super(props);
        this.setExtrasData = (selectedGlasses, selectedLensPack, selectedExtras)=>{
            const { monofocalExtras , multifocalExtras  } = this.createExtrasItems(this.props.lensExtras);
            const allowedExtras = this.props.lensExtrasResolver(selectedGlasses, selectedLensPack, selectedExtras, this.opticalData);
            let extrasData = selectedGlasses === 'frameAndMonofocal' ? monofocalExtras : multifocalExtras;
            extrasData = extrasData.map((extra)=>{
                const enabled = allowedExtras && allowedExtras.indexOf(extra.value) > -1;
                const checked = enabled && selectedExtras && selectedExtras.indexOf(extra.value) > -1;
                return swcHelpers.objectSpread({}, extra, {
                    isChecked: checked,
                    disabled: !enabled
                });
            });
            return extrasData;
        };
        this.createExtrasItems = (data)=>{
            const { intl  } = this.props;
            const monofocalExtras = data.filter((item)=>isExtraType(item.slug.en) && item.masterVariant.prices && item.masterVariant.prices.length
            ).map((item)=>{
                // @ts-ignore, is checked in the filter above
                const price = item.masterVariant.prices[0].value.centAmount;
                const Aside1 = /*#__PURE__*/ React.createElement("div", null, "+ ", /*#__PURE__*/ React.createElement(Price, {
                    value: price,
                    centAmount: true,
                    currency: intl.currency
                }));
                return {
                    scope: 'extras',
                    title: getLocalizedValue(item.name, intl.locale),
                    text: item.description ? getLocalizedValue(item.description, intl.locale) : '',
                    value: item.slug.en,
                    aside: Aside1,
                    price,
                    disabled: false
                };
            });
            const multifocalExtras = data.filter((item)=>item.variants.length !== 0 && item.variants[0].prices && item.variants[0].prices.length && isExtraType(item.slug.en)
            ).map((item)=>{
                // @ts-ignore, is checked in the filter above
                const price = item.variants[0].prices[0].value.centAmount;
                return {
                    scope: 'extras',
                    title: item.name ? getLocalizedValue(item.name, intl.locale) : '',
                    text: item.description ? getLocalizedValue(item.description, intl.locale) : '',
                    value: item.slug.en,
                    aside: /*#__PURE__*/ React.createElement(Aside, {
                        prefix: "+",
                        price: price,
                        currency: intl.currency
                    }),
                    price,
                    disabled: false
                };
            });
            return {
                monofocalExtras,
                multifocalExtras
            };
        };
        this.createGlassesItems = ()=>{
            const { initialGlasses , useIncludedFrame , intl  } = this.props;
            const glassesTypes = [
                'frameOnly',
                'frameAndMonofocal',
                'frameAndMultifocal'
            ];
            const glassesItems = glassesTypes.filter((glassesType)=>{
                // Only NON-kids frames can have multifocal.
                return !(glassesType === 'frameAndMultifocal' && this.opticalData.isKidsGlasses);
            }).map((glassesType)=>{
                let price = calcGlassesPrice(this.opticalData, glassesType);
                let prefix = '';
                if (useIncludedFrame) {
                    price = calcGlassesPriceDifference(this.opticalData, glassesType, initialGlasses);
                    prefix = price < 0 ? '-' : price > 0 ? '+' : '';
                }
                return {
                    title: intl.getLabel(`products.ssp.glasses.${glassesType}.title`),
                    text: intl.getLabel(`products.ssp.glasses.${glassesType}.text`),
                    value: glassesType,
                    scope: 'glasses',
                    aside: useIncludedFrame && price === 0 ? /*#__PURE__*/ React.createElement("div", null, intl.getLabel('products.included')) : /*#__PURE__*/ React.createElement(Aside, {
                        prefix: prefix,
                        price: Math.abs(price),
                        currency: intl.currency
                    }),
                    disabled: false
                };
            });
            return glassesItems;
        };
        this.handleGlassesTypeChange = (type)=>{
            if (!isGlassesType(type)) {
                console.error(`Invalid glasses type: "${type}"`);
                return;
            }
            const { selectedLensPack , selectedExtras  } = this.state;
            this.extrasData = this.setExtrasData(type, selectedLensPack, selectedExtras);
            let newExtras = [];
            if (type === 'frameOnly') {
                newExtras = [];
            } else {
                newExtras = this.filterByAllowed(type, selectedLensPack, selectedExtras);
            }
            const newGlassesPrice = calcGlassesPrice(this.opticalData, type);
            const newLensPackPrice = calcLensPackPrice(this.opticalData, type, selectedLensPack, this.props.useIncludedLensPack);
            const newExtrasPrice = calcSelectedExtrasPrice(this.extrasData, newExtras);
            const totalPrice = newGlassesPrice + newLensPackPrice + newExtrasPrice;
            this.setState({
                selectedGlasses: type,
                selectedExtras: newExtras,
                glassesPrice: newGlassesPrice,
                lensPackPrice: newLensPackPrice,
                extrasPrice: newExtrasPrice,
                totalPrice
            }, ()=>{
                this.props.onChange && this.props.onChange(this.state);
            });
        };
        this.handleLensPackChange = (pack)=>{
            const { selectedGlasses , selectedExtras  } = this.state;
            this.extrasData = this.setExtrasData(selectedGlasses, pack, selectedExtras);
            const newExtras = this.filterByAllowed(selectedGlasses, pack, selectedExtras);
            const newGlassesPrice = calcGlassesPrice(this.opticalData, selectedGlasses);
            const newLensPackPrice = calcLensPackPrice(this.opticalData, selectedGlasses, pack, this.props.useIncludedLensPack);
            const newExtrasPrice = calcSelectedExtrasPrice(this.extrasData, newExtras);
            const totalPrice = newGlassesPrice + newLensPackPrice + newExtrasPrice;
            this.setState({
                selectedLensPack: pack,
                selectedExtras: newExtras,
                glassesPrice: newGlassesPrice,
                lensPackPrice: newLensPackPrice,
                extrasPrice: newExtrasPrice,
                totalPrice
            }, ()=>{
                this.props.onChange && this.props.onChange(this.state);
            });
        };
        this.handleExtrasChange = (items)=>{
            const extras = items.filter((item)=>isExtraType(item.value)
            );
            const values = extras.map((i)=>i.value
            );
            const { selectedGlasses , selectedLensPack  } = this.state;
            const newExtras = this.filterByAllowed(selectedGlasses, selectedLensPack, values);
            const newGlassesPrice = calcGlassesPrice(this.opticalData, selectedGlasses);
            const newLensPackPrice = calcLensPackPrice(this.opticalData, selectedGlasses, selectedLensPack, this.props.useIncludedLensPack);
            const newExtrasPrice = calcSelectedExtrasPrice(this.extrasData, newExtras);
            const totalPrice = newGlassesPrice + newLensPackPrice + newExtrasPrice;
            this.setState({
                selectedExtras: newExtras,
                glassesPrice: newGlassesPrice,
                lensPackPrice: newLensPackPrice,
                extrasPrice: newExtrasPrice,
                totalPrice
            }, ()=>{
                this.props.onChange && this.props.onChange(this.state);
            });
        };
        // all product data, dynamically created based on data provided by page
        const frameData = getFrameData(this.props.product);
        const lensPackData = getLensPacks(this.props.product, frameData.isKidsGlasses);
        this.opticalData = swcHelpers.objectSpread({}, frameData, lensPackData, {
            lensExtras: this.props.lensExtras,
            frameAndMonofocalPrice: 0,
            frameAndMultifocalPrice: 0
        });
        var ref;
        const includedLensPackPrice = this.opticalData.includedLensPack ? (ref = getPriceOfLensPack(this.opticalData.includedLensPack)) !== null && ref !== void 0 ? ref : 0 : 0;
        const initialPrice = props.useIncludedLensPack ? includedLensPackPrice + frameData.framePrice : frameData.framePrice;
        const frameAndMonofocalPrice = initialPrice;
        const initLensPackMultifocal = getInitialLensPack(this.opticalData.multifocalLensPacks);
        var ref1;
        const initialLensPackMultifocalPrice = props.useIncludedLensPack && initLensPackMultifocal ? (ref1 = getPriceOfLensPack(initLensPackMultifocal)) !== null && ref1 !== void 0 ? ref1 : 0 : 0;
        const frameAndMultifocalPrice = !this.opticalData.isKidsGlasses ? initialLensPackMultifocalPrice + initialPrice : 0;
        this.opticalData = swcHelpers.objectSpread({}, this.opticalData, {
            frameAndMonofocalPrice,
            frameAndMultifocalPrice
        });
        // initial options
        // Initial selected type of glasses
        const initialGlasses1 = this.props.initialGlasses || 'frameAndMonofocal';
        const initialLensPackType = this.props.initialLensPack || getInitialLensPack(this.opticalData.monofocalLensPacks).packType;
        // Initial extras start empty
        const initialExtras = this.props.initialExtras || [];
        // Set extrasData
        this.extrasData = this.setExtrasData(initialGlasses1, initialLensPackType, initialExtras);
        // Set all prices based on initial selections
        const newGlassesPrice1 = calcGlassesPrice(this.opticalData, initialGlasses1);
        const newLensPackPrice1 = calcLensPackPrice(this.opticalData, initialGlasses1, initialLensPackType, props.useIncludedLensPack);
        const newExtrasPrice1 = calcSelectedExtrasPrice(this.extrasData, initialExtras);
        const totalPrice1 = newGlassesPrice1 + newLensPackPrice1 + newExtrasPrice1;
        this.state = {
            isLoading: true,
            selectedGlasses: initialGlasses1,
            selectedLensPack: initialLensPackType,
            selectedExtras: initialExtras,
            glassesPrice: newGlassesPrice1,
            lensPackPrice: newLensPackPrice1,
            extrasPrice: newExtrasPrice1,
            totalPrice: totalPrice1
        };
    }
}
var SSP$1 = withIntl(SSP);

var RecentlyViewedProducts = (_param)=>{
    var { title , renderLocation  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "title",
        "renderLocation"
    ]);
    const { currency , getLabel  } = useIntl();
    const { history , clear  } = useProductViewHistory();
    const { isLoading , products , error  } = useGetProductsBySku(history);
    const noHistory = Array.isArray(history) && history.length === 0;
    const noProducts = !error && (products === null || products === void 0 ? void 0 : products.length) === 0;
    const handleImpression = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createImpressionEvent$1(product, position, `recently-viewed recommendation ${renderLocation}`, currency));
    }, [
        currency,
        renderLocation
    ]);
    const handleInteraction = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createInteractionEvent(product, position, `recently-viewed recommendation ${renderLocation}`, currency));
    }, [
        currency,
        renderLocation
    ]);
    // Only return null when we are sure the history is empty or when there are no products matching the SKU's in history,
    // i.e. unpublished products
    // as history will never be defined on the server and can result in HTML mismatches if we always return
    if (noHistory || noProducts) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "recently-viewed-products",
        "data-t": "recently-viewed-products"
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium"
    }, title || getLabel('products.recentlyViewed.title')), /*#__PURE__*/ React.createElement(ProductBanner, swcHelpers.extends({
        isLoading: isLoading,
        error: error,
        products: products,
        onProductImpression: handleImpression,
        onProductInteraction: handleInteraction
    }, rest)), /*#__PURE__*/ React.createElement("div", {
        className: "recently-viewed-products__clear"
    }, /*#__PURE__*/ React.createElement(Button, {
        caption: getLabel('products.recentlyViewed.clear'),
        onClick: clear,
        variant: "ghost",
        size: "custom"
    }))));
};
var RecentlyViewedProducts$1 = withLazyLoading(RecentlyViewedProducts, {
    rootMargin: '200px 0px'
});

const recommendedProductFragment = gql`
  fragment RecommendedProductFragment on RecommendationProduct {
    sku
    price {
      value {
        type
        currencyCode
        centAmount
        fractionDigits
      }
      discounted {
        value {
          type
          currencyCode
          centAmount
          fractionDigits
        }
        discount {
          typeId
          description
        }
      }
    }
    brand
    brandModel
    productType
    name
    slug
    images {
      url
      label
      dimension {
        width
        height
      }
    }
    tags {
      key
      value
    }
    promotionLabel
    action {
      ... on RecommendationProductRedirectAction {
        slug
      }
    }
  }
`;
const recommendedBannerFragment = gql`
  fragment RecommendedBannerFragment on RecommendationBanner {
    title
    description
    image {
      url
      label
      dimension {
        width
        height
      }
    }
    position
    action {
      ... on RecommendationBannerRedirectToLinkAction {
        link {
          url
          label
        }
      }
      ... on RecommendationBannerApplyDiscountCodeAction {
        discountCode
      }
    }
  }
`;
var GET_RECOMMENDATIONS = gql`
  query getRecommendations($input: RecommendationInput!) {
    getRecommendations(input: $input) {
      recommendedProducts {
        ...RecommendedProductFragment
      }
      recommendedBanners {
        ...RecommendedBannerFragment
      }
    }
  }
  ${recommendedProductFragment}
  ${recommendedBannerFragment}
`;

function pushEvent(event, ecommerce) {
    DataLayer.pushEcommerceEvent({
        event,
        atfEcommerce: {
            ecommerce
        }
    });
}
function pushProductImpressions(product, position) {
    pushEvent('gvProductImpressions', {
        currencyCode: product.price.value.currencyCode,
        impressions: [
            convertProduct(product, position)
        ]
    });
}
function pushProductClick(product, position) {
    pushEvent('gvProductClick', {
        currencyCode: product.price.value.currencyCode,
        click: {
            actionField: {
                list: 'product recommendation mini cart'
            },
            products: [
                convertProduct(product, position)
            ]
        }
    });
}
function pushPromotionImpression(promotion) {
    pushEvent('gvPromotionImpressions', {
        promoView: {
            promotions: [
                convertPromotion(promotion)
            ]
        }
    });
}
function pushPromotionClick(promotion) {
    pushEvent('gvPromotionClick', {
        promoClick: {
            promotions: [
                convertPromotion(promotion)
            ]
        }
    });
}
function convertProduct(product, position) {
    return {
        name: product.name,
        id: product.sku,
        price: calcPrice(product.price.value.centAmount),
        brand: product.brand,
        list: 'product recommendation mini cart',
        position
    };
}
function convertPromotion(promotion) {
    return {
        name: promotion.title,
        creative: promotion.recommendationType,
        position: promotion.position
    };
}

const convertProductRecommendationInfo = (recommendation, formatProductUrl, locale)=>{
    var ref, ref1, ref2, ref3, ref4;
    if (!CommerceToolsApi.isProductTypeName(recommendation.productType)) {
        console.error(`Recommendation has invalid product type name "${recommendation.productType}"`);
        return;
    }
    const images = recommendation.images.reduce((m, image)=>!image.label || !image.dimension ? m : [
            ...m,
            {
                url: image.url,
                label: image.label,
                dimensions: {
                    w: image.dimension.width,
                    h: image.dimension.height
                }
            }, 
        ]
    , []);
    const hasFrontImage = Boolean(images[0]);
    const hasAngleImage = Boolean(images[1]);
    var ref5;
    const front = hasFrontImage ? createResponsiveImage((ref = images[0]) === null || ref === void 0 ? void 0 : ref.url, (ref5 = (ref1 = images[0]) === null || ref1 === void 0 ? void 0 : ref1.label) !== null && ref5 !== void 0 ? ref5 : undefined) : undefined;
    var ref6;
    const angle = hasAngleImage ? createResponsiveImage((ref2 = images[1]) === null || ref2 === void 0 ? void 0 : ref2.url, (ref6 = (ref3 = images[1]) === null || ref3 === void 0 ? void 0 : ref3.label) !== null && ref6 !== void 0 ? ref6 : undefined) : undefined;
    return swcHelpers.objectSpread({
        sku: recommendation.sku,
        brand: recommendation.brand,
        url: formatProductUrl({
            slug: {
                [locale]: recommendation.slug
            },
            sku: recommendation.sku,
            productType: recommendation.productType
        }),
        images: {
            front,
            angle
        },
        productType: recommendation.productType,
        name: recommendation.name || recommendation.brandModel || '',
        price: recommendation.price.value.centAmount,
        discountedPrice: (ref4 = recommendation.price.discounted) === null || ref4 === void 0 ? void 0 : ref4.value.centAmount,
        tags: recommendation.tags
    }, recommendation.promotionLabel ? {
        promotionLabel: recommendation.promotionLabel
    } : {});
};
const convertBannerRecommendationInfo = (recommendation)=>{
    const responsiveImage = createResponsiveImage(recommendation.image.url, recommendation.title);
    var _action;
    return {
        title: recommendation.title,
        description: recommendation.description,
        image: {
            url: responsiveImage.url,
            mobileUrl: responsiveImage.url,
            description: recommendation.description
        },
        action: (_action = recommendation.action) !== null && _action !== void 0 ? _action : undefined
    };
};

var BannerRecommendation = /*#__PURE__*/ React__default.forwardRef((_param, ref)=>{
    var { recommendation  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "recommendation"
    ]);
    const info = convertBannerRecommendationInfo(recommendation);
    if (!info) return null;
    let link;
    if (info.action && 'link' in info.action) {
        link = info.action.link;
    }
    return /*#__PURE__*/ React__default.createElement(PromotionBlock, swcHelpers.extends({
        ref: ref,
        id: `banner-recommendation_${info.title}`,
        /**
         * CTA will not show if there's no label. This is not clear from the type.
         */ ctaLabel: (link === null || link === void 0 ? void 0 : link.label) || '',
        size: "small",
        links: swcHelpers.objectSpread({}, link, {
            style: ''
        })
    }, info, rest));
});

const BannerRecommendationContainer = (props)=>{
    const { recommendation  } = props;
    const clickRef = useRef(false);
    const { ref , wasSeen  } = useWasSeenByUser();
    const handlePromotionClick = useCallback(()=>{
        if (!clickRef.current) {
            clickRef.current = true;
            pushPromotionClick(recommendation);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(()=>{
        if (wasSeen) {
            pushPromotionImpression(recommendation);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        wasSeen
    ]);
    return /*#__PURE__*/ React__default.createElement(BannerRecommendation, {
        ref: ref,
        recommendation: recommendation,
        onClick: handlePromotionClick
    });
};

const ListItemWrapper = ({ children  })=>/*#__PURE__*/ React__default.createElement(motion.li, {
        variants: {
            start: {
                opacity: 0
            },
            end: {
                opacity: 1
            }
        },
        className: "recommendation-list__list-item"
    }, children)
;

const getZeroDiscount = (recommendation)=>{
    const { discounted , value  } = recommendation.price;
    return discounted && discounted.value.centAmount === value.centAmount ? {
        key: null,
        value: discounted.discount.description
    } : undefined;
};

var ProductRecommendation = /*#__PURE__*/ React__default.forwardRef((_param, ref)=>{
    var { recommendation , formatProductUrl , locale  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "recommendation",
        "formatProductUrl",
        "locale"
    ]);
    const info = convertProductRecommendationInfo(recommendation, formatProductUrl, locale);
    if (!info) return null;
    const { sku , tags  } = info, recommendationRest = swcHelpers.objectWithoutProperties(info, [
        "sku",
        "tags"
    ]);
    const productTag = (tags === null || tags === void 0 ? void 0 : tags[0]) || getZeroDiscount(recommendation);
    return /*#__PURE__*/ React__default.createElement(ProductBlock, swcHelpers.extends({
        ref: ref,
        activeSku: sku
    }, recommendationRest, {
        /* We have to pass onVariantChange given it is not optional, even though
         * we know we will never have have variants on recommendations.
         */ /* eslint-disable-next-line @typescript-eslint/no-empty-function */ onVariantChange: ()=>{},
        /**
         * Some other props that are required but we don't need (yet).
         */ variants: [],
        isInsuranceReimbursable: false,
        /* Take the first tag as the product tag.
         * We currenlty dont have the percent based discount information in graphql to perform the propper fallback logic.
         */ tag: productTag
    }, rest));
});

const ProductRecommendationContainer = (props)=>{
    const { recommendation , position  } = props;
    const clickRef = useRef(false);
    const { ref , wasSeen  } = useWasSeenByUser();
    const handleRecommendationClick = useCallback(()=>{
        if (!clickRef.current) {
            pushProductClick(recommendation, position);
            clickRef.current = true;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(()=>{
        if (wasSeen) {
            pushProductImpressions(recommendation, position);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        wasSeen
    ]);
    return /*#__PURE__*/ React__default.createElement(ProductRecommendation, swcHelpers.extends({
        ref: ref
    }, props, {
        onClick: handleRecommendationClick
    }));
};

function isProductRecommendation(recommendation) {
    return recommendation.recommendationType === 'product';
}
function isBannerRecommendation(recommendation) {
    return recommendation.recommendationType === 'banner';
}

const RecommendationList = ({ labels , recommendations , locale , formatProductUrl ,  })=>{
    const validRecommendations = recommendations.filter(isValidRecommendation);
    if (!validRecommendations.length) return null;
    return /*#__PURE__*/ React__default.createElement(motion.div, {
        style: {
            overflow: 'hidden'
        },
        variants: {
            start: {
                height: 0
            },
            end: {
                height: 'auto'
            }
        },
        transition: {
            type: 'tween'
        },
        initial: "start",
        animate: "end",
        className: "recommendation-list"
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        component: "h2",
        variant: "smallest",
        className: "recommendation-list__title"
    }, labels.title), /*#__PURE__*/ React__default.createElement(motion.ul, {
        variants: {
            start: {
                opacity: 1
            },
            end: {
                opacity: 1
            }
        },
        transition: {
            delayChildren: 0.25,
            staggerChildren: 0.1
        },
        className: "recommendation-list__list"
    }, validRecommendations.map((recommendation, index)=>isProductRecommendation(recommendation) ? /*#__PURE__*/ React__default.createElement(ListItemWrapper, {
            key: recommendation.sku
        }, /*#__PURE__*/ React__default.createElement(ProductRecommendationContainer, {
            recommendation: recommendation,
            locale: locale,
            formatProductUrl: formatProductUrl,
            position: index + 1
        })) : /*#__PURE__*/ React__default.createElement(ListItemWrapper, {
            key: `${recommendation.position}-${recommendation.title}`
        }, /*#__PURE__*/ React__default.createElement(BannerRecommendationContainer, {
            recommendation: recommendation
        }))
    )));
};
function isValidRecommendation(recommendation) {
    return isBannerRecommendation(recommendation) || isProductRecommendation(recommendation) && CommerceToolsApi.isProductTypeName(recommendation.productType);
}

const mergeAndSortRecommendations = (recommendedProducts, recommendedBanners, options)=>{
    const positionAscending = (a, b)=>a.position - b.position
    ;
    const recommendations = recommendedProducts.map((p)=>swcHelpers.objectSpread({}, p, {
            recommendationType: 'product'
        })
    );
    const banners = recommendedBanners.map((b)=>swcHelpers.objectSpread({}, b, {
            recommendationType: 'banner'
        })
    );
    /*
   * Each promotion (a.k.a. banner) delivered by the backend has a position associated
   * with it. Here we make sure the promotions are interleaved with the
   * products, based on each promotion's "position" property.
   */ banners.sort(positionAscending).forEach((b)=>{
        if (isBannerRecommendation(b)) recommendations.splice(b.position, 0, b);
    });
    return (options === null || options === void 0 ? void 0 : options.maxItems) ? recommendations.slice(0, options.maxItems) : recommendations;
};

const RecommendationListContainer = ({ skus , recommendationContext , formatProductUrl , maxItems ,  })=>{
    var ref, ref1;
    const { getLabel , locale  } = useIntl();
    const { data , loading , error  } = useQuery(GET_RECOMMENDATIONS, {
        variables: {
            input: {
                skus,
                recommendationContext,
                locale
            }
        }
    });
    const labels = React__default.useMemo(()=>({
            title: getLabel('products.recommendationList.title')
        })
    , [
        getLabel
    ]);
    if (error || !loading && !data) {
        return null;
    }
    const recommendedProducts = (data === null || data === void 0 ? void 0 : (ref = data.getRecommendations) === null || ref === void 0 ? void 0 : ref.recommendedProducts) || [];
    const recommendedBanners = (data === null || data === void 0 ? void 0 : (ref1 = data.getRecommendations) === null || ref1 === void 0 ? void 0 : ref1.recommendedBanners) || [];
    const recommendations = mergeAndSortRecommendations(recommendedProducts, recommendedBanners, {
        maxItems
    });
    if (!loading && !recommendations.length) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(RecommendationList, {
        labels: labels,
        recommendations: recommendations,
        locale: locale,
        formatProductUrl: formatProductUrl
    });
};

const RecommendationListMiniCartLayout = (props)=>/*#__PURE__*/ React.createElement(RecommendationListContainer, swcHelpers.extends({}, props))
;

var FeaturedProducts = (_param)=>{
    var { title , renderLocation  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "title",
        "renderLocation"
    ]);
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(ProductPromotionEventProvider, {
        location: `featured reccommendation ${renderLocation}`
    }, /*#__PURE__*/ React.createElement("div", {
        className: "featured-products"
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Heading, {
        className: "featured-products__title",
        variant: "medium",
        align: "center"
    }, title || getLabel('products.featured.title')), /*#__PURE__*/ React.createElement(ProductBannerContainer, swcHelpers.extends({}, rest)))));
};
var FeaturedProducts$1 = withLazyLoading(FeaturedProducts);

const ProductStructuredDataObject = (props)=>{
    const { activeSku  } = useProductDetailContext();
    return /*#__PURE__*/ React.createElement(Product, swcHelpers.extends({}, props, {
        activeSKU: activeSku
    }));
};

function parseProductDetailQueryParams(queryParams) {
    const { isInsuranceReimbursable , offerings =''  } = queryParams || {};
    return {
        isReimbursable: isInsuranceReimbursable === 'true',
        filteredOfferings: Array.isArray(offerings) ? offerings : offerings.split(',').filter(Boolean)
    };
}

SagaRegistry.register('contactLensSubscription', contactLensSubscriptionSaga);
ReducersRegistry.register('contactLensSubscription', contactLensSubscriptionReducer);
SagaRegistry.register('prescriptionGlasses', prescriptionGlassesSaga);
ReducersRegistry.register('prescriptionGlasses', prescriptionGlassesReducer);

export { AlgoliaProductBlock, ConfigureContactLenses, CrossSellBlock, CrossSellItem$1 as CrossSellItem, DailyPackageQuantityContainer as DailyPackageQuantity, FeaturedProducts$1 as FeaturedProducts, helpers as Helpers, LensPacks$1 as LensPacks, RecommendationListMiniCartLayout as MiniCartProductRecommendations, PackageQuantityContainer$1 as PackageQuantity, PackageQuantityDropdown, Prescription$1 as Prescription, ProductBannerContainer as ProductBanner, ProductBanner as ProductBannerView, CommerceToolsProductBlock as ProductBlock, ProductBlocksContainer, ProductCatalogBreadcrumbs, ProductDetail, ProductDetailLensesFeatures, ProductDetailOpticsFeatures, ProductDetailProvider, ProductDetailUnitInfo, ProductDiscountBar, ProductFrameMeasurements, ProductImageGalleryContainer as ProductImageGallery, ProductListing, ProductPlaceholder, ProductPromotionEventProvider, ProductPromotions, ProductStructuredDataObject, types as ProductTypes, PromoteInstallments, RecentlyViewedProducts$1 as RecentlyViewedProducts, SSP$1 as SSP, Solution, PackageQuantityContainer as SubscriptionPackageQuantity, createImpressionEvent$1 as createImpressionEvent, createInteractionEvent, getProductSeoInfo, isContactLenses, isLightProductModel, isRateplansDaily, parseProductDetailQueryParams, useBrandLink, useProductDetailContext };
//# sourceMappingURL=index.js.map
